webpackJsonp([1],{

/***/ 1000:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Table_Clientes_vue__ = __webpack_require__(526);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_95209dd4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Table_Clientes_vue__ = __webpack_require__(1013);
function injectStyle (ssrContext) {
  __webpack_require__(1001)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-95209dd4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Table_Clientes_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_95209dd4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Table_Clientes_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1001:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1012:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo.9d08058.jpg";

/***/ }),

/***/ 1013:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-flex',[_c('h1',{staticStyle:{"color":"#969462 !important"}},[_vm._v("Clientes")]),_vm._v(" "),_c('div',{staticClass:"elevation-3"},[_c('v-dialog',{attrs:{"persistent":"","width":"350"},model:{value:(_vm.loader),callback:function ($$v) {_vm.loader=$$v},expression:"loader"}},[_c('v-card',{attrs:{"color":"#969462","dark":""}},[_c('v-card-text',[_vm._v("\r\n                    Esta operação pode demorar alguns minutos."),_c('br'),_vm._v("\r\n                    Por favor aguarde...\r\n                    "),_c('v-progress-linear',{staticClass:"mb-0",attrs:{"indeterminate":"","color":"white"}})],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"tableHeader"},[_c('v-dialog',{attrs:{"persistent":"","max-width":"500px"},model:{value:(_vm.modal),callback:function ($$v) {_vm.modal=$$v},expression:"modal"}},[_c('v-btn',{staticClass:"mb-2",attrs:{"slot":"activator","color":"#969462","dark":""},slot:"activator"},[_c('v-icon',{staticClass:"buttonIconText",attrs:{"color":"white"}},[_vm._v("playlist_add")]),_vm._v(" Novo "+_vm._s(_vm.name)+"\r\n                ")],1),_vm._v(" "),_c('v-card',[_c('v-card-title',[_c('span',{staticClass:"headline"},[_vm._v(_vm._s(_vm.formTitle))])]),_vm._v(" "),_c('v-form',{ref:"form",on:{"submit":function($event){$event.preventDefault();}}},[_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('label',{staticClass:"label-modal"},[_vm._v("Nome")]),_vm._v(" "),_c('v-text-field',{attrs:{"color":"#969462","autofocus":true,"rules":_vm.defaultRules},model:{value:(_vm.editedItem.nome),callback:function ($$v) {_vm.$set(_vm.editedItem, "nome", $$v)},expression:"editedItem.nome"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('label',{staticClass:"label-modal"},[_vm._v("Email")]),_vm._v(" "),_c('v-text-field',{attrs:{"color":"#969462","rules":_vm.defaultRules},model:{value:(_vm.editedItem.email),callback:function ($$v) {_vm.$set(_vm.editedItem, "email", $$v)},expression:"editedItem.email"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":"","sm6":"","md6":""}},[_c('label',{staticClass:"label-modal"},[_vm._v("Escritório")]),_vm._v(" "),_c('v-select',{attrs:{"color":"#969462","rules":_vm.defaultRules,"items":_vm.getEscritorios,"item-text":"nome","item-value":"id_escritorio"},model:{value:(_vm.editedItem.id_escritorio),callback:function ($$v) {_vm.$set(_vm.editedItem, "id_escritorio", $$v)},expression:"editedItem.id_escritorio"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":"","sm6":"","md6":""}},[_c('label',{staticClass:"label-modal"},[_vm._v("Telefone")]),_vm._v(" "),_c('v-text-field',{attrs:{"color":"#969462","rules":_vm.defaultRules},model:{value:(_vm.editedItem.telefone),callback:function ($$v) {_vm.$set(_vm.editedItem, "telefone", $$v)},expression:"editedItem.telefone"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":"","sm4":"","md4":""}},[_c('label',{staticClass:"label-modal"},[_vm._v("Código")]),_vm._v(" "),_c('v-text-field',{attrs:{"color":"#969462","rules":_vm.defaultRules},model:{value:(_vm.editedItem.codigo),callback:function ($$v) {_vm.$set(_vm.editedItem, "codigo", $$v)},expression:"editedItem.codigo"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":"","sm4":"","md4":""}},[_c('label',{staticClass:"label-modal"},[_vm._v("NIF")]),_vm._v(" "),_c('v-text-field',{attrs:{"color":"#969462","rules":_vm.defaultRules},model:{value:(_vm.editedItem.nif),callback:function ($$v) {_vm.$set(_vm.editedItem, "nif", $$v)},expression:"editedItem.nif"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":"","sm4":"","md4":""}},[_c('label',{staticClass:"label-modal"},[_vm._v("Ano inicio")]),_vm._v(" "),_c('v-text-field',{attrs:{"color":"#969462","rules":_vm.defaultRules},model:{value:(_vm.editedItem.ano),callback:function ($$v) {_vm.$set(_vm.editedItem, "ano", $$v)},expression:"editedItem.ano"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":"","sm6":"","md6":""}},[_c('label',{staticClass:"label-modal"},[_vm._v("URL Website")]),_vm._v(" "),_c('v-text-field',{attrs:{"color":"#969462"},model:{value:(_vm.editedItem.urlwebsite),callback:function ($$v) {_vm.$set(_vm.editedItem, "urlwebsite", $$v)},expression:"editedItem.urlwebsite"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":"","sm6":"","md6":""}},[_c('label',{staticClass:"label-modal"},[_vm._v("2 anos relatório de gestão?")]),_vm._v(" "),_c('v-radio-group',{attrs:{"mandatory":true,"row":""},model:{value:(_vm.editedItem.anos2),callback:function ($$v) {_vm.$set(_vm.editedItem, "anos2", $$v)},expression:"editedItem.anos2"}},[_c('v-radio',{attrs:{"color":"#969462","label":"Sim","value":1}}),_vm._v(" "),_c('v-radio',{attrs:{"color":"#969462","label":"Não","value":0}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('label',{staticClass:"label-modal"},[_vm._v("Pastas a ignorar")]),_vm._v(" "),_c('v-text-field',{attrs:{"color":"#969462"},model:{value:(_vm.editedItem.pastas),callback:function ($$v) {_vm.$set(_vm.editedItem, "pastas", $$v)},expression:"editedItem.pastas"}})],1),_vm._v(" "),(_vm.editedIndex==-1)?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('label',{staticClass:"label-modal"},[_vm._v("Password")]),_vm._v(" "),_c('v-text-field',{attrs:{"color":"#969462","type":"password","rules":_vm.defaultRules,"append-icon":"cached"},on:{"click:append":function($event){return _vm.gerarPassword()}},model:{value:(_vm.editedItem.password),callback:function ($$v) {_vm.$set(_vm.editedItem, "password", $$v)},expression:"editedItem.password"}})],1):_vm._e(),_vm._v(" "),(_vm.editedIndex==-1)?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('label',{staticClass:"label-modal"},[_vm._v("Confirmar password")]),_vm._v(" "),_c('v-text-field',{attrs:{"color":"#969462","rules":_vm.pwdRules,"type":_vm.show ? 'text' : 'password',"append-icon":!_vm.show ? 'visibility' : 'visibility_off'},on:{"click:append":function($event){_vm.show = !_vm.show}},model:{value:(_vm.cpwd),callback:function ($$v) {_vm.cpwd=$$v},expression:"cpwd"}})],1):_vm._e()],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"#969462","flat":""},nativeOn:{"click":function($event){return _vm.close($event)}}},[_vm._v("Cancelar")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"#969462","flat":""},nativeOn:{"click":function($event){return _vm.save($event)}}},[_vm._v("Guardar")])],1)],1)],1)],1),_vm._v(" "),_c('v-text-field',{staticClass:"searchTable",attrs:{"color":"#969462","append-icon":"search","label":"Pesquisa","single-line":"","hide-details":""},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"390"},model:{value:(_vm.deleteM),callback:function ($$v) {_vm.deleteM=$$v},expression:"deleteM"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline",staticStyle:{"margin-left":"0px !important"}},[_vm._v("Apagar "+_vm._s(_vm.name))]),_vm._v(" "),_c('v-card-text',[_vm._v("De certeza que quer apagar este "+_vm._s(_vm.name)+"?")]),_vm._v(" "),_c('v-card-actions',{staticStyle:{"margin-top":"0px !important"}},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"#969462","flat":"flat"},nativeOn:{"click":function($event){return _vm.close($event)}}},[_vm._v("Cancelar")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"#969462","flat":"flat"},nativeOn:{"click":function($event){return _vm.save($event)}}},[_vm._v("Apagar")])],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"500px"},model:{value:(_vm.modalPassword),callback:function ($$v) {_vm.modalPassword=$$v},expression:"modalPassword"}},[_c('v-card',[_c('v-card-title',[_c('span',{staticClass:"headline"},[_vm._v("Alterar password")])]),_vm._v(" "),_c('v-form',{ref:"formnovapassword",on:{"submit":function($event){$event.preventDefault();}}},[_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[(_vm.editedIndex==-1)?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('label',{staticClass:"label-modal"},[_vm._v("Nova Password")]),_vm._v(" "),_c('v-text-field',{attrs:{"color":"#969462","type":"text","rules":_vm.defaultRules},model:{value:(_vm.editedItemPassword.password),callback:function ($$v) {_vm.$set(_vm.editedItemPassword, "password", $$v)},expression:"editedItemPassword.password"}})],1):_vm._e()],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"#969462","flat":""},nativeOn:{"click":function($event){_vm.modalPassword=false}}},[_vm._v("Cancelar")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"#969462","flat":""},nativeOn:{"click":function($event){return _vm.saveNewPassword($event)}}},[_vm._v("Guardar")])],1)],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"500px"},model:{value:(_vm.email),callback:function ($$v) {_vm.email=$$v},expression:"email"}},[_c('v-card',[_c('v-card-title',[_c('span',{staticClass:"headline"},[_vm._v("Enviar email")])]),_vm._v(" "),_c('v-form',{ref:"formEmail",on:{"submit":function($event){$event.preventDefault();}}},[_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('label',{staticClass:"label-modal"},[_vm._v("Email")]),_vm._v(" "),_c('v-text-field',{attrs:{"color":"#969462","rules":_vm.defaultRules},model:{value:(_vm.E.email),callback:function ($$v) {_vm.$set(_vm.E, "email", $$v)},expression:"E.email"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('label',{staticClass:"label-modal"},[_vm._v("Assunto")]),_vm._v(" "),_c('v-text-field',{attrs:{"color":"#969462","rules":_vm.defaultRules},model:{value:(_vm.E.assunto),callback:function ($$v) {_vm.$set(_vm.E, "assunto", $$v)},expression:"E.assunto"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('label',{staticClass:"label-modal"},[_vm._v("Corpo")]),_vm._v(" "),_c('v-textarea',{attrs:{"rows":"5","color":"#969462","rules":_vm.defaultRules},model:{value:(_vm.E.corpo),callback:function ($$v) {_vm.$set(_vm.E, "corpo", $$v)},expression:"E.corpo"}})],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"#969462","flat":""},nativeOn:{"click":function($event){_vm.email=false}}},[_vm._v("Cancelar")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"#969462","flat":""},nativeOn:{"click":function($event){return _vm.sendMail($event)}}},[_vm._v("Enviar")])],1)],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"500px"},model:{value:(_vm.form),callback:function ($$v) {_vm.form=$$v},expression:"form"}},[_c('v-card',[_c('v-card-title',[_c('span',{staticClass:"headline"},[_vm._v("Parâmetros de pesquisa")])]),_vm._v(" "),_c('v-form',{ref:"formS",on:{"submit":function($event){$event.preventDefault();}}},[_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs6":"","sm6":"","md6":""}},[_c('label',{staticClass:"label-modal"},[_vm._v("Ano")]),_vm._v(" "),_c('v-autocomplete',{attrs:{"color":"#969462","items":_vm.editedItem.anos},model:{value:(_vm.ano),callback:function ($$v) {_vm.ano=$$v},expression:"ano"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":"","sm6":"","md6":""}},[_c('label',{staticClass:"label-modal"},[_vm._v("Mês")]),_vm._v(" "),_c('v-autocomplete',{attrs:{"color":"#969462","items":_vm.meses,"item-text":"nome","item-value":"mes"},model:{value:(_vm.mes),callback:function ($$v) {_vm.mes=$$v},expression:"mes"}})],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"#969462","flat":""},nativeOn:{"click":function($event){return _vm.close($event)}}},[_vm._v("Cancelar")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"#969462","flat":""},nativeOn:{"click":function($event){return _vm.gerar($event)}}},[_vm._v("Confirmar")])],1)],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"fullscreen":"","persistent":"","hide-overlay":"","transition":"dialog-bottom-transition"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[(_vm.editedIndex > -1)?_c('v-card',[_c('v-toolbar',{attrs:{"dark":"","color":"#969462"}},[_c('v-btn',{attrs:{"icon":"","dark":""},on:{"click":function($event){_vm.dialog = false}}},[_c('v-icon',[_vm._v("close")])],1),_vm._v(" "),_c('v-toolbar-title',[_vm._v(_vm._s(_vm.editedItem.nome)+" - Relatório de Gestão - "+_vm._s(_vm.ano)+"/"+_vm._s(_vm.meses.find(function (el){ return el.mes == _vm.mes }).nome))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-toolbar-items',{staticStyle:{"display":"flex !important","align-items":"center !important"}},[_c('v-btn',{attrs:{"color":"white","flat":""},on:{"click":function($event){return _vm.exportar()}}},[_vm._v("Exportar")]),_vm._v(" "),(_vm.path!=null)?_c('a',{attrs:{"target":"_blank","href":_vm.path}},[_vm._v("Abrir")]):_vm._e(),_vm._v(" "),(_vm.path!=null)?_c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-icon',_vm._g({attrs:{"color":"white"},on:{"click":function($event){_vm.email=true}}},on),[_vm._v("send")])]}}],null,false,2642719233)},[_vm._v(" "),_c('span',[_vm._v("Enviar e-mail")])]):_vm._e()],1)],1),_vm._v(" "),_c('v-card',{staticStyle:{"display":"flex","margin-top":"50px","justify-content":"center","box-shadow":"none !important"},attrs:{"id":"report"}},[_c('v-layout',{staticStyle:{"display":"flex","justify-content":"center"},attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs10":"","sm10":"","md10":"","pb-5":""}},[_c('div',{attrs:{"id":"P1"}},[_c('p',{staticClass:"r-header"},[_c('v-icon',[_vm._v("arrow_forward_ios")]),_vm._v(" Até ao final de "),_c('span',{staticClass:"bold-up"},[_vm._v(" "+_vm._s(_vm.meses.find(function (el){ return el.mes == _vm.mes }).nome)+" ")]),_vm._v(" de "),_c('span',{staticClass:"bold-up"},[_vm._v(" "+_vm._s(_vm.ano)+" ")]),_vm._v(" a empresa "),_c('span',{staticClass:"bold-up"},[_vm._v(" "+_vm._s(_vm.editedItem.nome)+" ")]),_vm._v(":\r\n                                ")],1),_vm._v(" "),_c('p',{staticClass:"r-child"},[_c('v-icon',[_vm._v("lens")]),_vm._v(" Gerou um volume de negócios de: "),_c('span',{staticClass:"bold-up"},[_vm._v(" € "+_vm._s(_vm.numberWithSpaces(_vm.VALUES.P1.volnegocios)))])],1),_vm._v(" "),_c('p',{staticClass:"r-child"},[_c('v-icon',[_vm._v("lens")]),_vm._v(" Registou uma margem bruta de: "),_c('span',{staticClass:"bold-up"},[_vm._v(" € "+_vm._s(_vm.numberWithSpaces(_vm.VALUES.P1.margembruta)))])],1),_vm._v(" "),_c('p',{staticClass:"r-child"},[_c('v-icon',[_vm._v("lens")]),_vm._v(" Apresentou um resultado antes de impostos de: "),_c('span',{staticClass:"bold-up"},[_vm._v(" € "+_vm._s(_vm.numberWithSpaces(_vm.T1T3A)))])],1),_vm._v(" "),_c('p',{staticClass:"r-child"},[_c('v-icon',[_vm._v("lens")]),_vm._v(" Gerou um EBIDTA (Cash Flow Operacional) de: "),_c('span',{staticClass:"bold-up"},[_vm._v(" € "+_vm._s(_vm.numberWithSpaces(_vm.T1T1A)))])],1)])]),_vm._v(" "),_c('v-flex',{attrs:{"xs10":"","sm10":"","md10":"","pb-5":""}},[_c('div',{attrs:{"id":"P2"}},[_c('p',{staticClass:"r-header"},[_c('v-icon',[_vm._v("arrow_forward_ios")]),_vm._v(" Contingências Fiscais:\r\n                                ")],1),_vm._v(" "),_c('v-edit-dialog',{attrs:{"large":"","persistent":"","save-text":"Guardar","cancel-text":"Cancelar","return-value":_vm.STRINGS[1]},on:{"update:returnValue":function($event){return _vm.$set(_vm.STRINGS, 1, $event)},"update:return-value":function($event){return _vm.$set(_vm.STRINGS, 1, $event)}},scopedSlots:_vm._u([{key:"input",fn:function(){return [_c('v-textarea',{attrs:{"autofocus":"","color":"#969462","rows":"6"},model:{value:(_vm.STRINGS[1]),callback:function ($$v) {_vm.$set(_vm.STRINGS, 1, $$v)},expression:"STRINGS[1]"}})]},proxy:true}],null,false,1029755542)},[_c('p',{staticClass:"r-child"},[_c('v-icon',[_vm._v("lens")]),_vm._v(" "+_vm._s(_vm.STRINGS[1])+"\r\n                                    ")],1)]),_vm._v(" "),_c('v-edit-dialog',{attrs:{"large":"","persistent":"","save-text":"Guardar","cancel-text":"Cancelar","return-value":_vm.STRINGS[2]},on:{"update:returnValue":function($event){return _vm.$set(_vm.STRINGS, 2, $event)},"update:return-value":function($event){return _vm.$set(_vm.STRINGS, 2, $event)}},scopedSlots:_vm._u([{key:"input",fn:function(){return [_c('v-textarea',{attrs:{"autofocus":"","color":"#969462","rows":"6"},model:{value:(_vm.STRINGS[2]),callback:function ($$v) {_vm.$set(_vm.STRINGS, 2, $$v)},expression:"STRINGS[2]"}})]},proxy:true}],null,false,4149933685)},[_c('p',{staticClass:"r-child"},[_c('v-icon',[_vm._v("lens")]),_vm._v(" "+_vm._s(_vm.STRINGS[2])+"\r\n                                    ")],1)]),_vm._v(" "),_c('v-edit-dialog',{attrs:{"large":"","persistent":"","save-text":"Guardar","cancel-text":"Cancelar","return-value":_vm.STRINGS[3]},on:{"update:returnValue":function($event){return _vm.$set(_vm.STRINGS, 3, $event)},"update:return-value":function($event){return _vm.$set(_vm.STRINGS, 3, $event)}},scopedSlots:_vm._u([{key:"input",fn:function(){return [_c('v-textarea',{attrs:{"autofocus":"","color":"#969462","rows":"6"},model:{value:(_vm.STRINGS[3]),callback:function ($$v) {_vm.$set(_vm.STRINGS, 3, $$v)},expression:"STRINGS[3]"}})]},proxy:true}],null,false,33145684)},[_c('p',{staticClass:"r-child"},[_c('v-icon',[_vm._v("lens")]),_vm._v(" "+_vm._s(_vm.STRINGS[3])+"\r\n                                    ")],1)]),_vm._v(" "),_c('v-edit-dialog',{attrs:{"large":"","persistent":"","save-text":"Guardar","cancel-text":"Cancelar","return-value":_vm.STRINGS[4]},on:{"update:returnValue":function($event){return _vm.$set(_vm.STRINGS, 4, $event)},"update:return-value":function($event){return _vm.$set(_vm.STRINGS, 4, $event)}},scopedSlots:_vm._u([{key:"input",fn:function(){return [_c('v-textarea',{attrs:{"autofocus":"","color":"#969462","rows":"6"},model:{value:(_vm.STRINGS[4]),callback:function ($$v) {_vm.$set(_vm.STRINGS, 4, $$v)},expression:"STRINGS[4]"}})]},proxy:true}],null,false,1743096115)},[_c('p',{staticClass:"r-child"},[_c('v-icon',[_vm._v("lens")]),_vm._v(" "+_vm._s(_vm.STRINGS[4])+"\r\n                                    ")],1)]),_vm._v(" "),_c('v-edit-dialog',{attrs:{"large":"","persistent":"","save-text":"Guardar","cancel-text":"Cancelar","return-value":_vm.STRINGS[5]},on:{"update:returnValue":function($event){return _vm.$set(_vm.STRINGS, 5, $event)},"update:return-value":function($event){return _vm.$set(_vm.STRINGS, 5, $event)}},scopedSlots:_vm._u([{key:"input",fn:function(){return [_c('v-textarea',{attrs:{"autofocus":"","color":"#969462","rows":"6"},model:{value:(_vm.STRINGS[5]),callback:function ($$v) {_vm.$set(_vm.STRINGS, 5, $$v)},expression:"STRINGS[5]"}})]},proxy:true}],null,false,3259522578)},[_c('p',{staticClass:"r-child"},[_c('v-icon',[_vm._v("lens")]),_vm._v(" "+_vm._s(_vm.STRINGS[5])+"\r\n                                    ")],1)])],1)]),_vm._v(" "),_c('v-flex',{attrs:{"xs10":"","sm10":"","md10":"","pb-5":""}},[_c('div',{attrs:{"id":"T1"}},[_c('table',{staticStyle:{"text-align":"right"},attrs:{"width":"100%"}},[_c('tr',[_c('th',{staticClass:"bold-up",attrs:{"width":"50%","colspan":"1"}},[_vm._v("Demonstração de resultados por natureza da empresa "+_vm._s(_vm.editedItem.nome)+" em "+_vm._s(_vm.meses.find(function (el){ return el.mes == _vm.mes }).nome)+" de "+_vm._s(_vm.ano))]),_vm._v(" "),_c('th',{staticClass:"bold-up",attrs:{"width":"50%","colspan":"4"}},[_vm._v("Períodos")])]),_vm._v(" "),_c('tr',[_c('th'),_vm._v(" "),_c('th',{attrs:{"colspan":_vm.editedItem.anos2 ? '1' : '4'}},[_vm._v(_vm._s(Number(_vm.ano)))]),_vm._v(" "),(_vm.editedItem.anos2)?_c('th',[_vm._v(_vm._s((Number(_vm.ano) - 1)))]):_vm._e(),_vm._v(" "),(_vm.editedItem.anos2)?_c('th',[_vm._v("Δ")]):_vm._e(),_vm._v(" "),(_vm.editedItem.anos2)?_c('th',[_vm._v("Δ%")]):_vm._e()]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"table-left"},[_vm._v("Rendimentos e gastos")]),_vm._v(" "),_c('td',{attrs:{"colspan":"4"}})]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"table-left"},[_vm._v("Vendas e serviços prestados")]),_vm._v(" "),_c('td',{attrs:{"colspan":_vm.editedItem.anos2 ? '1' : '4'}},[_c('v-edit-dialog',{attrs:{"return-value":_vm.VALUES.T1A.vendasservicosprestados},on:{"update:returnValue":function($event){return _vm.$set(_vm.VALUES.T1A, "vendasservicosprestados", $event)},"update:return-value":function($event){return _vm.$set(_vm.VALUES.T1A, "vendasservicosprestados", $event)}},scopedSlots:_vm._u([{key:"input",fn:function(){return [_c('v-text-field',{attrs:{"type":"number","min":"0","step":".1","color":"#969462","single-line":""},model:{value:(_vm.VALUES.T1A.vendasservicosprestados),callback:function ($$v) {_vm.$set(_vm.VALUES.T1A, "vendasservicosprestados", $$v)},expression:"VALUES.T1A.vendasservicosprestados"}})]},proxy:true}],null,false,634758948)},[_vm._v("\r\n                                                "+_vm._s(_vm.numberWithSpaces(_vm.VALUES.T1A.vendasservicosprestados) || '-')+"\r\n                                                ")])],1),_vm._v(" "),(_vm.editedItem.anos2)?_c('td',[_c('v-edit-dialog',{attrs:{"return-value":_vm.VALUES.T1B.vendasservicosprestados},on:{"update:returnValue":function($event){return _vm.$set(_vm.VALUES.T1B, "vendasservicosprestados", $event)},"update:return-value":function($event){return _vm.$set(_vm.VALUES.T1B, "vendasservicosprestados", $event)}},scopedSlots:_vm._u([{key:"input",fn:function(){return [_c('v-text-field',{attrs:{"type":"number","min":"0","step":".1","color":"#969462","single-line":""},model:{value:(_vm.VALUES.T1B.vendasservicosprestados),callback:function ($$v) {_vm.$set(_vm.VALUES.T1B, "vendasservicosprestados", $$v)},expression:"VALUES.T1B.vendasservicosprestados"}})]},proxy:true}],null,false,1016335943)},[_vm._v("\r\n                                                "+_vm._s(_vm.numberWithSpaces(_vm.VALUES.T1B.vendasservicosprestados) || '-')+"\r\n                                                ")])],1):_vm._e(),_vm._v(" "),(_vm.editedItem.anos2)?_c('td',[_vm._v(_vm._s(_vm.numberWithSpaces(_vm.getDiffT1('vendasservicosprestados').replace('-',''))))]):_vm._e(),_vm._v(" "),(_vm.editedItem.anos2)?_c('td',[_vm._v(_vm._s(_vm.getPercentT1('vendasservicosprestados')))]):_vm._e()]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"table-left"},[_vm._v("Subsídios à exploração")]),_vm._v(" "),_c('td',{attrs:{"colspan":_vm.editedItem.anos2 ? '1' : '4'}},[_c('v-edit-dialog',{attrs:{"return-value":_vm.VALUES.T1A.subsidiosaexploracao},on:{"update:returnValue":function($event){return _vm.$set(_vm.VALUES.T1A, "subsidiosaexploracao", $event)},"update:return-value":function($event){return _vm.$set(_vm.VALUES.T1A, "subsidiosaexploracao", $event)}},scopedSlots:_vm._u([{key:"input",fn:function(){return [_c('v-text-field',{attrs:{"type":"number","min":"0","step":".1","color":"#969462","single-line":""},model:{value:(_vm.VALUES.T1A.subsidiosaexploracao),callback:function ($$v) {_vm.$set(_vm.VALUES.T1A, "subsidiosaexploracao", $$v)},expression:"VALUES.T1A.subsidiosaexploracao"}})]},proxy:true}],null,false,1471226284)},[_vm._v("\r\n                                                "+_vm._s(_vm.numberWithSpaces(_vm.VALUES.T1A.subsidiosaexploracao) || '-')+"\r\n                                                ")])],1),_vm._v(" "),(_vm.editedItem.anos2)?_c('td',[_c('v-edit-dialog',{attrs:{"return-value":_vm.VALUES.T1B.subsidiosaexploracao},on:{"update:returnValue":function($event){return _vm.$set(_vm.VALUES.T1B, "subsidiosaexploracao", $event)},"update:return-value":function($event){return _vm.$set(_vm.VALUES.T1B, "subsidiosaexploracao", $event)}},scopedSlots:_vm._u([{key:"input",fn:function(){return [_c('v-text-field',{attrs:{"type":"number","min":"0","step":".1","color":"#969462","single-line":""},model:{value:(_vm.VALUES.T1B.subsidiosaexploracao),callback:function ($$v) {_vm.$set(_vm.VALUES.T1B, "subsidiosaexploracao", $$v)},expression:"VALUES.T1B.subsidiosaexploracao"}})]},proxy:true}],null,false,465059183)},[_vm._v("\r\n                                                "+_vm._s(_vm.numberWithSpaces(_vm.VALUES.T1B.subsidiosaexploracao) || '-')+"\r\n                                                ")])],1):_vm._e(),_vm._v(" "),(_vm.editedItem.anos2)?_c('td',[_vm._v(_vm._s(_vm.numberWithSpaces(_vm.getDiffT1('subsidiosaexploracao').replace('-',''))))]):_vm._e(),_vm._v(" "),(_vm.editedItem.anos2)?_c('td',[_vm._v(_vm._s(_vm.getPercentT1('subsidiosaexploracao')))]):_vm._e()]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"table-left"},[_vm._v("Variação nos inventários da produção")]),_vm._v(" "),_c('td',{attrs:{"colspan":_vm.editedItem.anos2 ? '1' : '4'}},[_c('v-edit-dialog',{attrs:{"return-value":_vm.VALUES.T1A.variacaoinventariosprod},on:{"update:returnValue":function($event){return _vm.$set(_vm.VALUES.T1A, "variacaoinventariosprod", $event)},"update:return-value":function($event){return _vm.$set(_vm.VALUES.T1A, "variacaoinventariosprod", $event)}},scopedSlots:_vm._u([{key:"input",fn:function(){return [_c('v-text-field',{attrs:{"type":"number","min":"0","step":".1","color":"#969462","single-line":""},model:{value:(_vm.VALUES.T1A.variacaoinventariosprod),callback:function ($$v) {_vm.$set(_vm.VALUES.T1A, "variacaoinventariosprod", $$v)},expression:"VALUES.T1A.variacaoinventariosprod"}})]},proxy:true}],null,false,2663719027)},[_vm._v("\r\n                                                "+_vm._s(_vm.numberWithSpaces(_vm.VALUES.T1A.variacaoinventariosprod) || '-')+"\r\n                                                ")])],1),_vm._v(" "),(_vm.editedItem.anos2)?_c('td',[_c('v-edit-dialog',{attrs:{"return-value":_vm.VALUES.T1B.variacaoinventariosprod},on:{"update:returnValue":function($event){return _vm.$set(_vm.VALUES.T1B, "variacaoinventariosprod", $event)},"update:return-value":function($event){return _vm.$set(_vm.VALUES.T1B, "variacaoinventariosprod", $event)}},scopedSlots:_vm._u([{key:"input",fn:function(){return [_c('v-text-field',{attrs:{"type":"number","min":"0","step":".1","color":"#969462","single-line":""},model:{value:(_vm.VALUES.T1B.variacaoinventariosprod),callback:function ($$v) {_vm.$set(_vm.VALUES.T1B, "variacaoinventariosprod", $$v)},expression:"VALUES.T1B.variacaoinventariosprod"}})]},proxy:true}],null,false,2129654288)},[_vm._v("\r\n                                                "+_vm._s(_vm.numberWithSpaces(_vm.VALUES.T1B.variacaoinventariosprod) || '-')+"\r\n                                                ")])],1):_vm._e(),_vm._v(" "),(_vm.editedItem.anos2)?_c('td',[_vm._v(_vm._s(_vm.numberWithSpaces(_vm.getDiffT1('variacaoinventariosprod').replace('-',''))))]):_vm._e(),_vm._v(" "),(_vm.editedItem.anos2)?_c('td',[_vm._v(_vm._s(_vm.getPercentT1('variacaoinventariosprod')))]):_vm._e()]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"table-left"},[_vm._v("Trabalhos para a própria entidade")]),_vm._v(" "),_c('td',{attrs:{"colspan":_vm.editedItem.anos2 ? '1' : '4'}},[_c('v-edit-dialog',{attrs:{"return-value":_vm.VALUES.T1A.trabalhospropriaentidade},on:{"update:returnValue":function($event){return _vm.$set(_vm.VALUES.T1A, "trabalhospropriaentidade", $event)},"update:return-value":function($event){return _vm.$set(_vm.VALUES.T1A, "trabalhospropriaentidade", $event)}},scopedSlots:_vm._u([{key:"input",fn:function(){return [_c('v-text-field',{attrs:{"type":"number","min":"0","step":".1","color":"#969462","single-line":""},model:{value:(_vm.VALUES.T1A.trabalhospropriaentidade),callback:function ($$v) {_vm.$set(_vm.VALUES.T1A, "trabalhospropriaentidade", $$v)},expression:"VALUES.T1A.trabalhospropriaentidade"}})]},proxy:true}],null,false,2549667771)},[_vm._v("\r\n                                                "+_vm._s(_vm.numberWithSpaces(_vm.VALUES.T1A.trabalhospropriaentidade) || '-')+"\r\n                                                ")])],1),_vm._v(" "),(_vm.editedItem.anos2)?_c('td',[_c('v-edit-dialog',{attrs:{"return-value":_vm.VALUES.T1B.trabalhospropriaentidade},on:{"update:returnValue":function($event){return _vm.$set(_vm.VALUES.T1B, "trabalhospropriaentidade", $event)},"update:return-value":function($event){return _vm.$set(_vm.VALUES.T1B, "trabalhospropriaentidade", $event)}},scopedSlots:_vm._u([{key:"input",fn:function(){return [_c('v-text-field',{attrs:{"type":"number","min":"0","step":".1","color":"#969462","single-line":""},model:{value:(_vm.VALUES.T1B.trabalhospropriaentidade),callback:function ($$v) {_vm.$set(_vm.VALUES.T1B, "trabalhospropriaentidade", $$v)},expression:"VALUES.T1B.trabalhospropriaentidade"}})]},proxy:true}],null,false,1214502008)},[_vm._v("\r\n                                                "+_vm._s(_vm.numberWithSpaces(_vm.VALUES.T1B.trabalhospropriaentidade) || '-')+"\r\n                                                ")])],1):_vm._e(),_vm._v(" "),(_vm.editedItem.anos2)?_c('td',[_vm._v(_vm._s(_vm.numberWithSpaces(_vm.getDiffT1('trabalhospropriaentidade').replace('-',''))))]):_vm._e(),_vm._v(" "),(_vm.editedItem.anos2)?_c('td',[_vm._v(_vm._s(_vm.getPercentT1('trabalhospropriaentidade')))]):_vm._e()]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"table-left"},[_vm._v("Custos das mercadorias vendidas e das matérias consumidas")]),_vm._v(" "),_c('td',{attrs:{"colspan":_vm.editedItem.anos2 ? '1' : '4'}},[_c('v-edit-dialog',{attrs:{"return-value":_vm.cmvcmcA},on:{"update:returnValue":function($event){_vm.cmvcmcA=$event},"update:return-value":function($event){_vm.cmvcmcA=$event}},scopedSlots:_vm._u([{key:"input",fn:function(){return [_c('v-text-field',{attrs:{"type":"number","min":"0","step":".1","color":"#969462","single-line":""},model:{value:(_vm.cmvcmcA),callback:function ($$v) {_vm.cmvcmcA=$$v},expression:"cmvcmcA"}})]},proxy:true}],null,false,899397998)},[_vm._v("\r\n                                                "+_vm._s(_vm.numberWithSpaces(_vm.cmvcmcA) || '-')+"\r\n                                                ")])],1),_vm._v(" "),(_vm.editedItem.anos2)?_c('td',[_c('v-edit-dialog',{attrs:{"return-value":_vm.cmvcmcB},on:{"update:returnValue":function($event){_vm.cmvcmcB=$event},"update:return-value":function($event){_vm.cmvcmcB=$event}},scopedSlots:_vm._u([{key:"input",fn:function(){return [_c('v-text-field',{attrs:{"type":"number","min":"0","step":".1","color":"#969462","single-line":""},model:{value:(_vm.cmvcmcB),callback:function ($$v) {_vm.cmvcmcB=$$v},expression:"cmvcmcB"}})]},proxy:true}],null,false,2626914157)},[_vm._v("\r\n                                                "+_vm._s(_vm.numberWithSpaces(_vm.cmvcmcB) || '-')+"\r\n                                                ")])],1):_vm._e(),_vm._v(" "),(_vm.editedItem.anos2)?_c('td',[_vm._v(_vm._s(_vm.numberWithSpaces(_vm.getDiffT1('cmvcmc').replace('-',''))))]):_vm._e(),_vm._v(" "),(_vm.editedItem.anos2)?_c('td',[_vm._v(_vm._s(_vm.getPercentT1('cmvcmc')))]):_vm._e()]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"table-left"},[_vm._v("Fornecimentos e serviços externos")]),_vm._v(" "),_c('td',{attrs:{"colspan":_vm.editedItem.anos2 ? '1' : '4'}},[_c('v-edit-dialog',{attrs:{"return-value":_vm.VALUES.T1A.fse},on:{"update:returnValue":function($event){return _vm.$set(_vm.VALUES.T1A, "fse", $event)},"update:return-value":function($event){return _vm.$set(_vm.VALUES.T1A, "fse", $event)}},scopedSlots:_vm._u([{key:"input",fn:function(){return [_c('v-text-field',{attrs:{"type":"number","min":"0","step":".1","color":"#969462","single-line":""},model:{value:(_vm.VALUES.T1A.fse),callback:function ($$v) {_vm.$set(_vm.VALUES.T1A, "fse", $$v)},expression:"VALUES.T1A.fse"}})]},proxy:true}],null,false,4214660482)},[_vm._v("\r\n                                                "+_vm._s(_vm.numberWithSpaces(_vm.VALUES.T1A.fse) || '-')+"\r\n                                                ")])],1),_vm._v(" "),(_vm.editedItem.anos2)?_c('td',[_c('v-edit-dialog',{attrs:{"return-value":_vm.VALUES.T1B.fse},on:{"update:returnValue":function($event){return _vm.$set(_vm.VALUES.T1B, "fse", $event)},"update:return-value":function($event){return _vm.$set(_vm.VALUES.T1B, "fse", $event)}},scopedSlots:_vm._u([{key:"input",fn:function(){return [_c('v-text-field',{attrs:{"type":"number","min":"0","step":".1","color":"#969462","single-line":""},model:{value:(_vm.VALUES.T1B.fse),callback:function ($$v) {_vm.$set(_vm.VALUES.T1B, "fse", $$v)},expression:"VALUES.T1B.fse"}})]},proxy:true}],null,false,2583773025)},[_vm._v("\r\n                                                "+_vm._s(_vm.numberWithSpaces(_vm.VALUES.T1B.fse) || '-')+"\r\n                                                ")])],1):_vm._e(),_vm._v(" "),(_vm.editedItem.anos2)?_c('td',[_vm._v(_vm._s(_vm.numberWithSpaces(_vm.getDiffT1('fse').replace('-',''))))]):_vm._e(),_vm._v(" "),(_vm.editedItem.anos2)?_c('td',[_vm._v(_vm._s(_vm.getPercentT1('fse')))]):_vm._e()]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"table-left"},[_vm._v("Gastos com o pessoal")]),_vm._v(" "),_c('td',{attrs:{"colspan":_vm.editedItem.anos2 ? '1' : '4'}},[_c('v-edit-dialog',{attrs:{"return-value":_vm.VALUES.T1A.gastoscompessoal},on:{"update:returnValue":function($event){return _vm.$set(_vm.VALUES.T1A, "gastoscompessoal", $event)},"update:return-value":function($event){return _vm.$set(_vm.VALUES.T1A, "gastoscompessoal", $event)}},scopedSlots:_vm._u([{key:"input",fn:function(){return [_c('v-text-field',{attrs:{"type":"number","min":"0","step":".1","color":"#969462","single-line":""},model:{value:(_vm.VALUES.T1A.gastoscompessoal),callback:function ($$v) {_vm.$set(_vm.VALUES.T1A, "gastoscompessoal", $$v)},expression:"VALUES.T1A.gastoscompessoal"}})]},proxy:true}],null,false,2621309721)},[_vm._v("\r\n                                                "+_vm._s(_vm.numberWithSpaces(_vm.VALUES.T1A.gastoscompessoal) || '-')+"\r\n                                                ")])],1),_vm._v(" "),(_vm.editedItem.anos2)?_c('td',[_c('v-edit-dialog',{attrs:{"return-value":_vm.VALUES.T1B.gastoscompessoal},on:{"update:returnValue":function($event){return _vm.$set(_vm.VALUES.T1B, "gastoscompessoal", $event)},"update:return-value":function($event){return _vm.$set(_vm.VALUES.T1B, "gastoscompessoal", $event)}},scopedSlots:_vm._u([{key:"input",fn:function(){return [_c('v-text-field',{attrs:{"type":"number","min":"0","step":".1","color":"#969462","single-line":""},model:{value:(_vm.VALUES.T1B.gastoscompessoal),callback:function ($$v) {_vm.$set(_vm.VALUES.T1B, "gastoscompessoal", $$v)},expression:"VALUES.T1B.gastoscompessoal"}})]},proxy:true}],null,false,1190959770)},[_vm._v("\r\n                                                "+_vm._s(_vm.numberWithSpaces(_vm.VALUES.T1B.gastoscompessoal) || '-')+"\r\n                                                ")])],1):_vm._e(),_vm._v(" "),(_vm.editedItem.anos2)?_c('td',[_vm._v(_vm._s(_vm.numberWithSpaces(_vm.getDiffT1('gastoscompessoal').replace('-',''))))]):_vm._e(),_vm._v(" "),(_vm.editedItem.anos2)?_c('td',[_vm._v(_vm._s(_vm.getPercentT1('gastoscompessoal')))]):_vm._e()]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"table-left"},[_vm._v("Imparidade (perdas/reversões)")]),_vm._v(" "),_c('td',{attrs:{"colspan":_vm.editedItem.anos2 ? '1' : '4'}},[_c('v-edit-dialog',{attrs:{"return-value":_vm.VALUES.T1A.imparidade},on:{"update:returnValue":function($event){return _vm.$set(_vm.VALUES.T1A, "imparidade", $event)},"update:return-value":function($event){return _vm.$set(_vm.VALUES.T1A, "imparidade", $event)}},scopedSlots:_vm._u([{key:"input",fn:function(){return [_c('v-text-field',{attrs:{"type":"number","min":"0","step":".1","color":"#969462","single-line":""},model:{value:(_vm.VALUES.T1A.imparidade),callback:function ($$v) {_vm.$set(_vm.VALUES.T1A, "imparidade", $$v)},expression:"VALUES.T1A.imparidade"}})]},proxy:true}],null,false,604471512)},[_vm._v("\r\n                                                "+_vm._s(_vm.numberWithSpaces(_vm.VALUES.T1A.imparidade) || '-')+"\r\n                                                ")])],1),_vm._v(" "),(_vm.editedItem.anos2)?_c('td',[_c('v-edit-dialog',{attrs:{"return-value":_vm.VALUES.T1B.imparidade},on:{"update:returnValue":function($event){return _vm.$set(_vm.VALUES.T1B, "imparidade", $event)},"update:return-value":function($event){return _vm.$set(_vm.VALUES.T1B, "imparidade", $event)}},scopedSlots:_vm._u([{key:"input",fn:function(){return [_c('v-text-field',{attrs:{"type":"number","min":"0","step":".1","color":"#969462","single-line":""},model:{value:(_vm.VALUES.T1B.imparidade),callback:function ($$v) {_vm.$set(_vm.VALUES.T1B, "imparidade", $$v)},expression:"VALUES.T1B.imparidade"}})]},proxy:true}],null,false,1978075)},[_vm._v("\r\n                                                "+_vm._s(_vm.numberWithSpaces(_vm.VALUES.T1B.imparidade) || '-')+"\r\n                                                ")])],1):_vm._e(),_vm._v(" "),(_vm.editedItem.anos2)?_c('td',[_vm._v(_vm._s(_vm.numberWithSpaces(_vm.getDiffT1('imparidade').replace('-',''))))]):_vm._e(),_vm._v(" "),(_vm.editedItem.anos2)?_c('td',[_vm._v(_vm._s(_vm.getPercentT1('imparidade')))]):_vm._e()]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"table-left"},[_vm._v("Provisões (aumentos/reduções)")]),_vm._v(" "),_c('td',{attrs:{"colspan":_vm.editedItem.anos2 ? '1' : '4'}},[_c('v-edit-dialog',{attrs:{"return-value":_vm.VALUES.T1A.provisoes},on:{"update:returnValue":function($event){return _vm.$set(_vm.VALUES.T1A, "provisoes", $event)},"update:return-value":function($event){return _vm.$set(_vm.VALUES.T1A, "provisoes", $event)}},scopedSlots:_vm._u([{key:"input",fn:function(){return [_c('v-text-field',{attrs:{"type":"number","min":"0","step":".1","color":"#969462","single-line":""},model:{value:(_vm.VALUES.T1A.provisoes),callback:function ($$v) {_vm.$set(_vm.VALUES.T1A, "provisoes", $$v)},expression:"VALUES.T1A.provisoes"}})]},proxy:true}],null,false,216073706)},[_vm._v("\r\n                                                "+_vm._s(_vm.numberWithSpaces(_vm.VALUES.T1A.provisoes) || '-')+"\r\n                                                ")])],1),_vm._v(" "),(_vm.editedItem.anos2)?_c('td',[_c('v-edit-dialog',{attrs:{"return-value":_vm.VALUES.T1B.provisoes},on:{"update:returnValue":function($event){return _vm.$set(_vm.VALUES.T1B, "provisoes", $event)},"update:return-value":function($event){return _vm.$set(_vm.VALUES.T1B, "provisoes", $event)}},scopedSlots:_vm._u([{key:"input",fn:function(){return [_c('v-text-field',{attrs:{"type":"number","min":"0","step":".1","color":"#969462","single-line":""},model:{value:(_vm.VALUES.T1B.provisoes),callback:function ($$v) {_vm.$set(_vm.VALUES.T1B, "provisoes", $$v)},expression:"VALUES.T1B.provisoes"}})]},proxy:true}],null,false,1340632969)},[_vm._v("\r\n                                                "+_vm._s(_vm.numberWithSpaces(_vm.VALUES.T1B.provisoes) || '-')+"\r\n                                                ")])],1):_vm._e(),_vm._v(" "),(_vm.editedItem.anos2)?_c('td',[_vm._v(_vm._s(_vm.numberWithSpaces(_vm.getDiffT1('provisoes').replace('-',''))))]):_vm._e(),_vm._v(" "),(_vm.editedItem.anos2)?_c('td',[_vm._v(_vm._s(_vm.getPercentT1('provisoes')))]):_vm._e()]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"table-left"},[_vm._v("Outros rendimentos e ganhos")]),_vm._v(" "),_c('td',{attrs:{"colspan":_vm.editedItem.anos2 ? '1' : '4'}},[_c('v-edit-dialog',{attrs:{"return-value":_vm.VALUES.T1A.outrosrendimentosganhos},on:{"update:returnValue":function($event){return _vm.$set(_vm.VALUES.T1A, "outrosrendimentosganhos", $event)},"update:return-value":function($event){return _vm.$set(_vm.VALUES.T1A, "outrosrendimentosganhos", $event)}},scopedSlots:_vm._u([{key:"input",fn:function(){return [_c('v-text-field',{attrs:{"type":"number","min":"0","step":".1","color":"#969462","single-line":""},model:{value:(_vm.VALUES.T1A.outrosrendimentosganhos),callback:function ($$v) {_vm.$set(_vm.VALUES.T1A, "outrosrendimentosganhos", $$v)},expression:"VALUES.T1A.outrosrendimentosganhos"}})]},proxy:true}],null,false,2527732628)},[_vm._v("\r\n                                                "+_vm._s(_vm.numberWithSpaces(_vm.VALUES.T1A.outrosrendimentosganhos) || '-')+"\r\n                                                ")])],1),_vm._v(" "),(_vm.editedItem.anos2)?_c('td',[_c('v-edit-dialog',{attrs:{"return-value":_vm.VALUES.T1B.outrosrendimentosganhos},on:{"update:returnValue":function($event){return _vm.$set(_vm.VALUES.T1B, "outrosrendimentosganhos", $event)},"update:return-value":function($event){return _vm.$set(_vm.VALUES.T1B, "outrosrendimentosganhos", $event)}},scopedSlots:_vm._u([{key:"input",fn:function(){return [_c('v-text-field',{attrs:{"type":"number","min":"0","step":".1","color":"#969462","single-line":""},model:{value:(_vm.VALUES.T1B.outrosrendimentosganhos),callback:function ($$v) {_vm.$set(_vm.VALUES.T1B, "outrosrendimentosganhos", $$v)},expression:"VALUES.T1B.outrosrendimentosganhos"}})]},proxy:true}],null,false,1512835959)},[_vm._v("\r\n                                                "+_vm._s(_vm.numberWithSpaces(_vm.VALUES.T1B.outrosrendimentosganhos) || '-')+"\r\n                                                ")])],1):_vm._e(),_vm._v(" "),(_vm.editedItem.anos2)?_c('td',[_vm._v(_vm._s(_vm.numberWithSpaces(_vm.getDiffT1('outrosrendimentosganhos').replace('-',''))))]):_vm._e(),_vm._v(" "),(_vm.editedItem.anos2)?_c('td',[_vm._v(_vm._s(_vm.getPercentT1('outrosrendimentosganhos')))]):_vm._e()]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"table-left"},[_vm._v("Outros gastos e perdas")]),_vm._v(" "),_c('td',{attrs:{"colspan":_vm.editedItem.anos2 ? '1' : '4'}},[_c('v-edit-dialog',{attrs:{"return-value":_vm.VALUES.T1A.outrosgastosperdas},on:{"update:returnValue":function($event){return _vm.$set(_vm.VALUES.T1A, "outrosgastosperdas", $event)},"update:return-value":function($event){return _vm.$set(_vm.VALUES.T1A, "outrosgastosperdas", $event)}},scopedSlots:_vm._u([{key:"input",fn:function(){return [_c('v-text-field',{attrs:{"type":"number","min":"0","step":".1","color":"#969462","single-line":""},model:{value:(_vm.VALUES.T1A.outrosgastosperdas),callback:function ($$v) {_vm.$set(_vm.VALUES.T1A, "outrosgastosperdas", $$v)},expression:"VALUES.T1A.outrosgastosperdas"}})]},proxy:true}],null,false,2399868542)},[_vm._v("\r\n                                                "+_vm._s(_vm.numberWithSpaces(_vm.VALUES.T1A.outrosgastosperdas) || '-')+"\r\n                                                ")])],1),_vm._v(" "),(_vm.editedItem.anos2)?_c('td',[_c('v-edit-dialog',{attrs:{"return-value":_vm.VALUES.T1B.outrosgastosperdas},on:{"update:returnValue":function($event){return _vm.$set(_vm.VALUES.T1B, "outrosgastosperdas", $event)},"update:return-value":function($event){return _vm.$set(_vm.VALUES.T1B, "outrosgastosperdas", $event)}},scopedSlots:_vm._u([{key:"input",fn:function(){return [_c('v-text-field',{attrs:{"type":"number","min":"0","step":".1","color":"#969462","single-line":""},model:{value:(_vm.VALUES.T1B.outrosgastosperdas),callback:function ($$v) {_vm.$set(_vm.VALUES.T1B, "outrosgastosperdas", $$v)},expression:"VALUES.T1B.outrosgastosperdas"}})]},proxy:true}],null,false,1612331965)},[_vm._v("\r\n                                                "+_vm._s(_vm.numberWithSpaces(_vm.VALUES.T1B.outrosgastosperdas) || '-')+"\r\n                                                ")])],1):_vm._e(),_vm._v(" "),(_vm.editedItem.anos2)?_c('td',[_vm._v(_vm._s(_vm.numberWithSpaces(_vm.getDiffT1('outrosgastosperdas').replace('-',''))))]):_vm._e(),_vm._v(" "),(_vm.editedItem.anos2)?_c('td',[_vm._v(_vm._s(_vm.getPercentT1('outrosgastosperdas')))]):_vm._e()]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"table-right bold-up"},[_vm._v("Resultados antes de depreciações, gastos de financiamento e impostos")]),_vm._v(" "),_c('td',{staticClass:"bold-up",attrs:{"colspan":_vm.editedItem.anos2 ? '1' : '4'}},[_c('b',[_vm._v(_vm._s(_vm.numberWithSpaces(_vm.T1T1A)))])]),_vm._v(" "),(_vm.editedItem.anos2)?_c('td',{staticClass:"bold-up"},[_c('b',[_vm._v(_vm._s(_vm.numberWithSpaces(_vm.T1T1B)))])]):_vm._e(),_vm._v(" "),(_vm.editedItem.anos2)?_c('td',[_vm._v(_vm._s(_vm.numberWithSpaces(_vm.getDiffTotal('1'))))]):_vm._e(),_vm._v(" "),(_vm.editedItem.anos2)?_c('td',[_vm._v(_vm._s((_vm.getPercentTotal('1'))))]):_vm._e()]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"table-left"},[_vm._v("Gastos/reversões de depreciação")]),_vm._v(" "),_c('td',{attrs:{"colspan":_vm.editedItem.anos2 ? '1' : '4'}},[_c('v-edit-dialog',{attrs:{"return-value":_vm.VALUES.T1A.gastosreversoesdepreciacao},on:{"update:returnValue":function($event){return _vm.$set(_vm.VALUES.T1A, "gastosreversoesdepreciacao", $event)},"update:return-value":function($event){return _vm.$set(_vm.VALUES.T1A, "gastosreversoesdepreciacao", $event)}},scopedSlots:_vm._u([{key:"input",fn:function(){return [_c('v-text-field',{attrs:{"type":"number","min":"0","step":".1","color":"#969462","single-line":""},model:{value:(_vm.VALUES.T1A.gastosreversoesdepreciacao),callback:function ($$v) {_vm.$set(_vm.VALUES.T1A, "gastosreversoesdepreciacao", $$v)},expression:"VALUES.T1A.gastosreversoesdepreciacao"}})]},proxy:true}],null,false,339016179)},[_vm._v("\r\n                                                "+_vm._s(_vm.numberWithSpaces(_vm.VALUES.T1A.gastosreversoesdepreciacao) || '-')+"\r\n                                                ")])],1),_vm._v(" "),(_vm.editedItem.anos2)?_c('td',[_c('v-edit-dialog',{attrs:{"return-value":_vm.VALUES.T1B.gastosreversoesdepreciacao},on:{"update:returnValue":function($event){return _vm.$set(_vm.VALUES.T1B, "gastosreversoesdepreciacao", $event)},"update:return-value":function($event){return _vm.$set(_vm.VALUES.T1B, "gastosreversoesdepreciacao", $event)}},scopedSlots:_vm._u([{key:"input",fn:function(){return [_c('v-text-field',{attrs:{"type":"number","min":"0","step":".1","color":"#969462","single-line":""},model:{value:(_vm.VALUES.T1B.gastosreversoesdepreciacao),callback:function ($$v) {_vm.$set(_vm.VALUES.T1B, "gastosreversoesdepreciacao", $$v)},expression:"VALUES.T1B.gastosreversoesdepreciacao"}})]},proxy:true}],null,false,1261331504)},[_vm._v("\r\n                                                "+_vm._s(_vm.numberWithSpaces(_vm.VALUES.T1B.gastosreversoesdepreciacao) || '-')+"\r\n                                                ")])],1):_vm._e(),_vm._v(" "),(_vm.editedItem.anos2)?_c('td',[_vm._v(_vm._s(_vm.numberWithSpaces(_vm.getDiffT1('gastosreversoesdepreciacao').replace('-',''))))]):_vm._e(),_vm._v(" "),(_vm.editedItem.anos2)?_c('td',[_vm._v(_vm._s(_vm.getPercentT1('gastosreversoesdepreciacao')))]):_vm._e()]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"table-left"},[_vm._v("Gastos/reversões de amortização")]),_vm._v(" "),_c('td',{attrs:{"colspan":_vm.editedItem.anos2 ? '1' : '4'}},[_c('v-edit-dialog',{attrs:{"return-value":_vm.VALUES.T1A.gastosreversoesdeamortizacao},on:{"update:returnValue":function($event){return _vm.$set(_vm.VALUES.T1A, "gastosreversoesdeamortizacao", $event)},"update:return-value":function($event){return _vm.$set(_vm.VALUES.T1A, "gastosreversoesdeamortizacao", $event)}},scopedSlots:_vm._u([{key:"input",fn:function(){return [_c('v-text-field',{attrs:{"type":"number","min":"0","step":".1","color":"#969462","single-line":""},model:{value:(_vm.VALUES.T1A.gastosreversoesdeamortizacao),callback:function ($$v) {_vm.$set(_vm.VALUES.T1A, "gastosreversoesdeamortizacao", $$v)},expression:"VALUES.T1A.gastosreversoesdeamortizacao"}})]},proxy:true}],null,false,687221928)},[_vm._v("\r\n                                                "+_vm._s(_vm.numberWithSpaces(_vm.VALUES.T1A.gastosreversoesdeamortizacao) || '-')+"\r\n                                                ")])],1),_vm._v(" "),(_vm.editedItem.anos2)?_c('td',[_c('v-edit-dialog',{attrs:{"return-value":_vm.VALUES.T1B.gastosreversoesdeamortizacao},on:{"update:returnValue":function($event){return _vm.$set(_vm.VALUES.T1B, "gastosreversoesdeamortizacao", $event)},"update:return-value":function($event){return _vm.$set(_vm.VALUES.T1B, "gastosreversoesdeamortizacao", $event)}},scopedSlots:_vm._u([{key:"input",fn:function(){return [_c('v-text-field',{attrs:{"type":"number","min":"0","step":".1","color":"#969462","single-line":""},model:{value:(_vm.VALUES.T1B.gastosreversoesdeamortizacao),callback:function ($$v) {_vm.$set(_vm.VALUES.T1B, "gastosreversoesdeamortizacao", $$v)},expression:"VALUES.T1B.gastosreversoesdeamortizacao"}})]},proxy:true}],null,false,2340969579)},[_vm._v("\r\n                                                "+_vm._s(_vm.numberWithSpaces(_vm.VALUES.T1B.gastosreversoesdeamortizacao) || '-')+"\r\n                                                ")])],1):_vm._e(),_vm._v(" "),(_vm.editedItem.anos2)?_c('td',[_vm._v(_vm._s(_vm.numberWithSpaces(_vm.getDiffT1('gastosreversoesdeamortizacao').replace('-',''))))]):_vm._e(),_vm._v(" "),(_vm.editedItem.anos2)?_c('td',[_vm._v(_vm._s(_vm.getPercentT1('gastosreversoesdeamortizacao')))]):_vm._e()]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"table-right bold-up"},[_vm._v("Resultado operacional (antes de gastos de financiamento e impostos)")]),_vm._v(" "),_c('td',{staticClass:"bold-up",attrs:{"colspan":_vm.editedItem.anos2 ? '1' : '4'}},[_c('b',[_vm._v(_vm._s(_vm.numberWithSpaces(_vm.T1T2A)))])]),_vm._v(" "),(_vm.editedItem.anos2)?_c('td',{staticClass:"bold-up"},[_c('b',[_vm._v(_vm._s(_vm.numberWithSpaces(_vm.T1T2B)))])]):_vm._e(),_vm._v(" "),(_vm.editedItem.anos2)?_c('td',[_vm._v(_vm._s(_vm.numberWithSpaces(_vm.getDiffTotal('2'))))]):_vm._e(),_vm._v(" "),(_vm.editedItem.anos2)?_c('td',[_vm._v(_vm._s((_vm.getPercentTotal('2'))))]):_vm._e()]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"table-left"},[_vm._v("Gasto líquido de financiamento")]),_vm._v(" "),_c('td',{attrs:{"colspan":_vm.editedItem.anos2 ? '1' : '4'}},[_c('v-edit-dialog',{attrs:{"return-value":_vm.VALUES.T1A.gastoliquidofinanciamento},on:{"update:returnValue":function($event){return _vm.$set(_vm.VALUES.T1A, "gastoliquidofinanciamento", $event)},"update:return-value":function($event){return _vm.$set(_vm.VALUES.T1A, "gastoliquidofinanciamento", $event)}},scopedSlots:_vm._u([{key:"input",fn:function(){return [_c('v-text-field',{attrs:{"type":"number","min":"0","step":".1","color":"#969462","single-line":""},model:{value:(_vm.VALUES.T1A.gastoliquidofinanciamento),callback:function ($$v) {_vm.$set(_vm.VALUES.T1A, "gastoliquidofinanciamento", $$v)},expression:"VALUES.T1A.gastoliquidofinanciamento"}})]},proxy:true}],null,false,2829258087)},[_vm._v("\r\n                                                "+_vm._s(_vm.numberWithSpaces(_vm.VALUES.T1A.gastoliquidofinanciamento) || '-')+"\r\n                                                ")])],1),_vm._v(" "),(_vm.editedItem.anos2)?_c('td',[_c('v-edit-dialog',{attrs:{"return-value":_vm.VALUES.T1B.gastoliquidofinanciamento},on:{"update:returnValue":function($event){return _vm.$set(_vm.VALUES.T1B, "gastoliquidofinanciamento", $event)},"update:return-value":function($event){return _vm.$set(_vm.VALUES.T1B, "gastoliquidofinanciamento", $event)}},scopedSlots:_vm._u([{key:"input",fn:function(){return [_c('v-text-field',{attrs:{"type":"number","min":"0","step":".1","color":"#969462","single-line":""},model:{value:(_vm.VALUES.T1B.gastoliquidofinanciamento),callback:function ($$v) {_vm.$set(_vm.VALUES.T1B, "gastoliquidofinanciamento", $$v)},expression:"VALUES.T1B.gastoliquidofinanciamento"}})]},proxy:true}],null,false,3395845124)},[_vm._v("\r\n                                                "+_vm._s(_vm.numberWithSpaces(_vm.VALUES.T1B.gastoliquidofinanciamento) || '-')+"\r\n                                                ")])],1):_vm._e(),_vm._v(" "),(_vm.editedItem.anos2)?_c('td',[_vm._v(_vm._s(_vm.numberWithSpaces(_vm.getDiffT1('gastoliquidofinanciamento').replace('-',''))))]):_vm._e(),_vm._v(" "),(_vm.editedItem.anos2)?_c('td',[_vm._v(_vm._s(_vm.getPercentT1('gastoliquidofinanciamento')))]):_vm._e()]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"table-right bold-up"},[_vm._v("Resultado antes de impostos")]),_vm._v(" "),_c('td',{staticClass:"bold-up",attrs:{"colspan":_vm.editedItem.anos2 ? '1' : '4'}},[_c('b',[_vm._v(_vm._s(_vm.numberWithSpaces(_vm.T1T3A)))])]),_vm._v(" "),(_vm.editedItem.anos2)?_c('td',{staticClass:"bold-up"},[_c('b',[_vm._v(_vm._s(_vm.numberWithSpaces(_vm.T1T3B)))])]):_vm._e(),_vm._v(" "),(_vm.editedItem.anos2)?_c('td',[_vm._v(_vm._s(_vm.numberWithSpaces(_vm.getDiffTotal('3'))))]):_vm._e(),_vm._v(" "),(_vm.editedItem.anos2)?_c('td',[_vm._v(_vm._s((_vm.getPercentTotal('3'))))]):_vm._e()]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"table-left"},[_vm._v("Imposto sobre o rendimento do período")]),_vm._v(" "),_c('td',{attrs:{"colspan":_vm.editedItem.anos2 ? '1' : '4'}},[_c('v-edit-dialog',{attrs:{"return-value":_vm.VALUES.T1A.impostosrp},on:{"update:returnValue":function($event){return _vm.$set(_vm.VALUES.T1A, "impostosrp", $event)},"update:return-value":function($event){return _vm.$set(_vm.VALUES.T1A, "impostosrp", $event)}},scopedSlots:_vm._u([{key:"input",fn:function(){return [_c('v-text-field',{attrs:{"type":"number","min":"0","step":".1","color":"#969462","single-line":""},on:{"change":_vm.changeP21},model:{value:(_vm.VALUES.T1A.impostosrp),callback:function ($$v) {_vm.$set(_vm.VALUES.T1A, "impostosrp", $$v)},expression:"VALUES.T1A.impostosrp"}})]},proxy:true}],null,false,1614979240)},[_vm._v("\r\n                                                "+_vm._s(_vm.numberWithSpaces(_vm.VALUES.T1A.impostosrp) || '-')+"\r\n                                                ")])],1),_vm._v(" "),(_vm.editedItem.anos2)?_c('td',[_c('v-edit-dialog',{attrs:{"return-value":_vm.VALUES.T1B.impostosrp},on:{"update:returnValue":function($event){return _vm.$set(_vm.VALUES.T1B, "impostosrp", $event)},"update:return-value":function($event){return _vm.$set(_vm.VALUES.T1B, "impostosrp", $event)}},scopedSlots:_vm._u([{key:"input",fn:function(){return [_vm._v("=\"number\" min=\"0\" step=\".1\" color=\"#969462\" v-model=\"VALUES.T1B.impostosrp\" single-line>")]},proxy:true}],null,false,3999759380)},[_vm._v("\r\n                                                "+_vm._s(_vm.numberWithSpaces(_vm.VALUES.T1B.impostosrp) || '-')+"\r\n                                                ")])],1):_vm._e(),_vm._v(" "),(_vm.editedItem.anos2)?_c('td',[_vm._v(_vm._s(_vm.numberWithSpaces(_vm.getDiffT1('impostosrp').replace('-',''))))]):_vm._e(),_vm._v(" "),(_vm.editedItem.anos2)?_c('td',[_vm._v(_vm._s(_vm.getPercentT1('impostosrp')))]):_vm._e()]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"table-right bold-up"},[_vm._v("Resultado líquido do período")]),_vm._v(" "),_c('td',{staticClass:"bold-up",attrs:{"colspan":_vm.editedItem.anos2 ? '1' : '4'}},[_c('b',[_vm._v(_vm._s(_vm.numberWithSpaces(_vm.T1T4A)))])]),_vm._v(" "),(_vm.editedItem.anos2)?_c('td',{staticClass:"bold-up"},[_c('b',[_vm._v(_vm._s(_vm.numberWithSpaces(_vm.T1T4B)))])]):_vm._e(),_vm._v(" "),(_vm.editedItem.anos2)?_c('td',[_vm._v(_vm._s(_vm.numberWithSpaces(_vm.getDiffTotal('4'))))]):_vm._e(),_vm._v(" "),(_vm.editedItem.anos2)?_c('td',[_vm._v(_vm._s((_vm.getPercentTotal('4'))))]):_vm._e()])])])]),_vm._v(" "),_c('v-flex',{attrs:{"xs5":"","sm5":"","md5":"","pb-5":""}},[((_vm.VALUES.CH1.MESES.length + _vm.VALUES.CH1.EMV.length + _vm.VALUES.CH1.CMVMC.length + _vm.VALUES.CH1.MB.length) > 0)?_c('div',{attrs:{"id":"CH1"}},[_c('Chart1',{attrs:{"MESES":_vm.VALUES.CH1.MESES,"EMV":_vm.VALUES.CH1.EMV,"CMVMC":_vm.VALUES.CH1.CMVMC,"MB":_vm.VALUES.CH1.MB}})],1):_vm._e()]),_vm._v(" "),_c('v-flex',{attrs:{"xs5":"","sm5":"","md5":"","pl-5":"","pb-5":""}},[((_vm.VALUES.CH2.MESES.length + _vm.VALUES.CH2.FSEM.length + _vm.VALUES.CH2.OG.length + _vm.VALUES.CH2.MB.length) > 0)?_c('div',{attrs:{"id":"CH2"}},[_c('Chart2',{attrs:{"MESES":_vm.VALUES.CH2.MESES,"FSEM":_vm.VALUES.CH2.FSEM,"OG":_vm.VALUES.CH2.OG,"MB":_vm.VALUES.CH2.MB}})],1):_vm._e()]),_vm._v(" "),_c('v-flex',{attrs:{"xs5":"","sm5":"","md5":"","pb-5":""}},[((_vm.VALUES.CH3.MESES.length + _vm.VALUES.CH3.FSEM.length + _vm.VALUES.CH3.OG.length + _vm.VALUES.CH3.FSE.length) > 0)?_c('div',{attrs:{"id":"CH3"}},[_c('Chart3',{attrs:{"MESES":_vm.VALUES.CH3.MESES,"FSEM":_vm.VALUES.CH3.FSEM,"FSE":_vm.VALUES.CH3.FSE,"OG":_vm.VALUES.CH3.OG}})],1):_vm._e()]),_vm._v(" "),_c('v-flex',{attrs:{"xs5":"","sm5":"","md5":"","pl-5":"","pb-5":""}},[((_vm.VALUES.CH4.MESES.length + _vm.VALUES.CH4.C6869.length + _vm.VALUES.CH4.C68.length + _vm.VALUES.CH4.C69.length) > 0)?_c('div',{attrs:{"id":"CH4"}},[_c('Chart4',{attrs:{"MESES":_vm.VALUES.CH4.MESES,"C6869":_vm.VALUES.CH4.C6869,"C68":_vm.VALUES.CH4.C68,"C69":_vm.VALUES.CH4.C69}})],1):_vm._e()]),_vm._v(" "),_c('v-flex',{attrs:{"xs5":"","sm5":"","md5":"","pb-5":""}},[((_vm.VALUES.CH5.ORDEM.length + _vm.VALUES.CH5.G.length) > 0)?_c('div',{attrs:{"id":"CH5"}},[_c('Chart5',{attrs:{"ORDEM":_vm.VALUES.CH5.ORDEM,"G":_vm.VALUES.CH5.G}})],1):_vm._e()]),_vm._v(" "),_c('v-flex',{attrs:{"xs5":"","sm5":"","md5":"","pl-5":"","pb-5":""}},[((_vm.VALUES.CH5.ORDEM.length + _vm.VALUES.CH5.G.length) > 0)?_c('div',{attrs:{"id":"T2"}},[_c('table',{staticStyle:{"text-align":"right"},attrs:{"width":"100%"}},[_c('tr',[_c('th',{staticClass:"table-left bold-up"},[_vm._v("Ranking decrescente dos gastos")]),_vm._v(" "),_c('th',{staticClass:"bold-up"},[_vm._v("Valor")])]),_vm._v(" "),_vm._l((_vm.VALUES.CH5.TABELA),function(item,i){return _c('tr',{key:i},[_c('td',{staticClass:"table-left"},[_vm._v(_vm._s(item.ordem)+" - "+_vm._s(item.conta))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.numberWithSpaces(parseFloat(item.saldo.replace(',','.')).toFixed(2)))+" €")])])}),_vm._v(" "),_c('tr',[_c('th',{staticClass:"table-left bold-up"},[_vm._v("Total")]),_vm._v(" "),_c('th',{staticClass:"bold-up"},[_vm._v(_vm._s(_vm.numberWithSpaces(_vm.getTotalByProperty(_vm.VALUES.CH5.TABELA, 'saldo'))))])])],2)]):_vm._e()]),_vm._v(" "),_c('v-flex',{attrs:{"xs10":"","sm10":"","md10":"","pb-5":""}},[_c('div',{attrs:{"id":"T3"}},[_c('table',{staticStyle:{"text-align":"right"},attrs:{"width":"100%"}},[_c('tr',[_c('th',{staticClass:"bold-up",attrs:{"width":"30%"}},[_vm._v("Rubricas")]),_vm._v(" "),_c('th',{staticClass:"bold-up",attrs:{"width":"20%","colspan":"2"}},[_vm._v("Períodos")]),_vm._v(" "),_c('th',{staticClass:"bold-up",attrs:{"width":"30%"}},[_vm._v("Rubricas")]),_vm._v(" "),_c('th',{staticClass:"bold-up",attrs:{"width":"20%","colspan":"2"}},[_vm._v("Períodos")])]),_vm._v(" "),_c('tr',[_c('th'),_vm._v(" "),_c('th',{staticClass:"bold-up",attrs:{"colspan":_vm.editedItem.anos2 ? '1' : '2',"width":"10%"}},[_vm._v(_vm._s(Number(_vm.ano)))]),_vm._v(" "),(_vm.editedItem.anos2)?_c('th',{staticClass:"bold-up",attrs:{"width":"10%"}},[_vm._v(_vm._s((Number(_vm.ano) - 1)))]):_vm._e(),_vm._v(" "),_c('th'),_vm._v(" "),_c('th',{staticClass:"bold-up",attrs:{"colspan":_vm.editedItem.anos2 ? '1' : '2',"width":"10%"}},[_vm._v(_vm._s(Number(_vm.ano)))]),_vm._v(" "),(_vm.editedItem.anos2)?_c('th',{staticClass:"bold-up",attrs:{"width":"10%"}},[_vm._v(_vm._s((Number(_vm.ano) - 1)))]):_vm._e()]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"table-left bold-up",staticStyle:{"text-align":"center !important"},attrs:{"colspan":"3"}},[_vm._v("Ativo")]),_vm._v(" "),_c('td',{staticClass:"table-left bold-up",staticStyle:{"text-align":"center !important"},attrs:{"colspan":"3"}},[_vm._v("Capital próprio e passivo")])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"table-left bold-up",attrs:{"colspan":"3"}},[_vm._v("Ativo não corrente")]),_vm._v(" "),_c('td',{staticClass:"table-left bold-up",attrs:{"colspan":"3"}},[_vm._v("Capital próprio")])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"table-left"},[_vm._v("Ativos fixos tangíveis")]),_vm._v(" "),_c('td',{attrs:{"colspan":_vm.editedItem.anos2 ? '1' : '2'}},[_c('v-edit-dialog',{attrs:{"return-value":_vm.AtivosTangiveisA},on:{"update:returnValue":function($event){_vm.AtivosTangiveisA=$event},"update:return-value":function($event){_vm.AtivosTangiveisA=$event}},scopedSlots:_vm._u([{key:"input",fn:function(){return [_c('v-text-field',{attrs:{"type":"number","min":"0","step":".1","color":"#969462","single-line":""},model:{value:(_vm.AtivosTangiveisA),callback:function ($$v) {_vm.AtivosTangiveisA=$$v},expression:"AtivosTangiveisA"}})]},proxy:true}],null,false,1964598801)},[_vm._v("\r\n                                                "+_vm._s(_vm.numberWithSpaces(_vm.AtivosTangiveisA) || '-')+"\r\n                                                ")])],1),_vm._v(" "),(_vm.editedItem.anos2)?_c('td',[_c('v-edit-dialog',{attrs:{"return-value":_vm.AtivosTangiveisB},on:{"update:returnValue":function($event){_vm.AtivosTangiveisB=$event},"update:return-value":function($event){_vm.AtivosTangiveisB=$event}},scopedSlots:_vm._u([{key:"input",fn:function(){return [_c('v-text-field',{attrs:{"type":"number","min":"0","step":".1","color":"#969462","single-line":""},model:{value:(_vm.AtivosTangiveisB),callback:function ($$v) {_vm.AtivosTangiveisB=$$v},expression:"AtivosTangiveisB"}})]},proxy:true}],null,false,2517177362)},[_vm._v("\r\n                                                "+_vm._s(_vm.numberWithSpaces(_vm.AtivosTangiveisB) || '-')+"\r\n                                                ")])],1):_vm._e(),_vm._v(" "),_c('td',{staticClass:"table-left"},[_vm._v("Capital realizado")]),_vm._v(" "),_c('td',{attrs:{"colspan":_vm.editedItem.anos2 ? '1' : '2'}},[_c('v-edit-dialog',{attrs:{"return-value":_vm.VALUES.T3A.capitalrealizado},on:{"update:returnValue":function($event){return _vm.$set(_vm.VALUES.T3A, "capitalrealizado", $event)},"update:return-value":function($event){return _vm.$set(_vm.VALUES.T3A, "capitalrealizado", $event)}},scopedSlots:_vm._u([{key:"input",fn:function(){return [_c('v-text-field',{attrs:{"type":"number","min":"0","step":".1","color":"#969462","single-line":""},model:{value:(_vm.VALUES.T3A.capitalrealizado),callback:function ($$v) {_vm.$set(_vm.VALUES.T3A, "capitalrealizado", $$v)},expression:"VALUES.T3A.capitalrealizado"}})]},proxy:true}],null,false,1277129553)},[_vm._v("\r\n                                                "+_vm._s(_vm.numberWithSpaces(_vm.VALUES.T3A.capitalrealizado) || '-')+"\r\n                                                ")])],1),_vm._v(" "),(_vm.editedItem.anos2)?_c('td',[_c('v-edit-dialog',{attrs:{"return-value":_vm.VALUES.T3B.capitalrealizado},on:{"update:returnValue":function($event){return _vm.$set(_vm.VALUES.T3B, "capitalrealizado", $event)},"update:return-value":function($event){return _vm.$set(_vm.VALUES.T3B, "capitalrealizado", $event)}},scopedSlots:_vm._u([{key:"input",fn:function(){return [_c('v-text-field',{attrs:{"type":"number","min":"0","step":".1","color":"#969462","single-line":""},model:{value:(_vm.VALUES.T3B.capitalrealizado),callback:function ($$v) {_vm.$set(_vm.VALUES.T3B, "capitalrealizado", $$v)},expression:"VALUES.T3B.capitalrealizado"}})]},proxy:true}],null,false,4013277394)},[_vm._v("\r\n                                                "+_vm._s(_vm.numberWithSpaces(_vm.VALUES.T3B.capitalrealizado) || '-')+"\r\n                                                ")])],1):_vm._e()]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"table-left"},[_vm._v("Ativos intangíveis")]),_vm._v(" "),_c('td',{attrs:{"colspan":_vm.editedItem.anos2 ? '1' : '2'}},[_c('v-edit-dialog',{attrs:{"return-value":_vm.AtivosIntangiveisA},on:{"update:returnValue":function($event){_vm.AtivosIntangiveisA=$event},"update:return-value":function($event){_vm.AtivosIntangiveisA=$event}},scopedSlots:_vm._u([{key:"input",fn:function(){return [_c('v-text-field',{attrs:{"type":"number","min":"0","step":".1","color":"#969462","single-line":""},model:{value:(_vm.AtivosIntangiveisA),callback:function ($$v) {_vm.AtivosIntangiveisA=$$v},expression:"AtivosIntangiveisA"}})]},proxy:true}],null,false,1378298422)},[_vm._v("\r\n                                                "+_vm._s(_vm.numberWithSpaces(_vm.AtivosIntangiveisA) || '-')+"\r\n                                                ")])],1),_vm._v(" "),(_vm.editedItem.anos2)?_c('td',[_c('v-edit-dialog',{attrs:{"return-value":_vm.AtivosIntangiveisB},on:{"update:returnValue":function($event){_vm.AtivosIntangiveisB=$event},"update:return-value":function($event){_vm.AtivosIntangiveisB=$event}},scopedSlots:_vm._u([{key:"input",fn:function(){return [_c('v-text-field',{attrs:{"type":"number","min":"0","step":".1","color":"#969462","single-line":""},model:{value:(_vm.AtivosIntangiveisB),callback:function ($$v) {_vm.AtivosIntangiveisB=$$v},expression:"AtivosIntangiveisB"}})]},proxy:true}],null,false,4277355829)},[_vm._v("\r\n                                                "+_vm._s(_vm.numberWithSpaces(_vm.AtivosIntangiveisB) || '-')+"\r\n                                                ")])],1):_vm._e(),_vm._v(" "),_c('td',{staticClass:"table-left"},[_vm._v("Outros instrumentos de capital próprio")]),_vm._v(" "),_c('td',{attrs:{"colspan":_vm.editedItem.anos2 ? '1' : '2'}},[_c('v-edit-dialog',{attrs:{"return-value":_vm.VALUES.T3A.outrosintrumentoscapitalproprio},on:{"update:returnValue":function($event){return _vm.$set(_vm.VALUES.T3A, "outrosintrumentoscapitalproprio", $event)},"update:return-value":function($event){return _vm.$set(_vm.VALUES.T3A, "outrosintrumentoscapitalproprio", $event)}},scopedSlots:_vm._u([{key:"input",fn:function(){return [_c('v-text-field',{attrs:{"type":"number","min":"0","step":".1","color":"#969462","single-line":""},model:{value:(_vm.VALUES.T3A.outrosintrumentoscapitalproprio),callback:function ($$v) {_vm.$set(_vm.VALUES.T3A, "outrosintrumentoscapitalproprio", $$v)},expression:"VALUES.T3A.outrosintrumentoscapitalproprio"}})]},proxy:true}],null,false,1248085569)},[_vm._v("\r\n                                                "+_vm._s(_vm.numberWithSpaces(_vm.VALUES.T3A.outrosintrumentoscapitalproprio) || '-')+"\r\n                                                ")])],1),_vm._v(" "),(_vm.editedItem.anos2)?_c('td',[_c('v-edit-dialog',{attrs:{"return-value":_vm.VALUES.T3B.outrosintrumentoscapitalproprio},on:{"update:returnValue":function($event){return _vm.$set(_vm.VALUES.T3B, "outrosintrumentoscapitalproprio", $event)},"update:return-value":function($event){return _vm.$set(_vm.VALUES.T3B, "outrosintrumentoscapitalproprio", $event)}},scopedSlots:_vm._u([{key:"input",fn:function(){return [_c('v-text-field',{attrs:{"type":"number","min":"0","step":".1","color":"#969462","single-line":""},model:{value:(_vm.VALUES.T3B.outrosintrumentoscapitalproprio),callback:function ($$v) {_vm.$set(_vm.VALUES.T3B, "outrosintrumentoscapitalproprio", $$v)},expression:"VALUES.T3B.outrosintrumentoscapitalproprio"}})]},proxy:true}],null,false,774263330)},[_vm._v("\r\n                                                "+_vm._s(_vm.numberWithSpaces(_vm.VALUES.T3B.outrosintrumentoscapitalproprio) || '-')+"\r\n                                                ")])],1):_vm._e()]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"table-left"},[_vm._v("Investimentos financeiros")]),_vm._v(" "),_c('td',{attrs:{"colspan":_vm.editedItem.anos2 ? '1' : '2'}},[_c('v-edit-dialog',{attrs:{"return-value":_vm.VALUES.T3A.investimentosfinanceiros},on:{"update:returnValue":function($event){return _vm.$set(_vm.VALUES.T3A, "investimentosfinanceiros", $event)},"update:return-value":function($event){return _vm.$set(_vm.VALUES.T3A, "investimentosfinanceiros", $event)}},scopedSlots:_vm._u([{key:"input",fn:function(){return [_c('v-text-field',{attrs:{"type":"number","min":"0","step":".1","color":"#969462","single-line":""},model:{value:(_vm.VALUES.T3A.investimentosfinanceiros),callback:function ($$v) {_vm.$set(_vm.VALUES.T3A, "investimentosfinanceiros", $$v)},expression:"VALUES.T3A.investimentosfinanceiros"}})]},proxy:true}],null,false,1912880779)},[_vm._v("\r\n                                                "+_vm._s(_vm.numberWithSpaces(_vm.VALUES.T3A.investimentosfinanceiros) || '-')+"\r\n                                                ")])],1),_vm._v(" "),(_vm.editedItem.anos2)?_c('td',[_c('v-edit-dialog',{attrs:{"return-value":_vm.VALUES.T3B.investimentosfinanceiros},on:{"update:returnValue":function($event){return _vm.$set(_vm.VALUES.T3B, "investimentosfinanceiros", $event)},"update:return-value":function($event){return _vm.$set(_vm.VALUES.T3B, "investimentosfinanceiros", $event)}},scopedSlots:_vm._u([{key:"input",fn:function(){return [_c('v-text-field',{attrs:{"type":"number","min":"0","step":".1","color":"#969462","single-line":""},model:{value:(_vm.VALUES.T3B.investimentosfinanceiros),callback:function ($$v) {_vm.$set(_vm.VALUES.T3B, "investimentosfinanceiros", $$v)},expression:"VALUES.T3B.investimentosfinanceiros"}})]},proxy:true}],null,false,2177086344)},[_vm._v("\r\n                                                "+_vm._s(_vm.numberWithSpaces(_vm.VALUES.T3B.investimentosfinanceiros) || '-')+"\r\n                                                ")])],1):_vm._e(),_vm._v(" "),_c('td',{staticClass:"table-left"},[_vm._v("Reservas")]),_vm._v(" "),_c('td',{attrs:{"colspan":_vm.editedItem.anos2 ? '1' : '2'}},[_c('v-edit-dialog',{attrs:{"return-value":_vm.VALUES.T3A.reservas},on:{"update:returnValue":function($event){return _vm.$set(_vm.VALUES.T3A, "reservas", $event)},"update:return-value":function($event){return _vm.$set(_vm.VALUES.T3A, "reservas", $event)}},scopedSlots:_vm._u([{key:"input",fn:function(){return [_c('v-text-field',{attrs:{"type":"number","min":"0","step":".1","color":"#969462","single-line":""},model:{value:(_vm.VALUES.T3A.reservas),callback:function ($$v) {_vm.$set(_vm.VALUES.T3A, "reservas", $$v)},expression:"VALUES.T3A.reservas"}})]},proxy:true}],null,false,688341319)},[_vm._v("\r\n                                                "+_vm._s(_vm.numberWithSpaces(_vm.VALUES.T3A.reservas) || '-')+"\r\n                                                ")])],1),_vm._v(" "),(_vm.editedItem.anos2)?_c('td',[_c('v-edit-dialog',{attrs:{"return-value":_vm.VALUES.T3B.reservas},on:{"update:returnValue":function($event){return _vm.$set(_vm.VALUES.T3B, "reservas", $event)},"update:return-value":function($event){return _vm.$set(_vm.VALUES.T3B, "reservas", $event)}},scopedSlots:_vm._u([{key:"input",fn:function(){return [_c('v-text-field',{attrs:{"type":"number","min":"0","step":".1","color":"#969462","single-line":""},model:{value:(_vm.VALUES.T3B.reservas),callback:function ($$v) {_vm.$set(_vm.VALUES.T3B, "reservas", $$v)},expression:"VALUES.T3B.reservas"}})]},proxy:true}],null,false,2465160132)},[_vm._v("\r\n                                                "+_vm._s(_vm.numberWithSpaces(_vm.VALUES.T3B.reservas) || '-')+"\r\n                                                ")])],1):_vm._e()]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"table-left"},[_vm._v("Créditos e outros ativos não correntes")]),_vm._v(" "),_c('td',{attrs:{"colspan":_vm.editedItem.anos2 ? '1' : '2'}},[_c('v-edit-dialog',{attrs:{"return-value":_vm.VALUES.T3A.creditosoutrosativosnaocorrentes},on:{"update:returnValue":function($event){return _vm.$set(_vm.VALUES.T3A, "creditosoutrosativosnaocorrentes", $event)},"update:return-value":function($event){return _vm.$set(_vm.VALUES.T3A, "creditosoutrosativosnaocorrentes", $event)}},scopedSlots:_vm._u([{key:"input",fn:function(){return [_c('v-text-field',{attrs:{"type":"number","min":"0","step":".1","color":"#969462","single-line":""},model:{value:(_vm.VALUES.T3A.creditosoutrosativosnaocorrentes),callback:function ($$v) {_vm.$set(_vm.VALUES.T3A, "creditosoutrosativosnaocorrentes", $$v)},expression:"VALUES.T3A.creditosoutrosativosnaocorrentes"}})]},proxy:true}],null,false,3462109426)},[_vm._v("\r\n                                                "+_vm._s(_vm.numberWithSpaces(_vm.VALUES.T3A.creditosoutrosativosnaocorrentes) || '-')+"\r\n                                                ")])],1),_vm._v(" "),(_vm.editedItem.anos2)?_c('td',[_c('v-edit-dialog',{attrs:{"return-value":_vm.VALUES.T3B.creditosoutrosativosnaocorrentes},on:{"update:returnValue":function($event){return _vm.$set(_vm.VALUES.T3B, "creditosoutrosativosnaocorrentes", $event)},"update:return-value":function($event){return _vm.$set(_vm.VALUES.T3B, "creditosoutrosativosnaocorrentes", $event)}},scopedSlots:_vm._u([{key:"input",fn:function(){return [_c('v-text-field',{attrs:{"type":"number","min":"0","step":".1","color":"#969462","single-line":""},model:{value:(_vm.VALUES.T3B.creditosoutrosativosnaocorrentes),callback:function ($$v) {_vm.$set(_vm.VALUES.T3B, "creditosoutrosativosnaocorrentes", $$v)},expression:"VALUES.T3B.creditosoutrosativosnaocorrentes"}})]},proxy:true}],null,false,325708209)},[_vm._v("\r\n                                                "+_vm._s(_vm.numberWithSpaces(_vm.VALUES.T3B.reservas) || '-')+"\r\n                                                ")])],1):_vm._e(),_vm._v(" "),_c('td',{staticClass:"table-left"},[_vm._v("Resultados transitados")]),_vm._v(" "),_c('td',{attrs:{"colspan":_vm.editedItem.anos2 ? '1' : '2'}},[_c('v-edit-dialog',{attrs:{"return-value":_vm.VALUES.T3A.resultadostransitados},on:{"update:returnValue":function($event){return _vm.$set(_vm.VALUES.T3A, "resultadostransitados", $event)},"update:return-value":function($event){return _vm.$set(_vm.VALUES.T3A, "resultadostransitados", $event)}},scopedSlots:_vm._u([{key:"input",fn:function(){return [_c('v-text-field',{attrs:{"type":"number","min":"0","step":".1","color":"#969462","single-line":""},model:{value:(_vm.VALUES.T3A.resultadostransitados),callback:function ($$v) {_vm.$set(_vm.VALUES.T3A, "resultadostransitados", $$v)},expression:"VALUES.T3A.resultadostransitados"}})]},proxy:true}],null,false,1805178750)},[_vm._v("\r\n                                                "+_vm._s(_vm.numberWithSpaces(_vm.VALUES.T3A.resultadostransitados) || '-')+"\r\n                                                ")])],1),_vm._v(" "),(_vm.editedItem.anos2)?_c('td',[_c('v-edit-dialog',{attrs:{"return-value":_vm.VALUES.T3B.resultadostransitados},on:{"update:returnValue":function($event){return _vm.$set(_vm.VALUES.T3B, "resultadostransitados", $event)},"update:return-value":function($event){return _vm.$set(_vm.VALUES.T3B, "resultadostransitados", $event)}},scopedSlots:_vm._u([{key:"input",fn:function(){return [_c('v-text-field',{attrs:{"type":"number","min":"0","step":".1","color":"#969462","single-line":""},model:{value:(_vm.VALUES.T3B.resultadostransitados),callback:function ($$v) {_vm.$set(_vm.VALUES.T3B, "resultadostransitados", $$v)},expression:"VALUES.T3B.resultadostransitados"}})]},proxy:true}],null,false,2094812829)},[_vm._v("\r\n                                                "+_vm._s(_vm.numberWithSpaces(_vm.VALUES.T3B.resultadostransitados) || '-')+"\r\n                                                ")])],1):_vm._e()]),_vm._v(" "),_c('tr',[_c('td'),_vm._v(" "),_c('td',{attrs:{"colspan":_vm.editedItem.anos2 ? '1' : '2'}}),_vm._v(" "),(_vm.editedItem.anos2)?_c('td'):_vm._e(),_vm._v(" "),_c('td',{staticClass:"table-left"},[_vm._v("Outras variações de capital próprio")]),_vm._v(" "),_c('td',{attrs:{"colspan":_vm.editedItem.anos2 ? '1' : '2'}},[_c('v-edit-dialog',{attrs:{"return-value":_vm.VALUES.T3A.outrasvariacoescapitalproprio},on:{"update:returnValue":function($event){return _vm.$set(_vm.VALUES.T3A, "outrasvariacoescapitalproprio", $event)},"update:return-value":function($event){return _vm.$set(_vm.VALUES.T3A, "outrasvariacoescapitalproprio", $event)}},scopedSlots:_vm._u([{key:"input",fn:function(){return [_c('v-text-field',{attrs:{"type":"number","min":"0","step":".1","color":"#969462","single-line":""},model:{value:(_vm.VALUES.T3A.outrasvariacoescapitalproprio),callback:function ($$v) {_vm.$set(_vm.VALUES.T3A, "outrasvariacoescapitalproprio", $$v)},expression:"VALUES.T3A.outrasvariacoescapitalproprio"}})]},proxy:true}],null,false,2660185186)},[_vm._v("\r\n                                                "+_vm._s(_vm.numberWithSpaces(_vm.VALUES.T3A.outrasvariacoescapitalproprio) || '-')+"\r\n                                                ")])],1),_vm._v(" "),(_vm.editedItem.anos2)?_c('td',[_c('v-edit-dialog',{attrs:{"return-value":_vm.VALUES.T3B.outrasvariacoescapitalproprio},on:{"update:returnValue":function($event){return _vm.$set(_vm.VALUES.T3B, "outrasvariacoescapitalproprio", $event)},"update:return-value":function($event){return _vm.$set(_vm.VALUES.T3B, "outrasvariacoescapitalproprio", $event)}},scopedSlots:_vm._u([{key:"input",fn:function(){return [_c('v-text-field',{attrs:{"type":"number","min":"0","step":".1","color":"#969462","single-line":""},model:{value:(_vm.VALUES.T3B.outrasvariacoescapitalproprio),callback:function ($$v) {_vm.$set(_vm.VALUES.T3B, "outrasvariacoescapitalproprio", $$v)},expression:"VALUES.T3B.outrasvariacoescapitalproprio"}})]},proxy:true}],null,false,1290049409)},[_vm._v("\r\n                                                "+_vm._s(_vm.numberWithSpaces(_vm.VALUES.T3B.outrasvariacoescapitalproprio) || '-')+"\r\n                                                ")])],1):_vm._e()]),_vm._v(" "),_c('tr',[_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td',{staticClass:"bold-up"},[_vm._v("Total")]),_vm._v(" "),_c('td',{attrs:{"colspan":_vm.editedItem.anos2 ? '1' : '2'}},[_vm._v(_vm._s(_vm.numberWithSpaces(_vm.T3T2A)))]),_vm._v(" "),(_vm.editedItem.anos2)?_c('td',[_vm._v(_vm._s(_vm.numberWithSpaces(_vm.T3T2B)))]):_vm._e()]),_vm._v(" "),_c('tr',[_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td',{staticClass:"table-left"},[_vm._v("Resultado líquido do período")]),_vm._v(" "),_c('td',{attrs:{"colspan":_vm.editedItem.anos2 ? '1' : '2'}},[_vm._v(_vm._s(_vm.numberWithSpaces(_vm.T1T4A)))]),_vm._v(" "),(_vm.editedItem.anos2)?_c('td',[_vm._v(_vm._s(_vm.numberWithSpaces(_vm.T1T4B)))]):_vm._e()]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"table-right bold-up"},[_vm._v("Total do ativo não corrente")]),_vm._v(" "),_c('td',{attrs:{"colspan":_vm.editedItem.anos2 ? '1' : '2'}},[_vm._v(_vm._s(_vm.numberWithSpaces(_vm.T3T1A)))]),_vm._v(" "),(_vm.editedItem.anos2)?_c('td',[_vm._v(_vm._s(_vm.numberWithSpaces(_vm.T3T1B)))]):_vm._e(),_vm._v(" "),_c('td',{staticClass:"table-right bold-up"},[_vm._v("Total do capital próprio")]),_vm._v(" "),_c('td',{attrs:{"colspan":_vm.editedItem.anos2 ? '1' : '2'}},[_vm._v(_vm._s(_vm.numberWithSpaces(_vm.T3T3A)))]),_vm._v(" "),(_vm.editedItem.anos2)?_c('td',[_vm._v(_vm._s(_vm.numberWithSpaces(_vm.T3T3B)))]):_vm._e()]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"table-left bold-up",attrs:{"colspan":"3"}},[_vm._v("Ativo corrente")]),_vm._v(" "),_c('td',{staticClass:"table-left bold-up"},[_c('b',[_vm._v("Passivo")])]),_vm._v(" "),_c('td'),_vm._v(" "),_c('td')]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"table-left"},[_vm._v("Inventários")]),_vm._v(" "),_c('td',{attrs:{"colspan":_vm.editedItem.anos2 ? '1' : '2'}},[_c('v-edit-dialog',{attrs:{"return-value":_vm.VALUES.T3A.inventarios},on:{"update:returnValue":function($event){return _vm.$set(_vm.VALUES.T3A, "inventarios", $event)},"update:return-value":function($event){return _vm.$set(_vm.VALUES.T3A, "inventarios", $event)}},scopedSlots:_vm._u([{key:"input",fn:function(){return [_c('v-text-field',{attrs:{"type":"number","min":"0","step":".1","color":"#969462","single-line":""},model:{value:(_vm.VALUES.T3A.inventarios),callback:function ($$v) {_vm.$set(_vm.VALUES.T3A, "inventarios", $$v)},expression:"VALUES.T3A.inventarios"}})]},proxy:true}],null,false,261155384)},[_vm._v("\r\n                                                "+_vm._s(_vm.numberWithSpaces(_vm.VALUES.T3A.inventarios) || '-')+"\r\n                                                ")])],1),_vm._v(" "),(_vm.editedItem.anos2)?_c('td',[_c('v-edit-dialog',{attrs:{"return-value":_vm.VALUES.T3B.inventarios},on:{"update:returnValue":function($event){return _vm.$set(_vm.VALUES.T3B, "inventarios", $event)},"update:return-value":function($event){return _vm.$set(_vm.VALUES.T3B, "inventarios", $event)}},scopedSlots:_vm._u([{key:"input",fn:function(){return [_c('v-text-field',{attrs:{"type":"number","min":"0","step":".1","color":"#969462","single-line":""},model:{value:(_vm.VALUES.T3B.inventarios),callback:function ($$v) {_vm.$set(_vm.VALUES.T3B, "inventarios", $$v)},expression:"VALUES.T3B.inventarios"}})]},proxy:true}],null,false,1652609755)},[_vm._v("\r\n                                                "+_vm._s(_vm.numberWithSpaces(_vm.VALUES.T3B.inventarios) || '-')+"\r\n                                                ")])],1):_vm._e(),_vm._v(" "),_c('td',{staticClass:"table-left bold-up"},[_c('b',[_vm._v("Passivo não corrente")])]),_vm._v(" "),_c('td'),_vm._v(" "),_c('td')]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"table-left"},[_vm._v("Clientes")]),_vm._v(" "),_c('td',{attrs:{"colspan":_vm.editedItem.anos2 ? '1' : '2'}},[_c('v-edit-dialog',{attrs:{"return-value":_vm.VALUES.T3A.clientes},on:{"update:returnValue":function($event){return _vm.$set(_vm.VALUES.T3A, "clientes", $event)},"update:return-value":function($event){return _vm.$set(_vm.VALUES.T3A, "clientes", $event)}},scopedSlots:_vm._u([{key:"input",fn:function(){return [_c('v-text-field',{attrs:{"type":"number","min":"0","step":".1","color":"#969462","single-line":""},model:{value:(_vm.VALUES.T3A.clientes),callback:function ($$v) {_vm.$set(_vm.VALUES.T3A, "clientes", $$v)},expression:"VALUES.T3A.clientes"}})]},proxy:true}],null,false,4037213439)},[_vm._v("\r\n                                                "+_vm._s(_vm.numberWithSpaces(_vm.VALUES.T3A.clientes) || '-')+"\r\n                                                ")])],1),_vm._v(" "),(_vm.editedItem.anos2)?_c('td',[_c('v-edit-dialog',{attrs:{"return-value":_vm.VALUES.T3B.clientes},on:{"update:returnValue":function($event){return _vm.$set(_vm.VALUES.T3B, "clientes", $event)},"update:return-value":function($event){return _vm.$set(_vm.VALUES.T3B, "clientes", $event)}},scopedSlots:_vm._u([{key:"input",fn:function(){return [_c('v-text-field',{attrs:{"type":"number","min":"0","step":".1","color":"#969462","single-line":""},model:{value:(_vm.VALUES.T3B.clientes),callback:function ($$v) {_vm.$set(_vm.VALUES.T3B, "clientes", $$v)},expression:"VALUES.T3B.clientes"}})]},proxy:true}],null,false,1464667068)},[_vm._v("\r\n                                                "+_vm._s(_vm.numberWithSpaces(_vm.VALUES.T3B.clientes) || '-')+"\r\n                                                ")])],1):_vm._e(),_vm._v(" "),_c('td',{staticClass:"table-left"},[_vm._v("Provisões")]),_vm._v(" "),_c('td',{attrs:{"colspan":_vm.editedItem.anos2 ? '1' : '2'}},[_c('v-edit-dialog',{attrs:{"return-value":_vm.VALUES.T3A.provisoes},on:{"update:returnValue":function($event){return _vm.$set(_vm.VALUES.T3A, "provisoes", $event)},"update:return-value":function($event){return _vm.$set(_vm.VALUES.T3A, "provisoes", $event)}},scopedSlots:_vm._u([{key:"input",fn:function(){return [_c('v-text-field',{attrs:{"type":"number","min":"0","step":".1","color":"#969462","single-line":""},model:{value:(_vm.VALUES.T3A.provisoes),callback:function ($$v) {_vm.$set(_vm.VALUES.T3A, "provisoes", $$v)},expression:"VALUES.T3A.provisoes"}})]},proxy:true}],null,false,2198695912)},[_vm._v("\r\n                                                "+_vm._s(_vm.numberWithSpaces(_vm.VALUES.T3A.provisoes) || '-')+"\r\n                                                ")])],1),_vm._v(" "),(_vm.editedItem.anos2)?_c('td',[_c('v-edit-dialog',{attrs:{"return-value":_vm.VALUES.T3B.provisoes},on:{"update:returnValue":function($event){return _vm.$set(_vm.VALUES.T3B, "provisoes", $event)},"update:return-value":function($event){return _vm.$set(_vm.VALUES.T3B, "provisoes", $event)}},scopedSlots:_vm._u([{key:"input",fn:function(){return [_c('v-text-field',{attrs:{"type":"number","min":"0","step":".1","color":"#969462","single-line":""},model:{value:(_vm.VALUES.T3B.provisoes),callback:function ($$v) {_vm.$set(_vm.VALUES.T3B, "provisoes", $$v)},expression:"VALUES.T3B.provisoes"}})]},proxy:true}],null,false,4279350795)},[_vm._v("\r\n                                                "+_vm._s(_vm.numberWithSpaces(_vm.VALUES.T3B.provisoes) || '-')+"\r\n                                                ")])],1):_vm._e()]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"table-left"},[_vm._v("Estado e outros entes públicos")]),_vm._v(" "),_c('td',{attrs:{"colspan":_vm.editedItem.anos2 ? '1' : '2'}},[_c('v-edit-dialog',{attrs:{"return-value":_vm.VALUES.T3A.estadooutrosentespublicosativo},on:{"update:returnValue":function($event){return _vm.$set(_vm.VALUES.T3A, "estadooutrosentespublicosativo", $event)},"update:return-value":function($event){return _vm.$set(_vm.VALUES.T3A, "estadooutrosentespublicosativo", $event)}},scopedSlots:_vm._u([{key:"input",fn:function(){return [_c('v-text-field',{attrs:{"type":"number","min":"0","step":".1","color":"#969462","single-line":""},model:{value:(_vm.VALUES.T3A.estadooutrosentespublicosativo),callback:function ($$v) {_vm.$set(_vm.VALUES.T3A, "estadooutrosentespublicosativo", $$v)},expression:"VALUES.T3A.estadooutrosentespublicosativo"}})]},proxy:true}],null,false,244932937)},[_vm._v("\r\n                                                "+_vm._s(_vm.numberWithSpaces(_vm.VALUES.T3A.estadooutrosentespublicosativo) || '-')+"\r\n                                                ")])],1),_vm._v(" "),(_vm.editedItem.anos2)?_c('td',[_c('v-edit-dialog',{attrs:{"return-value":_vm.VALUES.T3B.estadooutrosentespublicosativo},on:{"update:returnValue":function($event){return _vm.$set(_vm.VALUES.T3B, "estadooutrosentespublicosativo", $event)},"update:return-value":function($event){return _vm.$set(_vm.VALUES.T3B, "estadooutrosentespublicosativo", $event)}},scopedSlots:_vm._u([{key:"input",fn:function(){return [_c('v-text-field',{attrs:{"type":"number","min":"0","step":".1","color":"#969462","single-line":""},model:{value:(_vm.VALUES.T3B.estadooutrosentespublicosativo),callback:function ($$v) {_vm.$set(_vm.VALUES.T3B, "estadooutrosentespublicosativo", $$v)},expression:"VALUES.T3B.estadooutrosentespublicosativo"}})]},proxy:true}],null,false,2644885962)},[_vm._v("\r\n                                                "+_vm._s(_vm.numberWithSpaces(_vm.VALUES.T3B.estadooutrosentespublicosativo) || '-')+"\r\n                                                ")])],1):_vm._e(),_vm._v(" "),_c('td',{staticClass:"table-left"},[_vm._v("Financiamentos obtidos")]),_vm._v(" "),_c('td',{attrs:{"colspan":_vm.editedItem.anos2 ? '1' : '2'}},[_c('v-edit-dialog',{attrs:{"return-value":_vm.VALUES.T3A.financiamentosobtidos},on:{"update:returnValue":function($event){return _vm.$set(_vm.VALUES.T3A, "financiamentosobtidos", $event)},"update:return-value":function($event){return _vm.$set(_vm.VALUES.T3A, "financiamentosobtidos", $event)}},scopedSlots:_vm._u([{key:"input",fn:function(){return [_c('v-text-field',{attrs:{"type":"number","min":"0","step":".1","color":"#969462","single-line":""},model:{value:(_vm.VALUES.T3A.financiamentosobtidos),callback:function ($$v) {_vm.$set(_vm.VALUES.T3A, "financiamentosobtidos", $$v)},expression:"VALUES.T3A.financiamentosobtidos"}})]},proxy:true}],null,false,2312497555)},[_vm._v("\r\n                                                "+_vm._s(_vm.numberWithSpaces(_vm.VALUES.T3A.financiamentosobtidos) || '-')+"\r\n                                                ")])],1),_vm._v(" "),(_vm.editedItem.anos2)?_c('td',[_c('v-edit-dialog',{attrs:{"return-value":_vm.VALUES.T3B.financiamentosobtidos},on:{"update:returnValue":function($event){return _vm.$set(_vm.VALUES.T3B, "financiamentosobtidos", $event)},"update:return-value":function($event){return _vm.$set(_vm.VALUES.T3B, "financiamentosobtidos", $event)}},scopedSlots:_vm._u([{key:"input",fn:function(){return [_c('v-text-field',{attrs:{"type":"number","min":"0","step":".1","color":"#969462","single-line":""},model:{value:(_vm.VALUES.T3B.financiamentosobtidos),callback:function ($$v) {_vm.$set(_vm.VALUES.T3B, "financiamentosobtidos", $$v)},expression:"VALUES.T3B.financiamentosobtidos"}})]},proxy:true}],null,false,3772636912)},[_vm._v("\r\n                                                "+_vm._s(_vm.numberWithSpaces(_vm.VALUES.T3B.financiamentosobtidos) || '-')+"\r\n                                                ")])],1):_vm._e()]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"table-left"},[_vm._v("Diferimentos")]),_vm._v(" "),_c('td',{attrs:{"colspan":_vm.editedItem.anos2 ? '1' : '2'}},[_c('v-edit-dialog',{attrs:{"return-value":_vm.VALUES.T3A.diferimentospassivo},on:{"update:returnValue":function($event){return _vm.$set(_vm.VALUES.T3A, "diferimentospassivo", $event)},"update:return-value":function($event){return _vm.$set(_vm.VALUES.T3A, "diferimentospassivo", $event)}},scopedSlots:_vm._u([{key:"input",fn:function(){return [_c('v-text-field',{attrs:{"type":"number","min":"0","step":".1","color":"#969462","single-line":""},model:{value:(_vm.VALUES.T3A.diferimentospassivo),callback:function ($$v) {_vm.$set(_vm.VALUES.T3A, "diferimentospassivo", $$v)},expression:"VALUES.T3A.diferimentospassivo"}})]},proxy:true}],null,false,2920893770)},[_vm._v("\r\n                                                "+_vm._s(_vm.numberWithSpaces(_vm.VALUES.T3A.diferimentospassivo) || '-')+"\r\n                                                ")])],1),_vm._v(" "),(_vm.editedItem.anos2)?_c('td',[_c('v-edit-dialog',{attrs:{"return-value":_vm.VALUES.T3B.diferimentospassivo},on:{"update:returnValue":function($event){return _vm.$set(_vm.VALUES.T3B, "diferimentospassivo", $event)},"update:return-value":function($event){return _vm.$set(_vm.VALUES.T3B, "diferimentospassivo", $event)}},scopedSlots:_vm._u([{key:"input",fn:function(){return [_c('v-text-field',{attrs:{"type":"number","min":"0","step":".1","color":"#969462","single-line":""},model:{value:(_vm.VALUES.T3B.diferimentospassivo),callback:function ($$v) {_vm.$set(_vm.VALUES.T3B, "diferimentospassivo", $$v)},expression:"VALUES.T3B.diferimentospassivo"}})]},proxy:true}],null,false,3728027177)},[_vm._v("\r\n                                                "+_vm._s(_vm.numberWithSpaces(_vm.VALUES.T3B.diferimentospassivo) || '-')+"\r\n                                                ")])],1):_vm._e(),_vm._v(" "),_c('td',{staticClass:"table-left"},[_vm._v("Outras contas a pagar")]),_vm._v(" "),_c('td',{attrs:{"colspan":_vm.editedItem.anos2 ? '1' : '2'}},[_c('v-edit-dialog',{attrs:{"return-value":_vm.VALUES.T3A.outrascontaspagar},on:{"update:returnValue":function($event){return _vm.$set(_vm.VALUES.T3A, "outrascontaspagar", $event)},"update:return-value":function($event){return _vm.$set(_vm.VALUES.T3A, "outrascontaspagar", $event)}},scopedSlots:_vm._u([{key:"input",fn:function(){return [_c('v-text-field',{attrs:{"type":"number","min":"0","step":".1","color":"#969462","single-line":""},model:{value:(_vm.VALUES.T3A.outrascontaspagar),callback:function ($$v) {_vm.$set(_vm.VALUES.T3A, "outrascontaspagar", $$v)},expression:"VALUES.T3A.outrascontaspagar"}})]},proxy:true}],null,false,1519795551)},[_vm._v("\r\n                                                "+_vm._s(_vm.numberWithSpaces(_vm.VALUES.T3A.outrascontaspagar) || '-')+"\r\n                                                ")])],1),_vm._v(" "),(_vm.editedItem.anos2)?_c('td',[_c('v-edit-dialog',{attrs:{"return-value":_vm.VALUES.T3B.outrascontaspagar},on:{"update:returnValue":function($event){return _vm.$set(_vm.VALUES.T3B, "outrascontaspagar", $event)},"update:return-value":function($event){return _vm.$set(_vm.VALUES.T3B, "outrascontaspagar", $event)}},scopedSlots:_vm._u([{key:"input",fn:function(){return [_c('v-text-field',{attrs:{"type":"number","min":"0","step":".1","color":"#969462","single-line":""},model:{value:(_vm.VALUES.T3B.outrascontaspagar),callback:function ($$v) {_vm.$set(_vm.VALUES.T3B, "outrascontaspagar", $$v)},expression:"VALUES.T3B.outrascontaspagar"}})]},proxy:true}],null,false,1736902460)},[_vm._v("\r\n                                                "+_vm._s(_vm.numberWithSpaces(_vm.VALUES.T3B.outrascontaspagar) || '-')+"\r\n                                                ")])],1):_vm._e()]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"table-left"},[_vm._v("Outros ativos correntes")]),_vm._v(" "),_c('td',{attrs:{"colspan":_vm.editedItem.anos2 ? '1' : '2'}},[_c('v-edit-dialog',{attrs:{"return-value":_vm.VALUES.T3A.outrosativoscorrentes},on:{"update:returnValue":function($event){return _vm.$set(_vm.VALUES.T3A, "outrosativoscorrentes", $event)},"update:return-value":function($event){return _vm.$set(_vm.VALUES.T3A, "outrosativoscorrentes", $event)}},scopedSlots:_vm._u([{key:"input",fn:function(){return [_c('v-text-field',{attrs:{"type":"number","min":"0","step":".1","color":"#969462","single-line":""},model:{value:(_vm.VALUES.T3A.outrosativoscorrentes),callback:function ($$v) {_vm.$set(_vm.VALUES.T3A, "outrosativoscorrentes", $$v)},expression:"VALUES.T3A.outrosativoscorrentes"}})]},proxy:true}],null,false,2696952931)},[_vm._v("\r\n                                                "+_vm._s(_vm.numberWithSpaces(_vm.VALUES.T3A.outrosativoscorrentes) || '-')+"\r\n                                                ")])],1),_vm._v(" "),(_vm.editedItem.anos2)?_c('td',[_c('v-edit-dialog',{attrs:{"return-value":_vm.VALUES.T3B.outrosativoscorrentes},on:{"update:returnValue":function($event){return _vm.$set(_vm.VALUES.T3B, "outrosativoscorrentes", $event)},"update:return-value":function($event){return _vm.$set(_vm.VALUES.T3B, "outrosativoscorrentes", $event)}},scopedSlots:_vm._u([{key:"input",fn:function(){return [_c('v-text-field',{attrs:{"type":"number","min":"0","step":".1","color":"#969462","single-line":""},model:{value:(_vm.VALUES.T3B.outrosativoscorrentes),callback:function ($$v) {_vm.$set(_vm.VALUES.T3B, "outrosativoscorrentes", $$v)},expression:"VALUES.T3B.outrosativoscorrentes"}})]},proxy:true}],null,false,4018061440)},[_vm._v("\r\n                                                "+_vm._s(_vm.numberWithSpaces(_vm.VALUES.T3B.outrosativoscorrentes) || '-')+"\r\n                                                ")])],1):_vm._e(),_vm._v(" "),_c('td',{staticClass:"table-left"}),_vm._v(" "),_c('td',{staticClass:"table-left"}),_vm._v(" "),_c('td',{staticClass:"table-left"})]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"table-left"},[_vm._v("Caixa e depósitos bancários")]),_vm._v(" "),_c('td',{attrs:{"colspan":_vm.editedItem.anos2 ? '1' : '2'}},[_c('v-edit-dialog',{attrs:{"return-value":_vm.VALUES.T3A.caixaedepositosbancarios},on:{"update:returnValue":function($event){return _vm.$set(_vm.VALUES.T3A, "caixaedepositosbancarios", $event)},"update:return-value":function($event){return _vm.$set(_vm.VALUES.T3A, "caixaedepositosbancarios", $event)}},scopedSlots:_vm._u([{key:"input",fn:function(){return [_c('v-text-field',{attrs:{"type":"number","min":"0","step":".1","color":"#969462","single-line":""},model:{value:(_vm.VALUES.T3A.caixaedepositosbancarios),callback:function ($$v) {_vm.$set(_vm.VALUES.T3A, "caixaedepositosbancarios", $$v)},expression:"VALUES.T3A.caixaedepositosbancarios"}})]},proxy:true}],null,false,991896003)},[_vm._v("\r\n                                                "+_vm._s(_vm.numberWithSpaces(_vm.VALUES.T3A.caixaedepositosbancarios) || '-')+"\r\n                                                ")])],1),_vm._v(" "),(_vm.editedItem.anos2)?_c('td',[_c('v-edit-dialog',{attrs:{"return-value":_vm.VALUES.T3B.caixaedepositosbancarios},on:{"update:returnValue":function($event){return _vm.$set(_vm.VALUES.T3B, "caixaedepositosbancarios", $event)},"update:return-value":function($event){return _vm.$set(_vm.VALUES.T3B, "caixaedepositosbancarios", $event)}},scopedSlots:_vm._u([{key:"input",fn:function(){return [_c('v-text-field',{attrs:{"type":"number","min":"0","step":".1","color":"#969462","single-line":""},model:{value:(_vm.VALUES.T3B.caixaedepositosbancarios),callback:function ($$v) {_vm.$set(_vm.VALUES.T3B, "caixaedepositosbancarios", $$v)},expression:"VALUES.T3B.caixaedepositosbancarios"}})]},proxy:true}],null,false,2561845824)},[_vm._v("\r\n                                                "+_vm._s(_vm.numberWithSpaces(_vm.VALUES.T3B.caixaedepositosbancarios) || '-')+"\r\n                                                ")])],1):_vm._e(),_vm._v(" "),_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td')]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"table-right bold-up"},[_vm._v("Total do ativo corrente")]),_vm._v(" "),_c('td',{attrs:{"colspan":_vm.editedItem.anos2 ? '1' : '2'}},[_vm._v(_vm._s(_vm.numberWithSpaces(_vm.T3T4A)))]),_vm._v(" "),(_vm.editedItem.anos2)?_c('td',[_vm._v(_vm._s(_vm.numberWithSpaces(_vm.T3T4B))+" ")]):_vm._e(),_vm._v(" "),_c('td',{staticClass:"table-right bold-up"},[_vm._v("Total do passivo não corrente")]),_vm._v(" "),_c('td',{attrs:{"colspan":_vm.editedItem.anos2 ? '1' : '2'}},[_vm._v(_vm._s(_vm.numberWithSpaces(_vm.T3T5A)))]),_vm._v(" "),(_vm.editedItem.anos2)?_c('td',[_vm._v(_vm._s(_vm.numberWithSpaces(_vm.T3T5B)))]):_vm._e()]),_vm._v(" "),_c('tr',[_c('td',{attrs:{"colspan":"3"}}),_vm._v(" "),_c('td',{staticClass:"table-left bold-up"},[_c('b',[_vm._v("Passivo corrente")])]),_vm._v(" "),_c('td'),_vm._v(" "),_c('td')]),_vm._v(" "),_c('tr',[_c('td',{attrs:{"colspan":"3"}}),_vm._v(" "),_c('td',{staticClass:"table-left"},[_vm._v("Fornecedores")]),_vm._v(" "),_c('td',{attrs:{"colspan":_vm.editedItem.anos2 ? '1' : '2'}},[_c('v-edit-dialog',{attrs:{"return-value":_vm.VALUES.T3A.fornecedores},on:{"update:returnValue":function($event){return _vm.$set(_vm.VALUES.T3A, "fornecedores", $event)},"update:return-value":function($event){return _vm.$set(_vm.VALUES.T3A, "fornecedores", $event)}},scopedSlots:_vm._u([{key:"input",fn:function(){return [_c('v-text-field',{attrs:{"type":"number","min":"0","step":".1","color":"#969462","single-line":""},model:{value:(_vm.VALUES.T3A.fornecedores),callback:function ($$v) {_vm.$set(_vm.VALUES.T3A, "fornecedores", $$v)},expression:"VALUES.T3A.fornecedores"}})]},proxy:true}],null,false,1490169353)},[_vm._v("\r\n                                                "+_vm._s(_vm.numberWithSpaces(_vm.VALUES.T3A.fornecedores) || '-')+"\r\n                                                ")])],1),_vm._v(" "),(_vm.editedItem.anos2)?_c('td',[_c('v-edit-dialog',{attrs:{"return-value":_vm.VALUES.T3B.fornecedores},on:{"update:returnValue":function($event){return _vm.$set(_vm.VALUES.T3B, "fornecedores", $event)},"update:return-value":function($event){return _vm.$set(_vm.VALUES.T3B, "fornecedores", $event)}},scopedSlots:_vm._u([{key:"input",fn:function(){return [_c('v-text-field',{attrs:{"type":"number","min":"0","step":".1","color":"#969462","single-line":""},model:{value:(_vm.VALUES.T3B.fornecedores),callback:function ($$v) {_vm.$set(_vm.VALUES.T3B, "fornecedores", $$v)},expression:"VALUES.T3B.fornecedores"}})]},proxy:true}],null,false,100407818)},[_vm._v("\r\n                                                "+_vm._s(_vm.numberWithSpaces(_vm.VALUES.T3B.fornecedores) || '-')+"\r\n                                                ")])],1):_vm._e()]),_vm._v(" "),_c('tr',[_c('td',{attrs:{"colspan":"3"}}),_vm._v(" "),_c('td',{staticClass:"table-left"},[_vm._v("Estado e outros entes públicos")]),_vm._v(" "),_c('td',{attrs:{"colspan":_vm.editedItem.anos2 ? '1' : '2'}},[_c('v-edit-dialog',{attrs:{"return-value":_vm.VALUES.T3A.estadooutrosentespublicospassivo},on:{"update:returnValue":function($event){return _vm.$set(_vm.VALUES.T3A, "estadooutrosentespublicospassivo", $event)},"update:return-value":function($event){return _vm.$set(_vm.VALUES.T3A, "estadooutrosentespublicospassivo", $event)}},scopedSlots:_vm._u([{key:"input",fn:function(){return [_c('v-text-field',{attrs:{"type":"number","min":"0","step":".1","color":"#969462","single-line":""},model:{value:(_vm.VALUES.T3A.estadooutrosentespublicospassivo),callback:function ($$v) {_vm.$set(_vm.VALUES.T3A, "estadooutrosentespublicospassivo", $$v)},expression:"VALUES.T3A.estadooutrosentespublicospassivo"}})]},proxy:true}],null,false,3460021581)},[_vm._v("\r\n                                                "+_vm._s(_vm.numberWithSpaces(_vm.VALUES.T3A.estadooutrosentespublicospassivo) || '-')+"\r\n                                                ")])],1),_vm._v(" "),(_vm.editedItem.anos2)?_c('td',[_c('v-edit-dialog',{attrs:{"return-value":_vm.VALUES.T3B.estadooutrosentespublicospassivo},on:{"update:returnValue":function($event){return _vm.$set(_vm.VALUES.T3B, "estadooutrosentespublicospassivo", $event)},"update:return-value":function($event){return _vm.$set(_vm.VALUES.T3B, "estadooutrosentespublicospassivo", $event)}},scopedSlots:_vm._u([{key:"input",fn:function(){return [_c('v-text-field',{attrs:{"type":"number","min":"0","step":".1","color":"#969462","single-line":""},model:{value:(_vm.VALUES.T3B.estadooutrosentespublicospassivo),callback:function ($$v) {_vm.$set(_vm.VALUES.T3B, "estadooutrosentespublicospassivo", $$v)},expression:"VALUES.T3B.estadooutrosentespublicospassivo"}})]},proxy:true}],null,false,4007985870)},[_vm._v("\r\n                                                "+_vm._s(_vm.numberWithSpaces(_vm.VALUES.T3B.estadooutrosentespublicospassivo) || '-')+"\r\n                                                ")])],1):_vm._e()]),_vm._v(" "),_c('tr',[_c('td',{attrs:{"colspan":"3"}}),_vm._v(" "),_c('td',{staticClass:"table-left"},[_vm._v("Diferimentos")]),_vm._v(" "),_c('td',{attrs:{"colspan":_vm.editedItem.anos2 ? '1' : '2'}},[_c('v-edit-dialog',{attrs:{"return-value":_vm.VALUES.T3A.diferimentospassivo},on:{"update:returnValue":function($event){return _vm.$set(_vm.VALUES.T3A, "diferimentospassivo", $event)},"update:return-value":function($event){return _vm.$set(_vm.VALUES.T3A, "diferimentospassivo", $event)}},scopedSlots:_vm._u([{key:"input",fn:function(){return [_c('v-text-field',{attrs:{"type":"number","min":"0","step":".1","color":"#969462","single-line":""},model:{value:(_vm.VALUES.T3A.diferimentospassivo),callback:function ($$v) {_vm.$set(_vm.VALUES.T3A, "diferimentospassivo", $$v)},expression:"VALUES.T3A.diferimentospassivo"}})]},proxy:true}],null,false,2920893770)},[_vm._v("\r\n                                                "+_vm._s(_vm.numberWithSpaces(_vm.VALUES.T3A.diferimentospassivo) || '-')+"\r\n                                                ")])],1),_vm._v(" "),(_vm.editedItem.anos2)?_c('td',[_c('v-edit-dialog',{attrs:{"return-value":_vm.VALUES.T3B.diferimentospassivo},on:{"update:returnValue":function($event){return _vm.$set(_vm.VALUES.T3B, "diferimentospassivo", $event)},"update:return-value":function($event){return _vm.$set(_vm.VALUES.T3B, "diferimentospassivo", $event)}},scopedSlots:_vm._u([{key:"input",fn:function(){return [_c('v-text-field',{attrs:{"type":"number","min":"0","step":".1","color":"#969462","single-line":""},model:{value:(_vm.VALUES.T3B.diferimentospassivo),callback:function ($$v) {_vm.$set(_vm.VALUES.T3B, "diferimentospassivo", $$v)},expression:"VALUES.T3B.diferimentospassivo"}})]},proxy:true}],null,false,3728027177)},[_vm._v("\r\n                                                "+_vm._s(_vm.numberWithSpaces(_vm.VALUES.T3B.diferimentospassivo) || '-')+"\r\n                                                ")])],1):_vm._e()]),_vm._v(" "),_c('tr',[_c('td',{attrs:{"colspan":"3"}}),_vm._v(" "),_c('td',{staticClass:"table-left"},[_vm._v("Outros passivos correntes")]),_vm._v(" "),_c('td',{attrs:{"colspan":_vm.editedItem.anos2 ? '1' : '2'}},[_c('v-edit-dialog',{attrs:{"return-value":_vm.VALUES.T3A.outrospassivoscorrentes},on:{"update:returnValue":function($event){return _vm.$set(_vm.VALUES.T3A, "outrospassivoscorrentes", $event)},"update:return-value":function($event){return _vm.$set(_vm.VALUES.T3A, "outrospassivoscorrentes", $event)}},scopedSlots:_vm._u([{key:"input",fn:function(){return [_c('v-text-field',{attrs:{"type":"number","min":"0","step":".1","color":"#969462","single-line":""},model:{value:(_vm.VALUES.T3A.outrospassivoscorrentes),callback:function ($$v) {_vm.$set(_vm.VALUES.T3A, "outrospassivoscorrentes", $$v)},expression:"VALUES.T3A.outrospassivoscorrentes"}})]},proxy:true}],null,false,4123847783)},[_vm._v("\r\n                                                "+_vm._s(_vm.numberWithSpaces(_vm.VALUES.T3A.outrospassivoscorrentes) || '-')+"\r\n                                                ")])],1),_vm._v(" "),(_vm.editedItem.anos2)?_c('td',[_c('v-edit-dialog',{attrs:{"return-value":_vm.VALUES.T3B.outrospassivoscorrentes},on:{"update:returnValue":function($event){return _vm.$set(_vm.VALUES.T3B, "outrospassivoscorrentes", $event)},"update:return-value":function($event){return _vm.$set(_vm.VALUES.T3B, "outrospassivoscorrentes", $event)}},scopedSlots:_vm._u([{key:"input",fn:function(){return [_c('v-text-field',{attrs:{"type":"number","min":"0","step":".1","color":"#969462","single-line":""},model:{value:(_vm.VALUES.T3B.outrospassivoscorrentes),callback:function ($$v) {_vm.$set(_vm.VALUES.T3B, "outrospassivoscorrentes", $$v)},expression:"VALUES.T3B.outrospassivoscorrentes"}})]},proxy:true}],null,false,4138701700)},[_vm._v("\r\n                                                "+_vm._s(_vm.numberWithSpaces(_vm.VALUES.T3B.outrospassivoscorrentes) || '-')+"\r\n                                                ")])],1):_vm._e()]),_vm._v(" "),_c('tr',[_c('td',{attrs:{"colspan":"3"}}),_vm._v(" "),_c('td',{staticClass:"table-right bold-up"},[_vm._v("Total do passivo corrente")]),_vm._v(" "),_c('td',{attrs:{"colspan":_vm.editedItem.anos2 ? '1' : '2'}},[_vm._v(_vm._s(_vm.numberWithSpaces(_vm.T3T6A)))]),_vm._v(" "),(_vm.editedItem.anos2)?_c('td',[_vm._v(_vm._s(_vm.numberWithSpaces(_vm.T3T6B)))]):_vm._e()]),_vm._v(" "),_c('tr',[_c('td',{attrs:{"colspan":"3"}}),_vm._v(" "),_c('td',{staticClass:"table-right bold-up"},[_vm._v("Total do passivo")]),_vm._v(" "),_c('td',{attrs:{"colspan":_vm.editedItem.anos2 ? '1' : '2'}},[_vm._v(_vm._s(_vm.numberWithSpaces(_vm.T3T7A)))]),_vm._v(" "),(_vm.editedItem.anos2)?_c('td',[_vm._v(_vm._s(_vm.numberWithSpaces(_vm.T3T7B)))]):_vm._e()]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"table-right bold-up"},[_vm._v("Total do ativo")]),_vm._v(" "),_c('td',{attrs:{"colspan":_vm.editedItem.anos2 ? '1' : '2'}},[_vm._v(_vm._s(_vm.numberWithSpaces(_vm.T3T8A)))]),_vm._v(" "),(_vm.editedItem.anos2)?_c('td',[_vm._v(_vm._s(_vm.numberWithSpaces(_vm.T3T8B)))]):_vm._e(),_vm._v(" "),_c('td',{staticClass:"table-right bold-up"},[_vm._v("Total do capital próprio e do passivo")]),_vm._v(" "),_c('td',{attrs:{"colspan":_vm.editedItem.anos2 ? '1' : '2'}},[_vm._v(_vm._s(_vm.numberWithSpaces(_vm.T3T9A)))]),_vm._v(" "),(_vm.editedItem.anos2)?_c('td',[_vm._v(_vm._s(_vm.numberWithSpaces(_vm.T3T9B)))]):_vm._e()])])])]),_vm._v(" "),_c('v-flex',{attrs:{"xs5":"","sm5":"","md5":"","pb-5":""}},[(_vm.VALUES.T3A.displayCH6)?_c('div',{attrs:{"id":"CH6"}},[_c('Chart6',{attrs:{"ANC":_vm.T3T1A,"AC":_vm.T3T4A}})],1):_vm._e()]),_vm._v(" "),_c('v-flex',{attrs:{"xs5":"","sm5":"","md5":"","pl-5":"","pb-5":""}},[(_vm.VALUES.T3A.displayCH7)?_c('div',{attrs:{"id":"CH7"}},[_c('Chart7',{attrs:{"CP":_vm.T3T3A,"PNC":_vm.T3T5A,"PC":_vm.T3T6A}})],1):_vm._e()]),_vm._v(" "),_c('v-flex',{attrs:{"xs4":"","sm4":"","md4":"","pb-5":""}},[_c('div',{attrs:{"id":"T4"}},[_c('table',{staticStyle:{"text-align":"right"},attrs:{"width":"100%"}},[_c('tr',[_c('th',{staticClass:"table-left bold-up",attrs:{"width":"50%"}},[_vm._v("Descrição")]),_vm._v(" "),_c('th',{staticClass:"bold-up",attrs:{"width":"50%"}},[_vm._v("Resultados")])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"bold-up table-left",attrs:{"colspan":"2"}},[_vm._v("Indicadores de rentabilidade")])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"table-left"},[_vm._v("Margem bruta sobre as vendas (1)")]),_vm._v(" "),_c('td',[_c('v-progress-linear',{attrs:{"color":parseFloat(_vm.T4T1)>=0 ? 'rgb(98, 150, 103, 0.5)' : 'red',"height":"20","value":_vm.T4T1}},[_vm._v(_vm._s(_vm.T4T1)+"%")])],1)]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"table-left"},[_vm._v("Rendibilidade das vendas (2)")]),_vm._v(" "),_c('td',[_c('v-progress-linear',{attrs:{"color":parseFloat(_vm.T4T2)>=0 ? 'rgb(98, 150, 103, 0.5)' : 'red',"height":"20","value":_vm.T4T2}},[_vm._v(_vm._s(_vm.T4T2)+"%")])],1)]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"table-left"},[_vm._v("Rendibilidade dos capitais próprios (3)")]),_vm._v(" "),_c('td',[_c('v-progress-linear',{attrs:{"color":parseFloat(_vm.T4T3)>=0 ? 'rgb(98, 150, 103, 0.5)' : 'red',"height":"20","value":_vm.T4T3}},[_vm._v(_vm._s(_vm.T4T3)+"%")])],1)]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"table-left"},[_vm._v("Rendibilidade do ativo (4)")]),_vm._v(" "),_c('td',[_c('v-progress-linear',{attrs:{"color":parseFloat(_vm.T4T4)>=0 ? 'rgb(98, 150, 103, 0.5)' : 'red',"height":"20","value":_vm.T4T4}},[_vm._v(_vm._s(_vm.T4T4)+"%")])],1)]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"bold-up table-left",attrs:{"colspan":"2"}},[_vm._v("Indicadores de endividamento")])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"table-left"},[_vm._v("Autonomia financeira (5)")]),_vm._v(" "),_c('td',[_c('v-progress-linear',{attrs:{"color":parseFloat(_vm.T4T5)>=50 ? 'green' : 'red',"height":"20","value":_vm.T4T5}},[_vm._v(_vm._s(_vm.T4T5)+"%")])],1)]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"table-left"},[_vm._v("Peso do passivo (6)")]),_vm._v(" "),_c('td',[_c('v-progress-linear',{attrs:{"color":parseFloat(_vm.T4T6)>=50 ? 'red' : 'green',"height":"20","value":_vm.T4T6}},[_vm._v(_vm._s(_vm.T4T6)+"%")])],1)]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"bold-up table-left",attrs:{"colspan":"2"}},[_vm._v("Indicadores de atividade")])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"table-left"},[_vm._v("Prazo médio de recebimento (7)")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.T4T7))])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"table-left"},[_vm._v("Prazo médio de pagamento (8)")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.T4T8))])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"table-left"},[_vm._v("Rácio de Rotação do Ativo (9)")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.T4T9))])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"bold-up table-left",attrs:{"colspan":"2"}},[_vm._v("Indicadores de liquidez")])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"table-left"},[_vm._v("Indicador de liquidez geral (10)")]),_vm._v(" "),_c('td',{staticClass:"linha-indicadores"},[_c('span',{class:[parseFloat(_vm.T4T10.replace('.', ',')) >= 2 ? 'bola bola-verde' : (parseFloat(_vm.T4T10.replace('.', ','))>=1 && parseFloat(_vm.T4T10.replace('.', ',')) <2 ? 'bola bola-laranja' : 'bola bola-vermelha')]}),_c('span',[_vm._v(_vm._s(_vm.T4T10))])])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"table-left"},[_vm._v("Indicador de liquidez reduzida (11)")]),_vm._v(" "),_c('td',{staticClass:"linha-indicadores"},[_c('span',{class:[parseFloat(_vm.T4T11.replace('.', ',')) >= 2 ? 'bola bola-verde' : (parseFloat(_vm.T4T11.replace('.', ','))>=1 && parseFloat(_vm.T4T11.replace('.', ',')) <2 ? 'bola bola-laranja' : 'bola bola-vermelha')]}),_c('span',[_vm._v(_vm._s(_vm.T4T11))])])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"table-left"},[_vm._v("Indicador de liquidez imediata (12)")]),_vm._v(" "),_c('td',{staticClass:"linha-indicadores"},[_c('span',{class:[parseFloat(_vm.T4T12.replace('.', ',')) >= 2 ? 'bola bola-verde' : (parseFloat(_vm.T4T12.replace('.', ','))>=1 && parseFloat(_vm.T4T12.replace('.', ',')) <2 ? 'bola bola-laranja' : 'bola bola-vermelha')]}),_c('span',[_vm._v(_vm._s(_vm.T4T12))])])])])])]),_vm._v(" "),_c('v-flex',{attrs:{"xs6":"","sm6":"","md6":"","pl-5":"","pb-5":""}},[_c('div',{attrs:{"id":"T5"}},[_c('table',{staticStyle:{"text-align":"center"},attrs:{"width":"100%"}},[_c('tr',[_c('th',{staticClass:"bold-up"},[_vm._v("Nº")]),_vm._v(" "),_c('th',{staticClass:"bold-up"},[_vm._v("Forma de Cálculo")]),_vm._v(" "),_c('th',{staticClass:"bold-up"},[_vm._v("Significado Económico")])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("1")]),_vm._v(" "),_c('td',[_vm._v("(Vendas - Custos Directos) / Vendas")]),_vm._v(" "),_c('td',[_vm._v("Percentagem de lucro bruto (depois de retirados os custos directos) calculado sobre o preço de venda")])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("2")]),_vm._v(" "),_c('td',[_vm._v("Resultado líquido / Vendas")]),_vm._v(" "),_c('td',[_vm._v("Percentagem de lucro líquido (depois de retirados todos os custos) calculada sobre o preço de venda")])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("3")]),_vm._v(" "),_c('td',[_vm._v("Resultado líquido / Capital próprio")]),_vm._v(" "),_c('td',[_vm._v("Estimativa da taxa de rendibilidade obtida pelos sócios ou accionistas")])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("4")]),_vm._v(" "),_c('td',[_vm._v("(Resultado Antes de Impostos - Juros)/Ativo")]),_vm._v(" "),_c('td',[_vm._v("Estimativa da taxa de rendibilidade méida obtida pelos sócios ou accionistas e pelos financeiros (banca)")])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("5")]),_vm._v(" "),_c('td',[_vm._v("Capital Próprio / Ativo")]),_vm._v(" "),_c('td',[_vm._v("Parte dos bens e direitos da empresa que é financiada por fundos dos sócios ou accionistas")])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("6")]),_vm._v(" "),_c('td',[_vm._v("Passivo / Ativo")]),_vm._v(" "),_c('td',[_vm._v("Parte dos bens e direitos da empresa que é financidada por fundos alheios (banca, fornecedores, estado)")])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("7")]),_vm._v(" "),_c('td',[_vm._v("(Clientes / Vendas) * 365")]),_vm._v(" "),_c('td',[_vm._v("Estimativa do número médio de dias que os clientes demoram a pagar")])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("8")]),_vm._v(" "),_c('td',[_vm._v("(Fornecedores / Compras de bens e serviços) * 365")]),_vm._v(" "),_c('td',[_vm._v("Estimativa do número médio de dias que se demora a pagar aos fornecedores")])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("9")]),_vm._v(" "),_c('td',[_vm._v("Vendas / Ativo Total")]),_vm._v(" "),_c('td',[_vm._v("Eficiência no uso dos ativos da empresa")])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("10")]),_vm._v(" "),_c('td',[_vm._v("Ativo Corrente / Passivo Corrente")]),_vm._v(" "),_c('td',[_vm._v("Parte do ativo corrente sobre o passivo de curto prazo")])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("11")]),_vm._v(" "),_c('td',[_vm._v("(Ativo Corrente - Stocks) / Passivo Corrente")]),_vm._v(" "),_c('td',[_vm._v("Parte do ativo corrente depois de retirados os stocks calculada sobre o passivo de curto prazo")])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("12")]),_vm._v(" "),_c('td',[_vm._v("Ativo disponível / Passivo Corrente")]),_vm._v(" "),_c('td',[_vm._v("Parte do ativo disponível calculada sobre o passivo de curto prazo")])])])])])],1)],1)],1):_vm._e()],1),_vm._v(" "),_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.DATA,"search":_vm.search,"loading":_vm.loading,"item-key":"id","disable-initial-sort":true,"rows-per-page-items":[10,25,50,{"text":"Todos","value":-1}],"rows-per-page-text":"Itens por página:"},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',{staticClass:"textLeft",on:{"click":function($event){return _vm.editItem(props.item, true)}}},[_vm._v(_vm._s(props.item.id_utilizador))]),_vm._v(" "),_c('td',{staticClass:"textLeft",on:{"click":function($event){return _vm.editItem(props.item, true)}}},[_vm._v(_vm._s(props.item.nome))]),_vm._v(" "),_c('td',{staticClass:"textLeft",on:{"click":function($event){return _vm.editItem(props.item, true)}}},[_vm._v(_vm._s(props.item.codigo))]),_vm._v(" "),_c('td',{staticClass:"textLeft",on:{"click":function($event){return _vm.editItem(props.item, true)}}},[_vm._v(_vm._s(props.item.email))]),_vm._v(" "),_c('td',{class:[props.item.termos == 1  ? 'textLeft aceite' : 'textLeft naceite'],on:{"click":function($event){return _vm.editItem(props.item, true)}}},[_vm._v(_vm._s(props.item.termos == 1 ? 'Aceite' : 'Não aceite'))]),_vm._v(" "),_c('td',{staticClass:"textRight",on:{"click":function($event){return _vm.editItem(props.item, true)}}},[_vm._v(_vm._s(props.item.nif))]),_vm._v(" "),_c('td',{staticClass:"px-0 textTable textCenter"},[_c('v-btn',{staticClass:"mx-0",attrs:{"icon":""},on:{"click":function($event){return _vm.getReport(props.item)}}},[_c('v-icon',{attrs:{"color":"amber"}},[_vm._v("receipt")])],1),_vm._v(" "),_c('v-btn',{staticClass:"mx-0",attrs:{"icon":""},on:{"click":function($event){return _vm.editItem(props.item, true)}}},[_c('v-icon',{attrs:{"color":"light-green darken-1"}},[_vm._v("edit")])],1),_vm._v(" "),_c('v-btn',{staticClass:"mx-0",attrs:{"icon":""},on:{"click":function($event){return _vm.editItemPassword(props.item, true)}}},[_c('v-icon',{attrs:{"color":"light-green darken-1"}},[_vm._v("lock")])],1),_vm._v(" "),_c('v-btn',{staticClass:"mx-0",attrs:{"icon":""},on:{"click":function($event){return _vm.editItem(props.item, false)}}},[_c('v-icon',{attrs:{"color":"red lighten-1"}},[_vm._v("delete")])],1)],1)]}}])},[_vm._v(" "),_c('template',{staticClass:"alertTable",slot:"no-data"},[_c('v-alert',{attrs:{"value":true,"icon":"warning"}},[_vm._v("\r\n                    De momento não há nada a apresentar! :(\r\n                ")])],1)],2)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1014:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Table_Extrato_Conta_vue__ = __webpack_require__(528);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_442f18e4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Table_Extrato_Conta_vue__ = __webpack_require__(1353);
function injectStyle (ssrContext) {
  __webpack_require__(1015)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-442f18e4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Table_Extrato_Conta_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_442f18e4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Table_Extrato_Conta_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1015:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1353:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-flex',[_c('h1',{staticStyle:{"color":"#969462 !important"}},[_vm._v("Extratos de Conta")]),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","width":"350"},model:{value:(_vm.loader),callback:function ($$v) {_vm.loader=$$v},expression:"loader"}},[_c('v-card',{attrs:{"color":"#969462","dark":""}},[_c('v-card-text',[_vm._v("\r\n                Esta operação pode demorar alguns minutos."),_c('br'),_vm._v("\r\n                Por favor aguarde...\r\n                "),_c('v-progress-linear',{staticClass:"mb-0",attrs:{"indeterminate":"","color":"white"}})],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[(_vm.getSession.user.super == 1)?_c('v-flex',{attrs:{"xs3":"","sm3":"","md3":""}},[_c('label',{staticClass:"label-modal"},[_vm._v("Cliente")]),_vm._v(" "),_c('v-autocomplete',{attrs:{"color":"#969462","items":_vm.getClientes,"item-text":"nome","item-value":"id_utilizador"},on:{"change":function($event){return _vm.setAnos()}},model:{value:(_vm.cliente),callback:function ($$v) {_vm.cliente=$$v},expression:"cliente"}})],1):_vm._e(),_vm._v(" "),_c('v-flex',{class:_vm.getSession.user.super == 1 ? 'pl-5' : '',attrs:{"xs3":"","sm3":"","md3":""}},[_c('label',{staticClass:"label-modal"},[_vm._v("Ano")]),_vm._v(" "),_c('v-autocomplete',{attrs:{"color":"#969462","items":_vm.anos},on:{"change":_vm.changeAno},model:{value:(_vm.ano),callback:function ($$v) {_vm.ano=$$v},expression:"ano"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"pl-5",attrs:{"xs3":"","sm3":"","md3":""}},[_c('label',{staticClass:"label-modal"},[_vm._v("Data ínicio")]),_vm._v(" "),_c('v-menu',{attrs:{"close-on-content-click":false,"nudge-right":40,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},model:{value:(_vm.iniMenu),callback:function ($$v) {_vm.iniMenu=$$v},expression:"iniMenu"}},[_c('v-text-field',{attrs:{"slot":"activator","color":"#969462","readonly":""},slot:"activator",model:{value:(_vm.ini),callback:function ($$v) {_vm.ini=$$v},expression:"ini"}}),_vm._v(" "),_c('v-date-picker',{attrs:{"locale":"pt-pt","color":"#969462","min":(_vm.ano + "-01-01"),"max":(_vm.ano + "-12-31")},on:{"input":function($event){_vm.iniMenu = false},"change":function (){this$1.isIni = this$1.ini ? true : false}},model:{value:(_vm.ini),callback:function ($$v) {_vm.ini=$$v},expression:"ini"}})],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"pl-5",attrs:{"xs3":"","sm3":"","md3":""}},[_c('label',{staticClass:"label-modal"},[_vm._v("Data fim")]),_vm._v(" "),_c('v-menu',{attrs:{"close-on-content-click":false,"nudge-right":40,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},model:{value:(_vm.fimMenu),callback:function ($$v) {_vm.fimMenu=$$v},expression:"fimMenu"}},[_c('v-text-field',{attrs:{"slot":"activator","color":"#969462","readonly":""},slot:"activator",model:{value:(_vm.fim),callback:function ($$v) {_vm.fim=$$v},expression:"fim"}}),_vm._v(" "),_c('v-date-picker',{attrs:{"locale":"pt-pt","color":"#969462","min":_vm.ini,"max":(_vm.ano + "-12-31")},on:{"input":function($event){_vm.fimMenu = false},"change":function (){this$1.isFim = this$1.fim ? true : false}},model:{value:(_vm.fim),callback:function ($$v) {_vm.fim=$$v},expression:"fim"}})],1)],1),_vm._v(" "),(_vm.ano)?_c('v-flex',{class:_vm.getSession.user.super == 1 ? '':'pl-5',attrs:{"xs3":"","sm3":"","md3":""}},[_c('label',{staticClass:"label-modal"},[_vm._v("Tipo de pesquisa")]),_vm._v(" "),_c('v-radio-group',{attrs:{"color":"#969462","row":""},on:{"change":_vm.changeIsLista},model:{value:(_vm.isLista),callback:function ($$v) {_vm.isLista=$$v},expression:"isLista"}},[_c('v-radio',{attrs:{"color":"#969462","label":"Todas as contas","value":"0"}}),_vm._v(" "),_c('v-radio',{attrs:{"color":"#969462","label":"Intervalo contas","value":"1"}}),_vm._v(" "),_c('v-radio',{attrs:{"color":"#969462","label":"Múltiplas contas","value":"2"}})],1)],1):_vm._e(),_vm._v(" "),((_vm.isLista == 1 || _vm.isLista == 0) && _vm.ano)?_c('v-flex',{attrs:{"xs3":"","sm3":"","md3":""}},[_c('label',{staticClass:"label-modal"},[_vm._v("Conta ínicio")]),_vm._v(" "),_c('v-combobox',{attrs:{"color":"#969462","chips":"","clearable":""},on:{"input":_vm.changeCI},scopedSlots:_vm._u([{key:"selection",fn:function(data){return [_c('v-chip',{attrs:{"selected":data.selected,"close":""},on:{"input":function($event){return _vm.removeCI(data.item)}}},[_c('strong',[_vm._v(_vm._s(data.item))])])]}}],null,false,3290721075),model:{value:(_vm.cinicio),callback:function ($$v) {_vm.cinicio=$$v},expression:"cinicio"}})],1):_vm._e(),_vm._v(" "),((_vm.isLista == 1 || _vm.isLista == 0) && _vm.ano)?_c('v-flex',{staticClass:"pl-5",attrs:{"xs3":"","sm3":"","md3":""}},[_c('label',{staticClass:"label-modal"},[_vm._v("Conta fim")]),_vm._v(" "),_c('v-combobox',{attrs:{"color":"#969462","chips":"","clearable":""},on:{"input":_vm.changeCF},scopedSlots:_vm._u([{key:"selection",fn:function(data){return [_c('v-chip',{attrs:{"selected":data.selected,"close":""},on:{"input":function($event){return _vm.removeCF(data.item)}}},[_c('strong',[_vm._v(_vm._s(data.item))])])]}}],null,false,2721505500),model:{value:(_vm.cfim),callback:function ($$v) {_vm.cfim=$$v},expression:"cfim"}})],1):_vm._e(),_vm._v(" "),(_vm.isLista == 2 && _vm.ano)?_c('v-flex',{attrs:{"xs6":"","sm6":"","md6":""}},[_c('label',{staticClass:"label-modal"},[_vm._v("Lista contas")]),_vm._v(" "),_c('v-combobox',{attrs:{"color":"#969462","chips":"","clearable":"","multiple":""},on:{"input":_vm.changeLC},scopedSlots:_vm._u([{key:"selection",fn:function(data){return [_c('v-chip',{attrs:{"selected":data.selected,"close":""},on:{"input":function($event){return _vm.removeLC(data.item)}}},[_c('strong',[_vm._v(_vm._s(data.item))])])]}}],null,false,2007836918),model:{value:(_vm.listacontas),callback:function ($$v) {_vm.listacontas=$$v},expression:"listacontas"}})],1):_vm._e(),_vm._v(" "),(_vm.getSession.user.super == 0 || (_vm.getSession.user.super == 1 && _vm.ano))?_c('v-flex',{staticStyle:{"position":"relative"},attrs:{"xs3":"","sm3":"","md3":""}},[_c('v-btn',{staticClass:"btnSearch",attrs:{"dark":"","color":"#969462"},on:{"click":_vm.searchData}},[_vm._v("Pesquisar")])],1):_vm._e()],1)],1),_vm._v(" "),_c('div',{staticClass:"elevation-3"},[_c('div',{staticClass:"tableHeader"},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs8":"","sm8":"","md8":"","justify-start":"","align-center":"","d-flex":""}},[_c('v-autocomplete',{attrs:{"color":"#969462","items":_vm.CONTAS},on:{"change":_vm.changeConta},model:{value:(_vm.CONTA),callback:function ($$v) {_vm.CONTA=$$v},expression:"CONTA"}}),_vm._v(" "),_c('v-autocomplete',{staticClass:"ml-2 mr-2",attrs:{"color":"#969462","items":_vm.SUBCONTAS,"item-text":"key","item-value":"key"},on:{"change":_vm.changeSubConta},model:{value:(_vm.SUBCONTA),callback:function ($$v) {_vm.SUBCONTA=$$v},expression:"SUBCONTA"}}),_vm._v(" "),_c('v-btn',{attrs:{"dark":"","color":"#969462"},on:{"click":function($event){return _vm.generatePdf()}}},[_vm._v("Exportar")]),_vm._v(" "),_c('v-btn',{attrs:{"dark":"","color":"#969462"},on:{"click":function($event){return _vm.generatePdfAll()}}},[_vm._v("Exportar tudo")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs2":"","sm2":"","md2":""}}),_vm._v(" "),_c('v-flex',{attrs:{"xs2":"","sm2":"","md2":"","justify-end":"","d-flex":""}},[_c('v-text-field',{staticClass:"searchTable",attrs:{"color":"#969462","append-icon":"search","label":"Pesquisa","single-line":"","hide-details":""},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})],1)],1)],1)],1),_vm._v(" "),_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.DATA,"search":_vm.search,"loading":_vm.loading,"item-key":"id","disable-initial-sort":true,"color":"#969462","rows-per-page-items":[50,150,300,{"text":"Todos","value":-1}],"rows-per-page-text":"Itens por página:"},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',{staticClass:"textLeft"},[_vm._v(_vm._s(props.item.datamov || '-'))]),_vm._v(" "),_c('td',{staticClass:"textLeft"},[_vm._v(_vm._s(props.item.diario || '-'))]),_vm._v(" "),_c('td',{staticClass:"textLeft"},[_vm._v(_vm._s(props.item.numinterno || '-'))]),_vm._v(" "),_c('td',{staticClass:"textLeft"},[_vm._v(_vm._s(props.item.descricaolancamento || '-'))]),_vm._v(" "),_c('td',{staticClass:"textLeft"},[_vm._v(_vm._s(props.item.documento || '-'))]),_vm._v(" "),_c('td',{staticClass:"textLeft"},[_vm._v(_vm._s(props.item.observacoes || '-'))]),_vm._v(" "),_c('td',{staticClass:"textRight"},[_vm._v(_vm._s(_vm.numberWithSpaces(props.item.debito || '-')))]),_vm._v(" "),_c('td',{staticClass:"textRight"},[_vm._v(_vm._s(_vm.numberWithSpaces(props.item.credito) || '-'))]),_vm._v(" "),_c('td',{staticClass:"textRight"},[_vm._v(_vm._s(_vm.numberWithSpaces(props.item.saldo) || '-'))])]}}])},[_vm._v(" "),(_vm.DATA.length)?_c('template',{slot:"footer"},[_c('td',{staticClass:"textCenter",attrs:{"colspan":"6"}},[_c('strong',[_vm._v("Total")])]),_vm._v(" "),_c('td',{staticClass:"textRight"},[_c('strong',[_vm._v(_vm._s(_vm.numberWithSpaces(_vm.getTotalByProperty('debito'))))])]),_vm._v(" "),_c('td',{staticClass:"textRight"},[_c('strong',[_vm._v(_vm._s(_vm.numberWithSpaces(_vm.getTotalByProperty('credito'))))])]),_vm._v(" "),_c('td',{staticClass:"textRight"},[_c('strong',[_vm._v(_vm._s(_vm.numberWithSpaces(_vm.getTotalByProperty('saldo'))))])])]):_vm._e(),_vm._v(" "),_c('template',{staticClass:"alertTable",slot:"no-data"},[_c('v-alert',{attrs:{"value":true,"icon":"warning"}},[_vm._v("\r\n                    De momento não há nada a apresentar! :(\r\n                ")])],1)],2)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1354:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Table_Balancete_Analitico_vue__ = __webpack_require__(616);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2bc82aac_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Table_Balancete_Analitico_vue__ = __webpack_require__(1356);
function injectStyle (ssrContext) {
  __webpack_require__(1355)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2bc82aac"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Table_Balancete_Analitico_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2bc82aac_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Table_Balancete_Analitico_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1355:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1356:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-flex',[_c('h1',{staticStyle:{"color":"#969462 !important"}},[_vm._v("Balancetes Analíticos")]),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","width":"350"},model:{value:(_vm.loader),callback:function ($$v) {_vm.loader=$$v},expression:"loader"}},[_c('v-card',{attrs:{"color":"#969462","dark":""}},[_c('v-card-text',[_vm._v("\r\n                Esta operação pode demorar alguns minutos."),_c('br'),_vm._v("\r\n                Por favor aguarde...\r\n                "),_c('v-progress-linear',{staticClass:"mb-0",attrs:{"indeterminate":"","color":"white"}})],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[(_vm.getSession.user.super == 1)?_c('v-flex',{attrs:{"xs3":"","sm3":"","md3":""}},[_c('label',{staticClass:"label-modal"},[_vm._v("Cliente")]),_vm._v(" "),_c('v-autocomplete',{attrs:{"color":"#969462","items":_vm.getClientes,"item-text":"nome","item-value":"id_utilizador"},on:{"change":function($event){return _vm.setAnos()}},model:{value:(_vm.cliente),callback:function ($$v) {_vm.cliente=$$v},expression:"cliente"}})],1):_vm._e(),_vm._v(" "),_c('v-flex',{class:_vm.getSession.user.super == 1 ? 'pl-5' : '',attrs:{"xs3":"","sm3":"","md3":""}},[_c('label',{staticClass:"label-modal"},[_vm._v("Ano")]),_vm._v(" "),_c('v-autocomplete',{attrs:{"color":"#969462","items":_vm.anos},model:{value:(_vm.ano),callback:function ($$v) {_vm.ano=$$v},expression:"ano"}})],1),_vm._v(" "),_c('v-flex',{class:_vm.getSession.user.super == 0 ? 'xs3 sm3 md3 pl-5' : 'xs2 sm2 md2 pl-5'},[_c('label',{staticClass:"label-modal"},[_vm._v("Mês")]),_vm._v(" "),_c('v-autocomplete',{attrs:{"color":"#969462","items":_vm.meses,"item-text":"nome","item-value":"mes"},model:{value:(_vm.mes),callback:function ($$v) {_vm.mes=$$v},expression:"mes"}})],1),_vm._v(" "),_c('v-flex',{class:_vm.getSession.user.super == 0 ? 'xs3 sm3 md3' : 'xs2 sm2 md2',staticStyle:{"position":"relative"}},[_c('v-btn',{staticClass:"btnSearch",attrs:{"dark":"","color":"#969462"},on:{"click":_vm.searchData}},[_vm._v("Pesquisar")])],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"elevation-3"},[_c('div',{staticClass:"tableHeader"},[_c('v-btn',{attrs:{"dark":"","color":"#969462"},on:{"click":function($event){return _vm.generatePdf()}}},[_vm._v("Exportar")]),_vm._v(" "),_c('v-text-field',{staticClass:"searchTable",attrs:{"color":"#969462","append-icon":"search","label":"Pesquisa","single-line":"","hide-details":""},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})],1),_vm._v(" "),_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.DATA,"search":_vm.search,"item-key":"id","disable-initial-sort":true,"color":"#969462","rows-per-page-items":[50,150,300,{"text":"Todos","value":-1}],"rows-per-page-text":"Itens por página:"},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',{staticClass:"textLeft"},[_vm._v(_vm._s(props.item.codigoconta || '-'))]),_vm._v(" "),_c('td',{staticClass:"textLeft"},[_vm._v(_vm._s(props.item.designacao || '-'))]),_vm._v(" "),_c('td',{staticClass:"textRight"},[_vm._v(_vm._s(_vm.numberWithSpaces(props.item.valordebitosacumulados) || '-'))]),_vm._v(" "),_c('td',{staticClass:"textRight"},[_vm._v(_vm._s(_vm.numberWithSpaces(props.item.valorcreditosacumulados) || '-'))]),_vm._v(" "),_c('td',{staticClass:"textRight"},[_vm._v(_vm._s(_vm.numberWithSpaces(props.item.saldosdeb) || '-'))]),_vm._v(" "),_c('td',{staticClass:"textRight"},[_vm._v(_vm._s(_vm.numberWithSpaces(props.item.saldoscred) || '-'))])]}}])},[_vm._v(" "),(_vm.DATA.length > 0)?_c('template',{slot:"footer"},[_c('td',{staticClass:"textLeft",attrs:{"colspan":"2"}},[_c('strong',[_vm._v("Total")])]),_vm._v(" "),_c('td',{staticClass:"textRight"},[_c('strong',[_vm._v(_vm._s(_vm.numberWithSpaces(_vm.TOTAIS['valordebitosacumulados'])))])]),_vm._v(" "),_c('td',{staticClass:"textRight"},[_c('strong',[_vm._v(_vm._s(_vm.numberWithSpaces(_vm.TOTAIS['valorcreditosacumulados'])))])]),_vm._v(" "),_c('td',{staticClass:"textRight"},[_c('strong',[_vm._v(_vm._s(_vm.numberWithSpaces(_vm.TOTAIS['saldosdeb'])))])]),_vm._v(" "),_c('td',{staticClass:"textRight"},[_c('strong',[_vm._v(_vm._s(_vm.numberWithSpaces(_vm.TOTAIS['saldoscred'])))])])]):_vm._e(),_vm._v(" "),_c('template',{staticClass:"alertTable",slot:"no-data"},[_c('v-alert',{attrs:{"value":true,"icon":"warning"}},[_vm._v("\r\n                    De momento não há nada a apresentar! :(\r\n                ")])],1)],2)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1357:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Table_Balancete_Razao_vue__ = __webpack_require__(617);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_66bf16da_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Table_Balancete_Razao_vue__ = __webpack_require__(1359);
function injectStyle (ssrContext) {
  __webpack_require__(1358)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-66bf16da"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Table_Balancete_Razao_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_66bf16da_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Table_Balancete_Razao_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1358:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1359:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-flex',[_c('h1',{staticStyle:{"color":"#969462 !important"}},[_vm._v("Balancetes Razão")]),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","width":"350"},model:{value:(_vm.loader),callback:function ($$v) {_vm.loader=$$v},expression:"loader"}},[_c('v-card',{attrs:{"color":"#969462","dark":""}},[_c('v-card-text',[_vm._v("\r\n                Esta operação pode demorar alguns minutos."),_c('br'),_vm._v("\r\n                Por favor aguarde...\r\n                "),_c('v-progress-linear',{staticClass:"mb-0",attrs:{"indeterminate":"","color":"white"}})],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[(_vm.getSession.user.super == 1)?_c('v-flex',{attrs:{"xs3":"","sm3":"","md3":""}},[_c('label',{staticClass:"label-modal"},[_vm._v("Cliente")]),_vm._v(" "),_c('v-autocomplete',{attrs:{"color":"#969462","items":_vm.getClientes,"item-text":"nome","item-value":"id_utilizador"},on:{"change":function($event){return _vm.setAnos()}},model:{value:(_vm.cliente),callback:function ($$v) {_vm.cliente=$$v},expression:"cliente"}})],1):_vm._e(),_vm._v(" "),_c('v-flex',{class:_vm.getSession.user.super == 1 ? 'pl-5' : '',attrs:{"xs3":"","sm3":"","md3":""}},[_c('label',{staticClass:"label-modal"},[_vm._v("Ano")]),_vm._v(" "),_c('v-autocomplete',{attrs:{"color":"#969462","items":_vm.anos},model:{value:(_vm.ano),callback:function ($$v) {_vm.ano=$$v},expression:"ano"}})],1),_vm._v(" "),_c('v-flex',{class:_vm.getSession.user.super == 0 ? 'xs3 sm3 md3 pl-5' : 'xs2 sm2 md2 pl-5'},[_c('label',{staticClass:"label-modal"},[_vm._v("Mês")]),_vm._v(" "),_c('v-autocomplete',{attrs:{"color":"#969462","items":_vm.meses,"item-text":"nome","item-value":"mes"},model:{value:(_vm.mes),callback:function ($$v) {_vm.mes=$$v},expression:"mes"}})],1),_vm._v(" "),_c('v-flex',{class:_vm.getSession.user.super == 0 ? 'xs3 sm3 md3' : 'xs2 sm2 md2',staticStyle:{"position":"relative"}},[_c('v-btn',{staticClass:"btnSearch",attrs:{"dark":"","color":"#969462"},on:{"click":_vm.searchData}},[_vm._v("Pesquisar")])],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"elevation-3"},[_c('div',{staticClass:"tableHeader"},[_c('v-btn',{attrs:{"dark":"","color":"#969462"},on:{"click":function($event){return _vm.generatePdf()}}},[_vm._v("Exportar")]),_vm._v(" "),_c('v-text-field',{staticClass:"searchTable",attrs:{"color":"#969462","append-icon":"search","label":"Pesquisa","single-line":"","hide-details":""},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})],1),_vm._v(" "),_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.DATA,"search":_vm.search,"item-key":"id","disable-initial-sort":true,"color":"#969462","rows-per-page-items":[50,150,300,{"text":"Todos","value":-1}],"rows-per-page-text":"Itens por página:"},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',{staticClass:"textLeft"},[_vm._v(_vm._s(props.item.codcontaprincipal || '-'))]),_vm._v(" "),_c('td',{staticClass:"textLeft"},[_vm._v(_vm._s(props.item.designacao || '-'))]),_vm._v(" "),_c('td',{staticClass:"textRight"},[_vm._v(_vm._s(_vm.numberWithSpaces(props.item.valordebitosacumulados) || '-'))]),_vm._v(" "),_c('td',{staticClass:"textRight"},[_vm._v(_vm._s(_vm.numberWithSpaces(props.item.valorcreditosacumulados) || '-'))]),_vm._v(" "),_c('td',{staticClass:"textRight"},[_vm._v(_vm._s(_vm.numberWithSpaces(props.item.saldosdeb) || '-'))]),_vm._v(" "),_c('td',{staticClass:"textRight"},[_vm._v(_vm._s(_vm.numberWithSpaces(props.item.saldoscred) || '-'))])]}}])},[_vm._v(" "),(_vm.DATA.length > 0)?_c('template',{slot:"footer"},[_c('td',{staticClass:"textLeft",attrs:{"colspan":"2"}},[_c('strong',[_vm._v("Total")])]),_vm._v(" "),_c('td',{staticClass:"textRight"},[_c('strong',[_vm._v(_vm._s(_vm.numberWithSpaces(_vm.TOTAIS['valordebitosacumulados'])))])]),_vm._v(" "),_c('td',{staticClass:"textRight"},[_c('strong',[_vm._v(_vm._s(_vm.numberWithSpaces(_vm.TOTAIS['valorcreditosacumulados'])))])]),_vm._v(" "),_c('td',{staticClass:"textRight"},[_c('strong',[_vm._v(_vm._s(_vm.numberWithSpaces(_vm.TOTAIS['saldosdeb'])))])]),_vm._v(" "),_c('td',{staticClass:"textRight"},[_c('strong',[_vm._v(_vm._s(_vm.numberWithSpaces(_vm.TOTAIS['saldoscred'])))])])]):_vm._e(),_vm._v(" "),_c('template',{staticClass:"alertTable",slot:"no-data"},[_c('v-alert',{attrs:{"value":true,"icon":"warning"}},[_vm._v("\r\n                    De momento não há nada a apresentar! :(\r\n                ")])],1)],2)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1360:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Table_Documentos_vue__ = __webpack_require__(618);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1275ce59_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Table_Documentos_vue__ = __webpack_require__(1378);
function injectStyle (ssrContext) {
  __webpack_require__(1361)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1275ce59"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Table_Documentos_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1275ce59_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Table_Documentos_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1361:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1378:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-flex',[_c('h1',{staticStyle:{"color":"#969462 !important"}},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","width":"350"},model:{value:(_vm.loader),callback:function ($$v) {_vm.loader=$$v},expression:"loader"}},[_c('v-card',{attrs:{"color":"#969462","dark":""}},[_c('v-card-text',[_vm._v("\n        A carregar ficheiros.\n        "),_c('br'),_vm._v("Por favor aguarde...\n        "),_c('v-progress-linear',{staticClass:"mb-0",attrs:{"indeterminate":"","color":"white"}})],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"390"},model:{value:(_vm.deleteM),callback:function ($$v) {_vm.deleteM=$$v},expression:"deleteM"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline",staticStyle:{"margin-left":"0px !important"}},[_vm._v("Apagar ficheiro")]),_vm._v(" "),_c('v-card-text',[_vm._v("De certeza que quer apagar este ficheiro "+_vm._s(_vm.deleteF)+"?")]),_vm._v(" "),_c('v-card-actions',{staticStyle:{"margin-top":"0px !important"}},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"#969462","flat":"flat"},nativeOn:{"click":function($event){return _vm.close($event)}}},[_vm._v("Cancelar")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"#969462","flat":"flat"},nativeOn:{"click":function($event){return _vm.deleteFile($event)}}},[_vm._v("Apagar")])],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"390"},model:{value:(_vm.clear),callback:function ($$v) {_vm.clear=$$v},expression:"clear"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline",staticStyle:{"margin-left":"0px !important"}},[_vm._v("Limpar pasta")]),_vm._v(" "),_c('v-card-text',[_vm._v("De certeza que quer eliminar todos os ficheiros da pasta\n        uploads?")]),_vm._v(" "),_c('v-card-actions',{staticStyle:{"margin-top":"0px !important"}},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"#969462","flat":"flat"},nativeOn:{"click":function($event){_vm.clear = false}}},[_vm._v("Cancelar")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"#969462","flat":"flat"},nativeOn:{"click":function($event){return _vm.clearFolder($event)}}},[_vm._v("Apagar")])],1)],1)],1),_vm._v(" "),(_vm.getSession.user.super)?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-layout',{attrs:{"d-flex":"","align-center":"","row":"","wrap":""}},[(_vm.getSession.user.super == 1)?_c('v-flex',{attrs:{"xs3":"","sm3":"","md3":""}},[_c('label',{staticClass:"label-modal"},[_vm._v("Cliente")]),_vm._v(" "),_c('v-autocomplete',{attrs:{"color":"#969462","items":_vm.getClientesComOSuper,"item-text":"nome","item-value":"codigo"},on:{"change":function($event){return _vm.sync()}},model:{value:(_vm.getSession.user.docs),callback:function ($$v) {_vm.$set(_vm.getSession.user, "docs", $$v)},expression:"getSession.user.docs"}})],1):_vm._e()],1)],1):_vm._e(),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_vm._l((_vm.items),function(item,i){return _c('span',{key:'i-' + i,on:{"click":function($event){return _vm.setPath(item.object, item.index)}}},[_c('span',{staticClass:"target-object"},[_vm._v(_vm._s(item.text))]),_vm._v(" "),(i < _vm.items.length - 1)?_c('span',[_vm._v(">")]):_vm._e()])}),_vm._v(" "),_c('v-btn',{attrs:{"color":"#969462","flat":"flat","icon":""},nativeOn:{"click":function($event){return _vm.sync($event)}}},[_c('v-icon',[_vm._v("refresh")])],1)],2),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[(
        _vm.$route.name == 'uploads' ||
        (_vm.items &&
          _vm.items.findIndex(function (el) {
            return el.text == 'uploads';
          }) > -1)
      )?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-form',{ref:"docForm"},[_c('div',{staticClass:"file-input multiple"},[_c('div',{staticClass:"file-input-wrapper"},[_c('input',{ref:"doc",attrs:{"type":"file","multiple":"","id":"single-example","readonly":""},on:{"change":_vm.onDocChange}}),_vm._v(" "),_c('label',{staticClass:"upload-cta",attrs:{"for":"single-example"}},[_vm._v("Clique aqui ou arraste os ficheiros que pretende\n              carregar")])])])])],1):_vm._e(),_vm._v(" "),(
        _vm.$route.name == 'uploads' ||
        (_vm.items &&
          _vm.items.findIndex(function (el) {
            return el.text == 'uploads';
          }) > -1)
      )?_c('v-flex',{staticClass:"download-div"},[(_vm.OBJECT != null)?_c('v-btn',{attrs:{"color":"#969462","dark":""},nativeOn:{"click":function($event){return _vm.download($event)}}},[_vm._v("Descarregar todos")]):_vm._e(),_vm._v(" "),(_vm.getSession.user.super && _vm.OBJECT != null)?_c('v-btn',{attrs:{"color":"#969462","dark":""},nativeOn:{"click":function($event){_vm.clear = true}}},[_vm._v("Limpar pasta")]):_vm._e()],1):_vm._e()],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[(Object.keys(_vm.OBJECT).length > 0)?_c('v-layout',{staticStyle:{"display":"flex","align-items":"baseline","margin-top":"50px"},attrs:{"row":"","wrap":""}},_vm._l((Object.keys(_vm.OBJECT)),function(item,i){return _c('div',{key:i,staticClass:"square noselect",staticStyle:{"width":"15%"},on:{"contextmenu":function($event){return _vm.deleteI(item)},"click":function($event){_vm.setObject(
            _vm.OBJECT[item],
            item,
            typeof _vm.OBJECT[item] === 'object' || Array.isArray(_vm.OBJECT[item])
          )}}},[(
            typeof _vm.OBJECT[item] === 'object' || Array.isArray(_vm.OBJECT[item])
          )?_c('div',{staticClass:"item-object"},[_c('span',[_c('v-icon',{attrs:{"color":"amber"}},[_vm._v("folder")])],1),_vm._v(" "),_c('span',[_c('p',[_vm._v(_vm._s(item))])])]):_c('div',{staticClass:"item-object"},[_c('span',[_c('v-icon',{attrs:{"color":"primary"}},[_vm._v("description")])],1),_vm._v(" "),_c('span',[_c('p',[_vm._v(_vm._s(_vm.OBJECT[item]))])])])])}),0):(_vm.isLoading)?_c('v-layout',[_c('v-flex',{staticStyle:{"text-align":"center !important"},attrs:{"xs12":"","sm12":"","md12":""}},[_c('p',{staticClass:"label-modal"},[_vm._v("A carregar ficheiros...")]),_vm._v(" "),_c('v-progress-circular',{attrs:{"indeterminate":"","color":"#969462"}})],1)],1):_c('v-layout',[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('p',{staticClass:"label-modal mt-2"},[_vm._v("Selecione um cliente")])])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1379:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Table_Notificacoes_vue__ = __webpack_require__(621);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_326676a5_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Table_Notificacoes_vue__ = __webpack_require__(1380);
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Table_Notificacoes_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_326676a5_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Table_Notificacoes_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1380:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-flex',[_c('h1',{staticStyle:{"color":"#969462 !important"}},[_vm._v("Notificações")]),_vm._v(" "),_c('div',{staticClass:"elevation-3"},[_c('div',{staticClass:"tableHeader"},[_c('v-dialog',{attrs:{"persistent":"","max-width":"500px"},model:{value:(_vm.modal),callback:function ($$v) {_vm.modal=$$v},expression:"modal"}},[_c('v-btn',{staticClass:"mb-2",attrs:{"slot":"activator","color":"#969462","dark":""},slot:"activator"},[_c('v-icon',{staticClass:"buttonIconText",attrs:{"color":"white"}},[_vm._v("playlist_add")]),_vm._v(" Nova "+_vm._s(_vm.name)+"\r\n                ")],1),_vm._v(" "),_c('v-card',[_c('v-card-title',[_c('span',{staticClass:"headline"},[_vm._v(_vm._s(_vm.formTitle))])]),_vm._v(" "),_c('v-form',{ref:"form",on:{"submit":function($event){$event.preventDefault();}}},[_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[(_vm.agendar)?_c('v-flex',{attrs:{"xs6":"","sm6":"","md6":""}},[_c('label',{staticClass:"label-modal"},[_vm._v("Data")]),_vm._v(" "),_c('v-menu',{attrs:{"nudge-right":40,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},model:{value:(_vm.dataMenu),callback:function ($$v) {_vm.dataMenu=$$v},expression:"dataMenu"}},[_c('v-text-field',{attrs:{"slot":"activator","rules":_vm.defaultRules,"prepend-icon":"event","color":"#969462","readonly":""},slot:"activator",model:{value:(_vm.editedItem.data_agenda),callback:function ($$v) {_vm.$set(_vm.editedItem, "data_agenda", $$v)},expression:"editedItem.data_agenda"}}),_vm._v(" "),_c('v-date-picker',{attrs:{"locale":"pt","min":_vm.today,"color":"#969462"},on:{"change":_vm.dataChange},model:{value:(_vm.editedItem.data_agenda),callback:function ($$v) {_vm.$set(_vm.editedItem, "data_agenda", $$v)},expression:"editedItem.data_agenda"}})],1)],1):_vm._e(),_vm._v(" "),(_vm.agendar)?_c('v-flex',{attrs:{"xs6":"","sm6":"","md6":""}},[_c('label',{staticClass:"label-modal"},[_vm._v("Hora")]),_vm._v(" "),_c('v-menu',{attrs:{"close-on-content-click":false,"nudge-right":40,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","max-width":"290px","min-width":"290px"},model:{value:(_vm.iniMenu),callback:function ($$v) {_vm.iniMenu=$$v},expression:"iniMenu"}},[_c('v-text-field',{attrs:{"slot":"activator","rules":_vm.defaultRules,"prepend-icon":"timer","readonly":"","color":"#969462"},slot:"activator",model:{value:(_vm.editedItem.hora_agenda),callback:function ($$v) {_vm.$set(_vm.editedItem, "hora_agenda", $$v)},expression:"editedItem.hora_agenda"}}),_vm._v(" "),(_vm.iniMenu)?_c('v-time-picker',{attrs:{"full-width":"","format":"24hr","color":"#969462"},on:{"change":function($event){_vm.iniMenu=false}},model:{value:(_vm.editedItem.hora_agenda),callback:function ($$v) {_vm.$set(_vm.editedItem, "hora_agenda", $$v)},expression:"editedItem.hora_agenda"}}):_vm._e()],1)],1):_vm._e(),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('label',{staticClass:"label-modal"},[_vm._v("Método de envio de notificações")]),_vm._v(" "),_c('v-radio-group',{attrs:{"mandatory":true,"row":""},on:{"change":function($event){_vm.toSend=[]}},model:{value:(_vm.metodo),callback:function ($$v) {_vm.metodo=$$v},expression:"metodo"}},[_c('v-radio',{attrs:{"color":"#969462","label":"De forma individual","value":0}}),_vm._v(" "),_c('v-radio',{attrs:{"color":"#969462","label":"Por escritório","value":1}})],1)],1),_vm._v(" "),(_vm.metodo==0)?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('label',{staticClass:"label-modal"},[_vm._v("Destinatários")]),_vm._v(" "),_c('v-select',{attrs:{"color":"#969462","items":_vm.clientes,"menu-props":{ maxHeight: '400' },"item-text":"nome","item-value":"id_utilizador","multiple":""},on:{"change":_vm.changeSelect},model:{value:(_vm.toSend),callback:function ($$v) {_vm.toSend=$$v},expression:"toSend"}})],1):_vm._e(),_vm._v(" "),(_vm.metodo==1)?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('label',{staticClass:"label-modal"},[_vm._v("Escritórios")]),_vm._v(" "),_c('v-select',{attrs:{"color":"#969462","items":_vm.escritorios,"menu-props":{ maxHeight: '400' },"item-text":"nome","item-value":"id_escritorio","multiple":""},on:{"change":_vm.changeSelectD},model:{value:(_vm.toSend),callback:function ($$v) {_vm.toSend=$$v},expression:"toSend"}})],1):_vm._e(),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('label',{staticClass:"label-modal"},[_vm._v("Título")]),_vm._v(" "),_c('v-text-field',{attrs:{"color":"#969462","disabled":_vm.editedIndex>-1,"autofocus":true,"counter":"","maxlength":"50","rules":_vm.defaultRules},model:{value:(_vm.editedItem.titulo),callback:function ($$v) {_vm.$set(_vm.editedItem, "titulo", $$v)},expression:"editedItem.titulo"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('label',{staticClass:"label-modal"},[_vm._v("Descrição")]),_vm._v(" "),_c('v-text-field',{attrs:{"color":"#969462","disabled":_vm.editedIndex>-1,"rules":_vm.defaultRules,"counter":"","maxlength":"100"},model:{value:(_vm.editedItem.descricao),callback:function ($$v) {_vm.$set(_vm.editedItem, "descricao", $$v)},expression:"editedItem.descricao"}})],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"#969462","flat":""},nativeOn:{"click":function($event){return _vm.close($event)}}},[_vm._v("Cancelar")]),_vm._v(" "),(_vm.editedIndex==-1)?_c('v-btn',{attrs:{"disabled":_vm.toSend.length == 0,"color":"#969462","flat":""},nativeOn:{"click":function($event){return _vm.save($event)}}},[_vm._v("Guardar")]):_c('v-btn',{attrs:{"color":"#969462","disabled":_vm.toSend.length == 0,"flat":""},nativeOn:{"click":function($event){return _vm.sendNotification($event)}}},[_vm._v("Reenviar")])],1)],1)],1)],1),_vm._v(" "),_c('v-btn',{staticClass:"mb-2",attrs:{"color":"#969462","dark":""},on:{"click":_vm.agendarNotificacao}},[_c('v-icon',{staticClass:"buttonIconText",attrs:{"color":"white"}},[_vm._v("event")]),_vm._v(" Agendar "+_vm._s(_vm.name)+"\r\n            ")],1),_vm._v(" "),_c('v-text-field',{staticClass:"searchTable",attrs:{"color":"#969462","append-icon":"search","label":"Pesquisa","single-line":"","hide-details":""},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"390"},model:{value:(_vm.deleteM),callback:function ($$v) {_vm.deleteM=$$v},expression:"deleteM"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline",staticStyle:{"margin-left":"0px !important"}},[_vm._v("Apagar "+_vm._s(_vm.name))]),_vm._v(" "),_c('v-card-text',[_vm._v("De certeza que quer apagar este "+_vm._s(_vm.name)+"?")]),_vm._v(" "),_c('v-card-actions',{staticStyle:{"margin-top":"0px !important"}},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"#969462","flat":"flat"},nativeOn:{"click":function($event){return _vm.close($event)}}},[_vm._v("Cancelar")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"#969462","flat":"flat"},nativeOn:{"click":function($event){return _vm.save($event)}}},[_vm._v("Apagar")])],1)],1)],1),_vm._v(" "),_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.DATA,"search":_vm.search,"loading":_vm.loading,"item-key":"id","disable-initial-sort":true,"rows-per-page-items":[10,25,50,{"text":"Todos","value":-1}],"rows-per-page-text":"Itens por página:"},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',{staticClass:"textLeft",staticStyle:{"width":"15%"},on:{"click":function($event){return _vm.editItem(props.item, true)}}},[_vm._v(_vm._s(props.item.id_notificacao))]),_vm._v(" "),_c('td',{staticClass:"textLeft",on:{"click":function($event){return _vm.editItem(props.item, true)}}},[_vm._v(_vm._s(props.item.titulo))]),_vm._v(" "),_c('td',{staticClass:"textLeft",on:{"click":function($event){return _vm.editItem(props.item, true)}}},[_vm._v(_vm._s(props.item.data))]),_vm._v(" "),_c('td',{staticClass:"px-0 textTable textCenter"},[_c('v-btn',{staticClass:"mx-0",attrs:{"icon":""},on:{"click":function($event){return _vm.resend(props.item)}}},[_c('v-icon',{attrs:{"color":"amber"}},[_vm._v("send")])],1),_vm._v(" "),_c('v-btn',{staticClass:"mx-0",attrs:{"icon":""},on:{"click":function($event){return _vm.editItem(props.item, true)}}},[_c('v-icon',{attrs:{"color":"light-green darken-1"}},[_vm._v("edit")])],1),_vm._v(" "),_c('v-btn',{staticClass:"mx-0",attrs:{"icon":""},on:{"click":function($event){return _vm.editItem(props.item, false)}}},[_c('v-icon',{attrs:{"color":"red lighten-1"}},[_vm._v("delete")])],1)],1)]}}])},[_vm._v(" "),_c('template',{staticClass:"alertTable",slot:"no-data"},[_c('v-alert',{attrs:{"value":true,"icon":"warning"}},[_vm._v("\r\n                    De momento não há nada a apresentar! :(\r\n                ")])],1)],2)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1381:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Table_Avisos_vue__ = __webpack_require__(622);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e67bfd34_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Table_Avisos_vue__ = __webpack_require__(1382);
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Table_Avisos_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e67bfd34_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Table_Avisos_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1382:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-flex',[_c('h1',{staticStyle:{"color":"#969462 !important"}},[_vm._v("Informações Relevantes")]),_vm._v(" "),_c('div',{staticClass:"elevation-3"},[_c('div',{staticClass:"tableHeader"},[_c('v-dialog',{attrs:{"persistent":"","max-width":"700px"},model:{value:(_vm.modal),callback:function ($$v) {_vm.modal=$$v},expression:"modal"}},[_c('v-btn',{staticClass:"mb-2",attrs:{"slot":"activator","color":"#969462","dark":""},slot:"activator"},[_c('v-icon',{staticClass:"buttonIconText",attrs:{"color":"white"}},[_vm._v("playlist_add")]),_vm._v("\n          Nova "+_vm._s(_vm.name)+"\n        ")],1),_vm._v(" "),_c('v-card',[_c('v-card-title',[_c('span',{staticClass:"headline"},[_vm._v(_vm._s(_vm.formTitle))])]),_vm._v(" "),_c('v-form',{ref:"form",on:{"submit":function($event){$event.preventDefault();}}},[_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[(_vm.editedIndex==-1)?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('label',{staticClass:"label-modal"},[_vm._v("Escritórios")]),_vm._v(" "),_c('v-select',{attrs:{"color":"#969462","items":_vm.escritorios,"menu-props":{ maxHeight: '400' },"item-text":"nome","item-value":"id_escritorio","multiple":""},on:{"change":_vm.changeSelectD},model:{value:(_vm.toSend),callback:function ($$v) {_vm.toSend=$$v},expression:"toSend"}})],1):_vm._e(),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('label',{staticClass:"label-modal"},[_vm._v("Título")]),_vm._v(" "),_c('v-text-field',{attrs:{"color":"#969462","counter":"","maxlength":"200","autofocus":true,"rules":_vm.defaultRules},model:{value:(_vm.editedItem.titulo),callback:function ($$v) {_vm.$set(_vm.editedItem, "titulo", $$v)},expression:"editedItem.titulo"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('quill-editor',{model:{value:(_vm.editedItem.descricao),callback:function ($$v) {_vm.$set(_vm.editedItem, "descricao", $$v)},expression:"editedItem.descricao"}})],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"#969462","flat":""},nativeOn:{"click":function($event){return _vm.close($event)}}},[_vm._v("Cancelar")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"#969462","flat":""},nativeOn:{"click":function($event){return _vm.save($event)}}},[_vm._v("Guardar")])],1)],1)],1)],1),_vm._v(" "),_c('v-text-field',{staticClass:"searchTable",attrs:{"color":"#969462","append-icon":"search","label":"Pesquisa","single-line":"","hide-details":""},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"390"},model:{value:(_vm.deleteM),callback:function ($$v) {_vm.deleteM=$$v},expression:"deleteM"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline",staticStyle:{"margin-left":"0px !important"}},[_vm._v("Apagar "+_vm._s(_vm.name))]),_vm._v(" "),_c('v-card-text',[_vm._v("De certeza que quer apagar este "+_vm._s(_vm.name)+"?")]),_vm._v(" "),_c('v-card-actions',{staticStyle:{"margin-top":"0px !important"}},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"#969462","flat":"flat"},nativeOn:{"click":function($event){return _vm.close($event)}}},[_vm._v("Cancelar")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"#969462","flat":"flat"},nativeOn:{"click":function($event){return _vm.save($event)}}},[_vm._v("Apagar")])],1)],1)],1),_vm._v(" "),_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.DATA,"search":_vm.search,"loading":_vm.loading,"item-key":"id","rows-per-page-items":[10,25,50,{"text":"Todos","value":-1}],"disable-initial-sort":true,"rows-per-page-text":"Itens por página:"},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',{staticClass:"textLeft",staticStyle:{"width":"15%"},on:{"click":function($event){return _vm.editItem(props.item, true)}}},[_vm._v(_vm._s(props.item.id_aviso))]),_vm._v(" "),_c('td',{staticClass:"textLeft",on:{"click":function($event){return _vm.editItem(props.item, true)}}},[_vm._v(_vm._s(props.item.titulo))]),_vm._v(" "),_c('td',{staticClass:"textLeft",on:{"click":function($event){return _vm.editItem(props.item, true)}}},[_vm._v(_vm._s(props.item.data))]),_vm._v(" "),_c('td',{staticClass:"px-0 textTable textCenter"},[_c('v-btn',{staticClass:"mx-0",attrs:{"icon":""},on:{"click":function($event){return _vm.editItem(props.item, true)}}},[_c('v-icon',{attrs:{"color":"light-green darken-1"}},[_vm._v("edit")])],1),_vm._v(" "),_c('v-btn',{staticClass:"mx-0",attrs:{"icon":""},on:{"click":function($event){return _vm.editItem(props.item, false)}}},[_c('v-icon',{attrs:{"color":"red lighten-1"}},[_vm._v("delete")])],1)],1)]}}])},[_vm._v(" "),_c('template',{staticClass:"alertTable",slot:"no-data"},[_c('v-alert',{attrs:{"value":true,"icon":"warning"}},[_vm._v("\n                  De momento não há nada a apresentar! :(\n              ")])],1)],2)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1383:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Table_Escritorios_vue__ = __webpack_require__(623);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_81001b0c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Table_Escritorios_vue__ = __webpack_require__(1384);
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Table_Escritorios_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_81001b0c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Table_Escritorios_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1384:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-flex',[_c('h1',{staticStyle:{"color":"#969462 !important"}},[_vm._v("Escritórios")]),_vm._v(" "),_c('div',{staticClass:"elevation-3"},[_c('div',{staticClass:"tableHeader"},[_c('v-dialog',{attrs:{"persistent":"","max-width":"500px"},model:{value:(_vm.modal),callback:function ($$v) {_vm.modal=$$v},expression:"modal"}},[_c('v-btn',{staticClass:"mb-2",attrs:{"slot":"activator","color":"#969462","dark":""},slot:"activator"},[_c('v-icon',{staticClass:"buttonIconText",attrs:{"color":"white"}},[_vm._v("playlist_add")]),_vm._v(" Novo "+_vm._s(_vm.name))],1),_vm._v(" "),_c('v-card',[_c('v-card-title',[_c('span',{staticClass:"headline"},[_vm._v(_vm._s(_vm.formTitle))])]),_vm._v(" "),_c('v-form',{ref:"form",on:{"submit":function($event){$event.preventDefault();}}},[_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('label',{staticClass:"label-modal"},[_vm._v("Nome")]),_vm._v(" "),_c('v-text-field',{attrs:{"color":"#969462","autofocus":true,"rules":_vm.defaultRules},model:{value:(_vm.editedItem.nome),callback:function ($$v) {_vm.$set(_vm.editedItem, "nome", $$v)},expression:"editedItem.nome"}})],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"#969462","flat":""},nativeOn:{"click":function($event){return _vm.close($event)}}},[_vm._v("Cancelar")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"#969462","flat":""},nativeOn:{"click":function($event){return _vm.save($event)}}},[_vm._v("Guardar")])],1)],1)],1)],1),_vm._v(" "),_c('v-text-field',{staticClass:"searchTable",attrs:{"color":"#969462","append-icon":"search","label":"Pesquisa","single-line":"","hide-details":""},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"390"},model:{value:(_vm.deleteM),callback:function ($$v) {_vm.deleteM=$$v},expression:"deleteM"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline",staticStyle:{"margin-left":"0px !important"}},[_vm._v("Apagar "+_vm._s(_vm.name))]),_vm._v(" "),_c('v-card-text',[_vm._v("De certeza que quer apagar este "+_vm._s(_vm.name)+"?")]),_vm._v(" "),_c('v-card-actions',{staticStyle:{"margin-top":"0px !important"}},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"#969462","flat":"flat"},nativeOn:{"click":function($event){return _vm.close($event)}}},[_vm._v("Cancelar")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"#969462","flat":"flat"},nativeOn:{"click":function($event){return _vm.save($event)}}},[_vm._v("Apagar")])],1)],1)],1),_vm._v(" "),_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.DATA,"search":_vm.search,"loading":_vm.loading,"item-key":"id","disable-initial-sort":true,"rows-per-page-items":[10,25,50,{"text":"Todos","value":-1}],"rows-per-page-text":"Itens por página:"},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',{staticClass:"textLeft",staticStyle:{"width":"15%"},on:{"click":function($event){return _vm.editItem(props.item, true)}}},[_vm._v(_vm._s(props.item.id_escritorio))]),_vm._v(" "),_c('td',{staticClass:"textLeft",staticStyle:{"width":"60%"},on:{"click":function($event){return _vm.editItem(props.item, true)}}},[_vm._v(_vm._s(props.item.nome))]),_vm._v(" "),_c('td',{staticClass:" px-0 textTable textCenter"},[_c('v-btn',{staticClass:"mx-0",attrs:{"icon":""},on:{"click":function($event){return _vm.editItem(props.item, true)}}},[_c('v-icon',{attrs:{"color":"light-green darken-1"}},[_vm._v("edit")])],1),_vm._v(" "),_c('v-btn',{staticClass:"mx-0",attrs:{"icon":""},on:{"click":function($event){return _vm.editItem(props.item, false)}}},[_c('v-icon',{attrs:{"color":"red lighten-1"}},[_vm._v("delete")])],1)],1)]}}])},[_vm._v(" "),_c('template',{staticClass:"alertTable",slot:"no-data"},[_c('v-alert',{attrs:{"value":true,"icon":"warning"}},[_vm._v("\n        De momento não há nada a apresentar! :(\n    ")])],1)],2)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1385:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Chart1_vue__ = __webpack_require__(624);
/* unused harmony namespace reexport */
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Chart1_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1389:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Chart2_vue__ = __webpack_require__(625);
/* unused harmony namespace reexport */
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Chart2_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1390:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Chart3_vue__ = __webpack_require__(626);
/* unused harmony namespace reexport */
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Chart3_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1391:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Chart4_vue__ = __webpack_require__(627);
/* unused harmony namespace reexport */
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Chart4_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1392:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Chart5_vue__ = __webpack_require__(628);
/* unused harmony namespace reexport */
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Chart5_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1393:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Chart6_vue__ = __webpack_require__(629);
/* unused harmony namespace reexport */
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Chart6_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1394:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Chart7_vue__ = __webpack_require__(630);
/* unused harmony namespace reexport */
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Chart7_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 472:
/***/ (function(module, exports) {

module.exports = {"sha224WithRSAEncryption":{"sign":"rsa","hash":"sha224","id":"302d300d06096086480165030402040500041c"},"RSA-SHA224":{"sign":"ecdsa/rsa","hash":"sha224","id":"302d300d06096086480165030402040500041c"},"sha256WithRSAEncryption":{"sign":"rsa","hash":"sha256","id":"3031300d060960864801650304020105000420"},"RSA-SHA256":{"sign":"ecdsa/rsa","hash":"sha256","id":"3031300d060960864801650304020105000420"},"sha384WithRSAEncryption":{"sign":"rsa","hash":"sha384","id":"3041300d060960864801650304020205000430"},"RSA-SHA384":{"sign":"ecdsa/rsa","hash":"sha384","id":"3041300d060960864801650304020205000430"},"sha512WithRSAEncryption":{"sign":"rsa","hash":"sha512","id":"3051300d060960864801650304020305000440"},"RSA-SHA512":{"sign":"ecdsa/rsa","hash":"sha512","id":"3051300d060960864801650304020305000440"},"RSA-SHA1":{"sign":"rsa","hash":"sha1","id":"3021300906052b0e03021a05000414"},"ecdsa-with-SHA1":{"sign":"ecdsa","hash":"sha1","id":""},"sha256":{"sign":"ecdsa","hash":"sha256","id":""},"sha224":{"sign":"ecdsa","hash":"sha224","id":""},"sha384":{"sign":"ecdsa","hash":"sha384","id":""},"sha512":{"sign":"ecdsa","hash":"sha512","id":""},"DSA-SHA":{"sign":"dsa","hash":"sha1","id":""},"DSA-SHA1":{"sign":"dsa","hash":"sha1","id":""},"DSA":{"sign":"dsa","hash":"sha1","id":""},"DSA-WITH-SHA224":{"sign":"dsa","hash":"sha224","id":""},"DSA-SHA224":{"sign":"dsa","hash":"sha224","id":""},"DSA-WITH-SHA256":{"sign":"dsa","hash":"sha256","id":""},"DSA-SHA256":{"sign":"dsa","hash":"sha256","id":""},"DSA-WITH-SHA384":{"sign":"dsa","hash":"sha384","id":""},"DSA-SHA384":{"sign":"dsa","hash":"sha384","id":""},"DSA-WITH-SHA512":{"sign":"dsa","hash":"sha512","id":""},"DSA-SHA512":{"sign":"dsa","hash":"sha512","id":""},"DSA-RIPEMD160":{"sign":"dsa","hash":"rmd160","id":""},"ripemd160WithRSA":{"sign":"rsa","hash":"rmd160","id":"3021300906052b2403020105000414"},"RSA-RIPEMD160":{"sign":"rsa","hash":"rmd160","id":"3021300906052b2403020105000414"},"md5WithRSAEncryption":{"sign":"rsa","hash":"md5","id":"3020300c06082a864886f70d020505000410"},"RSA-MD5":{"sign":"rsa","hash":"md5","id":"3020300c06082a864886f70d020505000410"}}

/***/ }),

/***/ 479:
/***/ (function(module, exports) {

module.exports = {"aes-128-ecb":{"cipher":"AES","key":128,"iv":0,"mode":"ECB","type":"block"},"aes-192-ecb":{"cipher":"AES","key":192,"iv":0,"mode":"ECB","type":"block"},"aes-256-ecb":{"cipher":"AES","key":256,"iv":0,"mode":"ECB","type":"block"},"aes-128-cbc":{"cipher":"AES","key":128,"iv":16,"mode":"CBC","type":"block"},"aes-192-cbc":{"cipher":"AES","key":192,"iv":16,"mode":"CBC","type":"block"},"aes-256-cbc":{"cipher":"AES","key":256,"iv":16,"mode":"CBC","type":"block"},"aes128":{"cipher":"AES","key":128,"iv":16,"mode":"CBC","type":"block"},"aes192":{"cipher":"AES","key":192,"iv":16,"mode":"CBC","type":"block"},"aes256":{"cipher":"AES","key":256,"iv":16,"mode":"CBC","type":"block"},"aes-128-cfb":{"cipher":"AES","key":128,"iv":16,"mode":"CFB","type":"stream"},"aes-192-cfb":{"cipher":"AES","key":192,"iv":16,"mode":"CFB","type":"stream"},"aes-256-cfb":{"cipher":"AES","key":256,"iv":16,"mode":"CFB","type":"stream"},"aes-128-cfb8":{"cipher":"AES","key":128,"iv":16,"mode":"CFB8","type":"stream"},"aes-192-cfb8":{"cipher":"AES","key":192,"iv":16,"mode":"CFB8","type":"stream"},"aes-256-cfb8":{"cipher":"AES","key":256,"iv":16,"mode":"CFB8","type":"stream"},"aes-128-cfb1":{"cipher":"AES","key":128,"iv":16,"mode":"CFB1","type":"stream"},"aes-192-cfb1":{"cipher":"AES","key":192,"iv":16,"mode":"CFB1","type":"stream"},"aes-256-cfb1":{"cipher":"AES","key":256,"iv":16,"mode":"CFB1","type":"stream"},"aes-128-ofb":{"cipher":"AES","key":128,"iv":16,"mode":"OFB","type":"stream"},"aes-192-ofb":{"cipher":"AES","key":192,"iv":16,"mode":"OFB","type":"stream"},"aes-256-ofb":{"cipher":"AES","key":256,"iv":16,"mode":"OFB","type":"stream"},"aes-128-ctr":{"cipher":"AES","key":128,"iv":16,"mode":"CTR","type":"stream"},"aes-192-ctr":{"cipher":"AES","key":192,"iv":16,"mode":"CTR","type":"stream"},"aes-256-ctr":{"cipher":"AES","key":256,"iv":16,"mode":"CTR","type":"stream"},"aes-128-gcm":{"cipher":"AES","key":128,"iv":12,"mode":"GCM","type":"auth"},"aes-192-gcm":{"cipher":"AES","key":192,"iv":12,"mode":"GCM","type":"auth"},"aes-256-gcm":{"cipher":"AES","key":256,"iv":12,"mode":"GCM","type":"auth"}}

/***/ }),

/***/ 493:
/***/ (function(module, exports) {

module.exports = {"1.3.132.0.10":"secp256k1","1.3.132.0.33":"p224","1.2.840.10045.3.1.1":"p192","1.2.840.10045.3.1.7":"p256","1.3.132.0.34":"p384","1.3.132.0.35":"p521"}

/***/ }),

/***/ 505:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jsonwebtoken__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jsonwebtoken___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_jsonwebtoken__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store_fcm__ = __webpack_require__(962);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__store_variables__ = __webpack_require__(60);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      auth: -1,
      drawer: null,
      termos: false,
      items: [{
        icon: "home",
        super: 0,
        text: "Home",
        to: "/"
      }, {
        icon: "receipt",
        super: 0,
        text: "Extratos de Conta",
        to: "/extratos"
      }, {
        icon: "insert_chart",
        super: 0,
        text: "Balancetes Analíticos",
        to: "/balanceteanalitico"
      }, {
        icon: "insert_chart_outlined",
        super: 0,
        text: "Balancetes Razão",
        to: "/balanceterazao"
      }, {
        icon: "folder",
        super: 0,
        text: "Documentos",
        to: "/documentos"
      }, {
        icon: "class",
        super: 2,
        text: "Relatórios gestão - Nova versão",
        to: "/relatoriosgestao"
      }, {
        icon: "cloud_upload",
        super: 2,
        text: "Uploads",
        to: "/uploads"
      },
      //{ icon: "class", super: 0, text: "Relatórios", to: "/relatorios" },
      {
        icon: "warning",
        super: 1,
        text: "Informações relevantes",
        to: "/informacoes"
      }, {
        icon: "notification_important",
        super: 1,
        text: "Notificações",
        to: "/notificacoes"
      }, {
        icon: "people_outline",
        super: 1,
        text: "Clientes",
        to: "/clientes"
      }, {
        icon: "business",
        super: 1,
        text: "Escritórios",
        to: "/escritorios"
      }, {
        icon: "assignment",
        super: 1,
        text: "Termos e condições",
        to: "/termos"
      }, {
        icon: "group_add",
        super: 1,
        text: "Utilizadores",
        to: "/utilizadores"
      }],
      altpwd: false,
      email: "",
      pwd: "",
      cpwd: "",
      defaultRules: null,
      pwdRules: null
    };
  },
  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapGetters */])({
    getSession: "session/getState",
    getTermos: "termos/getTermos",
    IsReady: "termos/IsReady"
  })),
  watch: {
    getState: function getState(val) {
      //if(val) this.auth=1;
    },
    altpwd: function altpwd(val) {
      this.pwd = "";
      this.cpwd = "";
    }
  },
  created: function created() {
    var _this = this;

    this.pwdRules = [function (v) {
      return v == _this.pwd || "* As palavras-passe não coincidem!";
    }];

    this.ManageSession();

    this.$eventBus.$on("login", function (res) {
      if (res) {
        _this.SessionStart();
      }
    });

    /* this.$eventBus.$on("relatorio", codigo => {
           if (codigo) {
             let routeData = this.$router.resolve({name: 'relatorio', query: {cliente: codigo, ano: "2019", mes: "03"}});
             window.open(routeData.href, '_blank');
           }
         }); */

    this.$eventBus.$on("sendNotification", function (params) {
      Object(__WEBPACK_IMPORTED_MODULE_6__store_fcm__["a" /* sendNotification */])(params).then(function (res) {
        if (res) _this.toast("success", "Notificação enviada com sucesso!");else _this.toast("error", "Não foi possível enviar a notificação!");
      });
    });

    this.$eventBus.$on("logout", function () {
      _this.logout();
    });
  },

  methods: {
    setTermosChecked: function setTermosChecked() {
      var _this2 = this;

      if (this.getSession.user.super == 1) return;

      this.$store.dispatch("utilizadores/setTermosChecked", this.getSession.user.id_utilizador).then(function (res) {
        if (res) _this2.termos = false;
      });
    },
    changeData: function changeData() {
      var _this3 = this;

      if (this.pwd && this.pwd == this.cpwd) this.$store.dispatch("session/update", {
        id: this.getSession.user.id_utilizador,
        password: this.pwd
      }).then(function (res) {
        if (res) {
          _this3.toast("success", "Password alterada com sucesso!");
          _this3.altpwd = false;
        } else {
          _this3.toast("error", "Ocorreu um erro ao alterar a password!");
          _this3.altpwd = false;
        }
      });
    },
    toast: function toast(type, message) {
      if (type == "success") {
        return iziToast.show({
          title: "SUCESSO",
          color: "green",
          timeout: this.$toastTimeout,
          message: message,
          position: this.$toastPosition
        });
      } else {
        return iziToast.show({
          title: "ERRO",
          color: "red",
          timeout: this.$toastTimeout,
          message: message,
          position: this.$toastPosition
        });
      }
    },
    ManageSession: function ManageSession() {
      var _this4 = this;

      if (!this.$session.exists()) this.auth = 0;else {
        this.decode(this.$cookies.get("t")).then(function (res) {
          _this4.$store.dispatch("session/getData", {
            email: res
          }).then(function () {
            if (_this4.getSession.session) {
              _this4.SessionStart();
            } else _this4.auth = 0;
          });
        });
      }
    },
    SessionStart: function SessionStart() {
      this.$session.start();
      this.$cookies.config("3d");
      this.$cookies.set("t", this.token(this.getSession.user.email));
      this.OpenStore();
    },
    OpenStore: function OpenStore() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this5.$store.dispatch("termos/get");

                if (_this5.getSession.user.super == 1) _this5.$store.dispatch("avisos/get");else _this5.$store.dispatch("avisos/getByEscritorio");

                if (_this5.getSession.user.super == 1) _this5.$store.dispatch("notificacoes/get");else _this5.$store.dispatch("notificacoes/getByUser");

                if (_this5.getSession.user.super == 1) _this5.$store.dispatch("utilizadores/get");

                if (_this5.getSession.user.super == 0) _this5.$store.dispatch("documentos/get");
                //else this.$store.dispatch("documentos/getAllUsers");

                if (_this5.getSession.user.super == 1) _this5.$store.dispatch("escritorios/get");

                _this5.auth = 1;

                setTimeout(function () {
                  if (_this5.IsReady && _this5.getSession.user.super == 0 && _this5.getSession.user.termos == 0) _this5.termos = true;
                }, 1500);

                _this5.$eventBus.$emit("loader", false);

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this5);
      }))();
    },
    logout: function logout() {
      var _this6 = this;

      this.$store.dispatch("session/setSessionData", null).then(function () {
        _this6.auth = 0;
        _this6.$session.destroy();
        setTimeout(function () {
          location.reload();
        }, 500);
      });
    },
    token: function token(params) {
      return __WEBPACK_IMPORTED_MODULE_5_jsonwebtoken___default.a.sign({
        exp: Math.floor(Date.now() / 1000) + 60 * 60 * 12,
        data: params
      }, 'xP9(vX#J23~=tGxy');
    },
    decode: function decode(token) {
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_5_jsonwebtoken___default.a.verify(token, 'xP9(vX#J23~=tGxy', function (err, decoded) {
          if (err) resolve(false);else resolve(__WEBPACK_IMPORTED_MODULE_5_jsonwebtoken___default.a.decode(token).data);
        });
      });
    }
  }
});

/***/ }),

/***/ 506:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(12);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      dialog: false,
      todosN: false,
      todosA: false,
      loadingN: false,
      loadingA: false,
      dados: "Resultados dos últimos 30 dias",
      AVISO: null
    };
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])({
    getSession: "session/getState",
    getNotificacoes: "notificacoes/getAll",
    getAvisos: "avisos/getAll",
    getStateA: "avisos/getState",
    getStateN: "notificacoes/getState"
  }), {
    dadosN: function dadosN() {
      return this.todosN ? "Dados desde sempre" : this.dados;
    },
    dadosA: function dadosA() {
      return this.todosA ? "Dados desde sempre" : this.dados;
    }
  }),
  created: function created() {
    this.todosA = this.getStateA;
    this.todosN = this.getStateN;
  },

  methods: {
    getAvisosTodos: function getAvisosTodos() {
      var _this = this;

      if (this.todosA) return;
      this.loadingA = true;
      if (this.getSession.user.super == 1) {
        this.$store.dispatch("avisos/get", true).then(function (res) {
          _this.todosA = true;
          _this.loadingA = false;
        });
      } else {
        this.$store.dispatch("avisos/getByEscritorio", true).then(function (res) {
          _this.todosA = true;
          _this.loadingA = false;
        });
      }
    },
    getNotificacoesTodos: function getNotificacoesTodos() {
      var _this2 = this;

      if (this.todosN) return;
      this.loadingN = true;
      if (this.getSession.user.super == 1) {
        this.$store.dispatch("notificacoes/get", true).then(function (res) {
          _this2.todosN = true;
          _this2.loadingN = false;
        });
      } else {
        this.$store.dispatch("notificacoes/getByUser", true).then(function (res) {
          _this2.todosN = true;
          _this2.loadingN = false;
        });
      }
    },
    setNotificationChecked: function setNotificationChecked(item) {
      if (item.visto == 1 || this.getSession.user.super == 1) return;

      this.$store.dispatch("notificacoes/setChecked", {
        id: item.id_notificacao_utilizador,
        visto: 1,
        data_visto: this.$moment().format("YYYY-MM-DD HH:mm")
      }).then(function (res) {
        if (res) item.visto = 1;
      });
    },
    setAvisoChecked: function setAvisoChecked(item) {
      this.AVISO = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, item);
      this.dialog = true;

      /*if (item.visto == 1 || this.getSession.user.super == 1) return;
        setTimeout(() => {
        this.$store
          .dispatch("avisos/setChecked", {
            id: item.id_aviso_utilizador,
            visto: 1,
            data_visto: this.$moment().format("YYYY-MM-DD HH:mm")
          })
          .then(res => {
            if (res) item.visto = 1;
          });
      }, 50);*/
    },
    open: function open(path) {
      window.open(this.$fileURL + this.getSession.user.codigo + "/50.Em falta/" + path, "_blank");
    }
  }
});

/***/ }),

/***/ 507:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(12);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      email: "",
      password: "",
      loading: false,
      required: ""
    };
  },
  created: function created() {
    var _this = this;

    this.required = "* Campo obrigatório";

    this.$eventBus.$on("loader", function (state) {
      _this.loading = state;
    });
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])({
    getSession: "session/getState"
  })),
  methods: {
    toast: function toast(type, message) {
      if (type == "success") {
        return iziToast.show({
          title: "SUCESSO",
          color: "green",
          timeout: this.$toastTimeout,
          message: message,
          position: this.$toastPosition
        });
      } else {
        return iziToast.show({
          title: "ERRO",
          color: "red",
          timeout: this.$toastTimeout,
          message: message,
          position: this.$toastPosition
        });
      }
    },
    login: function login() {
      var _this2 = this;

      if (!this.$refs.form.validate()) return;
      this.loading = true;
      this.$store.dispatch("session/signIn", {
        email: this.email,
        password: this.password
      }).then(function (res) {
        if (res) {
          _this2.$eventBus.$emit("login", _this2.getSession.session);
        } else {
          _this2.loading = false;
          _this2.toast("error", "Os dados introduzidos não são válidos!");
        }
      });
    }
  }
});

/***/ }),

/***/ 508:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(12);

//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])({
    getSession: "session/getState"
  }))
});

/***/ }),

/***/ 509:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(12);

//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])({
    getSession: "session/getState"
  }))
});

/***/ }),

/***/ 510:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(12);

//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])({
    getSession: "session/getState"
  }))
});

/***/ }),

/***/ 511:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(12);

//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])({
    getSession: "session/getState"
  }))
});

/***/ }),

/***/ 512:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(12);

//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])({
    getSession: "session/getState"
  }))
});

/***/ }),

/***/ 513:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(12);

//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])({
    getSession: "session/getState"
  }))
});

/***/ }),

/***/ 514:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(12);

//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])({
    getSession: "session/getState"
  }))
});

/***/ }),

/***/ 515:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(12);

//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])({
    getSession: "session/getState"
  }))
});

/***/ }),

/***/ 516:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(12);

//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])({
    getSession: "session/getState"
  }))
});

/***/ }),

/***/ 517:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuetify_dist_vuetify_min_css__ = __webpack_require__(518);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuetify_dist_vuetify_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuetify_dist_vuetify_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_quill_dist_quill_core_css__ = __webpack_require__(519);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_quill_dist_quill_core_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_quill_dist_quill_core_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_quill_dist_quill_snow_css__ = __webpack_require__(520);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_quill_dist_quill_snow_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_quill_dist_quill_snow_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_quill_dist_quill_bubble_css__ = __webpack_require__(521);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_quill_dist_quill_bubble_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_quill_dist_quill_bubble_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_quill_editor__ = __webpack_require__(522);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_quill_editor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_quill_editor__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        quillEditor: __WEBPACK_IMPORTED_MODULE_6_vue_quill_editor__["quillEditor"]
    },
    data: function data() {
        return {
            termos: ''
        };
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])({
        getSession: "session/getState",
        getTermos: "termos/getTermos",
        IsReady: "termos/IsReady"
    })),
    watch: {
        getTermos: function getTermos(val) {
            this.initialize();
        }
    },
    created: function created() {
        this.initialize();
    },

    methods: {
        toast: function toast(type, message) {
            if (type == "success") {
                return iziToast.show({
                    title: "SUCESSO",
                    color: "green",
                    timeout: this.$toastTimeout,
                    message: message,
                    position: this.$toastPosition
                });
            } else {
                return iziToast.show({
                    title: "AVISO",
                    color: "red",
                    timeout: this.$toastTimeout,
                    message: message,
                    position: this.$toastPosition
                });
            }
        },
        initialize: function initialize() {
            this.termos = this.getTermos;
        },
        save: function save() {
            var _this = this;

            this.$store.dispatch("termos/update", {
                id: 1,
                texto: this.termos
            }).then(function (res) {
                if (res) {
                    _this.toast('success', 'Termos e condições guardados com sucesso.');
                } else _this.toast('error', 'Ocorreu um erro ao guardar os dados.');

                _this.modal = false;
            });
        }
    }
});

/***/ }),

/***/ 518:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 519:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 520:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 521:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 523:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(12);

//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])({
    getSession: "session/getState"
  }))
});

/***/ }),

/***/ 524:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(12);

//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])({
    getSession: "session/getState"
  }))
});

/***/ }),

/***/ 525:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(12);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var cName = {
    upper: "Utilizador",
    lower: "o utilizador!"
};

/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            table: 'utilizadores',
            name: 'utilizador',
            search: "",
            modal: false,
            deleteM: false,
            loading: true,
            searchP: '',
            show: false,
            cpwd: null,
            headers: [{
                text: "#",
                align: "left",
                sortable: true,
                value: "id_utilizador"
            }, {
                text: "Nome",
                align: "left",
                sortable: true,
                value: "nome"
            }, {
                text: "Email",
                align: "left",
                sortable: true,
                value: "email"
            }, {
                text: "Ações",
                value: "id",
                sortable: false,
                align: "center"
            }],
            DATA: [],
            editedIndex: -1,
            editedItem: {
                id_utilizador: '',
                nome: "",
                email: "",
                password: ''
            },
            defaultItem: {
                id_utilizador: '',
                nome: "",
                email: "",
                password: ''
            },
            messages: {
                add: {
                    success: cName.upper + " criado com sucesso!",
                    error: "Ocorreu um erro ao criar " + cName.lower
                },
                update: {
                    success: cName.upper + " alterado com sucesso!",
                    error: "Ocorreu um erro ao alterar " + cName.lower
                },
                delete: {
                    success: cName.upper + " eliminado com sucesso!",
                    error: "Ocorreu um erro ao apagar " + cName.lower
                },
                default: {
                    sucesso: "Sucesso",
                    error: "Ocorreu um erro!"
                }
            },
            defaultRules: null,
            pwdRules: null
        };
    },

    computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])({
        getAll: 'utilizadores/getUtilizadores'
    }), {
        formTitle: function formTitle() {
            return this.editedIndex === -1 ? "Novo " + this.name : "Editar " + this.name;
        }
    }),

    watch: {
        modal: function modal(val) {
            val || this.close();
        },
        deleteM: function deleteM(val) {
            val || this.close();
        },
        getAll: function getAll(val) {
            this.initialize();
        }
    },

    created: function created() {
        var _this = this;

        this.defaultRules = [function (v) {
            return !!v || _this.$requiredField + '';
        }];
        this.pwdRules = [function (v) {
            return v == _this.editedItem.password || '* As palavras-passe não coincidem!';
        }];
        this.initialize();
    },
    mounted: function mounted() {},

    methods: {
        toast: function toast(type, message) {
            if (type == "success") {
                return iziToast.show({
                    title: "SUCESSO",
                    color: "green",
                    timeout: this.$toastTimeout,
                    message: message,
                    position: this.$toastPosition
                });
            } else {
                return iziToast.show({
                    title: "AVISO",
                    color: "red",
                    timeout: this.$toastTimeout,
                    message: message,
                    position: this.$toastPosition
                });
            }
        },
        gerarPassword: function gerarPassword() {
            this.editedItem.password = this.generatePassword();
            this.cpwd = this.editedItem.password;
        },
        generatePassword: function generatePassword() {
            var length = 8,
                charset = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789",
                retVal = "";
            for (var i = 0, n = charset.length; i < length; ++i) {
                retVal += charset.charAt(Math.floor(Math.random() * n));
            }
            return retVal;
        },
        initialize: function initialize() {
            this.loading = true;
            this.DATA = this.getAll;
            this.loading = false;
        },
        editItem: function editItem(item, dialog) {
            this.editedIndex = this.DATA.indexOf(item);
            this.editedItem = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, item);

            if (dialog) this.modal = true;else this.deleteM = true;
        },
        delete: function _delete() {
            var _this2 = this;

            if (!this.editedItem.id_utilizador) return;

            this.$store.dispatch(this.table + "/delete", {
                id: this.editedItem.id_utilizador
            }).then(function (res) {
                if (res) {
                    _this2.toast('success', _this2.messages.delete.success);
                    _this2.initialize();
                } else _this2.toast('error', _this2.messages.delete.error);

                _this2.deleteM = false;
            });
        },
        close: function close() {
            var _this3 = this;

            this.modal = this.deleteM = false;
            setTimeout(function () {
                _this3.editedItem = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, _this3.defaultItem);
                _this3.editedIndex = -1;

                _this3.$refs.form.reset();
            }, 110);
        },
        save: function save() {
            var _this4 = this;

            if (this.deleteM) {
                this.delete();
                return;
            }

            if (!this.$refs.form.validate()) return;

            if (this.editedIndex == -1) {
                this.$store.dispatch(this.table + "/insert", {
                    nome: this.editedItem.nome,
                    email: this.editedItem.email,
                    password: this.editedItem.password,
                    super: 1,
                    ativo: 1,
                    codigo: '',
                    urlwebsite: '',
                    nif: '',
                    anos2: 0
                }).then(function (res) {
                    if (res) {
                        _this4.toast('success', _this4.messages.add.success);
                        _this4.initialize();
                    } else _this4.toast('error', _this4.messages.add.error);

                    _this4.modal = false;
                });
            } else {
                this.$store.dispatch(this.table + "/update", {
                    id: this.editedItem.id_utilizador,
                    nome: this.editedItem.nome,
                    email: this.editedItem.email,
                    super: 1,
                    ativo: 1,
                    codigo: '',
                    urlwebsite: '',
                    nif: '',
                    anos2: 0
                }).then(function (res) {
                    if (res) {
                        _this4.toast('success', _this4.messages.update.success);
                        _this4.initialize();
                    } else _this4.toast('error', _this4.messages.update.error);

                    _this4.modal = false;
                });
            }
        }
    }
});

/***/ }),

/***/ 526:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(527);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_finite__ = __webpack_require__(1006);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_finite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_finite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_number_is_nan__ = __webpack_require__(1009);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_number_is_nan___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_number_is_nan__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_axios__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_qs__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_qs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_xml_js__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_xml_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_xml_js__);







//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







var cName = {
  upper: "Cliente",
  lower: "o cliente!"
};

var margin = 10;

var P1 = {
  volnegocios: 0,
  margembruta: 0
};

var T1 = {
  vendasservicosprestados: 0,
  subsidiosaexploracao: 0,
  variacaoinventariosprod: 0,
  trabalhospropriaentidade: 0,
  cmvcmc: 0,
  fse: 0,
  gastoscompessoal: 0,
  gastosreversoesdepreciacao: 0,
  gastosreversoesdeamortizacao: 0,
  imparidade: 0,
  provisoes: 0,
  outrosrendimentosganhos: 0,
  outrosgastosperdas: 0,
  saldoconta79: 0,
  saldoconta69: 0,
  gastoliquidofinanciamento: 0,
  impostosrp: 0
};

var T3 = {
  displayCH6: false,
  displayCH7: false,
  saldo11: 0,
  saldo12: 0,
  saldo13: 0,
  saldo14ativo: 0,
  clientes: 0,
  fornecedores: 0,
  saldo23passivo: 0,
  estadooutrosentespublicospassivo: 0,
  financiamentosobtidos: 0,
  saldo27passivo: 0,
  inventarios: 0,
  investimentosfinanceiros: 0,
  saldo43: 0,
  saldo44: 0,
  capitalrealizado: 0,
  reservas: 0,
  resultadostransitados: 0,
  diferimentosativo: 0,
  ativostangiveis: 0,
  ativosintangiveis: 0,
  outrosativoscorrentes: 0,
  outrospassivoscorrentes: 0,
  caixaedepositosbancarios: 0,
  outrasvariacoescapitalproprio: 0,
  outrosintrumentoscapitalproprio: 0,
  estadooutrosentespublicosativo: 0,
  diferimentospassivo: 0,
  outrascontaspagar: 0,
  creditosoutrosativosnaocorrentes: 0,
  provisoes: 0
};

var CH1 = {
  MESES: [],
  EMV: [],
  CMVMC: [],
  MB: []
};

var CH2 = {
  MESES: [],
  MB: [],
  FSEM: [],
  OG: []
};

var CH3 = {
  MESES: [],
  FSEM: [],
  FSE: [],
  OG: []
};

var CH4 = {
  MESES: [],
  C68: [],
  C69: [],
  C6869: []
};

var CH5 = {
  ORDEM: [],
  G: [],
  TABELA: []
};

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      logo: __webpack_require__(1012),
      base64Img: null,
      email: false,
      E: {},
      loader: false,
      REPORT: [],
      STRINGS: [],
      dialog: false,
      form: false,
      table: "utilizadores",
      name: "cliente",
      search: "",
      modal: false,
      modalPassword: false,
      deleteM: false,
      loading: true,
      searchP: "",
      ano: "",
      mes: "",
      show: false,
      cpwd: null,
      meses: [{
        mes: "01",
        nome: "Janeiro"
      }, {
        mes: "02",
        nome: "Fevereiro"
      }, {
        mes: "03",
        nome: "Março"
      }, {
        mes: "04",
        nome: "Abril"
      }, {
        mes: "05",
        nome: " Maio"
      }, {
        mes: "06",
        nome: "Junho"
      }, {
        mes: "07",
        nome: "Julho"
      }, {
        mes: "08",
        nome: "Agosto"
      }, {
        mes: "09",
        nome: "Setembro"
      }, {
        mes: "10",
        nome: "Outubro"
      }, {
        mes: "11",
        nome: "Novembro"
      }, {
        mes: "12",
        nome: "Dezembro"
      }],
      headers: [{
        text: "#",
        align: "left",
        sortable: true,
        value: "id_utilizador"
      }, {
        text: "Nome",
        align: "left",
        sortable: true,
        value: "nome"
      }, {
        text: "Código",
        align: "left",
        sortable: true,
        value: "codigo"
      }, {
        text: "Email",
        align: "left",
        sortable: true,
        value: "email"
      }, {
        text: "Termos",
        align: "left",
        sortable: true,
        value: "termos"
      }, {
        text: "NIF",
        align: "right",
        sortable: true,
        value: "nif"
      }, {
        text: "Ações",
        value: "id",
        sortable: false,
        align: "center"
      }],
      path: null,
      DATA: [],
      editedIndex: -1,
      editedItem: {
        id_utilizador: "",
        nome: "",
        email: "",
        codigo: "",
        urlwebsite: "",
        nif: "",
        ano: "2018",
        pastas: "",
        anos2: 0,
        password: "",
        telefone: ""
      },
      editedItemPasswordIndex: -1,
      editedItemPassword: {
        id_utilizador: "",
        password: ""
      },
      defaultItem: {
        id_utilizador: "",
        nome: "",
        email: "",
        codigo: "",
        urlwebsite: "",
        nif: "",
        ano: "2018",
        pastas: "",
        anos2: 0,
        password: "",
        telefone: ""
      },
      messages: {
        add: {
          success: cName.upper + " criado com sucesso!",
          error: "Ocorreu um erro ao criar " + cName.lower
        },
        update: {
          success: cName.upper + " alterado com sucesso!",
          error: "Ocorreu um erro ao alterar " + cName.lower
        },
        delete: {
          success: cName.upper + " eliminado com sucesso!",
          error: "Ocorreu um erro ao apagar " + cName.lower
        },
        default: {
          sucesso: "Sucesso",
          error: "Ocorreu um erro!"
        }
      },
      defaultRules: null,
      VALUES: {
        P1: __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()({}, P1),
        T1A: __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()({}, T1),
        T1B: __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()({}, T1),
        CH1: __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()({}, CH1),
        CH2: __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()({}, CH2),
        CH3: __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()({}, CH3),
        CH4: __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()({}, CH4),
        CH5: __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()({}, CH5),
        T3A: __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()({}, T3),
        T3B: __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()({}, T3)
      },
      defaultValues: {
        P1: __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()({}, P1),
        T1A: __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()({}, T1),
        T1B: __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()({}, T1),
        CH1: __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()({}, CH1),
        CH2: __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()({}, CH2),
        CH3: __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()({}, CH3),
        CH4: __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()({}, CH4),
        CH5: __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()({}, CH5),
        T3A: __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()({}, T3),
        T3B: __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()({}, T3)
      },
      pwdRules: null
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_7_vuex__["b" /* mapGetters */])({
    getAll: "utilizadores/getClientes",
    getEscritorios: "escritorios/getAll",
    getLinks: "session/getLinks"
  }), {
    formTitle: function formTitle() {
      return this.editedIndex === -1 ? "Novo " + this.name : "Editar " + this.name;
    },
    cmvcmcA: function cmvcmcA() {
      var total = parseFloat(this.VALUES.T1A.cmvcmc) - parseFloat(this.VALUES.T3A.inventarios);

      return parseFloat(total).toFixed(2);
    },
    cmvcmcB: function cmvcmcB() {
      var total = parseFloat(this.VALUES.T1B.cmvcmc) - parseFloat(this.VALUES.T3B.inventarios);

      return parseFloat(total).toFixed(2);
    },
    T1T1A: function T1T1A() {
      var val = this.VALUES.T1A;
      var total = parseFloat(String(val.vendasservicosprestados).replace("-", "")) + parseFloat(String(val.subsidiosaexploracao).replace("-", "")) + parseFloat(String(val.variacaoinventariosprod).replace("-", "")) + parseFloat(String(val.trabalhospropriaentidade).replace("-", "")) - parseFloat(String(this.cmvcmcA).replace("-", "")) - parseFloat(String(val.fse).replace("-", "")) - parseFloat(String(val.gastoscompessoal).replace("-", "")) - parseFloat(String(val.imparidade).replace("-", "")) + parseFloat(String(val.provisoes).replace("-", "")) + parseFloat(String(val.outrosrendimentosganhos).replace("-", "")) - parseFloat(String(val.outrosgastosperdas).replace("-", ""));

      return parseFloat(total).toFixed(2);
    },
    T1T2A: function T1T2A() {
      var total = parseFloat(this.T1T1A) - parseFloat(this.VALUES.T1A.gastosreversoesdepreciacao);

      return parseFloat(total).toFixed(2);
    },
    T1T3A: function T1T3A() {
      var total = parseFloat(this.T1T2A) - parseFloat(this.VALUES.T1A.gastoliquidofinanciamento);

      return parseFloat(total).toFixed(2);
    },
    T1T4A: function T1T4A() {
      var total = parseFloat(this.T1T3A) - parseFloat(this.VALUES.T1A.impostosrp);

      return parseFloat(total).toFixed(2);
    },
    T1T1B: function T1T1B() {
      var val = this.VALUES.T1B;
      var total = parseFloat(String(val.vendasservicosprestados).replace("-", "")) + parseFloat(String(val.subsidiosaexploracao).replace("-", "")) + parseFloat(String(val.variacaoinventariosprod).replace("-", "")) + parseFloat(String(val.trabalhospropriaentidade).replace("-", "")) - parseFloat(String(this.cmvcmcB).replace("-", "")) - parseFloat(String(val.fse).replace("-", "")) - parseFloat(String(val.gastoscompessoal).replace("-", "")) - parseFloat(String(val.imparidade).replace("-", "")) + parseFloat(String(val.provisoes).replace("-", "")) + parseFloat(String(val.outrosrendimentosganhos).replace("-", "")) - parseFloat(String(val.outrosgastosperdas).replace("-", ""));

      return parseFloat(total).toFixed(2);
    },
    T1T2B: function T1T2B() {
      var total = parseFloat(this.T1T1B) - parseFloat(this.VALUES.T1B.gastosreversoesdepreciacao);

      return parseFloat(total).toFixed(2);
    },
    T1T3B: function T1T3B() {
      var total = parseFloat(this.T1T2B) - parseFloat(this.VALUES.T1B.gastoliquidofinanciamento);

      return parseFloat(total).toFixed(2);
    },
    T1T4B: function T1T4B() {
      var total = parseFloat(this.T1T3B) - parseFloat(this.VALUES.T1B.impostosrp);

      return parseFloat(total).toFixed(2);
    },
    T3T1A: function T3T1A() {
      var val = this.VALUES.T3A;
      var total = parseFloat(this.AtivosTangiveisA) + parseFloat(val.ativosintangiveis) + parseFloat(val.investimentosfinanceiros) + parseFloat(val.creditosoutrosativosnaocorrentes);

      return parseFloat(total).toFixed(2);
    },
    T3T1B: function T3T1B() {
      var val = this.VALUES.T3B;
      var total = parseFloat(this.AtivosTangiveisB) + parseFloat(val.ativosintangiveis) + parseFloat(val.investimentosfinanceiros) + parseFloat(val.creditosoutrosativosnaocorrentes);

      return parseFloat(total).toFixed(2);
    },
    T3T2A: function T3T2A() {
      var val = this.VALUES.T3A;
      var total = parseFloat(val.capitalrealizado) + parseFloat(val.outrosintrumentoscapitalproprio) + parseFloat(val.reservas) + parseFloat(val.resultadostransitados) + parseFloat(val.outrasvariacoescapitalproprio);

      return parseFloat(total).toFixed(2);
    },
    T3T2B: function T3T2B() {
      var val = this.VALUES.T3B;
      var total = parseFloat(val.capitalrealizado) + parseFloat(val.outrosintrumentoscapitalproprio) + parseFloat(val.reservas) + parseFloat(val.resultadostransitados) + parseFloat(val.outrasvariacoescapitalproprio);

      return parseFloat(total).toFixed(2);
    },
    T3T3A: function T3T3A() {
      var total = parseFloat(this.T3T2A) + parseFloat(this.T1T4A);

      return parseFloat(total).toFixed(2);
    },
    T3T3B: function T3T3B() {
      var total = parseFloat(this.T3T2B) + parseFloat(this.T1T4B);

      return parseFloat(total).toFixed(2);
    },
    T3T4A: function T3T4A() {
      var val = this.VALUES.T3A;
      var total = parseFloat(val.inventarios) + parseFloat(val.clientes) + parseFloat(val.estadooutrosentespublicosativo) + parseFloat(val.diferimentosativo) + parseFloat(val.outrosativoscorrentes) + parseFloat(val.caixaedepositosbancarios);

      return parseFloat(total).toFixed(2);
    },
    T3T4B: function T3T4B() {
      var val = this.VALUES.T3B;
      var total = parseFloat(val.inventarios) + parseFloat(val.clientes) + parseFloat(val.estadooutrosentespublicosativo) + parseFloat(val.diferimentosativo) + parseFloat(val.outrosativoscorrentes) + parseFloat(val.caixaedepositosbancarios);

      return parseFloat(total).toFixed(2);
    },
    T3T5A: function T3T5A() {
      var val = this.VALUES.T3A;
      var total = parseFloat(val.provisoes) + parseFloat(val.financiamentosobtidos) + parseFloat(val.outrascontaspagar);
      return parseFloat(total).toFixed(2);
    },
    T3T5B: function T3T5B() {
      var val = this.VALUES.T3B;
      var total = parseFloat(val.provisoes) + parseFloat(val.financiamentosobtidos) + parseFloat(val.outrascontaspagar);

      return parseFloat(total).toFixed(2);
    },
    T3T6A: function T3T6A() {
      var val = this.VALUES.T3A;
      var total = parseFloat(val.fornecedores) + parseFloat(val.estadooutrosentespublicospassivo) + parseFloat(val.diferimentospassivo) + parseFloat(val.outrospassivoscorrentes);

      return parseFloat(total).toFixed(2);
    },
    T3T6B: function T3T6B() {
      var val = this.VALUES.T3B;
      var total = parseFloat(val.fornecedores) + parseFloat(val.estadooutrosentespublicospassivo) + parseFloat(val.diferimentospassivo) + parseFloat(val.outrospassivoscorrentes);

      return parseFloat(total).toFixed(2);
    },
    T3T7A: function T3T7A() {
      var total = parseFloat(this.T3T5A) + parseFloat(this.T3T6A);

      return parseFloat(total).toFixed(2);
    },
    T3T7B: function T3T7B() {
      var total = parseFloat(this.T3T5B) + parseFloat(this.T3T6B);

      return parseFloat(total).toFixed(2);
    },
    T3T8A: function T3T8A() {
      var total = parseFloat(this.T3T1A) + parseFloat(this.T3T4A);

      return parseFloat(total).toFixed(2);
    },
    T3T8B: function T3T8B() {
      var total = parseFloat(this.T3T1B) + parseFloat(this.T3T4B);

      return parseFloat(total).toFixed(2);
    },
    T3T9A: function T3T9A() {
      var total = parseFloat(this.T3T3A) + parseFloat(this.T3T7A);

      return parseFloat(total).toFixed(2);
    },
    T3T9B: function T3T9B() {
      var total = parseFloat(this.T3T3B) + parseFloat(this.T3T7B);

      return parseFloat(total).toFixed(2);
    },
    T4T1: function T4T1() {
      var val = this.VALUES.T1A;
      var total = (parseFloat(val.vendasservicosprestados) - parseFloat(val.cmvcmc)) / parseFloat(val.vendasservicosprestados) * 100;

      return parseFloat(total).toFixed(1);
    },
    T4T2: function T4T2() {
      var val = this.VALUES.T1A;
      var total = parseFloat(this.T1T4A) / parseFloat(val.vendasservicosprestados) * 100;

      return parseFloat(total).toFixed(1);
    },
    T4T3: function T4T3() {
      var total = parseFloat(this.T1T4A) / parseFloat(this.T3T3A) * 100;

      return parseFloat(this.T1T4A) < 0 ? parseFloat(total * -1).toFixed(1) : parseFloat(total).toFixed(1);
    },
    T4T4: function T4T4() {
      var total = parseFloat(this.T1T2A) / parseFloat(this.T3T8A) * 100;

      return parseFloat(total).toFixed(1);
    },
    T4T5: function T4T5() {
      var total = parseFloat(this.T3T3A) / parseFloat(this.T3T8A) * 100;

      return parseFloat(total).toFixed(1);
    },
    T4T6: function T4T6() {
      var total = parseFloat(this.T3T7A) / parseFloat(this.T3T8A) * 100;

      return parseFloat(total).toFixed(1);
    },
    T4T7: function T4T7() {
      var val = this.VALUES.T1A;
      var total = parseFloat(this.VALUES.T3A.clientes) / parseFloat(val.vendasservicosprestados) * 365;

      return parseFloat(total).toFixed(1);
    },
    T4T8: function T4T8() {
      var total = parseFloat(this.VALUES.T3A.fornecedores) / (parseFloat(this.VALUES.T1A.cmvcmc) + parseFloat(this.VALUES.T1A.fse)) * 365;

      return parseFloat(total).toFixed(1);
    },
    T4T9: function T4T9() {
      var total = parseFloat(this.VALUES.T1A.vendasservicosprestados) / parseFloat(this.T3T8A);

      return parseFloat(total).toFixed(1);
    },
    T4T10: function T4T10() {
      var total = parseFloat(this.T3T4A) / parseFloat(this.T3T6A);

      return parseFloat(total).toFixed(1);
    },
    T4T11: function T4T11() {
      var total = (parseFloat(this.T3T4A) - this.VALUES.T3A.inventarios) / parseFloat(this.T3T6A);

      return parseFloat(total).toFixed(1);
    },
    T4T12: function T4T12() {
      var total = parseFloat(this.VALUES.T3A.caixaedepositosbancarios) / parseFloat(this.T3T6A);

      return parseFloat(total).toFixed(1);
    },
    AtivosTangiveisA: function AtivosTangiveisA() {
      var total = parseFloat(this.VALUES.T3A.ativostangiveis) - parseFloat(this.VALUES.T1A.gastosreversoesdepreciacao);

      return parseFloat(total).toFixed(2);
    },
    AtivosTangiveisB: function AtivosTangiveisB() {
      var total = parseFloat(this.VALUES.T3B.ativostangiveis) - parseFloat(this.VALUES.T1B.gastosreversoesdepreciacao);

      return parseFloat(total).toFixed(2);
    },
    AtivosIntangiveisA: function AtivosIntangiveisA() {
      var total = parseFloat(this.VALUES.T3A.ativosintangiveis) - parseFloat(this.VALUES.T1A.gastosreversoesdeamortizacao);

      return parseFloat(total).toFixed(2);
    },
    AtivosIntangiveisB: function AtivosIntangiveisB() {
      var total = parseFloat(this.VALUES.T3B.ativosintangiveis) - parseFloat(this.VALUES.T1B.gastosreversoesdeamortizacao);

      return parseFloat(total).toFixed(2);
    }
  }),

  watch: {
    T3T4A: function T3T4A(val) {
      var _this = this;

      if (Number(val)) {
        this.VALUES.T3A.displayCH6 = false;
        this.VALUES.T3A.displayCH7 = false;
        setTimeout(function () {
          _this.VALUES.T3A.displayCH6 = true;
          _this.VALUES.T3A.displayCH7 = true;
        }, 0);
      }
    },
    T3T9A: function T3T9A(val) {
      var _this2 = this;

      if (Number(val)) {
        this.VALUES.T3A.displayCH6 = false;
        this.VALUES.T3A.displayCH7 = false;
        setTimeout(function () {
          _this2.VALUES.T3A.displayCH6 = true;
          _this2.VALUES.T3A.displayCH7 = true;
        }, 0);
      }
    },
    modal: function modal(val) {
      val || this.close();
    },
    dialog: function dialog(val) {
      val || this.close();
    },
    deleteM: function deleteM(val) {
      val || this.close();
    },
    getAll: function getAll(val) {
      this.initialize();
    },
    email: function email(val) {
      var _this3 = this;

      if (val && this.editedIndex > -1 && this.path) {
        this.E.email = this.editedItem.email;
        this.E.assunto = "Relatório Gestão - " + this.meses.find(function (el) {
          return el.mes == _this3.mes;
        }).nome + "/" + this.ano;
        this.E.corpo = "Segue o link para consultar o relatório relativo a " + this.meses.find(function (el) {
          return el.mes == _this3.mes;
        }).nome + "/" + this.ano;
        this.E.link = this.path;
      }
    }
  },

  created: function created() {
    var _this4 = this;

    this.defaultRules = [function (v) {
      return !!v || _this4.$requiredField + "";
    }];
    this.pwdRules = [function (v) {
      return v == _this4.editedItem.password || "* As palavras-passe não coincidem!";
    }];
    this.initialize();

    this.ano = Number(this.$moment().format("YYYY"));
    this.mes = this.$moment().format("MM");

    this.STRINGS[1] = "De referir que face aos resultados obtidos, prevê-se que haja lugar ao apuramento de IRC no montante de € {#####,##}. Neste montante estão incluídos € ####,## referente às tributações autónomas relacionadas com ajudas de custo, despesas de representação e encargos com viaturas ligeiras de passageiros.";
    this.STRINGS[2] = "Relativamente \xE0s pr\xF3ximas obriga\xE7\xF5es fiscais, ainda face a " + this.ano + ", relembramos que existe em ###, ###, ###, pagamento por conta de \u20AC ####,## cada.";
    this.STRINGS[3] = "A conta de sócios apresenta um saldo devedor de € ####,##.";
    this.STRINGS[4] = "Texto exemplo";
    this.STRINGS[5] = "Texto exemplo";
  },
  mounted: function mounted() {},

  methods: {
    numberWithSpaces: function numberWithSpaces(x) {
      var parts = x.toString().split(".");
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, " ");
      return parts.join(".");
    },
    changeP21: function changeP21() {
      var _this5 = this;

      setTimeout(function () {
        var str = _this5.STRINGS[1];

        var str1 = str.split("{")[0];
        var str2 = str.split("{")[1].split("}")[1];

        _this5.STRINGS[1] = str1 + "{" + _this5.numberWithSpaces(_this5.VALUES.T1A.impostosrp) + "}" + str2;

        _this5.$forceUpdate();
      }, 1000);
    },
    toast: function toast(type, message) {
      if (type == "success") {
        return iziToast.show({
          title: "SUCESSO",
          color: "green",
          timeout: this.$toastTimeout,
          message: message,
          position: this.$toastPosition
        });
      } else {
        return iziToast.show({
          title: "AVISO",
          color: "red",
          timeout: this.$toastTimeout,
          message: message,
          position: this.$toastPosition
        });
      }
    },
    gerarPassword: function gerarPassword() {
      this.editedItem.password = this.generatePassword();
      this.cpwd = this.editedItem.password;
    },
    generatePassword: function generatePassword() {
      var length = 8,
          charset = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789",
          retVal = "";
      for (var i = 0, n = charset.length; i < length; ++i) {
        retVal += charset.charAt(Math.floor(Math.random() * n));
      }
      return retVal;
    },
    formatValue: function formatValue(value) {
      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_number_is_nan___default()(value) || value == 0 ? "0" : parseFloat(value).toFixed(2);
    },
    sendMail: function sendMail() {
      var _this6 = this;

      this.$store.dispatch("utilizadores/email", this.E).then(function (res) {
        if (res) _this6.toast("success", "E-mail enviado com sucesso.");else _this6.toast("error", "Não foi possível enviar o e-mail.");

        _this6.email = false;
      });
    },
    getBase64: function getBase64(value) {
      return this.$html2canvas(document.querySelector("#" + value)).then(function (canvas) {
        return canvas.toDataURL("image/png", 0.5);
      });
    },
    exportar: function exportar() {
      var _this7 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
        var nome;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this7.loader = true;

                nome = String(_this7.editedItem.codigo).toUpperCase() + "_" + _this7.mes + _this7.ano + "_" + _this7.$moment().format("YYYY-MM-DD HH:mm:ss").replace(" ", "_").split("-").join("").split(":").join("");


                _this7.$store.dispatch("imagens/ExportarRelatorio", {
                  nome: nome,
                  isMultiple: _this7.editedItem.anos2,
                  ano1: _this7.ano,
                  ano2: _this7.editedItem.anos2 ? Number(_this7.ano) - 1 : false,
                  mes: _this7.meses.find(function (el) {
                    return el.mes == _this7.mes;
                  }).nome,
                  cliente: _this7.editedItem.nome,
                  codigo: _this7.editedItem.codigo,
                  header: String(_this7.editedItem.codigo).toUpperCase() + "_" + _this7.mes + _this7.ano,
                  P1: [_this7.numberWithSpaces(_this7.VALUES.P1.volnegocios), _this7.numberWithSpaces(_this7.VALUES.P1.margembruta), _this7.numberWithSpaces(_this7.T1T3A), _this7.numberWithSpaces(_this7.T1T1A)],
                  P2: _this7.STRINGS,
                  T1: [{
                    text: "Rendimentos e gastos",
                    align: "boldleft",
                    values: ["", "", "", ""]
                  }, {
                    text: "Vendas e serviços prestados",
                    align: "left",
                    values: [_this7.numberWithSpaces(_this7.VALUES.T1A.vendasservicosprestados), _this7.numberWithSpaces(_this7.VALUES.T1B.vendasservicosprestados), _this7.numberWithSpaces(_this7.getDiffT1("vendasservicosprestados").replace("-", "")), _this7.getPercentT1("vendasservicosprestados")]
                  }, {
                    text: "Subsídios à exploração",
                    align: "left",
                    values: [_this7.numberWithSpaces(_this7.VALUES.T1A.subsidiosaexploracao), _this7.numberWithSpaces(_this7.VALUES.T1B.subsidiosaexploracao), _this7.numberWithSpaces(_this7.getDiffT1("subsidiosaexploracao").replace("-", "")), _this7.getPercentT1("subsidiosaexploracao")]
                  }, {
                    text: "Variação nos inventários da produção",
                    align: "left",
                    values: [_this7.numberWithSpaces(_this7.VALUES.T1A.variacaoinventariosprod), _this7.numberWithSpaces(_this7.VALUES.T1B.variacaoinventariosprod), _this7.numberWithSpaces(_this7.getDiffT1("variacaoinventariosprod").replace("-", "")), _this7.getPercentT1("variacaoinventariosprod")]
                  }, {
                    text: "Trabalhos para a própria entidade",
                    align: "left",
                    values: [_this7.numberWithSpaces(_this7.VALUES.T1A.trabalhospropriaentidade), _this7.numberWithSpaces(_this7.VALUES.T1B.trabalhospropriaentidade), _this7.numberWithSpaces(_this7.getDiffT1("trabalhospropriaentidade").replace("-", "")), _this7.getPercentT1("trabalhospropriaentidade")]
                  }, {
                    text: "Custos das mercadorias vendidas e das matérias consumidas",
                    align: "left",
                    values: [_this7.numberWithSpaces(_this7.cmvcmcA), _this7.numberWithSpaces(_this7.cmvcmcB), _this7.numberWithSpaces(_this7.getDiffT1("cmvcmc").replace("-", "")), _this7.getPercentT1("cmvcmc")]
                  }, {
                    text: "Fornecimentos e serviços externos",
                    align: "left",
                    values: [_this7.numberWithSpaces(_this7.VALUES.T1A.fse), _this7.numberWithSpaces(_this7.VALUES.T1B.fse), _this7.numberWithSpaces(_this7.getDiffT1("fse").replace("-", "")), _this7.getPercentT1("fse")]
                  }, {
                    text: "Gastos com o pessoal",
                    align: "left",
                    values: [_this7.numberWithSpaces(_this7.VALUES.T1A.gastoscompessoal), _this7.numberWithSpaces(_this7.VALUES.T1B.gastoscompessoal), _this7.numberWithSpaces(_this7.getDiffT1("gastoscompessoal").replace("-", "")), _this7.getPercentT1("gastoscompessoal")]
                  }, {
                    text: "Imparidade (perdas/reversões)",
                    align: "left",
                    values: [_this7.numberWithSpaces(_this7.VALUES.T1A.imparidade), _this7.numberWithSpaces(_this7.VALUES.T1B.imparidade), _this7.numberWithSpaces(_this7.getDiffT1("imparidade").replace("-", "")), _this7.getPercentT1("imparidade")]
                  }, {
                    text: "Provisões (aumentos/reduções)",
                    align: "left",
                    values: [_this7.numberWithSpaces(_this7.VALUES.T1A.provisoes), _this7.numberWithSpaces(_this7.VALUES.T1B.provisoes), _this7.numberWithSpaces(_this7.getDiffT1("provisoes").replace("-", "")), _this7.getPercentT1("provisoes")]
                  }, {
                    text: "Outros rendimentos e ganhos",
                    align: "left",
                    values: [_this7.numberWithSpaces(_this7.VALUES.T1A.outrosrendimentosganhos), _this7.numberWithSpaces(_this7.VALUES.T1B.outrosrendimentosganhos), _this7.numberWithSpaces(_this7.getDiffT1("outrosrendimentosganhos").replace("-", "")), _this7.getPercentT1("outrosrendimentosganhos")]
                  }, {
                    text: "Outros gastos e perdas",
                    align: "left",
                    values: [_this7.numberWithSpaces(_this7.VALUES.T1A.outrosgastosperdas), _this7.numberWithSpaces(_this7.VALUES.T1B.outrosgastosperdas), _this7.numberWithSpaces(_this7.getDiffT1("outrosgastosperdas").replace("-", "")), _this7.getPercentT1("outrosgastosperdas")]
                  }, {
                    text: "Resultados antes de depreciações, gastos de financiamento e impostos",
                    align: "right",
                    values: [_this7.numberWithSpaces(_this7.T1T1A), _this7.numberWithSpaces(_this7.T1T1B), _this7.numberWithSpaces(_this7.getDiffTotal("1")), _this7.getPercentTotal("1")]
                  }, {
                    text: "Gastos/reversões de depreciação",
                    align: "left",
                    values: [_this7.numberWithSpaces(_this7.VALUES.T1A.gastosreversoesdepreciacao), _this7.numberWithSpaces(_this7.VALUES.T1B.gastosreversoesdepreciacao), _this7.numberWithSpaces(_this7.getDiffT1("gastosreversoesdepreciacao").replace("-", "")), _this7.getPercentT1("gastosreversoesdepreciacao")]
                  }, {
                    text: "Gastos/reversões de amortização",
                    align: "left",
                    values: [_this7.numberWithSpaces(_this7.VALUES.T1A.gastosreversoesdeamortizacao), _this7.numberWithSpaces(_this7.VALUES.T1B.gastosreversoesdeamortizacao), _this7.numberWithSpaces(_this7.getDiffT1("gastosreversoesdeamortizacao").replace("-", "")), _this7.getPercentT1("gastosreversoesdeamortizacao")]
                  }, {
                    text: "Resultado operacional (antes de gastos de financiamento e impostos)",
                    align: "right",
                    values: [_this7.numberWithSpaces(_this7.T1T2A), _this7.numberWithSpaces(_this7.T1T2B), _this7.numberWithSpaces(_this7.getDiffTotal("2")), _this7.getPercentTotal("2")]
                  }, {
                    text: "Gasto líquido de financiamento",
                    align: "left",
                    values: [_this7.numberWithSpaces(_this7.VALUES.T1A.gastoliquidofinanciamento), _this7.numberWithSpaces(_this7.VALUES.T1B.gastoliquidofinanciamento), _this7.numberWithSpaces(_this7.getDiffT1("gastoliquidofinanciamento").replace("-", "")), _this7.getPercentT1("gastoliquidofinanciamento")]
                  }, {
                    text: "Resultado antes de impostos",
                    align: "right",
                    values: [_this7.numberWithSpaces(_this7.T1T3A), _this7.numberWithSpaces(_this7.T1T3B), _this7.numberWithSpaces(_this7.getDiffTotal("3")), _this7.getPercentTotal("3")]
                  }, {
                    text: "Imposto sobre o rendimento do período",
                    align: "left",
                    values: [_this7.numberWithSpaces(_this7.VALUES.T1A.impostosrp), _this7.numberWithSpaces(_this7.VALUES.T1B.impostosrp), _this7.numberWithSpaces(_this7.getDiffT1("impostosrp").replace("-", "")), _this7.getPercentT1("impostosrp")]
                  }, {
                    text: "Resultado líquido do período",
                    align: "right",
                    values: [_this7.numberWithSpaces(_this7.T1T4A), _this7.numberWithSpaces(_this7.T1T4B), _this7.numberWithSpaces(_this7.getDiffTotal("4")), _this7.getPercentTotal("4")]
                  }],
                  T3: [[{
                    value: "Ativos fixos tangíveis",
                    align: "left"
                  }, {
                    value: _this7.numberWithSpaces(_this7.AtivosTangiveisA),
                    align: "right"
                  }, {
                    value: _this7.numberWithSpaces(_this7.AtivosTangiveisB),
                    align: "right"
                  }, {
                    value: "Capital realizado",
                    align: "left"
                  }, {
                    value: _this7.numberWithSpaces(_this7.VALUES.T3A.capitalrealizado),
                    align: "right"
                  }, {
                    value: _this7.numberWithSpaces(_this7.VALUES.T3B.capitalrealizado),
                    align: "right"
                  }], [{
                    value: "Ativos intangíveis",
                    align: "left"
                  }, {
                    value: _this7.numberWithSpaces(_this7.AtivosIntangiveisA),
                    align: "right"
                  }, {
                    value: _this7.numberWithSpaces(_this7.AtivosIntangiveisB),
                    align: "right"
                  }, {
                    value: "Outros instrumentos de capital próprio",
                    align: "left"
                  }, {
                    value: _this7.numberWithSpaces(_this7.VALUES.T3A.outrosintrumentoscapitalproprio),
                    align: "right"
                  }, {
                    value: _this7.numberWithSpaces(_this7.VALUES.T3B.outrosintrumentoscapitalproprio),
                    align: "right"
                  }], [{
                    value: "Investimentos financeiros",
                    align: "left"
                  }, {
                    value: _this7.numberWithSpaces(_this7.VALUES.T3A.investimentosfinanceiros),
                    align: "right"
                  }, {
                    value: _this7.numberWithSpaces(_this7.VALUES.T3B.investimentosfinanceiros),
                    align: "right"
                  }, {
                    value: "Reservas",
                    align: "left"
                  }, {
                    value: _this7.numberWithSpaces(_this7.VALUES.T3A.reservas),
                    align: "right"
                  }, {
                    value: _this7.numberWithSpaces(_this7.VALUES.T3B.reservas),
                    align: "right"
                  }], [{
                    value: "Créditos e outros ativos não correntes",
                    align: "left"
                  }, {
                    value: _this7.numberWithSpaces(_this7.VALUES.T3A.creditosoutrosativosnaocorrentes),
                    align: "right"
                  }, {
                    value: _this7.numberWithSpaces(_this7.VALUES.T3B.creditosoutrosativosnaocorrentes),
                    align: "right"
                  }, {
                    value: "Resultados transitados",
                    align: "left"
                  }, {
                    value: _this7.numberWithSpaces(_this7.VALUES.T3A.resultadostransitados),
                    align: "right"
                  }, {
                    value: _this7.numberWithSpaces(_this7.VALUES.T3B.resultadostransitados),
                    align: "right"
                  }], [{
                    value: "",
                    align: ""
                  }, {
                    value: "",
                    align: ""
                  }, {
                    value: "",
                    align: ""
                  }, {
                    value: "Outras variações de capital próprio",
                    align: "left"
                  }, {
                    value: _this7.numberWithSpaces(_this7.VALUES.T3A.outrasvariacoescapitalproprio),
                    align: "right"
                  }, {
                    value: _this7.numberWithSpaces(_this7.VALUES.T3B.outrasvariacoescapitalproprio),
                    align: "right"
                  }], [{
                    value: "",
                    align: "left"
                  }, {
                    value: "",
                    align: "left"
                  }, {
                    value: "",
                    align: "left"
                  }, {
                    value: "Total",
                    align: "boldleft"
                  }, {
                    value: _this7.numberWithSpaces(_this7.T3T2A),
                    align: "right"
                  }, {
                    value: _this7.numberWithSpaces(_this7.T3T2B),
                    align: "right"
                  }], [{
                    value: "",
                    align: "left"
                  }, {
                    value: "",
                    align: "left"
                  }, {
                    value: "",
                    align: "left"
                  }, {
                    value: "Resultado líquido do período",
                    align: "left"
                  }, {
                    value: _this7.numberWithSpaces(_this7.T1T4A),
                    align: "right"
                  }, {
                    value: _this7.numberWithSpaces(_this7.T1T4B),
                    align: "right"
                  }], [{
                    value: "Total do ativo não corrente",
                    align: "boldright"
                  }, {
                    value: _this7.numberWithSpaces(_this7.T3T1A),
                    align: "right"
                  }, {
                    value: _this7.numberWithSpaces(_this7.T3T1B),
                    align: "right"
                  }, {
                    value: "Total do capital próprio",
                    align: "boldright"
                  }, {
                    value: _this7.numberWithSpaces(_this7.T3T3A),
                    align: "right"
                  }, {
                    value: _this7.numberWithSpaces(_this7.T3T3B),
                    align: "right"
                  }], [{
                    value: "Ativo corrente",
                    align: "boldleft"
                  }, {
                    value: "",
                    align: "left"
                  }, {
                    value: "",
                    align: "left"
                  }, {
                    value: "Passivo",
                    align: "boldleft"
                  }, {
                    value: "",
                    align: "left"
                  }, {
                    value: "",
                    align: "left"
                  }], [{
                    value: "Inventários",
                    align: "left"
                  }, {
                    value: _this7.numberWithSpaces(_this7.VALUES.T3A.inventarios),
                    align: "right"
                  }, {
                    value: _this7.numberWithSpaces(_this7.VALUES.T3B.inventarios),
                    align: "right"
                  }, {
                    value: "Passivo não corrente",
                    align: "boldleft"
                  }, {
                    value: "",
                    align: "left"
                  }, {
                    value: "",
                    align: "left"
                  }], [{
                    value: "Clientes",
                    align: "left"
                  }, {
                    value: _this7.numberWithSpaces(_this7.VALUES.T3A.clientes),
                    align: "right"
                  }, {
                    value: _this7.numberWithSpaces(_this7.VALUES.T3B.clientes),
                    align: "right"
                  }, {
                    value: "Provisões",
                    align: "left"
                  }, {
                    value: _this7.numberWithSpaces(_this7.VALUES.T3A.provisoes),
                    align: "right"
                  }, {
                    value: _this7.numberWithSpaces(_this7.VALUES.T3B.provisoes),
                    align: "right"
                  }], [{
                    value: "Estado e outros entes públicos",
                    align: "left"
                  }, {
                    value: _this7.numberWithSpaces(_this7.VALUES.T3A.estadooutrosentespublicosativo),
                    align: "right"
                  }, {
                    value: _this7.numberWithSpaces(_this7.VALUES.T3B.estadooutrosentespublicosativo),
                    align: "right"
                  }, {
                    value: "Financiamentos obtidos",
                    align: "left"
                  }, {
                    value: _this7.numberWithSpaces(_this7.VALUES.T3A.financiamentosobtidos),
                    align: "right"
                  }, {
                    value: _this7.numberWithSpaces(_this7.VALUES.T3B.financiamentosobtidos),
                    align: "right"
                  }], [{
                    value: "Diferimentos",
                    align: "left"
                  }, {
                    value: _this7.numberWithSpaces(_this7.VALUES.T3A.diferimentosativo),
                    align: "right"
                  }, {
                    value: _this7.numberWithSpaces(_this7.VALUES.T3B.diferimentosativo),
                    align: "right"
                  }, {
                    value: "Outras contas a pagar",
                    align: "left"
                  }, {
                    value: _this7.numberWithSpaces(_this7.VALUES.T3A.outrascontaspagar),
                    align: "right"
                  }, {
                    value: _this7.numberWithSpaces(_this7.VALUES.T3B.outrascontaspagar),
                    align: "right"
                  }], [{
                    value: "Outros ativos correntes",
                    align: "left"
                  }, {
                    value: _this7.numberWithSpaces(_this7.VALUES.T3A.outrosativoscorrentes),
                    align: "right"
                  }, {
                    value: _this7.numberWithSpaces(_this7.VALUES.T3B.outrosativoscorrentes),
                    align: "right"
                  }, {
                    value: "",
                    align: "left"
                  }, {
                    value: "",
                    align: "left"
                  }, {
                    value: "",
                    align: "left"
                  }], [{
                    value: "Caixa e depósitos bancários",
                    align: "left"
                  }, {
                    value: _this7.numberWithSpaces(_this7.VALUES.T3A.caixaedepositosbancarios),
                    align: "right"
                  }, {
                    value: _this7.numberWithSpaces(_this7.VALUES.T3B.caixaedepositosbancarios),
                    align: "right"
                  }, {
                    value: "",
                    align: "left"
                  }, {
                    value: "",
                    align: "left"
                  }, {
                    value: "",
                    align: "left"
                  }], [{
                    value: "Total do ativo corrente",
                    align: "boldright"
                  }, {
                    value: _this7.numberWithSpaces(_this7.T3T4A),
                    align: "right"
                  }, {
                    value: _this7.numberWithSpaces(_this7.T3T4B),
                    align: "right"
                  }, {
                    value: "Total do passivo não corrente",
                    align: "boldright"
                  }, {
                    value: _this7.numberWithSpaces(_this7.T3T5A),
                    align: "right"
                  }, {
                    value: _this7.numberWithSpaces(_this7.T3T5B),
                    align: "right"
                  }], [{
                    value: "",
                    align: "left"
                  }, {
                    value: "",
                    align: "left"
                  }, {
                    value: "",
                    align: "left"
                  }, {
                    value: "Passivo corrente",
                    align: "boldleft"
                  }, {
                    value: "",
                    align: "left"
                  }, {
                    value: "",
                    align: "left"
                  }], [{
                    value: "",
                    align: "left"
                  }, {
                    value: "",
                    align: "left"
                  }, {
                    value: "",
                    align: "left"
                  }, {
                    value: "Fornecedores",
                    align: "left"
                  }, {
                    value: _this7.numberWithSpaces(_this7.VALUES.T3A.fornecedores),
                    align: "right"
                  }, {
                    value: _this7.numberWithSpaces(_this7.VALUES.T3B.fornecedores),
                    align: "right"
                  }], [{
                    value: "",
                    align: "left"
                  }, {
                    value: "",
                    align: "left"
                  }, {
                    value: "",
                    align: "left"
                  }, {
                    value: "Estado e outros entes públicos",
                    align: "left"
                  }, {
                    value: _this7.numberWithSpaces(_this7.VALUES.T3A.estadooutrosentespublicospassivo),
                    align: "right"
                  }, {
                    value: _this7.numberWithSpaces(_this7.VALUES.T3B.estadooutrosentespublicospassivo),
                    align: "right"
                  }], [{
                    value: "",
                    align: "left"
                  }, {
                    value: "",
                    align: "left"
                  }, {
                    value: "",
                    align: "left"
                  }, {
                    value: "Diferimentos",
                    align: "left"
                  }, {
                    value: _this7.numberWithSpaces(_this7.VALUES.T3A.diferimentospassivo),
                    align: "right"
                  }, {
                    value: _this7.numberWithSpaces(_this7.VALUES.T3B.diferimentospassivo),
                    align: "right"
                  }], [{
                    value: "",
                    align: "left"
                  }, {
                    value: "",
                    align: "left"
                  }, {
                    value: "",
                    align: "left"
                  }, {
                    value: "Outros passivos correntes",
                    align: "left"
                  }, {
                    value: _this7.numberWithSpaces(_this7.VALUES.T3A.outrospassivoscorrentes),
                    align: "right"
                  }, {
                    value: _this7.numberWithSpaces(_this7.VALUES.T3B.outrospassivoscorrentes),
                    align: "right"
                  }], [{
                    value: "",
                    align: "left"
                  }, {
                    value: "",
                    align: "left"
                  }, {
                    value: "",
                    align: "left"
                  }, {
                    value: "Total do passivo corrente",
                    align: "boldright"
                  }, {
                    value: _this7.numberWithSpaces(_this7.T3T6A),
                    align: "right"
                  }, {
                    value: _this7.numberWithSpaces(_this7.T3T6B),
                    align: "right"
                  }], [{
                    value: "",
                    align: "left"
                  }, {
                    value: "",
                    align: "left"
                  }, {
                    value: "",
                    align: "left"
                  }, {
                    value: "Total do passivo",
                    align: "boldright"
                  }, {
                    value: _this7.numberWithSpaces(_this7.T3T7A),
                    align: "right"
                  }, {
                    value: _this7.numberWithSpaces(_this7.T3T7B),
                    align: "right"
                  }], [{
                    value: "",
                    align: "left"
                  }, {
                    value: "",
                    align: "left"
                  }, {
                    value: "",
                    align: "left"
                  }, {
                    value: "",
                    align: "left"
                  }, {
                    value: "",
                    align: "left"
                  }, {
                    value: "",
                    align: "left"
                  }], [{
                    value: "Total do ativo",
                    align: "boldright"
                  }, {
                    value: _this7.numberWithSpaces(_this7.T3T8A),
                    align: "right"
                  }, {
                    value: _this7.numberWithSpaces(_this7.T3T8B),
                    align: "right"
                  }, {
                    value: "Total do capital próprio e do passivo",
                    align: "boldright"
                  }, {
                    value: _this7.numberWithSpaces(_this7.T3T9A),
                    align: "right"
                  }, {
                    value: _this7.numberWithSpaces(_this7.T3T9B),
                    align: "right"
                  }]],
                  CH1: document.querySelector("#CH1 canvas").toDataURL("image/png", 0.5),
                  CH2: document.querySelector("#CH2 canvas").toDataURL("image/png", 0.5),
                  CH3: document.querySelector("#CH3 canvas").toDataURL("image/png", 0.5),
                  CH4: document.querySelector("#CH4 canvas").toDataURL("image/png", 0.5),
                  CH5: document.querySelector("#CH5 canvas").toDataURL("image/png", 0.5),
                  CH6: document.querySelector("#CH6 canvas").toDataURL("image/png", 0.5),
                  CH7: document.querySelector("#CH7 canvas").toDataURL("image/png", 0.5),
                  //T4: await this.getBase64('T4'),
                  T2: _this7.VALUES.CH5.TABELA.map(function (el) {
                    return {
                      text: el.ordem + " - " + el.conta,
                      value: _this7.numberWithSpaces(parseFloat(el.saldo.replace(",", ".")).toFixed(2))
                    };
                  }).concat([{
                    text: "Total",
                    value: _this7.numberWithSpaces(_this7.getTotalByProperty(_this7.VALUES.CH5.TABELA, "saldo"))
                  }]),
                  T4: [[{
                    text: "Indicadores de rentabilidade",
                    align: "bold",
                    color: "#000"
                  }, {
                    text: "",
                    align: "bold",
                    color: "#000"
                  }], [{
                    text: "Margem bruta sobre as vendas (1)",
                    align: "normal",
                    color: "#000"
                  }, {
                    text: _this7.T4T1 + "%",
                    align: "right",
                    color: parseFloat(_this7.T4T1) >= 0 ? "rgb(98, 150, 103, 0.5)" : "red"
                  }], [{
                    text: "Rendibilidade das vendas (2)",
                    align: "normal",
                    color: "#000"
                  }, {
                    text: _this7.T4T2 + "%",
                    align: "right",
                    color: parseFloat(_this7.T4T2) >= 0 ? "rgb(98, 150, 103, 0.5)" : "red"
                  }], [{
                    text: "Rendibilidade dos capitais próprios (3)",
                    align: "normal",
                    color: "#000"
                  }, {
                    text: _this7.T4T3 + "%",
                    align: "right",
                    color: parseFloat(_this7.T4T3) >= 0 ? "rgb(98, 150, 103, 0.5)" : "red"
                  }], [{
                    text: "Rendibilidade do ativo (4)",
                    align: "normal",
                    color: "#000"
                  }, {
                    text: _this7.T4T4 + "%",
                    align: "right",
                    color: parseFloat(_this7.T4T4) >= 0 ? "rgb(98, 150, 103, 0.5)" : "red"
                  }], [{
                    text: "Indicadores de endividamento",
                    align: "bold",
                    color: "#000"
                  }, {
                    text: "",
                    align: "right",
                    color: "#000"
                  }], [{
                    text: "Autonomia financeira (5)",
                    align: "normal",
                    color: "#000"
                  }, {
                    text: _this7.T4T5 + "%",
                    align: "right",
                    color: parseFloat(_this7.T4T5) >= 50 ? "green" : "red"
                  }], [{
                    text: "Peso do passivo (6)",
                    align: "normal",
                    color: "#000"
                  }, {
                    text: _this7.T4T6 + "%",
                    align: "right",
                    color: parseFloat(_this7.T4T6) >= 50 ? "red" : "green"
                  }], [{
                    text: "Indicadores de atividade",
                    align: "bold",
                    color: "#000"
                  }, {
                    text: "",
                    align: "right",
                    color: "#000"
                  }], [{
                    text: "Prazo médio de recebimento (7)",
                    align: "normal",
                    color: "#000"
                  }, {
                    text: _this7.T4T7,
                    align: "right",
                    color: "#000"
                  }], [{
                    text: "Prazo médio de pagamento (8)",
                    align: "normal",
                    color: "#000"
                  }, {
                    text: _this7.T4T8,
                    align: "right",
                    color: "#000"
                  }], [{
                    text: "Rácio de Rotação do Ativo (9)",
                    align: "normal",
                    color: "#000"
                  }, {
                    text: _this7.T4T9,
                    align: "right",
                    color: "#000"
                  }], [{
                    text: "Indicadores de liquidez",
                    align: "bold",
                    color: "#000"
                  }, {
                    text: "",
                    align: "right",
                    color: "#000"
                  }], [{
                    text: "Indicador de liquidez geral (10)",
                    align: "normal",
                    color: "#000"
                  }, {
                    text: _this7.T4T10,
                    align: "right",
                    color: parseFloat(_this7.T4T10.replace(".", ",")) >= 2 ? "green" : parseFloat(_this7.T4T10.replace(".", ",")) >= 1 && parseFloat(_this7.T4T10.replace(".", ",")) < 2 ? "orange" : "red"
                  }], [{
                    text: "Indicador de liquidez reduzida (11)",
                    align: "normal",
                    color: "#000"
                  }, {
                    text: _this7.T4T11,
                    align: "right",
                    color: parseFloat(_this7.T4T11.replace(".", ",")) >= 2 ? "green" : parseFloat(_this7.T4T11.replace(".", ",")) >= 1 && parseFloat(_this7.T4T11.replace(".", ",")) < 2 ? "orange" : "red"
                  }], [{
                    text: "Indicador de liquidez imediata (12)",
                    align: "normal",
                    color: "#000"
                  }, {
                    text: _this7.T4T12,
                    align: "right",
                    color: parseFloat(_this7.T4T12.replace(".", ",")) >= 2 ? "green" : parseFloat(_this7.T4T12.replace(".", ",")) >= 1 && parseFloat(_this7.T4T12.replace(".", ",")) < 2 ? "orange" : "red"
                  }]]
                }).then(function (res) {
                  if (res) {
                    _this7.path = _this7.$fileURL + _this7.editedItem.codigo + "/Relatórios Gestão/" + nome + ".pdf";

                    window.open(_this7.path, "_blank");
                    _this7.loader = false;
                  } else {
                    _this7.toast("error", "Não foi possível exportar os dados apresentados.");
                    _this7.loader = false;
                  }
                });

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this7);
      }))();
    },
    getTotalByProperty: function getTotalByProperty(array, prop) {
      if (array.length == 0) return 0;else return array.map(function (el) {
        return el[prop];
      }).reduce(function (a, b) {
        return (parseFloat(String(a).replace(",", ".")) + parseFloat(String(b).replace(",", "."))).toFixed(2);
      }) + " €";
    },
    searchData: function searchData() {
      var _this8 = this;

      var url = this.getLinks.rgURL;
      this.loader = true;
      var options = {
        method: "POST",
        crossDomain: true,
        async: true,
        headers: {
          "content-type": "application/x-www-form-urlencoded"
        },
        data: __WEBPACK_IMPORTED_MODULE_9_qs___default.a.stringify({
          invocationPassword: this.$servicePWD,
          cliente: this.editedItem.codigo,
          ano: this.ano,
          mesfim: this.mes,
          mes: ""
        }),
        url: url
      };

      __WEBPACK_IMPORTED_MODULE_8_axios___default()(options).then(function (res) {
        var str = JSON.parse(__WEBPACK_IMPORTED_MODULE_10_xml_js___default.a.xml2json(res.data, {
          compact: true,
          spaces: 4
        })).string._text;

        var result = JSON.parse("[" + str + "]");

        _this8.REPORT = Array.isArray(result) ? [].concat(result) : [];

        if (_this8.REPORT.length == 0) _this8.toast("error", "Não foram encontrados resultados para a pesquisa efetuada.");else {
          // -- P1
          _this8.VALUES.P1.volnegocios = _this8.getValues(_this8.REPORT[0], "volnegocios");
          _this8.VALUES.P1.margembruta = _this8.getValues(_this8.REPORT[0], "margembruta");

          // -- T1
          _this8.VALUES.T1A.vendasservicosprestados = _this8.getValues(_this8.REPORT[1], "vendasservicosprestados");
          _this8.VALUES.T1A.subsidiosaexploracao = _this8.getValues(_this8.REPORT[1], "subsidiosaexploracao");
          _this8.VALUES.T1A.variacaoinventariosprod = _this8.getValues(_this8.REPORT[1], "variacaoinventariosprod");
          _this8.VALUES.T1A.trabalhospropriaentidade = _this8.getValues(_this8.REPORT[1], "trabalhospropriaentidade");
          _this8.VALUES.T1A.cmvcmc = _this8.getValues(_this8.REPORT[1], "cmvcmc");
          _this8.VALUES.T1A.fse = _this8.getValues(_this8.REPORT[1], "fse");
          _this8.VALUES.T1A.gastoscompessoal = _this8.getValues(_this8.REPORT[1], "gastoscompessoal");
          _this8.VALUES.T1A.gastosreversoesdepreciacao = _this8.getValues(_this8.REPORT[1], "gastosreversoesdepreciacao");
          _this8.VALUES.T1A.gastosreversoesdeamortizacao = _this8.getValues(_this8.REPORT[1], "gastosreversoesdeamortizacao");
          _this8.VALUES.T1A.imparidade = _this8.getValues(_this8.REPORT[1], "imparidade");
          _this8.VALUES.T1A.provisoes = _this8.getValues(_this8.REPORT[1], "provisoes");
          _this8.VALUES.T1A.outrosrendimentosganhos = _this8.getValues(_this8.REPORT[1], "outrosrendimentosganhos");
          _this8.VALUES.T1A.outrosgastosperdas = _this8.getValues(_this8.REPORT[1], "outrosgastosperdas");
          _this8.VALUES.T1A.saldoconta79 = _this8.getValues(_this8.REPORT[1], "saldoconta79");
          _this8.VALUES.T1A.saldoconta69 = _this8.getValues(_this8.REPORT[1], "saldoconta69");
          _this8.VALUES.T1A.gastoliquidofinanciamento = _this8.getValues(_this8.REPORT[1], "gastoliquidofinanciamento");
          _this8.VALUES.T1A.impostosrp = _this8.getValues(_this8.REPORT[1], "impostosrp");

          // -- CH1
          _this8.VALUES.CH1.MESES = _this8.REPORT[2].map(function (el) {
            return el.mes;
          });
          _this8.VALUES.CH1.EMV = _this8.REPORT[2].map(function (el) {
            return parseFloat(parseFloat(el.vendas.replace(",", ".")).toFixed(2));
          });
          _this8.VALUES.CH1.CMVMC = _this8.REPORT[2].map(function (el) {
            return parseFloat(parseFloat(el.cmvmc.replace(",", ".")).toFixed(2));
          });
          _this8.VALUES.CH1.MB = _this8.REPORT[2].map(function (el) {
            return parseFloat(parseFloat(el.margembruta.replace(",", ".")).toFixed(2));
          });

          // -- CH2
          _this8.VALUES.CH2.MESES = _this8.REPORT[2].map(function (el) {
            return el.mes;
          });
          _this8.VALUES.CH2.FSEM = _this8.REPORT[2].map(function (el) {
            return parseFloat(parseFloat(el.fsemaisoutrosgastos.replace(",", ".")).toFixed(2));
          });
          _this8.VALUES.CH2.OG = _this8.REPORT[2].map(function (el) {
            return parseFloat(parseFloat(el.outrosgastos.replace(",", ".")).toFixed(2));
          });
          _this8.VALUES.CH2.MB = _this8.REPORT[2].map(function (el) {
            return parseFloat(parseFloat(el.margembruta.replace(",", ".")).toFixed(2));
          });

          // -- CH3
          _this8.VALUES.CH3.MESES = _this8.REPORT[2].map(function (el) {
            return el.mes;
          });
          _this8.VALUES.CH3.FSEM = _this8.REPORT[2].map(function (el) {
            return parseFloat(parseFloat(el.fsemaisoutrosgastos.replace(",", ".")).toFixed(2));
          });
          _this8.VALUES.CH3.FSE = _this8.REPORT[2].map(function (el) {
            return parseFloat(parseFloat(el.fse.replace(",", ".")).toFixed(2));
          });
          _this8.VALUES.CH3.OG = _this8.REPORT[2].map(function (el) {
            return parseFloat(parseFloat(el.outrosgastos.replace(",", ".")).toFixed(2));
          });

          // -- CH4
          _this8.VALUES.CH4.MESES = _this8.REPORT[3].map(function (el) {
            return el.mes;
          });
          _this8.VALUES.CH4.C68 = _this8.REPORT[3].map(function (el) {
            return parseFloat(parseFloat(el.conta68.replace(",", ".")).toFixed(2));
          });
          _this8.VALUES.CH4.C69 = _this8.REPORT[3].map(function (el) {
            return parseFloat(parseFloat(el.conta69.replace(",", ".")).toFixed(2));
          });
          _this8.VALUES.CH4.C6869 = _this8.REPORT[3].map(function (el) {
            return parseFloat(parseFloat(el.contas68e69.replace(",", ".")).toFixed(2));
          });

          // -- CH5
          _this8.VALUES.CH5.ORDEM = _this8.REPORT[4].map(function (el) {
            return el.ordem;
          });
          _this8.VALUES.CH5.G = _this8.REPORT[4].map(function (el) {
            return parseFloat(parseFloat(el.saldo.replace(",", ".")).toFixed(2));
          });
          _this8.VALUES.CH5.TABELA = _this8.REPORT[4];

          // -- T3
          _this8.VALUES.T3A.saldo11 = _this8.getValues(_this8.REPORT[5], "saldo11");
          _this8.VALUES.T3A.saldo12 = _this8.getValues(_this8.REPORT[5], "saldo12");
          _this8.VALUES.T3A.saldo13 = _this8.getValues(_this8.REPORT[5], "saldo13");
          _this8.VALUES.T3A.saldo14ativo = _this8.getValues(_this8.REPORT[5], "saldo14ativo");
          _this8.VALUES.T3A.clientes = _this8.getValues(_this8.REPORT[5], "clientes");
          _this8.VALUES.T3A.fornecedores = _this8.getValues(_this8.REPORT[5], "fornecedores");
          _this8.VALUES.T3A.saldo23passivo = _this8.getValues(_this8.REPORT[5], "saldo23passivo");
          _this8.VALUES.T3A.estadooutrosentespublicospassivo = _this8.getValues(_this8.REPORT[5], "estadooutrosentespublicospassivo");
          _this8.VALUES.T3A.financiamentosobtidos = _this8.getValues(_this8.REPORT[5], "financiamentosobtidos");
          _this8.VALUES.T3A.saldo27passivo = _this8.getValues(_this8.REPORT[5], "saldo27passivo");
          _this8.VALUES.T3A.inventarios = _this8.getValues(_this8.REPORT[5], "inventarios");
          _this8.VALUES.T3A.investimentosfinanceiros = _this8.getValues(_this8.REPORT[5], "investimentosfinanceiros");
          _this8.VALUES.T3A.saldo43 = _this8.getValues(_this8.REPORT[5], "saldo43");
          _this8.VALUES.T3A.saldo44 = _this8.getValues(_this8.REPORT[5], "saldo44");
          _this8.VALUES.T3A.capitalrealizado = _this8.getValues(_this8.REPORT[5], "capitalrealizado");
          _this8.VALUES.T3A.reservas = _this8.getValues(_this8.REPORT[5], "reservas");
          _this8.VALUES.T3A.resultadostransitados = _this8.getValues(_this8.REPORT[5], "resultadostransitados");
          _this8.VALUES.T3A.diferimentosativo = _this8.getValues(_this8.REPORT[5], "diferimentosativo");
          _this8.VALUES.T3A.ativostangiveis = _this8.getValues(_this8.REPORT[5], "ativostangiveis");
          _this8.VALUES.T3A.ativosintangiveis = _this8.getValues(_this8.REPORT[5], "ativosintangiveis");
          _this8.VALUES.T3A.outrosativoscorrentes = _this8.getValues(_this8.REPORT[5], "outrosativoscorrentes");
          _this8.VALUES.T3A.outrospassivoscorrentes = _this8.getValues(_this8.REPORT[5], "outrospassivoscorrentes");
          _this8.VALUES.T3A.caixaedepositosbancarios = _this8.getValues(_this8.REPORT[5], "caixaedepositosbancarios");
          _this8.VALUES.T3A.outrasvariacoescapitalproprio = _this8.getValues(_this8.REPORT[5], "outrasvariacoescapitalproprio");
          _this8.VALUES.T3A.outrosintrumentoscapitalproprio = _this8.getValues(_this8.REPORT[5], "outrosintrumentoscapitalproprio");
          _this8.VALUES.T3A.estadooutrosentespublicosativo = _this8.getValues(_this8.REPORT[5], "estadooutrosentespublicosativo");
          _this8.VALUES.T3A.diferimentospassivo = _this8.getValues(_this8.REPORT[5], "diferimentospassivo");
          _this8.VALUES.T3A.provisoes = _this8.getValues(_this8.REPORT[5], "provisoes");

          _this8.VALUES.T3A.displayCH6 = true;
          _this8.VALUES.T3A.displayCH7 = true;

          //this.$forceUpdate();
        }
        _this8.dialog = true;
        _this8.loader = false;
      }).catch(function (err) {
        //console.log(err);
        _this8.loader = false;
        _this8.toast("error", "Não foram encontrados resultados para a pesquisa efetuada.");
      });
    },
    getDiffT1: function getDiffT1(field) {
      var a = parseFloat(this.VALUES.T1A[field]) > 0;
      var total = a ? parseFloat(String(this.VALUES.T1A[field]).replace("-", "")) - parseFloat(String(this.VALUES.T1B[field]).replace("-", "")) : null;

      return total != null ? parseFloat(total).toFixed(2) : "-";
    },
    getPercentT1: function getPercentT1(field) {
      var a = parseFloat(this.VALUES.T1A[field]) > 0;
      var total = a ? parseFloat(this.getDiffT1(field) * 100) / parseFloat(String(this.VALUES.T1B[field]).replace("-", "")) : null;

      return total != null && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_finite___default()(total) ? this.numberWithSpaces(parseFloat(total).toFixed(2)) : "-";
    },
    getDiffTotal: function getDiffTotal(field) {
      if (field == "1") {
        return parseFloat(parseFloat(String(this.T1T1A).replace("-", "")) - parseFloat(String(this.T1T1B).replace("-", ""))).toFixed(2);
      } else if (field == "2") {
        return parseFloat(parseFloat(String(this.T1T2A).replace("-", "")) - parseFloat(String(this.T1T2B).replace("-", ""))).toFixed(2);
      } else if (field == "3") {
        return parseFloat(parseFloat(String(this.T1T3A).replace("-", "")) - parseFloat(String(this.T1T3B).replace("-", ""))).toFixed(2);
      } else if (field == "4") {
        return parseFloat(parseFloat(String(this.T1T4A).replace("-", "")) - parseFloat(String(this.T1T4B).replace("-", ""))).toFixed(2);
      }
    },
    getPercentTotal: function getPercentTotal(field) {
      var total = 0;
      if (field == "1") {
        total = parseFloat(this.getDiffTotal(field)).toFixed(2) * 100 / parseFloat(parseFloat(String(this.T1T1A).replace("-", "")));
      } else if (field == "2") {
        total = parseFloat(this.getDiffTotal(field)).toFixed(2) * 100 / parseFloat(parseFloat(String(this.T1T2A).replace("-", "")));
      } else if (field == "3") {
        total = parseFloat(this.getDiffTotal(field)).toFixed(2) * 100 / parseFloat(parseFloat(String(this.T1T3A).replace("-", "")));
      } else if (field == "4") {
        total = parseFloat(this.getDiffTotal(field)).toFixed(2) * 100 / parseFloat(parseFloat(String(this.T1T4A).replace("-", "")));
      }

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_finite___default()(total) ? parseFloat(total).toFixed(2) : 0.0;
    },
    getValues: function getValues(array, field) {
      var val = array.find(function (el) {
        return el.nomecampo == field;
      });

      if (field == "resultadostransitados" || field == "capitalrealizado" || field == "reservas" || field == "outrasvariacoescapitalproprio" || field == "outrosintrumentoscapitalproprio") return typeof val == "undefined" ? 0 : parseFloat(val.valorcampo.replace(",", ".")).toFixed(2);else return typeof val == "undefined" ? 0 : parseFloat(val.valorcampo.replace("-", "").replace(",", ".")).toFixed(2);
    },
    initialize: function initialize() {
      this.loading = true;
      this.DATA = this.getAll;
      this.loading = false;
    },
    editItem: function editItem(item, dialog) {
      this.editedIndex = this.DATA.indexOf(item);
      this.editedItem = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()({}, item);

      if (dialog) this.modal = true;else this.deleteM = true;
    },
    editItemPassword: function editItemPassword(item, dialog) {
      this.editedPasswordIndex = this.DATA.indexOf(item);
      this.editedItemPassword = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()({}, item);

      if (dialog) this.modalPassword = true;else this.deleteM = true;
    },
    gerar: function gerar() {
      this.form = false;
      this.searchData();
    },
    getReport: function getReport(item) {
      this.editedIndex = this.DATA.indexOf(item);
      this.editedItem = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()({}, item);

      this.form = true;
      //this.$eventBus.$emit("relatorio", item.codigo);
    },
    delete: function _delete() {
      var _this9 = this;

      if (!this.editedItem.id_utilizador) return;

      this.$store.dispatch(this.table + "/delete", {
        id: this.editedItem.id_utilizador
      }).then(function (res) {
        if (res) {
          _this9.toast("success", _this9.messages.delete.success);
          _this9.initialize();
        } else _this9.toast("error", _this9.messages.delete.error);

        _this9.deleteM = false;
      });
    },
    close: function close() {
      var _this10 = this;

      this.modal = this.deleteM = this.dialog = this.form = false;
      setTimeout(function () {
        _this10.editedItem = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()({}, _this10.defaultItem);
        _this10.editedIndex = -1;

        _this10.path = null;
        _this10.E = {};
        _this10.VALUES = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()({}, _this10.defaultValues);

        _this10.$refs.form.reset();
      }, 110);
    },
    saveNewPassword: function saveNewPassword() {
      var _this11 = this;

      if (this.editedPasswordIndex != -1) {
        this.$store.dispatch(this.table + "/new_password", {
          id_utilizador: this.editedItemPassword.id_utilizador,
          password: this.editedItemPassword.password
        }).then(function (res) {
          if (res) {
            _this11.toast("success", "Password editada com sucesso");
            _this11.initialize();
          } else _this11.toast("error", _this11.messages.add.error);

          _this11.modalPassword = false;
        });
      }
    },
    save: function save() {
      var _this12 = this;

      if (this.deleteM) {
        this.delete();
        return;
      }

      if (!this.$refs.form.validate()) {
        var errors = [];
        this.$refs.form.inputs.forEach(function (e) {
          if (e.errorBucket && e.errorBucket.length) {
            console.log(e);
            errors.push.apply(errors, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(e.errorBucket));
          }
        });
        console.log(errors);
        return;
      }

      if (this.editedIndex == -1) {
        this.$store.dispatch(this.table + "/insert", {
          nome: this.editedItem.nome,
          email: this.editedItem.email,
          password: this.editedItem.password,
          codigo: String(this.editedItem.codigo).toUpperCase(),
          ano: this.editedItem.ano,
          urlwebsite: this.editedItem.urlwebsite,
          pastas: this.editedItem.pastas,
          nif: this.editedItem.nif,
          super: 0,
          ativo: 1,
          anos2: this.editedItem.anos2,
          escritorio: this.editedItem.id_escritorio,
          telefone: this.editedItem.telefone
        }).then(function (res) {
          if (res) {
            _this12.toast("success", _this12.messages.add.success);
            _this12.initialize();
          } else _this12.toast("error", _this12.messages.add.error);

          _this12.modal = false;
        });
      } else {
        this.$store.dispatch(this.table + "/update", {
          id: this.editedItem.id_utilizador,
          nome: this.editedItem.nome,
          email: this.editedItem.email,
          codigo: String(this.editedItem.codigo).toUpperCase(),
          ano: this.editedItem.ano,
          urlwebsite: this.editedItem.urlwebsite,
          pastas: this.editedItem.pastas,
          nif: this.editedItem.nif,
          super: 0,
          ativo: 1,
          anos2: this.editedItem.anos2,
          escritorio: this.editedItem.id_escritorio,
          telefone: this.editedItem.telefone
        }).then(function (res) {
          if (res) {
            _this12.toast("success", _this12.messages.update.success);
            _this12.initialize();
          } else _this12.toast("error", _this12.messages.update.error);

          _this12.modal = false;
        });
      }
    }
  }
});

/***/ }),

/***/ 528:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(527);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_qs__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_qs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_xml_js__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_xml_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_xml_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_d3__ = __webpack_require__(1016);





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








var cName = {
    upper: "Extrato de conta",
    lower: "o extrato de conta!"
};

/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            table: 'utilizadores',
            name: 'extrato',
            search: "",
            loading: false,
            loader: false,
            searchP: '',
            headers: [{
                text: "Data",
                align: "left",
                sortable: true,
                value: "datamov"
            }, {
                text: "Diário",
                align: "left",
                sortable: true,
                value: "diario"
            }, {
                text: "Nº Int.",
                align: "left",
                sortable: true,
                value: "numinterno"
            }, {
                text: "Descrição",
                align: "left",
                sortable: true,
                value: "descricaolancamento"
            }, {
                text: "Documento",
                align: "left",
                sortable: true,
                value: "documento"
            }, {
                text: "Obs",
                align: "left",
                sortable: true,
                value: "observacoes"
            }, {
                text: "Débito €",
                align: "right",
                sortable: true,
                value: "debito"
            }, {
                text: "Crédito €",
                align: "right",
                sortable: true,
                value: "credito"
            }, {
                text: "Saldo €",
                align: "right",
                sortable: true,
                value: "saldo"
            }],
            anos: [],
            DATA: [],
            iniMenu: false,
            ini: '',
            fimMenu: false,
            fim: '',
            isIni: false,
            isFim: false,
            isLista: '0',
            cliente: '',
            ano: '',
            cinicio: '',
            cfim: '',
            listacontas: '',
            timer: null,
            STATS: [],
            SUBCONTAS: [],
            CONTAS: [],
            SUBCONTA: '',
            CONTA: '',
            first: '',
            last: '',
            messages: {
                add: {
                    success: cName.upper + " criado com sucesso!",
                    error: "Ocorreu um erro ao criar " + cName.lower
                },
                update: {
                    success: cName.upper + " alterado com sucesso!",
                    error: "Ocorreu um erro ao alterar " + cName.lower
                },
                delete: {
                    success: cName.upper + " eliminado com sucesso!",
                    error: "Ocorreu um erro ao apagar " + cName.lower
                },
                default: {
                    sucesso: "Sucesso",
                    error: "Ocorreu um erro!"
                }
            }
        };
    },

    computed: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapGetters */])({
        getSession: 'session/getState',
        getClientes: 'utilizadores/getClientes',
        getContasByCodigo: 'contas/getContasByCodigo',
        getFirstLastContas: 'contas/getFirstLastContas',
        getClienteByCodigo: 'utilizadores/getClienteByCodigo',
        getClienteById: 'utilizadores/getById',
        getLinks: 'session/getLinks'
    }), {
        isIniIcon: function isIniIcon() {
            return this.isIni ? "check_box" : "check_box_outline_blank";
        },
        isFimIcon: function isFimIcon() {
            return this.isFim ? "check_box" : "check_box_outline_blank";
        }
    }),

    watch: {},

    created: function created() {
        var _this = this;

        //this.ano = Number(this.$moment().format('YYYY'));
        if (this.getSession.user.super == 0) this.cliente = this.getSession.user.id_utilizador;

        setTimeout(function () {
            try {
                _this.setAnos();
            } catch (error) {
                setTimeout(function () {
                    try {
                        _this.setAnos();
                    } catch (error) {}
                }, 500);
            }
        }, 500);
    },

    methods: {
        setAnos: function setAnos() {
            if (this.getSession.user.super == 0) this.anos = this.getSession.user.anos;else this.anos = this.getClienteById(this.cliente).anos;
        },
        numberWithSpaces: function numberWithSpaces(x) {
            var parts = x.toString().replace('.', ',').split(".");
            parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, " ");
            return parts.join(".");
        },
        toast: function toast(type, message) {
            if (type == "success") {
                return iziToast.show({
                    title: "SUCESSO",
                    color: "green",
                    timeout: this.$toastTimeout,
                    message: message,
                    position: this.$toastPosition
                });
            } else {
                return iziToast.show({
                    title: "AVISO",
                    color: "red",
                    timeout: this.$toastTimeout,
                    message: message,
                    position: this.$toastPosition
                });
            }
        },
        generatePdfAll: function generatePdfAll() {
            var _this2 = this;

            if (this.STATS.length == 0) return;

            this.loader = true;
            var cliente = this.getSession.user.super == 1 ? this.getClienteById(this.cliente) : this.getSession.user;
            var nome = this.$moment().unix();
            this.$store.dispatch('contas/generatePdfExtratoAll', {
                data: this.STATS,
                cliente: cliente.codigo + ' - ' + cliente.nome,
                nif: cliente.nif,
                nome: nome,
                inicio: this.ini,
                fim: this.fim
            }).then(function (res) {
                if (res) window.open(_this2.$pdfURL + nome + '.pdf', '_blank');else _this2.toast('error', 'Ocorreu um erro ao exportar.');

                _this2.loader = false;
            });
        },
        generatePdf: function generatePdf() {
            var _this3 = this;

            if (this.DATA.length == 0) return;

            this.loader = true;

            var cliente = this.getSession.user.super == 1 ? this.getClienteById(this.cliente) : this.getSession.user;

            var nome = this.$moment().unix();
            this.$store.dispatch('contas/generatePdfExtrato', {
                data: this.STATS.find(function (el) {
                    return el.key == _this3.SUBCONTA;
                }),
                cliente: cliente.codigo + ' - ' + cliente.nome,
                nif: cliente.nif,
                nome: nome,
                inicio: this.ini,
                fim: this.fim
            }).then(function (res) {
                if (res) window.open(_this3.$pdfURL + nome + '.pdf', '_blank');else _this3.toast('error', 'Ocorreu um erro ao exportar.');

                _this3.loader = false;
            });
        },
        getTotalByProperty: function getTotalByProperty(prop) {
            if (this.DATA.length == 0) return 0;

            if (prop === 'saldo') {
                //return Math.max.apply(Math,this.DATA.map((el)=>{ return parseFloat(String(el[prop]).replace(',','.')) })).toFixed(2) + ' €';
                var array = this.DATA.map(function (el) {
                    return parseFloat(String(el[prop]).replace(',', '.'));
                });

                return parseFloat(array[array.length - 1]).toFixed(2) + ' €';
            } else return this.DATA.map(function (el) {
                return el[prop];
            }).reduce(function (a, b) {
                return (parseFloat(String(a).replace(',', '.')) + parseFloat(String(b).replace(',', '.'))).toFixed(2);
            }) + ' €';
        },
        getTotalByPropArray: function getTotalByPropArray(array, prop) {
            if (prop === 'saldo') {
                //return Math.max.apply(Math,this.DATA.map((el)=>{ return parseFloat(String(el[prop]).replace(',','.')) })).toFixed(2) + ' €';
                var array = array.map(function (el) {
                    return parseFloat(String(el[prop]).replace(',', '.'));
                });

                return parseFloat(array[array.length - 1]).toFixed(2) + ' €';
            } else return array.map(function (el) {
                return el[prop];
            }).reduce(function (a, b) {
                return (parseFloat(String(a).replace(',', '.')) + parseFloat(String(b).replace(',', '.'))).toFixed(2);
            }) + ' €';
        },
        isIniChange: function isIniChange() {
            this.isIni = !this.isIni;
        },
        isFimChange: function isFimChange() {
            this.isFim = !this.isFim;
        },
        changeIsLista: function changeIsLista() {
            if (String(this.isLista) == '0') {
                this.cinicio = this.first;
                this.cfim = this.last;
            }
        },
        changeCI: function changeCI() {
            var _this4 = this;

            if (!this.cinicio) return;

            this.getContasByCodigo(this.cinicio).then(function (res) {
                if (res.length == 0) {
                    _this4.toast('error', 'Conta inexistente.');_this4.removeCI();
                }
            });
        },
        changeCF: function changeCF() {
            var _this5 = this;

            if (!this.cfim) return;

            this.getContasByCodigo(this.cfim).then(function (res) {
                if (res.length == 0 || _this5.cfim <= _this5.cinicio) {
                    _this5.toast('error', 'Conta inexistente.');_this5.removeCF();
                }
            });
        },
        changeLC: function changeLC() {
            var _this6 = this;

            if (this.listacontas.length == 0) return;

            this.getContasByCodigo(this.listacontas[this.listacontas.length - 1]).then(function (res) {
                if (res.length == 0) {
                    _this6.toast('error', 'Conta inexistente.');_this6.removeLC(_this6.listacontas.length - 1);
                }
            });
        },
        removeCI: function removeCI() {
            this.cinicio = null;
        },
        removeCF: function removeCF() {
            this.cfim = null;
        },
        removeLC: function removeLC(item) {
            this.listacontas.splice(this.listacontas.indexOf(item), 1);
            this.listacontas = [].concat(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(this.listacontas));
        },
        StatPerConta: function StatPerConta(contas) {
            var _this7 = this;

            var value = __WEBPACK_IMPORTED_MODULE_9_d3__["a" /* nest */]().key(function (d) {
                return d.codigoconta + ' - ' + d.designacao;
            }).rollup(function (v) {
                return {
                    dados: v,
                    totalDebito: _this7.getTotalByPropArray(v, 'debito'),
                    totalCredito: _this7.getTotalByPropArray(v, 'credito'),
                    totalSaldo: _this7.getTotalByPropArray(v, 'saldo'),
                    contaPrincipal: v[0].codcontaprincipal
                };
            }).entries(contas);
            return value;
        },
        changeSubConta: function changeSubConta() {
            var _this8 = this;

            this.DATA = this.STATS.find(function (el) {
                return el.key == _this8.SUBCONTA;
            }).value.dados;
        },
        changeConta: function changeConta() {
            var _this9 = this;

            this.SUBCONTAS = this.STATS.filter(function (el) {
                return String(el.value.contaPrincipal) == String(_this9.CONTA.split('-')[0].trim());
            }).map(function (el) {
                return el.key;
            });
            this.SUBCONTA = this.SUBCONTAS[0];
            this.changeSubConta();
        },
        changeAno: function changeAno() {
            var _this10 = this;

            this.cinicio = '';
            this.cfim = '';
            this.listacontas = '';

            var codigo = this.getSession.user.super == 1 ? this.getClienteById(this.cliente).codigo : this.getSession.user.codigo;

            this.$store.dispatch('contas/clearData').then(function (res) {
                _this10.$store.dispatch('contas/get', {
                    pwd: _this10.$servicePWD,
                    cliente: codigo,
                    ano: _this10.ano,
                    url: _this10.getLinks.contasURL
                }).then(function () {
                    var get = _this10.getFirstLastContas;

                    if (get) {
                        _this10.first = get.first;
                        _this10.last = get.last;
                        _this10.cinicio = get.first;
                        _this10.cfim = get.last;
                    }
                });
            });
        },
        splitContas: function splitContas(array) {
            var aux = [];

            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(array), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var a = _step.value;
                    if (aux.indexOf(a) == -1) aux.push(a);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            return aux;
        },
        searchData: function searchData() {
            var _this11 = this;

            if (!this.ini || !this.fim) {
                this.toast('error', 'Intervalo de datas não definido.');
                return;
            } else if (this.isLista == 2 && this.listacontas == '') {
                this.toast('error', 'Deve escolher pelo menos uma conta.');
                return;
            } else if (this.isLista == 1 && (!this.cinicio || !this.cfim)) {
                this.toast('error', 'Intervalo de contas não definido.');
                return;
            }

            var url = this.getLinks.extratoURL;
            this.loader = true;
            var codigo = this.getSession.user.super == 1 ? this.getClienteById(this.cliente).codigo : this.getSession.user.codigo;

            var options = {
                timeout: 60000,
                method: 'POST',
                headers: {
                    'content-type': 'application/x-www-form-urlencoded'
                },
                data: __WEBPACK_IMPORTED_MODULE_7_qs___default.a.stringify({
                    invocationPassword: this.$servicePWD,
                    cliente: codigo,
                    ano: this.ano,
                    datainicio: this.ini,
                    datafim: this.fim,
                    containicio: this.isLista == 1 ? this.cinicio : '',
                    contafim: this.isLista == 1 ? this.cfim : '',
                    listacontas: this.isLista == 2 ? this.listacontas.join('|') : ''
                }),
                url: url
            };

            __WEBPACK_IMPORTED_MODULE_6_axios___default()(options).then(function () {
                var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(res) {
                    var result, ARRAY;
                    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                        while (1) {
                            switch (_context.prev = _context.next) {
                                case 0:
                                    result = JSON.parse(JSON.parse(__WEBPACK_IMPORTED_MODULE_8_xml_js___default.a.xml2json(res.data, {
                                        compact: true,
                                        spaces: 4
                                    })).string._text);
                                    ARRAY = Array.isArray(result) ? result : [];

                                    if (!(ARRAY.length == 0)) {
                                        _context.next = 6;
                                        break;
                                    }

                                    _this11.toast('error', 'Não foram encontrados resultados para a pesquisa efetuada.');
                                    _context.next = 14;
                                    break;

                                case 6:
                                    _context.next = 8;
                                    return _this11.splitContas(ARRAY.map(function (el) {
                                        return el.codcontaprincipal + ' - ' + el.nomecontaprincipal;
                                    })).sort(function (a, b) {
                                        return Number(a) - Number(b);
                                    });

                                case 8:
                                    _this11.CONTAS = _context.sent;
                                    _context.next = 11;
                                    return _this11.StatPerConta(ARRAY).sort(function (a, b) {
                                        return Number(a.key.split('-')[0].trim()) - Number(b.key.split('-')[0].trim());
                                    });

                                case 11:
                                    _this11.STATS = _context.sent;


                                    _this11.CONTA = _this11.CONTAS[0];
                                    _this11.changeConta();

                                case 14:

                                    _this11.loader = false;

                                case 15:
                                case 'end':
                                    return _context.stop();
                            }
                        }
                    }, _callee, _this11);
                }));

                return function (_x) {
                    return _ref.apply(this, arguments);
                };
            }()).catch(function (err) {
                _this11.loader = false;
                _this11.toast('error', 'Não foram encontrados resultados para a pesquisa efetuada.');
            });
        }
    }
});

/***/ }),

/***/ 59:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return instance; });
/* unused harmony export HOST */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);


/* const HOST =
  process.env.API_IP + ":" + process.env.API_PORT + "/enesapi/client"; */

var HOST = "https://cliente.eacontabilidade.com" + "/enesapi/client";

var instance = __WEBPACK_IMPORTED_MODULE_0_axios___default.a.create({
  baseURL: HOST
});



/***/ }),

/***/ 60:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PRIVATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return PUBLIC; });
var PRIVATE = "\n-----BEGIN RSA PRIVATE KEY-----\nMIICXgIBAAKBgQ9vuppoSr7Z6Ba0RudxaTP8hqhme9ObPc4Ig6jouw4mn1BMBjBN\ng+O9ZVCoqQSAGH0uMiOpVivQxILdKoYOhvoOl3/TrrMLYXXbJOzZfWtCgxsloTER\n88fGDJif6+T6Nd9HAryX2LZ9/oCm3s8RUXC54XlnXO095tsF/MGtB+UUywIDAQAB\nAoGBD29d/GVKUBndu04aE/TQCB56m0qWiJmTLEBRPgUwfU7bQFQ0X/oyZfeMpiFv\nl8NqOUmG8yewtXEz/dKeYZuHFdzD5JsRVTN225Dowtueh+OI5WzPLwU6/36qnJgd\nQfh7KctahNpdPBS6eF6PlBjjs9NUPmB1HNMhonaTMeKmNoyZAkED77EbHCoQo/Tc\nukmcTW0aAQfvaoEMTuTAcSKPRqYdqWBa6ofOJesJIzFKZ/azaka9Kq3m3d3yq/ef\nJ/Zh6933lwJBA+vrri1kvDw5cECIpkmoJsNBhmmlMASyKv0VtgmfvLO9acxZGYZE\nJEAvO85CaoGcSeo7zP0QeQJSs8ujp3270u0CQCmnQ3ydjISKeZlFs61LpjiGsHHR\nlcWpFP9YM13zPeSjc/6f0Himx4Dp5652dyIcfHNILvPa2c4b9Ts8pv2N9k8CQQOy\nG+uLZisryqnqd53XPrxBOYh2GbJWSp7O4t4q1bqd3b1OUw4GBkPvpVQEf30mZucV\n84OtXw/by5scKEBZ81/FAkEAoewDP6paWSVfT2wHTUtY7wVz/9fOVrd+0XLT5rEf\n9+9wLPpA7TvPskE6DsQZW2xmGxVdeKrUHefVZtyxzHduEQ==\n-----END RSA PRIVATE KEY-----\n";

var PUBLIC = "\n-----BEGIN PUBLIC KEY-----\nMIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQteSH0i9IQRWrbjchsp1QewAvV+\nl/NaCnkDyIOz/0ILinaixETXPYcpDLmYSm+9TLy2cA/RW+YKnxdstnCCEUj7l16j\nZ+Gkp7ZmKbK3CrwaqyzBthxyn2qYdQvMY2/pwiwCsrcE4nPGcO1amBMkPQe61q97\nIuSGriJR0bzKuMr0TQIDAQAB\n-----END PUBLIC KEY-----\n";



/***/ }),

/***/ 616:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_qs__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_qs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_xml_js__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_xml_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_xml_js__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







var cName = {
    upper: "Balancete analítico",
    lower: "o balancete analítico!"
};

/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            table: 'utilizadores',
            name: 'balancete',
            search: "",
            searchP: '',
            loader: false,
            headers: [{
                text: "Código",
                align: "left",
                sortable: true,
                value: "codigoconta"
            }, {
                text: "Designação",
                align: "left",
                sortable: true,
                value: "designacao"
            },
            /*{
                text: "Débitos Mensais €",
                align: "right",
                sortable: true,
                value: "valordebitos"
            },
            {
                text: "Créditos Mensais €",
                align: "right",
                sortable: true,
                value: "valorcreditos"
            },*/
            {
                text: "Débitos Acumulados €",
                align: "right",
                sortable: true,
                value: "valordebitosacumulados"
            }, {
                text: "Créditos Acumulados €",
                align: "right",
                sortable: true,
                value: "valorcreditosacumulados"
            }, {
                text: "Saldos Devedores €",
                align: "right",
                sortable: true,
                value: "saldosdeb"
            }, {
                text: "Saldos Credores €",
                align: "right",
                sortable: true,
                value: "saldoscred"
            }],
            anos: [],
            TOTAIS: {},
            meses: [{
                mes: 1,
                nome: 'Janeiro'
            }, {
                mes: 2,
                nome: 'Fevereiro'
            }, {
                mes: 3,
                nome: 'Março'
            }, {
                mes: 4,
                nome: 'Abril'
            }, {
                mes: 5,
                nome: ' Maio'
            }, {
                mes: 6,
                nome: 'Junho'
            }, {
                mes: 7,
                nome: 'Julho'
            }, {
                mes: 8,
                nome: 'Agosto'
            }, {
                mes: 9,
                nome: 'Setembro'
            }, {
                mes: 10,
                nome: 'Outubro'
            }, {
                mes: 11,
                nome: 'Novembro'
            }, {
                mes: 12,
                nome: 'Dezembro'
            }],
            DATA: [],
            cliente: '',
            ano: '',
            mes: '',
            mesFim: '',
            messages: {
                add: {
                    success: cName.upper + " criado com sucesso!",
                    error: "Ocorreu um erro ao criar " + cName.lower
                },
                update: {
                    success: cName.upper + " alterado com sucesso!",
                    error: "Ocorreu um erro ao alterar " + cName.lower
                },
                delete: {
                    success: cName.upper + " eliminado com sucesso!",
                    error: "Ocorreu um erro ao apagar " + cName.lower
                },
                default: {
                    sucesso: "Sucesso",
                    error: "Ocorreu um erro!"
                }
            }
        };
    },

    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])({
        getSession: 'session/getState',
        getClientes: 'utilizadores/getClientes',
        getClienteByCodigo: 'utilizadores/getClienteByCodigo',
        getClienteById: 'utilizadores/getById',
        getLinks: 'session/getLinks'
    })),

    watch: {},

    created: function created() {
        var _this = this;

        //this.ano = Number(this.$moment().format('YYYY'));
        if (this.getSession.user.super == 0) this.cliente = this.getSession.user.id_utilizador;

        setTimeout(function () {
            try {
                _this.setAnos();
            } catch (error) {
                setTimeout(function () {
                    try {
                        _this.setAnos();
                    } catch (error) {}
                }, 500);
            }
        }, 500);
    },
    mounted: function mounted() {},

    methods: {
        numberWithSpaces: function numberWithSpaces(x) {
            var parts = x.toString().replace('.', ',').split(".");
            parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, " ");
            return parts.join(".");
        },
        setAnos: function setAnos() {
            if (this.getSession.user.super == 0) this.anos = this.getSession.user.anos;else this.anos = this.getClienteById(this.cliente).anos;
        },
        toast: function toast(type, message) {
            if (type == "success") {
                return iziToast.show({
                    title: "SUCESSO",
                    color: "green",
                    timeout: this.$toastTimeout,
                    message: message,
                    position: this.$toastPosition
                });
            } else {
                return iziToast.show({
                    title: "AVISO",
                    color: "red",
                    timeout: this.$toastTimeout,
                    message: message,
                    position: this.$toastPosition
                });
            }
        },
        generatePdf: function generatePdf() {
            var _this2 = this;

            if (this.DATA.length == 0) return;

            this.loader = true;
            var cliente = this.getSession.user.super == 1 ? this.getClienteById(this.cliente) : this.getSession.user;
            var nome = this.$moment().unix();
            this.$store.dispatch('contas/generatePdfAnalitico', {
                data: this.DATA,
                totais: this.TOTAIS,
                mes: this.meses.find(function (el) {
                    return el.mes == _this2.mes;
                }).nome,
                ano: this.ano,
                cliente: cliente.codigo + ' - ' + cliente.nome,
                nif: cliente.nif,
                nome: nome
            }).then(function (res) {
                if (res) window.open(_this2.$pdfURL + nome + '.pdf', '_blank');else _this2.toast('error', 'Ocorreu um erro ao exportar.');

                _this2.loader = false;
            });
        },
        getTotalByProperty: function getTotalByProperty(prop) {
            if (this.DATA.length == 0) return 0;else return this.DATA.map(function (el) {
                return el[prop];
            }).reduce(function (a, b) {
                return (parseFloat(String(a).replace(',', '.')) + parseFloat(String(b).replace(',', '.'))).toFixed(2);
            }) + ' €';
        },
        searchData: function searchData() {
            var _this3 = this;

            if (!this.ano) {
                this.toast('error', 'Ano não definido.');
                return;
            } else if (!this.mes) {
                this.toast('error', 'Mês não definido.');
                return;
            }

            var url = this.getLinks.balanceteAURL;
            this.loader = true;
            var codigo = this.getSession.user.super == 1 ? this.getClienteById(this.cliente).codigo : this.getSession.user.codigo;
            var options = {
                method: 'POST',
                crossDomain: true,
                async: true,
                headers: {
                    'content-type': 'application/x-www-form-urlencoded'
                },
                data: __WEBPACK_IMPORTED_MODULE_3_qs___default.a.stringify({
                    invocationPassword: this.$servicePWD,
                    cliente: codigo,
                    ano: this.ano,
                    mes: this.mes,
                    mesfim: ''
                }),
                url: url
            };

            __WEBPACK_IMPORTED_MODULE_2_axios___default()(options).then(function (res) {
                var result = JSON.parse(JSON.parse(__WEBPACK_IMPORTED_MODULE_4_xml_js___default.a.xml2json(res.data, {
                    compact: true,
                    spaces: 4
                })).string._text);

                _this3.DATA = Array.isArray(result) ? result : [];

                if (_this3.DATA.length == 0) _this3.toast('error', 'Não foram encontrados resultados para a pesquisa efetuada.');else {
                    _this3.TOTAIS = {
                        //valordebitos: this.getTotalByProperty('valordebitos'),
                        //valorcreditos: this.getTotalByProperty('valorcreditos'),
                        valordebitosacumulados: _this3.DATA[0].totalvalordebitosacumulados,
                        valorcreditosacumulados: _this3.DATA[0].totalvalorcreditosacumulados,
                        saldosdeb: _this3.DATA[0].totalsaldosdeb,
                        saldoscred: _this3.DATA[0].totalsaldoscred
                    };
                }

                _this3.loader = false;
            }).catch(function (err) {
                _this3.DATA = [];
                _this3.loader = false;
                _this3.toast('error', 'Não foram encontrados resultados para a pesquisa efetuada.');
            });
        }
    }
});

/***/ }),

/***/ 617:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_qs__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_qs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_xml_js__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_xml_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_xml_js__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







var cName = {
    upper: "Balancete razão",
    lower: "o balancete razão!"
};

/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            table: 'utilizadores',
            name: 'balancete',
            search: "",
            searchP: '',
            loader: false,
            headers: [{
                text: "Código",
                align: "left",
                sortable: true,
                value: "codcontaprincipal"
            }, {
                text: "Designação",
                align: "left",
                sortable: true,
                value: "designacao"
            },
            /*{
                text: "Débitos Mensais €",
                align: "right",
                sortable: true,
                value: "valordebitos"
            },
            {
                text: "Créditos Mensais €",
                align: "right",
                sortable: true,
                value: "valorcreditos"
            },*/
            {
                text: "Débitos Acumulados €",
                align: "right",
                sortable: true,
                value: "valordebitosacumulados"
            }, {
                text: "Créditos Acumulados €",
                align: "right",
                sortable: true,
                value: "valorcreditosacumulados"
            }, {
                text: "Saldos Devedores €",
                align: "right",
                sortable: true,
                value: "saldosdeb"
            }, {
                text: "Saldos Credores €",
                align: "right",
                sortable: true,
                value: "saldoscred"
            }],
            anos: [],
            meses: [{
                mes: 1,
                nome: 'Janeiro'
            }, {
                mes: 2,
                nome: 'Fevereiro'
            }, {
                mes: 3,
                nome: 'Março'
            }, {
                mes: 4,
                nome: 'Abril'
            }, {
                mes: 5,
                nome: ' Maio'
            }, {
                mes: 6,
                nome: 'Junho'
            }, {
                mes: 7,
                nome: 'Julho'
            }, {
                mes: 8,
                nome: 'Agosto'
            }, {
                mes: 9,
                nome: 'Setembro'
            }, {
                mes: 10,
                nome: 'Outubro'
            }, {
                mes: 11,
                nome: 'Novembro'
            }, {
                mes: 12,
                nome: 'Dezembro'
            }],
            DATA: [],
            cliente: '',
            ano: '',
            mes: '',
            mesFim: '',
            TOTAIS: {},
            messages: {
                add: {
                    success: cName.upper + " criado com sucesso!",
                    error: "Ocorreu um erro ao criar " + cName.lower
                },
                update: {
                    success: cName.upper + " alterado com sucesso!",
                    error: "Ocorreu um erro ao alterar " + cName.lower
                },
                delete: {
                    success: cName.upper + " eliminado com sucesso!",
                    error: "Ocorreu um erro ao apagar " + cName.lower
                },
                default: {
                    sucesso: "Sucesso",
                    error: "Ocorreu um erro!"
                }
            }
        };
    },

    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])({
        getSession: 'session/getState',
        getClientes: 'utilizadores/getClientes',
        getClienteByCodigo: 'utilizadores/getClienteByCodigo',
        getClienteById: 'utilizadores/getById',
        getLinks: 'session/getLinks'
    })),

    watch: {},

    created: function created() {
        var _this = this;

        //this.ano = Number(this.$moment().format('YYYY'));
        if (this.getSession.user.super == 0) this.cliente = this.getSession.user.id_utilizador;

        setTimeout(function () {
            try {
                _this.setAnos();
            } catch (error) {
                setTimeout(function () {
                    try {
                        _this.setAnos();
                    } catch (error) {}
                }, 500);
            }
        }, 500);
    },
    mounted: function mounted() {},

    methods: {
        numberWithSpaces: function numberWithSpaces(x) {
            var parts = x.toString().replace('.', ',').split(".");
            parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, " ");
            return parts.join(".");
        },
        setAnos: function setAnos() {
            if (this.getSession.user.super == 0) this.anos = this.getSession.user.anos;else this.anos = this.getClienteById(this.cliente).anos;
        },
        toast: function toast(type, message) {
            if (type == "success") {
                return iziToast.show({
                    title: "SUCESSO",
                    color: "green",
                    timeout: this.$toastTimeout,
                    message: message,
                    position: this.$toastPosition
                });
            } else {
                return iziToast.show({
                    title: "AVISO",
                    color: "red",
                    timeout: this.$toastTimeout,
                    message: message,
                    position: this.$toastPosition
                });
            }
        },
        generatePdf: function generatePdf() {
            var _this2 = this;

            if (this.DATA.length == 0) return;

            this.loader = true;
            var cliente = this.getSession.user.super == 1 ? this.getClienteById(this.cliente) : this.getSession.user;
            var nome = this.$moment().unix();
            this.$store.dispatch('contas/generatePdfRazao', {
                data: this.DATA,
                totais: this.TOTAIS,
                mes: this.meses.find(function (el) {
                    return el.mes == _this2.mes;
                }).nome,
                ano: this.ano,
                cliente: cliente.codigo + ' - ' + cliente.nome,
                nif: cliente.nif,
                nome: nome
            }).then(function (res) {
                if (res) window.open(_this2.$pdfURL + nome + '.pdf', '_blank');else _this2.toast('error', 'Ocorreu um erro ao exportar.');

                _this2.loader = false;
            });
        },
        getTotalByProperty: function getTotalByProperty(prop) {
            if (this.DATA.length == 0) return 0;else return this.DATA.map(function (el) {
                return el[prop];
            }).reduce(function (a, b) {
                return (parseFloat(String(a).replace(',', '.')) + parseFloat(String(b).replace(',', '.'))).toFixed(2);
            }) + ' €';
        },
        searchData: function searchData() {
            var _this3 = this;

            if (!this.ano) {
                this.toast('error', 'Ano não definido.');
                return;
            } else if (!this.mes) {
                this.toast('error', 'Mês não definido.');
                return;
            }

            var url = this.getLinks.balanceteRURL;
            this.loader = true;
            var codigo = this.getSession.user.super == 1 ? this.getClienteById(this.cliente).codigo : this.getSession.user.codigo;
            var options = {
                method: 'POST',
                crossDomain: true,
                async: true,
                headers: {
                    'content-type': 'application/x-www-form-urlencoded'
                },
                data: __WEBPACK_IMPORTED_MODULE_3_qs___default.a.stringify({
                    invocationPassword: this.$servicePWD,
                    cliente: codigo,
                    ano: this.ano,
                    mes: this.mes,
                    mesfim: ''
                }),
                url: url
            };

            __WEBPACK_IMPORTED_MODULE_2_axios___default()(options).then(function (res) {
                var result = JSON.parse(JSON.parse(__WEBPACK_IMPORTED_MODULE_4_xml_js___default.a.xml2json(res.data, {
                    compact: true,
                    spaces: 4
                })).string._text);

                _this3.DATA = Array.isArray(result) ? result : [];

                if (_this3.DATA.length == 0) _this3.toast('error', 'Não foram encontrados resultados para a pesquisa efetuada.');else {
                    _this3.TOTAIS = {
                        valordebitos: _this3.getTotalByProperty('valordebitos'),
                        valorcreditos: _this3.getTotalByProperty('valorcreditos'),
                        valordebitosacumulados: _this3.getTotalByProperty('valordebitosacumulados'),
                        valorcreditosacumulados: _this3.getTotalByProperty('valorcreditosacumulados'),
                        saldosdeb: _this3.getTotalByProperty('saldosdeb'),
                        saldoscred: _this3.getTotalByProperty('saldoscred')
                    };
                }

                _this3.loader = false;
            }).catch(function (err) {
                _this3.DATA = [];
                _this3.loader = false;
                _this3.toast('error', 'Não foram encontrados resultados para a pesquisa efetuada.');
            });
        }
    }
});

/***/ }),

/***/ 618:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_names__ = __webpack_require__(1362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_names___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_names__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__(1366);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(12);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var cName = {
  upper: "Documentos",
  lower: "o documento!"
};

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      clear: false,
      deleteM: false,
      isLoading: false,
      loader: false,
      menuItems: ["Apagar"],
      table: "documentos",
      name: "documento",
      DATA: [],
      OBJECT: null,
      raw: "",
      cliente: null,
      deleteF: "",
      items: [{
        text: "Início",
        object: null,
        index: 0
      }],
      defaultItems: [{
        text: "Início",
        object: null,
        index: 0
      }],
      messages: {
        add: {
          success: cName.upper + " criado com sucesso!",
          error: "Ocorreu um erro ao criar " + cName.lower
        },
        update: {
          success: cName.upper + " alterado com sucesso!",
          error: "Ocorreu um erro ao alterar " + cName.lower
        },
        delete: {
          success: cName.upper + " eliminado com sucesso!",
          error: "Ocorreu um erro ao apagar " + cName.lower
        },
        default: {
          sucesso: "Sucesso",
          error: "Ocorreu um erro!"
        }
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapGetters */])({
    getSession: "session/getState",
    getAll: "documentos/getAll",
    getClientes: "utilizadores/getClientes",
    getClientesComOSuper: "utilizadores/getClientesComOSuper"
  }), {
    title: function title() {
      if (this.$route.name == "uploads") return "Uploads";else if (this.$route.name == "relatoriosgestao") return "Relatórios de Gestão - Nova versão";else if (this.getSession.user.super && this.getSession.user.docs) return "Documentos - " + this.getSession.user.docs;else return "Documentos";
    }
  }),

  watch: {
    getAll: function getAll(val) {
      if (this.items.length == 1 || this.$route.name == "uploads" || this.$route.name == "relatoriosgestao") this.initialize();
    }
  },
  created: function created() {
    this.initialize();

    if (true) window.addEventListener("contextmenu", function (event) {
      return event.preventDefault();
    });
  },
  mounted: function mounted() {},

  methods: {
    sync: function sync() {
      var _this = this;

      if (!this.getSession.user.docs) return;
      this.isLoading = true;
      this.loader = true;

      this.$store.dispatch("documentos/getByCliente", this.getSession.user.docs).then(function (res) {
        _this.isLoading = false;
        _this.loader = false;
        setTimeout(function () {
          _this.initialize();
        }, 110);
      });
    },
    toast: function toast(type, message) {
      if (type == "success") {
        return iziToast.show({
          title: "SUCESSO",
          color: "green",
          timeout: this.$toastTimeout,
          message: message,
          position: this.$toastPosition
        });
      } else {
        return iziToast.show({
          title: "AVISO",
          color: "red",
          timeout: this.$toastTimeout,
          message: message,
          position: this.$toastPosition
        });
      }
    },
    download: function download() {
      var _this2 = this;

      var cliente = this.getSession.user.super ? this.cliente : this.getSession.user.codigo;

      this.$store.dispatch("documentos/download", cliente).then(function (res) {
        if (res != false) {
          window.open(_this2.$apiURL + "/" + res, "_blank");
        }
      });
    },
    clearFolder: function clearFolder() {
      var _this3 = this;

      var cliente = this.getSession.user.super ? this.cliente : this.getSession.user.codigo;

      this.$store.dispatch("documentos/clear", cliente).then(function (res) {
        if (res) {
          _this3.OBJECT = [];
          _this3.items.find(function (el) {
            return el.text == "uploads";
          }).object = [];
          _this3.items[1].object.uploads = [];

          setTimeout(function () {
            _this3.$forceUpdate();
          }, 500);

          _this3.toast("success", "Ficheiros apagados com sucesso!");
        } else _this3.toast("error", "Ocorreu um erro ao apagar os ficheiros!");

        _this3.clear = false;
      });
    },
    close: function close() {
      var _this4 = this;

      this.deleteM = false;
      setTimeout(function () {
        _this4.deleteF = null;
      }, 110);
    },
    onDocChange: function onDocChange(e) {
      var _this5 = this;

      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;

      this.loader = true;

      var cliente = this.getSession.user.super ? this.cliente : this.getSession.user.codigo;

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(files), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var d = _step.value;

          this.$store.dispatch("documentos/upload", [cliente, d]).then(function (res) {
            if (res) {
              _this5.OBJECT = res;
              _this5.items.find(function (el) {
                return el.text == "uploads";
              }).object = _this5.OBJECT;
            } else _this5.toast("error", "Ocorreu um erro ao submeter o ficheiro!");
          });
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      setTimeout(function () {
        _this5.$forceUpdate();
        _this5.toast("success", "Ficheiros carregados com sucesso!");

        _this5.$refs.docForm.reset();
        _this5.loader = false;
      }, 500);
    },
    deleteI: function deleteI(item, state) {
      if (this.getSession.user.super == 0) return;

      this.deleteF = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(this.OBJECT[item]) === "object" ? item : this.OBJECT[item];
      this.deleteM = true;
    },
    deleteFile: function deleteFile() {
      var _this6 = this;

      if (this.getSession.user.super == 0) return;

      var array = [].concat(this.items);
      array.shift();

      if (array.length == 0) {
        var path = this.getSession.user.docs + "/";
      } else {
        var path = this.getSession.user.docs + "/" + array.map(function (el) {
          return el.text;
        }).join("/") + "/";
      }

      this.$store.dispatch("documentos/delete", {
        path: path,
        file: this.deleteF
      }).then(function (res) {
        if (!res.errors) {
          _this6.OBJECT = res;
          _this6.items[_this6.items.length - 1].object = res;

          _this6.toast("success", "Ficheiro apagado com sucesso!");
          _this6.$forceUpdate();

          setTimeout(function () {
            _this6.sync();
          }, 800);
        }
        if (res.errors) {
          _this6.toast("error", "Não foi possível apagar o ficheiro pretendido!");
        }
        setTimeout(function () {
          _this6.deleteM = false;
          _this6.deleteF = "";
        }, 110);
      });
    },
    setPath: function setPath(object, index) {
      if (index == 0) {
        this.items = [].concat(this.defaultItems);
        this.OBJECT = this.getAll;
      } else {
        this.items = this.items.filter(function (el) {
          return el.index < index + 1;
        });
        this.OBJECT = object;
      }
    },
    setObject: function setObject(item, path, state) {
      if (state) {
        this.items.push({
          text: path,
          object: item,
          index: this.items.length
        });

        if (this.getSession.user.super && this.items.length == 2) this.cliente = this.items[1].text;

        this.OBJECT = item;
      } else {
        var array = [].concat(this.items);
        array.shift();

        if (this.getSession.user.super) {
          var path = this.$fileURL + this.getSession.user.docs + "/" + array.map(function (el) {
            return el.text;
          }).join("/") + "/" + item;
        } else {
          if (this.$route.name == "relatoriosgestao") {
            var path = this.$fileURL +
            //  this.getSession.user.docs +
            "/" + this.getSession.user.codigo + "/Relatórios Gestão/" + array.map(function (el) {
              return el.text;
            }).join("/") + "/" + item;
          } else {
            var path = this.$fileURL + this.getSession.user.codigo + "/" + array.map(function (el) {
              return el.text;
            }).join("/") + "/" + item;
            /*             console.log(this.$fileURL);
            console.log(this.getSession.user.codigo);
            console.log(path); */

            if (this.$route.name == "uploads") {
              var path = this.$fileURL + this.getSession.user.codigo + "/uploads/" + item;
            }
          }
        }

        window.open(path, "_blank");
      }
    },


    /*orderKeys(obj) {
              var keys = Object.keys(obj).sort(function keyOrder(k1, k2) {
                if (k1 < k2) return -1;
                else if (k1 > k2) return +1;
                else return 0;
            });
              var i, after = {};
            for (i = 0; i < keys.length; i++) {
                after[keys[i]] = obj[keys[i]];
                delete obj[keys[i]];
            }
              for (i = 0; i < keys.length; i++) {
                obj[keys[i]] = after[keys[i]];
            }
            return obj;
        }, */

    initialize: function initialize() {
      var path = this.$route.name;

      this.items = path == "uploads" || path == "relatoriosgestao" ? [] : [].concat(this.defaultItems);

      this.loading = true;
      var emfalta = "50.Em falta";

      if (this.getSession.user.super == 0 && path == "documentos") {
        var array = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_names___default()(this.getAll);

        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(this.getSession.user.pastas.split(",")), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var p = _step2.value;

            var key = array.find(function (el) {
              return el.split(".")[0] == p;
            });

            if (this.getAll.hasOwnProperty(String(key))) {
              delete this.getAll[key];
            }
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }

        if (this.getAll.hasOwnProperty(emfalta)) delete this.getAll[emfalta];
        this.OBJECT = this.getAll;
      } else if (this.getSession.user.super == 0 && path == "uploads") {
        if (this.getAll.hasOwnProperty("uploads")) this.OBJECT = this.getAll["uploads"];
      } else if (this.getSession.user.super == 0 && path == "relatoriosgestao") {
        if (this.getAll.hasOwnProperty("Relatórios Gestão")) this.OBJECT = this.getAll["Relatórios Gestão"];
      } else this.OBJECT = this.getAll;

      this.loading = false;
    }
  }
});

/***/ }),

/***/ 621:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(12);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var cName = {
    upper: "Notificação",
    lower: "a notificação!"
};

/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            table: 'notificacoes',
            name: 'notificação',
            search: "",
            toSend: [],
            clientes: [],
            escritorios: [],
            modal: false,
            deleteM: false,
            loading: true,
            searchP: '',
            headers: [{
                text: "#",
                align: "left",
                sortable: true,
                value: "id_notificacao"
            }, {
                text: "Título",
                align: "left",
                sortable: true,
                value: "titulo"
            }, {
                text: "Data",
                align: "left",
                sortable: true,
                value: "data"
            }, {
                text: "Ações",
                value: "id",
                sortable: false,
                align: "center"
            }],
            metodo: 0,
            DATA: [],
            editedIndex: -1,
            agendar: false,
            editedItem: {
                id_notificacao: '',
                titulo: "",
                descricao: "",
                data: "",
                agendada: 0,
                hora_agenda: '',
                data_agenda: ''
            },
            defaultItem: {
                id_notificacao: '',
                titulo: "",
                descricao: "",
                data: "",
                agendada: 0,
                hora_agenda: '',
                data_agenda: ''
            },
            messages: {
                add: {
                    success: cName.upper + " criada com sucesso!",
                    error: "Ocorreu um erro ao criar " + cName.lower
                },
                update: {
                    success: cName.upper + " alterada com sucesso!",
                    error: "Ocorreu um erro ao alterar " + cName.lower
                },
                delete: {
                    success: cName.upper + " eliminada com sucesso!",
                    error: "Ocorreu um erro ao apagar " + cName.lower
                },
                default: {
                    sucesso: "Sucesso",
                    error: "Ocorreu um erro!"
                }
            },
            defaultRules: null,
            today: '',
            dataMenu: false,
            iniMenu: false
        };
    },

    computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])({
        getAll: 'notificacoes/getAll',
        getClientes: 'utilizadores/getClientes',
        getEscritorios: 'escritorios/getAll'
    }), {
        formTitle: function formTitle() {
            return this.editedIndex === -1 ? "Nova " + this.name : "Editar " + this.name;
        }
    }),

    watch: {
        modal: function modal(val) {
            val || this.close();
        },
        deleteM: function deleteM(val) {
            val || this.close();
        },
        getAll: function getAll(val) {
            this.initialize();
        },
        getClientes: function getClientes(val) {
            this.intiArrays();
        },
        getEscritorios: function getEscritorios(val) {
            this.intiArrays();
        }
    },

    created: function created() {
        var _this = this;

        this.defaultRules = [function (v) {
            return !!v || _this.$requiredField + '';
        }];

        this.today = this.$moment().format("YYYY-MM-DD");

        setTimeout(function () {
            _this.intiArrays();
        }, 1000);
        this.initialize();
    },
    mounted: function mounted() {},

    methods: {
        dataChange: function dataChange() {
            this.dataMenu = false;
            this.iniMenu = true;
        },
        intiArrays: function intiArrays() {
            this.clientes = [].concat(this.getClientes);
            this.clientes.unshift({
                id_utilizador: 0,
                nome: 'Todos'
            });

            this.escritorios = [].concat(this.getEscritorios);
            this.escritorios.unshift({
                id_escritorio: 0,
                nome: 'Todos'
            });
        },
        toast: function toast(type, message) {
            if (type == "success") {
                return iziToast.show({
                    title: "SUCESSO",
                    color: "green",
                    timeout: this.$toastTimeout,
                    message: message,
                    position: this.$toastPosition
                });
            } else {
                return iziToast.show({
                    title: "AVISO",
                    color: "red",
                    timeout: this.$toastTimeout,
                    message: message,
                    position: this.$toastPosition
                });
            }
        },
        changeSelect: function changeSelect() {
            if (this.toSend.findIndex(function (el) {
                return el == 0;
            }) > -1) this.toSend = this.clientes.map(function (el) {
                return el.id_utilizador;
            });
        },
        changeSelectD: function changeSelectD() {
            if (this.toSend.findIndex(function (el) {
                return el == 0;
            }) > -1) this.toSend = this.escritorios.map(function (el) {
                return el.id_escritorio;
            });
        },
        initialize: function initialize() {
            this.loading = true;
            this.DATA = this.getAll;
            this.loading = false;
        },
        agendarNotificacao: function agendarNotificacao() {
            this.agendar = true;
            this.modal = true;
        },
        editItem: function editItem(item, dialog) {
            this.editedIndex = this.DATA.indexOf(item);
            this.editedItem = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, item);

            if (dialog) this.modal = true;else this.deleteM = true;
        },
        resend: function resend(item) {
            this.editedIndex = this.DATA.indexOf(item);
            this.editedItem = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, item);

            this.modal = true;
        },
        delete: function _delete() {
            var _this2 = this;

            if (!this.editedItem.id_notificacao) return;

            this.$store.dispatch(this.table + "/delete", {
                id: this.editedItem.id_notificacao
            }).then(function (res) {
                if (res) {
                    _this2.toast('success', _this2.messages.delete.success);
                    _this2.initialize();
                } else _this2.toast('error', _this2.messages.delete.error);

                _this2.deleteM = false;
            });
        },
        close: function close() {
            var _this3 = this;

            this.modal = this.deleteM = false;
            setTimeout(function () {
                _this3.editedItem = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, _this3.defaultItem);
                _this3.editedIndex = -1;
                _this3.toSend = [];
                _this3.agendar = false;
                _this3.$refs.form.reset();

                setTimeout(function () {
                    _this3.metodo = 0;
                }, 50);
            }, 110);
        },
        sendNotification: function sendNotification() {
            var _this4 = this;

            if (this.toSend.length == 0) return;

            if (this.toSend.findIndex(function (el) {
                return el == 0;
            }) > -1) {
                this.$store.dispatch('notificacoes/sendToAll', {
                    titulo: this.editedItem.titulo.toUpperCase(),
                    descricao: this.editedItem.descricao
                }).then(function (res) {
                    if (res) _this4.toast('success', 'Notificação enviada com sucesso.');else _this4.toast('error', 'Ocorreu um erro ao enviar a notificação.');
                });
            } else {
                this.$store.dispatch('notificacoes/sendToUsers', {
                    titulo: this.editedItem.titulo.toUpperCase(),
                    descricao: this.editedItem.descricao,
                    clientes: this.metodo == 0 ? this.toSend.filter(function (el) {
                        return el > 0;
                    }) : this.clientes.map(function (el) {
                        if (_this4.toSend.findIndex(function (e) {
                            return e == el.id_escritorio;
                        }) > -1) return el.id_utilizador;
                    }).filter(function (el) {
                        return typeof el != 'undefined';
                    })
                }).then(function (res) {
                    if (res) _this4.toast('success', 'Notificação enviada com sucesso.');else _this4.toast('error', 'Ocorreu um erro ao enviar a notificação.');
                });
            }

            this.modal = false;
        },
        save: function save() {
            var _this5 = this;

            if (this.deleteM) {
                this.delete();
                return;
            }
            if (!this.$refs.form.validate()) return;

            if (this.toSend.length == 0) return;

            if (this.editedIndex == -1) {
                this.$store.dispatch(this.table + "/insert", {
                    titulo: this.editedItem.titulo,
                    descricao: this.editedItem.descricao,
                    agendada: this.agendar ? 1 : 0,
                    data_agendada: this.agendar ? this.editedItem.data_agenda + ' ' + this.editedItem.hora_agenda : '-',
                    clientes: this.metodo == 0 ? this.toSend.filter(function (el) {
                        return el > 0;
                    }) : this.clientes.map(function (el) {
                        if (_this5.toSend.findIndex(function (e) {
                            return e == el.id_escritorio;
                        }) > -1) return el.id_utilizador;
                    }).filter(function (el) {
                        return typeof el != 'undefined';
                    })
                }).then(function (res) {
                    if (res) {
                        if (!_this5.agendar) _this5.sendNotification();
                        _this5.initialize();
                    } else _this5.toast('error', _this5.messages.add.error);

                    _this5.modal = false;
                });
            }
        }
    }
});

/***/ }),

/***/ 622:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetify_dist_vuetify_min_css__ = __webpack_require__(518);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetify_dist_vuetify_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuetify_dist_vuetify_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_quill_dist_quill_core_css__ = __webpack_require__(519);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_quill_dist_quill_core_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_quill_dist_quill_core_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_quill_dist_quill_snow_css__ = __webpack_require__(520);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_quill_dist_quill_snow_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_quill_dist_quill_snow_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_quill_dist_quill_bubble_css__ = __webpack_require__(521);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_quill_dist_quill_bubble_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_quill_dist_quill_bubble_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_quill_editor__ = __webpack_require__(522);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_quill_editor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_quill_editor__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var cName = {
  upper: "Informação",
  lower: "a informação!"
};







/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    quillEditor: __WEBPACK_IMPORTED_MODULE_7_vue_quill_editor__["quillEditor"]
  },
  data: function data() {
    return {
      table: "avisos",
      name: "informação",
      search: "",
      modal: false,
      deleteM: false,
      loading: true,
      searchP: "",
      toSend: [],
      //clientes: [],
      escritorios: [],
      headers: [{
        text: "#",
        align: "left",
        sortable: true,
        value: "id_aviso"
      }, {
        text: "Título",
        align: "left",
        sortable: true,
        value: "titulo"
      }, {
        text: "Data",
        align: "left",
        sortable: true,
        value: "data"
      }, {
        text: "Ações",
        value: "id",
        sortable: false,
        align: "center"
      }],
      //metodo: 0,
      DATA: [],
      editedIndex: -1,
      editedItem: {
        id_aviso: "",
        titulo: "",
        descricao: "",
        data: ""
      },
      defaultItem: {
        id_aviso: "",
        titulo: "",
        descricao: "",
        data: ""
      },
      messages: {
        add: {
          success: cName.upper + " criada com sucesso!",
          error: "Ocorreu um erro ao criar " + cName.lower
        },
        update: {
          success: cName.upper + " alterada com sucesso!",
          error: "Ocorreu um erro ao alterar " + cName.lower
        },
        delete: {
          success: cName.upper + " eliminada com sucesso!",
          error: "Ocorreu um erro ao apagar " + cName.lower
        },
        default: {
          sucesso: "Sucesso",
          error: "Ocorreu um erro!"
        }
      },
      defaultRules: null
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])({
    getAll: "avisos/getAll",
    //getClientes: "utilizadores/getClientes",
    getEscritorios: 'escritorios/getAll'
  }), {
    formTitle: function formTitle() {
      return this.editedIndex === -1 ? "Nova " + this.name : "Editar " + this.name;
    }
  }),

  watch: {
    modal: function modal(val) {
      val || this.close();
    },
    deleteM: function deleteM(val) {
      val || this.close();
    },
    getAll: function getAll(val) {
      this.initialize();
    },

    /*getClientes(val) {
            this.intiArrays();
    },*/
    getEscritorios: function getEscritorios(val) {
      this.intiArrays();
    }
  },

  created: function created() {
    var _this = this;

    this.defaultRules = [function (v) {
      return !!v || _this.$requiredField + "";
    }];

    setTimeout(function () {
      _this.intiArrays();
    }, 1000);
    this.initialize();
  },
  mounted: function mounted() {},

  methods: {
    intiArrays: function intiArrays() {
      /*this.clientes = [].concat(this.getClientes);
      this.clientes.unshift({
          id_utilizador: 0,
          nome: 'Todos'
      }); */

      this.escritorios = [].concat(this.getEscritorios);
      this.escritorios.unshift({
        id_escritorio: 0,
        nome: 'Todos'
      });
    },
    toast: function toast(type, message) {
      if (type == "success") {
        return iziToast.show({
          title: "SUCESSO",
          color: "green",
          timeout: this.$toastTimeout,
          message: message,
          position: this.$toastPosition
        });
      } else {
        return iziToast.show({
          title: "AVISO",
          color: "red",
          timeout: this.$toastTimeout,
          message: message,
          position: this.$toastPosition
        });
      }
    },


    /*changeSelect() {
      if (
        this.toSend.findIndex(el => {
          return el == 0;
        }) > -1
      )
        this.toSend = this.clientes.map(el => {
          return el.id_utilizador;
        });
    }, */

    changeSelectD: function changeSelectD() {
      console.log(this.toSend);
      if (this.toSend.findIndex(function (el) {
        return el == 0;
      }) > -1) this.toSend = this.escritorios.map(function (el) {
        return el.id_escritorio;
      });

      console.log(this.toSend);
    },
    initialize: function initialize() {
      this.loading = true;
      this.DATA = this.getAll;
      this.loading = false;
    },
    editItem: function editItem(item, dialog) {
      this.editedIndex = this.DATA.indexOf(item);
      this.editedItem = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, item);

      if (dialog) this.modal = true;else this.deleteM = true;
    },
    delete: function _delete() {
      var _this2 = this;

      if (!this.editedItem.id_aviso) return;

      this.$store.dispatch(this.table + "/delete", {
        id: this.editedItem.id_aviso
      }).then(function (res) {
        if (res) {
          _this2.toast("success", _this2.messages.delete.success);
          _this2.initialize();
        } else _this2.toast("error", _this2.messages.delete.error);

        _this2.deleteM = false;
      });
    },
    close: function close() {
      var _this3 = this;

      this.modal = this.deleteM = false;
      setTimeout(function () {
        _this3.editedItem = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, _this3.defaultItem);
        _this3.editedIndex = -1;
        _this3.toSend = [];

        _this3.$refs.form.reset();

        /*setTimeout(() => {
            this.metodo = 1;
        }, 50);*/
      }, 110);
    },
    save: function save() {
      var _this4 = this;

      if (this.deleteM) {
        this.delete();
        return;
      }

      if (!this.$refs.form.validate()) return;

      if (this.editedIndex == -1) {

        if (this.toSend.length == 0) return;

        this.$store.dispatch(this.table + "/insert", {
          titulo: this.editedItem.titulo,
          descricao: this.editedItem.descricao,
          data: this.$moment().format("YYYY-MM-DD HH:mm"),
          escritorios: this.toSend.findIndex(function (el) {
            return el == 0;
          }) > -1 ? this.getEscritorios.map(function (el) {
            return el.id_escritorio;
          }) : this.toSend
        }).then(function (res) {
          if (res) {
            _this4.toast("success", _this4.messages.add.success);
            _this4.initialize();
          } else _this4.toast("error", _this4.messages.add.error);

          _this4.modal = false;
        });
      } else {
        this.$store.dispatch(this.table + "/update", {
          id: this.editedItem.id_aviso,
          titulo: this.editedItem.titulo,
          descricao: this.editedItem.descricao,
          data: this.$moment().format("YYYY-MM-DD HH:mm")
        }).then(function (res) {
          if (res) {
            _this4.toast("success", _this4.messages.update.success);
            _this4.initialize();
          } else _this4.toast("error", _this4.messages.update.error);

          _this4.modal = false;
        });
      }
    }
  }
});

/***/ }),

/***/ 623:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(12);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var cName = {
    upper: "Escritório",
    lower: "o escritório!"
};

/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            table: 'escritorios',
            name: 'escritório',
            search: "",
            modal: false,
            deleteM: false,
            loading: true,
            searchP: '',
            headers: [{
                text: "#",
                align: "left",
                sortable: true,
                value: "id_escritorio"
            }, {
                text: "Nome",
                align: "left",
                sortable: true,
                value: "nome"
            }, {
                text: "Ações",
                value: "id",
                sortable: false,
                align: "center"
            }],
            DATA: [],
            editedIndex: -1,
            editedItem: {
                id_escritorio: 0,
                nome: ""
            },
            defaultItem: {
                id_escritorio: 0,
                nome: ""
            },
            messages: {
                add: {
                    success: cName.upper + " criado com sucesso!",
                    error: "Ocorreu um erro ao criar " + cName.lower
                },
                update: {
                    success: cName.upper + " alterado com sucesso!",
                    error: "Ocorreu um erro ao alterar " + cName.lower
                },
                delete: {
                    success: cName.upper + " eliminado com sucesso!",
                    error: "Ocorreu um erro ao apagar " + cName.lower
                },
                default: {
                    sucesso: "Sucesso",
                    error: "Ocorreu um erro!"
                }
            },
            defaultRules: null
        };
    },

    computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])({
        getAll: 'escritorios/getAll'
    }), {
        formTitle: function formTitle() {
            return this.editedIndex === -1 ? "Novo " + this.name : "Editar " + this.name;
        }
    }),

    watch: {
        modal: function modal(val) {
            val || this.close();
        },
        deleteM: function deleteM(val) {
            val || this.close();
        },
        getAll: function getAll(val) {
            this.initialize();
        }
    },

    created: function created() {
        var _this = this;

        this.defaultRules = [function (v) {
            return !!v || _this.$requiredField + '';
        }];
        this.initialize();
    },
    mounted: function mounted() {},

    methods: {
        toast: function toast(type, message) {
            if (type == "success") {
                return iziToast.show({
                    title: "SUCESSO",
                    color: "green",
                    timeout: this.$toastTimeout,
                    message: message,
                    position: this.$toastPosition
                });
            } else {
                return iziToast.show({
                    title: "AVISO",
                    color: "red",
                    timeout: this.$toastTimeout,
                    message: message,
                    position: this.$toastPosition
                });
            }
        },
        initialize: function initialize() {
            this.loading = true;
            this.DATA = this.getAll;
            this.loading = false;
        },
        editItem: function editItem(item, dialog) {
            this.editedIndex = this.DATA.indexOf(item);
            this.editedItem = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, item);

            if (dialog) this.modal = true;else this.deleteM = true;
        },
        delete: function _delete() {
            var _this2 = this;

            if (!this.editedItem.id_escritorio) return;

            this.$store.dispatch(this.table + "/delete", { id: this.editedItem.id_escritorio }).then(function (res) {
                if (res) {
                    _this2.toast('success', _this2.messages.delete.success);_this2.initialize();
                } else _this2.toast('error', _this2.messages.delete.error);

                _this2.deleteM = false;
            });
        },
        close: function close() {
            var _this3 = this;

            this.modal = this.deleteM = false;
            setTimeout(function () {
                _this3.editedItem = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, _this3.defaultItem);
                _this3.editedIndex = -1;

                _this3.$refs.form.reset();
            }, 110);
        },
        save: function save() {
            var _this4 = this;

            if (this.deleteM) {
                this.delete();return;
            }

            if (!this.$refs.form.validate()) return;

            if (this.editedIndex == -1) {
                this.$store.dispatch(this.table + "/insert", { nome: this.editedItem.nome }).then(function (res) {
                    if (res) {
                        _this4.toast('success', _this4.messages.add.success);_this4.initialize();
                    } else _this4.toast('error', _this4.messages.add.error);

                    _this4.modal = false;
                });
            } else {
                this.$store.dispatch(this.table + "/update", { id: this.editedItem.id_escritorio, nome: this.editedItem.nome }).then(function (res) {
                    if (res) {
                        _this4.toast('success', _this4.messages.update.success);_this4.initialize();
                    } else _this4.toast('error', _this4.messages.update.error);

                    _this4.modal = false;
                });
            }
        }
    }
});

/***/ }),

/***/ 624:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__(91);



/* harmony default export */ __webpack_exports__["a"] = ({
  extends: __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["a" /* Bar */],
  props: ["MESES", "MB", "EMV", "CMVMC"],
  mounted: function mounted() {
    this.renderChart({
      labels: this.MESES,
      datasets: [{
        label: "Margem Bruta",
        borderColor: "rgb(255, 141, 165)",
        pointBackgroundColor: "rgb(255, 141, 165)",
        type: "line",
        fill: false,
        lineTension: 0,
        data: this.MB
      }, {
        label: "Prestações de serviços",
        backgroundColor: "rgb(113, 206, 206, 0.5)",
        borderColor: "rgb(113, 206, 206, 1)",
        borderWidth: 1,
        data: this.EMV
      }, {
        label: "CMVMC ou Compras",
        backgroundColor: "rgb(255, 185, 115, 0.5)",
        borderColor: "rgb(255, 185, 115, 1)",
        borderWidth: 1,
        data: this.CMVMC
      }]
    }, {
      responsive: true,
      maintainAspectRatio: false,
      title: {
        display: true,
        text: "Evolução mensal das Vendas, CMVMC ou Compras e Margem Bruta",
        fontSize: 14
      },
      scales: {
        yAxes: [{
          scaleLabel: {
            display: true,
            labelString: "Valores em €"
          },
          ticks: {
            beginAtZero: true
          }
        }]
      }
    });
  }
});

/***/ }),

/***/ 625:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__(91);



/* harmony default export */ __webpack_exports__["a"] = ({
  extends: __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["a" /* Bar */],
  props: ["MESES", "MB", "FSEM", "OG"],
  mounted: function mounted() {
    this.renderChart({
      labels: this.MESES,
      datasets: [{
        label: "Margem Bruta",
        borderColor: "rgb(255, 141, 165)",
        pointBackgroundColor: "rgb(255, 141, 165)",
        type: "line",
        lineTension: 0,
        fill: false,
        data: this.MB
      }, {
        label: "FSE, Gastos com Pessoal, Outros Gastos",
        backgroundColor: "rgb(181, 143, 255, 0.5)",
        borderColor: "rgb(181, 143, 255, 1)",
        borderWidth: 1,
        data: this.FSEM
        /*{
                  label: 'OG',
                  backgroundColor: 'rgb(108, 187, 241, 0.5)',
                  borderColor: 'rgb(108, 187, 241, 1)',
                  borderWidth: 1,
                  data: this.OG
              } */
      }]
    }, {
      responsive: true,
      maintainAspectRatio: false,
      title: {
        display: true,
        text: "Análise comparativa Margem Bruta - Restantes Gastos",
        fontSize: 14
      },
      scales: {
        yAxes: [{
          scaleLabel: {
            display: true,
            labelString: "Valores em €"
          },
          ticks: {
            beginAtZero: true
          }
        }]
      }
    });
  }
});

/***/ }),

/***/ 626:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__(91);



/* harmony default export */ __webpack_exports__["a"] = ({
    extends: __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["a" /* Bar */],
    props: ['MESES', 'FSEM', 'FSE', 'OG'],
    mounted: function mounted() {
        this.renderChart({
            labels: this.MESES,
            datasets: [{
                label: 'Gastos com Pessoal',
                borderColor: 'rgb(108, 187, 241, 1)',
                pointBackgroundColor: 'rgb(108, 187, 241, 1)',
                type: 'line',
                lineTension: 0,
                fill: false,
                data: this.OG
            }, {
                label: 'FSE',
                borderColor: 'rgb(255, 141, 165)',
                pointBackgroundColor: 'rgb(255, 141, 165)',
                type: 'line',
                lineTension: 0,
                fill: false,
                data: this.FSE
            }, {
                label: 'FSE, Gastos com Pessoal, Outros Gastos',
                backgroundColor: 'rgb(98, 150, 103, 0.25)',
                borderColor: 'rgb(98, 150, 103, 1)',
                borderWidth: 1,
                data: this.FSEM
            }]
        }, {
            responsive: true,
            maintainAspectRatio: false,
            title: {
                display: true,
                text: 'Evolução mensal dos FSE e gastos com pessoal',
                fontSize: 14
            },
            scales: {
                yAxes: [{
                    scaleLabel: {
                        display: true,
                        labelString: 'Valores em €'
                    },
                    ticks: {
                        beginAtZero: true
                    }
                }]
            }
        });
    }
});

/***/ }),

/***/ 627:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__(91);



/* harmony default export */ __webpack_exports__["a"] = ({
  extends: __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["a" /* Bar */],
  props: ["MESES", "C6869", "C68", "C69"],
  mounted: function mounted() {
    this.renderChart({
      labels: this.MESES,
      datasets: [{
        label: "Outros Gastos",
        borderColor: "rgb(108, 187, 241)",
        pointBackgroundColor: "rgb(108, 187, 241)",
        type: "line",
        lineTension: 0,
        fill: false,
        data: this.C68
      }, {
        label: "Gastos de Financiamento",
        borderColor: "rgb(98, 150, 103)",
        pointBackgroundColor: "rgb(98, 150, 103)",
        type: "line",
        lineTension: 0,
        fill: false,
        data: this.C69
      }, {
        label: "Outros Gastos + Gastos de Financiamento",
        backgroundColor: "rgb(255, 99, 132, 0.3)",
        borderColor: "rgb(255, 99, 132, 1)",
        borderWidth: 1,
        data: this.C6869
      }]
    }, {
      responsive: true,
      maintainAspectRatio: false,
      title: {
        display: true,
        text: "Outros Gastos + Gastos de Financiamento",
        fontSize: 14
      },
      scales: {
        yAxes: [{
          scaleLabel: {
            display: true,
            labelString: "Valores em €"
          },
          ticks: {
            beginAtZero: true
          }
        }]
      }
    });
  }
});

/***/ }),

/***/ 628:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__(91);



/* harmony default export */ __webpack_exports__["a"] = ({
    extends: __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["c" /* HorizontalBar */],
    props: ['ORDEM', 'G'],
    mounted: function mounted() {
        this.renderChart({
            labels: this.ORDEM,
            datasets: [{
                label: 'Gastos',
                backgroundColor: 'rgb(108, 187, 241, 0.5)',
                borderColor: 'rgb(108, 187, 241, 1)',
                borderWidth: 1,
                data: this.G
            }]
        }, {
            responsive: true,
            maintainAspectRatio: false,
            title: {
                display: true,
                text: 'Ranking - Gastos',
                fontSize: 14
            },
            scales: {
                xAxes: [{
                    scaleLabel: {
                        display: true,
                        labelString: 'Valores em €'
                    },
                    ticks: {
                        beginAtZero: true
                    }
                }]
            }
        });
    }
});

/***/ }),

/***/ 629:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__(91);



/* harmony default export */ __webpack_exports__["a"] = ({
    extends: __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["b" /* Doughnut */],
    props: ['ANC', 'AC'],
    mounted: function mounted() {
        this.renderChart({
            labels: ['Ativo não corrente', 'Ativo corrente'],
            datasets: [{
                data: [parseFloat(parseFloat(this.ANC) * 100 / (parseFloat(this.ANC) + parseFloat(this.AC))).toFixed(0), parseFloat(parseFloat(this.AC) * 100 / (parseFloat(this.ANC) + parseFloat(this.AC))).toFixed(0)],
                backgroundColor: ['rgb(113, 206, 206, 0.5)', 'rgb(181, 143, 255, 0.5)'],
                borderColor: ['rgb(113, 206, 206, 1)', 'rgb(181, 143, 255, 1)'],
                borderWidth: 1,
                borderAlign: 'inner'
            }]
        }, {
            responsive: true,
            maintainAspectRatio: false,
            title: {
                display: true,
                text: 'Estrutura do Ativo',
                fontSize: 14
            }
        });
    }
});

/***/ }),

/***/ 630:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__(91);



/* harmony default export */ __webpack_exports__["a"] = ({
    extends: __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["b" /* Doughnut */],
    props: ['CP', 'PNC', 'PC'],
    mounted: function mounted() {
        this.renderChart({
            labels: ['Capital próprio', 'Passivo não corrente', 'Passivo corrente'],
            datasets: [{
                data: [parseFloat(parseFloat(this.CP) * 100 / (parseFloat(this.PNC) + parseFloat(this.PC) + parseFloat(this.CP))).toFixed(0), parseFloat(parseFloat(this.PNC) * 100 / (parseFloat(this.PNC) + parseFloat(this.PC) + parseFloat(this.CP))).toFixed(0), parseFloat(parseFloat(this.PC) * 100 / (parseFloat(this.PNC) + parseFloat(this.PC) + parseFloat(this.CP))).toFixed(0)],
                backgroundColor: ['rgb(98, 150, 103, 0.3)', 'rgb(255, 99, 132, 0.5)', 'rgb(255, 185, 115, 0.5)'],
                borderColor: ['rgb(98, 150, 103, 1)', 'rgb(255, 99, 132, 1)', 'rgb(255, 185, 115, 1)'],
                borderWidth: 1,
                borderAlign: 'inner'
            }]
        }, {
            responsive: true,
            maintainAspectRatio: false,
            title: {
                display: true,
                text: 'Estrutura do Capital Próprio e Passivo',
                fontSize: 14
            }
        });
    }
});

/***/ }),

/***/ 633:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_polyfill__ = __webpack_require__(634);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(800);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__App__ = __webpack_require__(959);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router__ = __webpack_require__(964);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuetify__ = __webpack_require__(1395);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_session__ = __webpack_require__(1396);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_session___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_session__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_idle_vue__ = __webpack_require__(1397);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_idle_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_idle_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_cookies__ = __webpack_require__(1398);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_cookies___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue_cookies__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_html2canvas__ = __webpack_require__(1399);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_html2canvas___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_html2canvas__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_html_to_image__ = __webpack_require__(1400);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_html_to_image___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_html_to_image__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.














__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6_vuetify___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_10_vue_cookies___default.a);

var options = {
  persist: true
};
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_7_vue_session___default.a, options);

var eventsHub = new __WEBPACK_IMPORTED_MODULE_1_vue__["default"]();
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_8_idle_vue___default.a, {
  eventEmitter: eventsHub,
  idleTime: 3600000
});

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].prototype.$eventBus = new __WEBPACK_IMPORTED_MODULE_1_vue__["default"]();
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].prototype.$toastPosition = "bottomRight";
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].prototype.$toastTimeout = "5000";

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].prototype.$requiredField = "* Campo obrigatório";
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].prototype.$invalidEmail = "* E-mail inválido";
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].prototype.$invalidPassword = "* A password deve conter no minimo 8 carateres (maiúscula, minúscula, alfanumérico, simbolo) ";
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].prototype.$invalidTelefone = "* Telefone inválido";
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].prototype.$invalidTelemovel = "* Telemóvel inválido";
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].prototype.$invalidCodPostal = "* Código postal inválido";

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].prototype.$pdfURL = "https://cliente.eacontabilidade.com" + ":" + "443" + "/enesapi/client/routes/pdf/";
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].prototype.$fileURL = "https://cliente.eacontabilidade.com" + ":" + "443" + "/enesapi/docs/";
/* Vue.prototype.$apiURL = process.env.API_IP +':'+ process.env.API_PORT + '/enesapi/'; */
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].prototype.$apiURL = "https://cliente.eacontabilidade.com" + "/enesapi/";
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].prototype.$servicePWD = Number(__WEBPACK_IMPORTED_MODULE_9_moment___default()().format("D")) < 10 ? "!1n0v3.,0" + __WEBPACK_IMPORTED_MODULE_9_moment___default()().format("D") : "!1n0v3.," + __WEBPACK_IMPORTED_MODULE_9_moment___default()().format("D");

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].prototype.$moment = __WEBPACK_IMPORTED_MODULE_9_moment___default.a;
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].prototype.$html2canvas = __WEBPACK_IMPORTED_MODULE_11_html2canvas___default.a;
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].prototype.$htmlToImage = __WEBPACK_IMPORTED_MODULE_12_html_to_image__;
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].prototype.$defaultPassword = "abc123";

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_1_vue__["default"]({
  el: "#app",
  router: __WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */],
  components: { App: __WEBPACK_IMPORTED_MODULE_4__App__["a" /* default */] },
  template: "<App/>",
  data: function data() {
    return {
      active: -1
    };
  },
  onIdle: function onIdle() {
    this.active = 0;
    this.$eventBus.$emit("logout");
  },
  onActive: function onActive() {
    this.active = 1;
  }
});

/***/ }),

/***/ 800:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_session__ = __webpack_require__(801);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_utilizadores__ = __webpack_require__(942);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_contas__ = __webpack_require__(945);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_notificacoes__ = __webpack_require__(953);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_avisos__ = __webpack_require__(954);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modules_escritorios__ = __webpack_require__(955);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__modules_termos__ = __webpack_require__(956);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__modules_documentos__ = __webpack_require__(957);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__modules_imagens__ = __webpack_require__(958);












__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
    modules: {
        session: __WEBPACK_IMPORTED_MODULE_2__modules_session__["a" /* default */],
        utilizadores: __WEBPACK_IMPORTED_MODULE_3__modules_utilizadores__["a" /* default */],
        contas: __WEBPACK_IMPORTED_MODULE_4__modules_contas__["a" /* default */],
        notificacoes: __WEBPACK_IMPORTED_MODULE_5__modules_notificacoes__["a" /* default */],
        avisos: __WEBPACK_IMPORTED_MODULE_6__modules_avisos__["a" /* default */],
        escritorios: __WEBPACK_IMPORTED_MODULE_7__modules_escritorios__["a" /* default */],
        termos: __WEBPACK_IMPORTED_MODULE_8__modules_termos__["a" /* default */],
        documentos: __WEBPACK_IMPORTED_MODULE_9__modules_documentos__["a" /* default */],
        imagens: __WEBPACK_IMPORTED_MODULE_10__modules_imagens__["a" /* default */]
    },
    strict: false
}));

/***/ }),

/***/ 801:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__axios__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__variables__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jsonwebtoken__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jsonwebtoken___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_jsonwebtoken__);








var TABLE = "/user/";

// initial state
var state = {
  session: false,
  user: null,
  links: {},
  docs: null
};

// getters
var getters = {
  getState: function getState(state) {
    return state;
  },
  getLinks: function getLinks(state) {
    return state.links;
  }
};

// actions
var actions = {
  getData: function getData(_ref, params) {
    var commit = _ref.commit;

    return __WEBPACK_IMPORTED_MODULE_2__axios__["a" /* instance */].post(TABLE + "get/" + token(params)).then(function (res) {
      if (res.data.results == 1) {
        return decode(res.data.data).then(function (r) {
          if (r) {
            commit("setSessionData", r[0]);
            return true;
          } else {
            commit("setSessionData", null);
            return false;
          }
        });
      } else {
        commit("setSessionData", null);
        return false;
      }
    }).catch(function (err) {
      commit("setSessionData", null);
      return false;
    });
  },
  signIn: function signIn(_ref2, params) {
    var commit = _ref2.commit;

    return __WEBPACK_IMPORTED_MODULE_2__axios__["a" /* instance */].post(TABLE + "login/" + token(params)).then(function (res) {
      if (res.data.results == 1) {
        return decode(res.data.data).then(function (r) {
          if (r) {
            commit("setSessionData", r[0]);
            return true;
          } else {
            commit("setSessionData", null);
            return false;
          }
        });
      } else {
        commit("setSessionData", null);
        return false;
      }
    }).catch(function (err) {
      commit("setSessionData", null);
      return false;
    });
  },
  update: function update(_ref3, params) {
    var dispatch = _ref3.dispatch;

    return __WEBPACK_IMPORTED_MODULE_2__axios__["a" /* instance */].put(TABLE + token(params)).then(function (res) {
      if (!res.data.errors) {
        return true;
      } else return false;
    }).catch(function (err) {
      return false;
    });
  },
  setSessionData: function setSessionData(_ref4, data) {
    var commit = _ref4.commit;

    return commit("setSessionData", data);
  },
  setObra: function setObra(_ref5, id) {
    var commit = _ref5.commit;

    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      commit("setObra", id);
      resolve(true);
    });
  }
};

function token(params) {
  return __WEBPACK_IMPORTED_MODULE_5_jsonwebtoken___default.a.sign({
    exp: Math.floor(Date.now() / 1000) + 60,
    data: params
  }, __WEBPACK_IMPORTED_MODULE_3__variables__["a" /* PRIVATE */], { algorithm: "RS256" });
}

function decode(token) {
  return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_5_jsonwebtoken___default.a.verify(token, __WEBPACK_IMPORTED_MODULE_3__variables__["b" /* PUBLIC */], function (err, decoded) {
      if (err) resolve(false);else resolve(__WEBPACK_IMPORTED_MODULE_5_jsonwebtoken___default.a.decode(token).data);
    });
  });
}

// mutations
var mutations = {
  setSessionData: function setSessionData(state, data) {
    if (data) {
      state.user = data;

      var SERVICE_API_IP = data.server.server_address;
      var obj = {
        serviceURL: SERVICE_API_IP + "/wscontabilidades/cntservice.asmx",
        extratoURL: SERVICE_API_IP + "/wscontabilidades/cntservice.asmx/DaExtratoConta",
        balanceteAURL: SERVICE_API_IP + "/wscontabilidades/cntservice.asmx/DaBalanceteAnalitico",
        balanceteRURL: SERVICE_API_IP + "/wscontabilidades/cntservice.asmx/DaBalanceteRazao",
        contasURL: SERVICE_API_IP + "/wscontabilidades/cntservice.asmx/DaContasCliente",
        rgURL: SERVICE_API_IP + "/wscontabilidades/cntservice.asmx/DaRelGestaoV2"
      };
      state.links = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, obj);

      state.session = true;

      if (state.user.super == 0) {
        state.user.anos = [];
        for (var i = Number(state.user.ano); i <= Number(__WEBPACK_IMPORTED_MODULE_4_moment___default()().format("YYYY")); i++) {
          state.user.anos.push(i);
        }
      }
    } else state.session = false;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),

/***/ 841:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 332,
	"./af.js": 332,
	"./ar": 333,
	"./ar-dz": 334,
	"./ar-dz.js": 334,
	"./ar-kw": 335,
	"./ar-kw.js": 335,
	"./ar-ly": 336,
	"./ar-ly.js": 336,
	"./ar-ma": 337,
	"./ar-ma.js": 337,
	"./ar-sa": 338,
	"./ar-sa.js": 338,
	"./ar-tn": 339,
	"./ar-tn.js": 339,
	"./ar.js": 333,
	"./az": 340,
	"./az.js": 340,
	"./be": 341,
	"./be.js": 341,
	"./bg": 342,
	"./bg.js": 342,
	"./bm": 343,
	"./bm.js": 343,
	"./bn": 344,
	"./bn.js": 344,
	"./bo": 345,
	"./bo.js": 345,
	"./br": 346,
	"./br.js": 346,
	"./bs": 347,
	"./bs.js": 347,
	"./ca": 348,
	"./ca.js": 348,
	"./cs": 349,
	"./cs.js": 349,
	"./cv": 350,
	"./cv.js": 350,
	"./cy": 351,
	"./cy.js": 351,
	"./da": 352,
	"./da.js": 352,
	"./de": 353,
	"./de-at": 354,
	"./de-at.js": 354,
	"./de-ch": 355,
	"./de-ch.js": 355,
	"./de.js": 353,
	"./dv": 356,
	"./dv.js": 356,
	"./el": 357,
	"./el.js": 357,
	"./en-SG": 358,
	"./en-SG.js": 358,
	"./en-au": 359,
	"./en-au.js": 359,
	"./en-ca": 360,
	"./en-ca.js": 360,
	"./en-gb": 361,
	"./en-gb.js": 361,
	"./en-ie": 362,
	"./en-ie.js": 362,
	"./en-il": 363,
	"./en-il.js": 363,
	"./en-nz": 364,
	"./en-nz.js": 364,
	"./eo": 365,
	"./eo.js": 365,
	"./es": 366,
	"./es-do": 367,
	"./es-do.js": 367,
	"./es-us": 368,
	"./es-us.js": 368,
	"./es.js": 366,
	"./et": 369,
	"./et.js": 369,
	"./eu": 370,
	"./eu.js": 370,
	"./fa": 371,
	"./fa.js": 371,
	"./fi": 372,
	"./fi.js": 372,
	"./fo": 373,
	"./fo.js": 373,
	"./fr": 374,
	"./fr-ca": 375,
	"./fr-ca.js": 375,
	"./fr-ch": 376,
	"./fr-ch.js": 376,
	"./fr.js": 374,
	"./fy": 377,
	"./fy.js": 377,
	"./ga": 378,
	"./ga.js": 378,
	"./gd": 379,
	"./gd.js": 379,
	"./gl": 380,
	"./gl.js": 380,
	"./gom-latn": 381,
	"./gom-latn.js": 381,
	"./gu": 382,
	"./gu.js": 382,
	"./he": 383,
	"./he.js": 383,
	"./hi": 384,
	"./hi.js": 384,
	"./hr": 385,
	"./hr.js": 385,
	"./hu": 386,
	"./hu.js": 386,
	"./hy-am": 387,
	"./hy-am.js": 387,
	"./id": 388,
	"./id.js": 388,
	"./is": 389,
	"./is.js": 389,
	"./it": 390,
	"./it-ch": 391,
	"./it-ch.js": 391,
	"./it.js": 390,
	"./ja": 392,
	"./ja.js": 392,
	"./jv": 393,
	"./jv.js": 393,
	"./ka": 394,
	"./ka.js": 394,
	"./kk": 395,
	"./kk.js": 395,
	"./km": 396,
	"./km.js": 396,
	"./kn": 397,
	"./kn.js": 397,
	"./ko": 398,
	"./ko.js": 398,
	"./ku": 399,
	"./ku.js": 399,
	"./ky": 400,
	"./ky.js": 400,
	"./lb": 401,
	"./lb.js": 401,
	"./lo": 402,
	"./lo.js": 402,
	"./lt": 403,
	"./lt.js": 403,
	"./lv": 404,
	"./lv.js": 404,
	"./me": 405,
	"./me.js": 405,
	"./mi": 406,
	"./mi.js": 406,
	"./mk": 407,
	"./mk.js": 407,
	"./ml": 408,
	"./ml.js": 408,
	"./mn": 409,
	"./mn.js": 409,
	"./mr": 410,
	"./mr.js": 410,
	"./ms": 411,
	"./ms-my": 412,
	"./ms-my.js": 412,
	"./ms.js": 411,
	"./mt": 413,
	"./mt.js": 413,
	"./my": 414,
	"./my.js": 414,
	"./nb": 415,
	"./nb.js": 415,
	"./ne": 416,
	"./ne.js": 416,
	"./nl": 417,
	"./nl-be": 418,
	"./nl-be.js": 418,
	"./nl.js": 417,
	"./nn": 419,
	"./nn.js": 419,
	"./pa-in": 420,
	"./pa-in.js": 420,
	"./pl": 421,
	"./pl.js": 421,
	"./pt": 422,
	"./pt-br": 423,
	"./pt-br.js": 423,
	"./pt.js": 422,
	"./ro": 424,
	"./ro.js": 424,
	"./ru": 425,
	"./ru.js": 425,
	"./sd": 426,
	"./sd.js": 426,
	"./se": 427,
	"./se.js": 427,
	"./si": 428,
	"./si.js": 428,
	"./sk": 429,
	"./sk.js": 429,
	"./sl": 430,
	"./sl.js": 430,
	"./sq": 431,
	"./sq.js": 431,
	"./sr": 432,
	"./sr-cyrl": 433,
	"./sr-cyrl.js": 433,
	"./sr.js": 432,
	"./ss": 434,
	"./ss.js": 434,
	"./sv": 435,
	"./sv.js": 435,
	"./sw": 436,
	"./sw.js": 436,
	"./ta": 437,
	"./ta.js": 437,
	"./te": 438,
	"./te.js": 438,
	"./tet": 439,
	"./tet.js": 439,
	"./tg": 440,
	"./tg.js": 440,
	"./th": 441,
	"./th.js": 441,
	"./tl-ph": 442,
	"./tl-ph.js": 442,
	"./tlh": 443,
	"./tlh.js": 443,
	"./tr": 444,
	"./tr.js": 444,
	"./tzl": 445,
	"./tzl.js": 445,
	"./tzm": 446,
	"./tzm-latn": 447,
	"./tzm-latn.js": 447,
	"./tzm.js": 446,
	"./ug-cn": 448,
	"./ug-cn.js": 448,
	"./uk": 449,
	"./uk.js": 449,
	"./ur": 450,
	"./ur.js": 450,
	"./uz": 451,
	"./uz-latn": 452,
	"./uz-latn.js": 452,
	"./uz.js": 451,
	"./vi": 453,
	"./vi.js": 453,
	"./x-pseudo": 454,
	"./x-pseudo.js": 454,
	"./yo": 455,
	"./yo.js": 455,
	"./zh-cn": 456,
	"./zh-cn.js": 456,
	"./zh-hk": 457,
	"./zh-hk.js": 457,
	"./zh-tw": 458,
	"./zh-tw.js": 458
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 841;

/***/ }),

/***/ 845:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 847:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 882:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 883:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 884:
/***/ (function(module, exports) {

module.exports = {"modp1":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a63a3620ffffffffffffffff"},"modp2":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece65381ffffffffffffffff"},"modp5":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca237327ffffffffffffffff"},"modp14":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aacaa68ffffffffffffffff"},"modp15":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a93ad2caffffffffffffffff"},"modp16":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c934063199ffffffffffffffff"},"modp17":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c93402849236c3fab4d27c7026c1d4dcb2602646dec9751e763dba37bdf8ff9406ad9e530ee5db382f413001aeb06a53ed9027d831179727b0865a8918da3edbebcf9b14ed44ce6cbaced4bb1bdb7f1447e6cc254b332051512bd7af426fb8f401378cd2bf5983ca01c64b92ecf032ea15d1721d03f482d7ce6e74fef6d55e702f46980c82b5a84031900b1c9e59e7c97fbec7e8f323a97a7e36cc88be0f1d45b7ff585ac54bd407b22b4154aacc8f6d7ebf48e1d814cc5ed20f8037e0a79715eef29be32806a1d58bb7c5da76f550aa3d8a1fbff0eb19ccb1a313d55cda56c9ec2ef29632387fe8d76e3c0468043e8f663f4860ee12bf2d5b0b7474d6e694f91e6dcc4024ffffffffffffffff"},"modp18":{"gen":"02","prime":"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"}}

/***/ }),

/***/ 888:
/***/ (function(module, exports) {

module.exports = {"_args":[["elliptic@6.4.1","D:\\laragon\\www\\enes"]],"_development":true,"_from":"elliptic@6.4.1","_id":"elliptic@6.4.1","_inBundle":false,"_integrity":"sha512-BsXLz5sqX8OHcsh7CqBMztyXARmGQ3LWPtGjJi6DiJHq5C/qvi9P3OqgswKSDftbu8+IoI/QDTAm2fFnQ9SZSQ==","_location":"/elliptic","_phantomChildren":{},"_requested":{"type":"version","registry":true,"raw":"elliptic@6.4.1","name":"elliptic","escapedName":"elliptic","rawSpec":"6.4.1","saveSpec":null,"fetchSpec":"6.4.1"},"_requiredBy":["/browserify-sign","/create-ecdh"],"_resolved":"https://registry.npmjs.org/elliptic/-/elliptic-6.4.1.tgz","_spec":"6.4.1","_where":"D:\\laragon\\www\\enes","author":{"name":"Fedor Indutny","email":"fedor@indutny.com"},"bugs":{"url":"https://github.com/indutny/elliptic/issues"},"dependencies":{"bn.js":"^4.4.0","brorand":"^1.0.1","hash.js":"^1.0.0","hmac-drbg":"^1.0.0","inherits":"^2.0.1","minimalistic-assert":"^1.0.0","minimalistic-crypto-utils":"^1.0.0"},"description":"EC cryptography","devDependencies":{"brfs":"^1.4.3","coveralls":"^2.11.3","grunt":"^0.4.5","grunt-browserify":"^5.0.0","grunt-cli":"^1.2.0","grunt-contrib-connect":"^1.0.0","grunt-contrib-copy":"^1.0.0","grunt-contrib-uglify":"^1.0.1","grunt-mocha-istanbul":"^3.0.1","grunt-saucelabs":"^8.6.2","istanbul":"^0.4.2","jscs":"^2.9.0","jshint":"^2.6.0","mocha":"^2.1.0"},"files":["lib"],"homepage":"https://github.com/indutny/elliptic","keywords":["EC","Elliptic","curve","Cryptography"],"license":"MIT","main":"lib/elliptic.js","name":"elliptic","repository":{"type":"git","url":"git+ssh://git@github.com/indutny/elliptic.git"},"scripts":{"jscs":"jscs benchmarks/*.js lib/*.js lib/**/*.js lib/**/**/*.js test/index.js","jshint":"jscs benchmarks/*.js lib/*.js lib/**/*.js lib/**/**/*.js test/index.js","lint":"npm run jscs && npm run jshint","test":"npm run lint && npm run unit","unit":"istanbul test _mocha --reporter=spec test/index.js","version":"grunt dist && git add dist/"},"version":"6.4.1"}

/***/ }),

/***/ 921:
/***/ (function(module, exports) {

module.exports = {"2.16.840.1.101.3.4.1.1":"aes-128-ecb","2.16.840.1.101.3.4.1.2":"aes-128-cbc","2.16.840.1.101.3.4.1.3":"aes-128-ofb","2.16.840.1.101.3.4.1.4":"aes-128-cfb","2.16.840.1.101.3.4.1.21":"aes-192-ecb","2.16.840.1.101.3.4.1.22":"aes-192-cbc","2.16.840.1.101.3.4.1.23":"aes-192-ofb","2.16.840.1.101.3.4.1.24":"aes-192-cfb","2.16.840.1.101.3.4.1.41":"aes-256-ecb","2.16.840.1.101.3.4.1.42":"aes-256-cbc","2.16.840.1.101.3.4.1.43":"aes-256-ofb","2.16.840.1.101.3.4.1.44":"aes-256-cfb"}

/***/ }),

/***/ 942:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__axios__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jsonwebtoken__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jsonwebtoken___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jsonwebtoken__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__variables__ = __webpack_require__(60);








var TABLE = '/user/';

// initial state
var state = {
    data: []

    // getters
};var getters = {
    getAll: function getAll(state) {
        return state.data;
    },
    getById: function getById(state) {
        return function (id) {
            if (!id) return;
            return state.data.find(function (el) {
                return el.id_utilizador == id;
            });
        };
    },
    getClientes: function getClientes(state) {
        return state.data.filter(function (el) {
            return el.super == 0;
        });
    },
    getClientesComOSuper: function getClientesComOSuper(state) {
        return state.data.filter(function (el) {
            return el;
        });
    },
    getUtilizadores: function getUtilizadores(state) {
        return state.data.filter(function (el) {
            return el.super == 1;
        });
    },
    getClienteByCodigo: function getClienteByCodigo(state) {
        return function (cod) {
            return state.data.find(function (el) {
                return el.codigo == cod;
            });
        };
    },
    getTermosByUtilizador: function getTermosByUtilizador(state) {
        return function (id) {
            return state.data.find(function (el) {
                return el.id_utilizador == id;
            }).termos;
        };
    }

    // actions
};var actions = {
    get: function get(_ref) {
        var commit = _ref.commit;

        return __WEBPACK_IMPORTED_MODULE_2__axios__["a" /* instance */].get(TABLE).then(function (res) {
            decode(res.data.data).then(function (r) {
                if (r) commit('setData', r);else commit('setData', null);
            });
        }).catch(function (err) {
            commit('setData', null);
        });
    },
    setTermosChecked: function setTermosChecked(_ref2, id) {
        var commit = _ref2.commit;

        if (!id) return;

        return __WEBPACK_IMPORTED_MODULE_2__axios__["a" /* instance */].get(TABLE + 'termos/' + id).then(function (res) {
            return !res.data.errors;
        }).catch(function (err) {
            return false;
        });
    },
    insert: function insert(_ref3, params) {
        var dispatch = _ref3.dispatch;


        return __WEBPACK_IMPORTED_MODULE_2__axios__["a" /* instance */].post(TABLE + token(params)).then(function (res) {
            if (!res.data.errors) {
                dispatch('get');
                return true;
            } else return false;
        }).catch(function (err) {
            return false;
        });
    },
    new_password: function new_password(_ref4, params) {
        var dispatch = _ref4.dispatch;


        return __WEBPACK_IMPORTED_MODULE_2__axios__["a" /* instance */].put('/user/password/' + token(params)).then(function (res) {
            if (!res.data.errors) {
                dispatch('get');
                return true;
            } else return false;
        }).catch(function (err) {
            return false;
        });
    },
    email: function email(_ref5, params) {
        var dispatch = _ref5.dispatch;

        return __WEBPACK_IMPORTED_MODULE_2__axios__["a" /* instance */].post(TABLE + 'email/' + token(params)).then(function (res) {
            return res.data == 1;
        }).catch(function (err) {
            return false;
        });
    },
    update: function update(_ref6, params) {
        var dispatch = _ref6.dispatch;

        return __WEBPACK_IMPORTED_MODULE_2__axios__["a" /* instance */].put(TABLE + token(params)).then(function (res) {
            if (!res.data.errors) {
                dispatch('get');
                return true;
            } else return false;
        }).catch(function (err) {
            return false;
        });
    },
    delete: function _delete(_ref7, params) {
        var dispatch = _ref7.dispatch;

        return __WEBPACK_IMPORTED_MODULE_2__axios__["a" /* instance */].delete(TABLE + token(params)).then(function (res) {
            if (!res.data.errors) {
                dispatch('get');
                return true;
            } else return false;
        }).catch(function (err) {
            return false;
        });
    }
};

// mutations
var mutations = {
    setData: function setData(state, data) {
        state.data = data ? data : [];

        if (data) {
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(state.data), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var d = _step.value;

                    if (d.super == 0) {
                        d.anos = [];
                        for (var i = Number(d.ano); i <= Number(__WEBPACK_IMPORTED_MODULE_4_moment___default()().format('YYYY')); i++) {
                            d.anos.push(i);
                        }
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
    }
};

function token(params) {
    return __WEBPACK_IMPORTED_MODULE_3_jsonwebtoken___default.a.sign({
        exp: Math.floor(Date.now() / 1000) + 60,
        data: params
    }, __WEBPACK_IMPORTED_MODULE_5__variables__["a" /* PRIVATE */], { algorithm: 'RS256' });
}

function decode(token) {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_3_jsonwebtoken___default.a.verify(token, __WEBPACK_IMPORTED_MODULE_5__variables__["b" /* PUBLIC */], function (err, decoded) {
            if (err) resolve(false);else resolve(__WEBPACK_IMPORTED_MODULE_3_jsonwebtoken___default.a.decode(token).data);
        });
    });
}

/* harmony default export */ __webpack_exports__["a"] = ({
    namespaced: true,
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
});

/***/ }),

/***/ 945:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__axios__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_qs__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_qs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_xml_js__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_xml_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_xml_js__);









// initial state
var state = {
    data: []

    // getters
};var getters = {
    getAll: function getAll(state) {
        return state.data;
    },
    getContasByCodigo: function getContasByCodigo(state) {
        return function (str) {
            return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                if (state.data.length > 0 && str) resolve(state.data.filter(function (el) {
                    return el.codigoconta === String(str);
                }));else resolve([]);
            });
        };
    },
    getFirstLastContas: function getFirstLastContas(state) {
        if (state.data.length == 0) return null;else if (state.data.length == 1) return state.data[0];else return { first: state.data[0].codigoconta, last: state.data[state.data.length - 1].codigoconta };
    }

    // actions
};var actions = {
    get: function get(_ref, params) {
        var commit = _ref.commit;


        var url = params.url;

        var options = {
            method: 'POST',
            headers: {
                'content-type': 'application/x-www-form-urlencoded'
            },
            data: __WEBPACK_IMPORTED_MODULE_5_qs___default.a.stringify({
                invocationPassword: params.pwd,
                cliente: params.cliente,
                ano: params.ano
            }),
            url: url
        };

        return __WEBPACK_IMPORTED_MODULE_4_axios___default()(options).then(function (res) {
            try {
                commit('setData', __WEBPACK_IMPORTED_MODULE_6_xml_js___default.a.xml2json(res.data, { compact: true, spaces: 4 }));
            } catch (error) {
                commit('setData', null);
            }
        }).catch(function (err) {
            commit('setData', null);
        });
    },
    generatePdfRazao: function generatePdfRazao(_ref2, data) {
        var commit = _ref2.commit;

        return __WEBPACK_IMPORTED_MODULE_3__axios__["a" /* instance */].post('/pdf/razao', {
            data: data
        }).then(function (res) {
            return !res.errors;
        }).catch(function (err) {
            return false;
        });
    },
    generatePdfAnalitico: function generatePdfAnalitico(_ref3, data) {
        var commit = _ref3.commit;

        return __WEBPACK_IMPORTED_MODULE_3__axios__["a" /* instance */].post('/pdf/analitico', {
            data: data
        }).then(function (res) {
            return !res.errors;
        }).catch(function (err) {
            return false;
        });
    },
    generatePdfExtrato: function generatePdfExtrato(_ref4, data) {
        var commit = _ref4.commit;

        return __WEBPACK_IMPORTED_MODULE_3__axios__["a" /* instance */].post('/pdf/extrato', {
            data: data
        }).then(function (res) {
            return !res.errors;
        }).catch(function (err) {
            return false;
        });
    },
    generatePdfExtratoAll: function generatePdfExtratoAll(_ref5, data) {
        var commit = _ref5.commit;

        return __WEBPACK_IMPORTED_MODULE_3__axios__["a" /* instance */].post('/pdf/extratoAll', {
            data: data
        }).then(function (res) {
            return !res.errors;
        }).catch(function (err) {
            return false;
        });
    },
    clearData: function clearData(_ref6) {
        var _this = this;

        var commit = _ref6.commit;

        return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function () {
            var _ref7 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(resolve, reject) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return commit('setData', null);

                            case 2:
                                resolve(true);

                            case 3:
                            case "end":
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }));

            return function (_x, _x2) {
                return _ref7.apply(this, arguments);
            };
        }());
    }
};

// mutations
var mutations = {
    setData: function setData(state, data) {
        state.data = data ? JSON.parse(JSON.parse(data).string._text) : [];
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    namespaced: true,
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
});

/***/ }),

/***/ 953:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__axios__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jsonwebtoken__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jsonwebtoken___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jsonwebtoken__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__variables__ = __webpack_require__(60);






var TABLE = '/notificacao/';

// initial state
var state = {
    data: [],
    all: false

    // getters
};var getters = {
    getAll: function getAll(state) {
        return state.data;
    },
    getState: function getState(state) {
        return state.all;
    }

    // actions
};var actions = {
    get: function get(_ref) {
        var commit = _ref.commit;
        var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

        var t = params ? TABLE + 'todos/' : TABLE;
        return __WEBPACK_IMPORTED_MODULE_1__axios__["a" /* instance */].get(t).then(function (res) {
            decode(res.data.data).then(function (r) {
                if (r) {
                    commit('setData', r);commit('setAll', params);
                } else commit('setData', null);
            });
        }).catch(function (err) {
            commit('setData', null);
        });
    },
    getByUser: function getByUser(_ref2) {
        var commit = _ref2.commit,
            rootState = _ref2.rootState;
        var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

        var t = params ? TABLE + 'todos/' + rootState.session.user.id_utilizador : TABLE + 'user/' + rootState.session.user.id_utilizador;
        return __WEBPACK_IMPORTED_MODULE_1__axios__["a" /* instance */].get(t).then(function (res) {
            return decode(res.data.data).then(function (r) {
                if (r) {
                    commit('setData', r);commit('setAll', params);
                } else commit('setData', null);
            });
        }).catch(function (err) {
            commit('setData', null);
        });
    },
    insert: function insert(_ref3, params) {
        var dispatch = _ref3.dispatch;


        return __WEBPACK_IMPORTED_MODULE_1__axios__["a" /* instance */].post(TABLE + token(params)).then(function (res) {
            if (!res.data.errors) {
                dispatch('get');
                return true;
            } else return false;
        }).catch(function (err) {
            return false;
        });
    },
    sendToUsers: function sendToUsers(_ref4, params) {
        var dispatch = _ref4.dispatch;


        return __WEBPACK_IMPORTED_MODULE_1__axios__["a" /* instance */].post(TABLE + 'send/' + token(params)).then(function (res) {
            return !res.data.errors;
        }).catch(function (err) {
            return false;
        });
    },
    sendToAll: function sendToAll(_ref5, params) {
        var dispatch = _ref5.dispatch;


        return __WEBPACK_IMPORTED_MODULE_1__axios__["a" /* instance */].post(TABLE + 'send/all/' + token(params)).then(function (res) {
            return !res.data.errors;
        }).catch(function (err) {
            return false;
        });
    },
    update: function update(_ref6, params) {
        var dispatch = _ref6.dispatch;

        return __WEBPACK_IMPORTED_MODULE_1__axios__["a" /* instance */].put(TABLE + token(params)).then(function (res) {
            if (!res.data.errors) {
                dispatch('get');
                return true;
            } else return false;
        }).catch(function (err) {
            return false;
        });
    },
    setChecked: function setChecked(_ref7, params) {
        var dispatch = _ref7.dispatch;

        return __WEBPACK_IMPORTED_MODULE_1__axios__["a" /* instance */].put(TABLE + 'checked/' + token(params)).then(function (res) {
            return !res.data.errors;
        }).catch(function (err) {
            return false;
        });
    },
    delete: function _delete(_ref8, params) {
        var dispatch = _ref8.dispatch;

        return __WEBPACK_IMPORTED_MODULE_1__axios__["a" /* instance */].delete(TABLE + token(params)).then(function (res) {
            if (!res.data.errors) {
                dispatch('get');
                return true;
            } else return false;
        }).catch(function (err) {
            return false;
        });
    }
};

// mutations
var mutations = {
    setData: function setData(state, data) {
        state.data = data ? data : [];
    },
    setAll: function setAll(state, data) {
        state.all = data;
    }
};

function token(params) {
    return __WEBPACK_IMPORTED_MODULE_2_jsonwebtoken___default.a.sign({
        exp: Math.floor(Date.now() / 1000) + 60,
        data: params
    }, __WEBPACK_IMPORTED_MODULE_3__variables__["a" /* PRIVATE */], { algorithm: 'RS256' });
}

function decode(token) {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_2_jsonwebtoken___default.a.verify(token, __WEBPACK_IMPORTED_MODULE_3__variables__["b" /* PUBLIC */], function (err, decoded) {
            if (err) resolve(false);else resolve(__WEBPACK_IMPORTED_MODULE_2_jsonwebtoken___default.a.decode(token).data);
        });
    });
}

/* harmony default export */ __webpack_exports__["a"] = ({
    namespaced: true,
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
});

/***/ }),

/***/ 954:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__axios__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jsonwebtoken__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jsonwebtoken___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jsonwebtoken__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__variables__ = __webpack_require__(60);






var TABLE = "/aviso/";

// initial state
var state = {
  data: [],
  all: false
};

// getters
var getters = {
  getAll: function getAll(state) {
    return state.data;
  },
  getState: function getState(state) {
    return state.all;
  }
};

// actions
var actions = {
  get: function get(_ref) {
    var commit = _ref.commit;
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    var t = params ? TABLE + "todos/" : TABLE;
    return __WEBPACK_IMPORTED_MODULE_1__axios__["a" /* instance */].get(t).then(function (res) {
      decode(res.data.data).then(function (r) {
        if (r) {
          commit("setData", r);
          commit("setAll", params);
        } else commit("setData", null);
      });
    }).catch(function (err) {
      commit("setData", null);
    });
  },
  getByEscritorio: function getByEscritorio(_ref2) {
    var commit = _ref2.commit,
        rootState = _ref2.rootState;
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    var t = params ? TABLE + "todos/" + rootState.session.user.id_escritorio : TABLE + "user/" + rootState.session.user.id_escritorio;
    return __WEBPACK_IMPORTED_MODULE_1__axios__["a" /* instance */].get(t).then(function (res) {
      return decode(res.data.data).then(function (r) {
        if (r) {
          commit("setData", r);
          commit("setAll", params);
        } else commit("setData", null);
      });
    }).catch(function (err) {
      commit("setData", null);
    });
  },
  insert: function insert(_ref3, params) {
    var dispatch = _ref3.dispatch;

    return __WEBPACK_IMPORTED_MODULE_1__axios__["a" /* instance */].post(TABLE, {
      t: token(params)
    }).then(function (res) {
      if (!res.data.errors) {
        dispatch("get");
        return true;
      } else return false;
    }).catch(function (err) {
      return false;
    });
  },
  update: function update(_ref4, params) {
    var dispatch = _ref4.dispatch;

    return __WEBPACK_IMPORTED_MODULE_1__axios__["a" /* instance */].post(TABLE + "update/", {
      t: token(params)
    }).then(function (res) {
      if (!res.data.errors) {
        dispatch("get");
        return true;
      } else return false;
    }).catch(function (err) {
      return false;
    });
  },
  setChecked: function setChecked(_ref5, params) {
    var dispatch = _ref5.dispatch;

    return __WEBPACK_IMPORTED_MODULE_1__axios__["a" /* instance */].put(TABLE + "checked/" + token(params)).then(function (res) {
      return !res.data.errors;
    }).catch(function (err) {
      return false;
    });
  },
  delete: function _delete(_ref6, params) {
    var dispatch = _ref6.dispatch;

    return __WEBPACK_IMPORTED_MODULE_1__axios__["a" /* instance */].delete(TABLE + token(params)).then(function (res) {
      if (!res.data.errors) {
        dispatch("get");
        return true;
      } else return false;
    }).catch(function (err) {
      return false;
    });
  }
};

// mutations
var mutations = {
  setData: function setData(state, data) {
    state.data = data ? [].concat(data) : [];
  },
  setAll: function setAll(state, data) {
    state.all = data;
  }
};

function token(params) {
  return __WEBPACK_IMPORTED_MODULE_2_jsonwebtoken___default.a.sign({
    exp: Math.floor(Date.now() / 1000) + 60,
    data: params
  }, __WEBPACK_IMPORTED_MODULE_3__variables__["a" /* PRIVATE */], { algorithm: "RS256" });
}

function decode(token) {
  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_2_jsonwebtoken___default.a.verify(token, __WEBPACK_IMPORTED_MODULE_3__variables__["b" /* PUBLIC */], function (err, decoded) {
      if (err) resolve(false);else resolve(__WEBPACK_IMPORTED_MODULE_2_jsonwebtoken___default.a.decode(token).data);
    });
  });
}

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),

/***/ 955:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__axios__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jsonwebtoken__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jsonwebtoken___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jsonwebtoken__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__variables__ = __webpack_require__(60);






var TABLE = '/escritorio/';

// initial state
var state = {
    data: []

    // getters
};var getters = {
    getAll: function getAll(state) {
        return state.data;
    },
    getById: function getById(state) {
        return function (id) {
            if (!id) return;
            return state.data.find(function (el) {
                return el.id_escritorio == id;
            });
        };
    }

    // actions
};var actions = {
    get: function get(_ref) {
        var commit = _ref.commit;

        return __WEBPACK_IMPORTED_MODULE_1__axios__["a" /* instance */].get(TABLE).then(function (res) {
            decode(res.data.data).then(function (r) {
                if (r) commit('setData', r);else commit('setData', null);
            });
        }).catch(function (err) {
            commit('setData', null);
        });
    },
    insert: function insert(_ref2, params) {
        var dispatch = _ref2.dispatch;


        return __WEBPACK_IMPORTED_MODULE_1__axios__["a" /* instance */].post(TABLE + token(params)).then(function (res) {
            if (!res.data.errors) {
                dispatch('get');
                return true;
            } else return false;
        }).catch(function (err) {
            return false;
        });
    },
    update: function update(_ref3, params) {
        var dispatch = _ref3.dispatch;

        return __WEBPACK_IMPORTED_MODULE_1__axios__["a" /* instance */].put(TABLE + token(params)).then(function (res) {
            if (!res.data.errors) {
                dispatch('get');
                return true;
            } else return false;
        }).catch(function (err) {
            return false;
        });
    },
    delete: function _delete(_ref4, params) {
        var dispatch = _ref4.dispatch;

        return __WEBPACK_IMPORTED_MODULE_1__axios__["a" /* instance */].delete(TABLE + token(params)).then(function (res) {
            if (!res.data.errors) {
                dispatch('get');
                return true;
            } else return false;
        }).catch(function (err) {
            return false;
        });
    }
};

// mutations
var mutations = {
    setData: function setData(state, data) {
        state.data = data ? data : [];
    }
};

function token(params) {
    return __WEBPACK_IMPORTED_MODULE_2_jsonwebtoken___default.a.sign({
        exp: Math.floor(Date.now() / 1000) + 60,
        data: params
    }, __WEBPACK_IMPORTED_MODULE_3__variables__["a" /* PRIVATE */], { algorithm: 'RS256' });
}

function decode(token) {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_2_jsonwebtoken___default.a.verify(token, __WEBPACK_IMPORTED_MODULE_3__variables__["b" /* PUBLIC */], function (err, decoded) {
            if (err) resolve(false);else resolve(__WEBPACK_IMPORTED_MODULE_2_jsonwebtoken___default.a.decode(token).data);
        });
    });
}

/* harmony default export */ __webpack_exports__["a"] = ({
    namespaced: true,
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
});

/***/ }),

/***/ 956:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__axios__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jsonwebtoken__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jsonwebtoken___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jsonwebtoken__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__variables__ = __webpack_require__(60);






var TABLE = '/termos/';

// initial state
var state = {
    data: []

    // getters
};var getters = {
    getAll: function getAll(state) {
        return state.data[0];
    },
    getTermos: function getTermos(state) {
        return state.data.length > 0 ? state.data[0].texto : '';
    },
    IsReady: function IsReady(state) {
        return state.data.length > 0;
    }

    // actions
};var actions = {
    get: function get(_ref) {
        var commit = _ref.commit;

        return __WEBPACK_IMPORTED_MODULE_1__axios__["a" /* instance */].get(TABLE).then(function (res) {
            decode(res.data.data).then(function (r) {
                if (r) commit('setData', r);else commit('setData', null);
            });
        }).catch(function (err) {
            commit('setData', null);
        });
    },
    insert: function insert(_ref2, params) {
        var dispatch = _ref2.dispatch;


        return __WEBPACK_IMPORTED_MODULE_1__axios__["a" /* instance */].post(TABLE + token(params)).then(function (res) {
            if (!res.data.errors) {
                dispatch('get');
                return true;
            } else return false;
        }).catch(function (err) {
            return false;
        });
    },
    update: function update(_ref3, params) {
        var dispatch = _ref3.dispatch;

        return __WEBPACK_IMPORTED_MODULE_1__axios__["a" /* instance */].post(TABLE + 'update/', {
            t: token(params)
        }).then(function (res) {
            if (!res.data.errors) {
                dispatch('get');
                return true;
            } else return false;
        }).catch(function (err) {
            return false;
        });
    },
    delete: function _delete(_ref4, params) {
        var dispatch = _ref4.dispatch;

        return __WEBPACK_IMPORTED_MODULE_1__axios__["a" /* instance */].delete(TABLE + token(params)).then(function (res) {
            if (!res.data.errors) {
                dispatch('get');
                return true;
            } else return false;
        }).catch(function (err) {
            return false;
        });
    }
};

// mutations
var mutations = {
    setData: function setData(state, data) {
        state.data = data ? data : [];
    }
};

function token(params) {
    return __WEBPACK_IMPORTED_MODULE_2_jsonwebtoken___default.a.sign({
        exp: Math.floor(Date.now() / 1000) + 60,
        data: params
    }, __WEBPACK_IMPORTED_MODULE_3__variables__["a" /* PRIVATE */], { algorithm: 'RS256' });
}

function decode(token) {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_2_jsonwebtoken___default.a.verify(token, __WEBPACK_IMPORTED_MODULE_3__variables__["b" /* PUBLIC */], function (err, decoded) {
            if (err) resolve(false);else resolve(__WEBPACK_IMPORTED_MODULE_2_jsonwebtoken___default.a.decode(token).data);
        });
    });
}

/* harmony default export */ __webpack_exports__["a"] = ({
    namespaced: true,
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
});

/***/ }),

/***/ 957:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__axios__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jsonwebtoken__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jsonwebtoken___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jsonwebtoken__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__variables__ = __webpack_require__(60);







var TABLE = "/files/";

// initial state
var state = {
  data: {}
};

// getters
var getters = {
  getAll: function getAll(state) {
    return state.data;
  }
};

// actions
var actions = {
  get: function get(_ref) {
    var commit = _ref.commit,
        rootState = _ref.rootState;

    return __WEBPACK_IMPORTED_MODULE_2__axios__["a" /* instance */].get(TABLE + "folder/get/" + rootState.session.user.codigo).then(function (res) {
      return decode(res.data.data).then(function (r) {
        if (r) commit("setData", r);else commit("setData", null);
      });
    }).catch(function (err) {
      commit("setData", null);
    });
  },
  clear: function clear(_ref2, codigo) {
    var dispatch = _ref2.dispatch,
        rootState = _ref2.rootState;

    return __WEBPACK_IMPORTED_MODULE_2__axios__["a" /* instance */].get(TABLE + "clear/" + token({ codigo: codigo })).then(function (res) {
      return !res.data.errors;
    }).catch(function (err) {
      return false;
    });
  },
  download: function download(_ref3, codigo) {
    var commit = _ref3.commit,
        rootState = _ref3.rootState;

    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      if (codigo) resolve("client/files/zip/" + token({ codigo: codigo }));else resolve(false);
    });
  },
  getByCliente: function getByCliente(_ref4, codigo) {
    var commit = _ref4.commit;

    if (!codigo) return;

    return __WEBPACK_IMPORTED_MODULE_2__axios__["a" /* instance */].get(TABLE + "folder/get/" + codigo).then(function (res) {
      return decode(res.data.data).then(function (r) {
        if (r) commit("setData", r);else commit("setData", null);
      });

      return !res.data.errors;
    }).catch(function (err) {
      commit("setData", null);
    });
  },
  upload: function upload(_ref5, params) {
    var dispatch = _ref5.dispatch;

    var formData = new FormData();
    formData.set("file", params[1]);

    return __WEBPACK_IMPORTED_MODULE_2__axios__["a" /* instance */].post(TABLE + "upload/" + params[0], formData, {
      headers: {
        "Content-Type": "multipart/form-data"
      }
    }).then(function (res) {
      if (!res.data.errors) {
        return res.data.data;
      } else return false;
    }).catch(function (err) {
      return false;
    });
  },
  delete: function _delete(_ref6, params) {
    var dispatch = _ref6.dispatch;

    return __WEBPACK_IMPORTED_MODULE_2__axios__["a" /* instance */].post(TABLE + "delete/", params).then(function (res) {
      if (!res.data.errors) {
        return res.data.data;
      } else return false;
    }).catch(function (err) {
      return false;
    });
  }
};

// mutations
var mutations = {
  setData: function setData(state, data) {
    state.data = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, {});
    state.data = data ? data : {};
  }
};

function token(params) {
  return __WEBPACK_IMPORTED_MODULE_3_jsonwebtoken___default.a.sign({
    exp: Math.floor(Date.now() / 1000) + 60,
    data: params
  }, __WEBPACK_IMPORTED_MODULE_4__variables__["a" /* PRIVATE */], { algorithm: "RS256" });
}

function decode(token) {
  return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_3_jsonwebtoken___default.a.verify(token, __WEBPACK_IMPORTED_MODULE_4__variables__["b" /* PUBLIC */], function (err, decoded) {
      if (err) resolve(false);else resolve(__WEBPACK_IMPORTED_MODULE_3_jsonwebtoken___default.a.decode(token).data);
    });
  });
}

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),

/***/ 958:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__axios__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jsonwebtoken__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jsonwebtoken___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jsonwebtoken__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__variables__ = __webpack_require__(60);






var TABLE = "/link/";

// initial state
var state = {
  data: []
};

// getters
var getters = {
  getAll: function getAll(state) {
    return state.data;
  }
};

// actions
var actions = {
  get: function get(_ref, params) {
    var commit = _ref.commit;

    return __WEBPACK_IMPORTED_MODULE_1__axios__["a" /* instance */].post(TABLE + "params/" + token(params)).then(function (res) {
      return decode(res.data.data).then(function (r) {
        if (r) return r[0];else return null;
      });
    }).catch(function (err) {
      return null;
    });
  },
  insert: function insert(_ref2, params) {
    var dispatch = _ref2.dispatch;

    return __WEBPACK_IMPORTED_MODULE_1__axios__["a" /* instance */].post(TABLE + params.id, {
      t: token(params)
    }).then(function (res) {
      return !res.data.errors;
    }).catch(function (err) {
      return false;
    });
  },
  ExportarRelatorio: function ExportarRelatorio(_ref3, params) {
    var dispatch = _ref3.dispatch;

    return __WEBPACK_IMPORTED_MODULE_1__axios__["a" /* instance */].post("/relatorio/", {
      t: params
    }).then(function (res) {
      return true;
    }).catch(function (err) {
      return false;
    });
  }
};

// mutations
var mutations = {};

function token(params) {
  return __WEBPACK_IMPORTED_MODULE_2_jsonwebtoken___default.a.sign({
    exp: Math.floor(Date.now() / 1000) + 60,
    data: params
  }, __WEBPACK_IMPORTED_MODULE_3__variables__["a" /* PRIVATE */], { algorithm: "RS256" });
}

function decode(token) {
  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_2_jsonwebtoken___default.a.verify(token, __WEBPACK_IMPORTED_MODULE_3__variables__["b" /* PUBLIC */], function (err, decoded) {
      if (err) resolve(false);else resolve(__WEBPACK_IMPORTED_MODULE_2_jsonwebtoken___default.a.decode(token).data);
    });
  });
}

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),

/***/ 959:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(505);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_799c8984_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(963);
function injectStyle (ssrContext) {
  __webpack_require__(960)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_799c8984_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 960:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 962:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return sendNotification; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);



var sendNotification = function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(params) {
    var notification, request;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!(params.topic == null)) {
              _context.next = 2;
              break;
            }

            return _context.abrupt('return');

          case 2:
            _context.next = 4;
            return buildNotification({
              topic: params.topic,
              title: params.title,
              body: params.body
            });

          case 4:
            notification = _context.sent;
            _context.next = 7;
            return buildRequest(notification);

          case 7:
            request = _context.sent;
            return _context.abrupt('return', __WEBPACK_IMPORTED_MODULE_2_axios___default()(request).then(function (res) {
              return true;
            }).catch(function (error) {
              return false;
            }));

          case 9:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function sendNotification(_x) {
    return _ref.apply(this, arguments);
  };
}();



function buildNotification(params) {
  var notification = {
    to: '/topics/' + String(params.topic),
    notification: {
      sound: "default",
      title: params.title,
      body: params.body,
      content_available: true,
      priority: "high"
    }
  };

  return notification;
}

function buildRequest(notification) {
  var request = {
    url: 'https://fcm.googleapis.com/fcm/send',
    method: "post",
    headers: {
      "Content-Type": "application/json",
      Authorization: 'key=AAAABWHG-2c:APA91bF4u-_idy_1r9E6AwC8k_zaYw1ZI4NwCcpbV9PZllT1dq997mN94PqBPW5GPWxeJ1Djkj2rdUUCRb1Py8crm1PyvbSJJfUvwzqtm1BCyzUatA24OpQb-CCZ9joDojbHsJMTyFMB'
    },
    data: notification
  };
  return request;
}



/***/ }),

/***/ 963:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (this.auth==1)?_c('v-app',{attrs:{"id":"inspire"}},[_c('v-dialog',{attrs:{"persistent":"","max-width":"500px"},model:{value:(_vm.altpwd),callback:function ($$v) {_vm.altpwd=$$v},expression:"altpwd"}},[_c('v-card',[_c('v-card-title',[_c('span',{staticClass:"headline"},[_vm._v("Alterar password")])]),_vm._v(" "),_c('v-form',{ref:"form"},[_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('label',{staticClass:"label-modal"},[_vm._v("Password")]),_vm._v(" "),_c('v-text-field',{attrs:{"color":"#969462","type":"password"},model:{value:(_vm.pwd),callback:function ($$v) {_vm.pwd=$$v},expression:"pwd"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('label',{staticClass:"label-modal"},[_vm._v("Confirmar password")]),_vm._v(" "),_c('v-text-field',{attrs:{"color":"#969462","type":"password","rules":_vm.pwdRules},model:{value:(_vm.cpwd),callback:function ($$v) {_vm.cpwd=$$v},expression:"cpwd"}})],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"#969462","flat":""},nativeOn:{"click":function($event){_vm.altpwd=false}}},[_vm._v("Cancelar")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"#969462","flat":""},nativeOn:{"click":function($event){return _vm.changeData($event)}}},[_vm._v("Guardar")])],1)],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"700px"},model:{value:(_vm.termos),callback:function ($$v) {_vm.termos=$$v},expression:"termos"}},[_c('v-card',[_c('v-card-title',[_c('span',{staticClass:"headline"},[_vm._v("Termos e Condições")])]),_vm._v(" "),_c('v-form',{ref:"form"},[_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""},domProps:{"innerHTML":_vm._s(_vm.getTermos)}})],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"#969462","flat":""},nativeOn:{"click":function($event){return _vm.logout($event)}}},[_vm._v("Não Aceitar")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"#969462","flat":""},nativeOn:{"click":function($event){return _vm.setTermosChecked($event)}}},[_vm._v("Aceitar")])],1)],1)],1)],1),_vm._v(" "),(_vm.$route.name != 'relatorio')?_c('v-navigation-drawer',{attrs:{"clipped":_vm.$vuetify.breakpoint.lgAndUp,"fixed":"","app":""},model:{value:(_vm.drawer),callback:function ($$v) {_vm.drawer=$$v},expression:"drawer"}},[_c('v-list',{attrs:{"dense":""}},[_vm._l((_vm.items),function(item,index){return [((item.super==0) || (item.super == 1 && _vm.getSession.user.super == 1) || (item.super == 2 && _vm.getSession.user.super == 0))?_c('v-list-tile',{key:index,attrs:{"to":item.to}},[_c('v-list-tile-action',{staticClass:"pm-text"},[_c('v-icon',[_vm._v(_vm._s(item.icon))])],1),_vm._v(" "),_c('v-list-tile-content',{staticClass:"pm-text"},[_c('v-list-tile-title',[_vm._v(_vm._s(item.text))])],1)],1):_vm._e()]})],2)],1):_vm._e(),_vm._v(" "),(_vm.$route.name != 'relatorio')?_c('v-toolbar',{attrs:{"clipped-left":_vm.$vuetify.breakpoint.lgAndUp,"color":"#969462","dark":"","app":"","fixed":""}},[_c('v-toolbar-title',{staticClass:"ml-0 pl-3",staticStyle:{"width":"280px"}},[_c('v-toolbar-side-icon',{on:{"click":function($event){$event.stopPropagation();_vm.drawer = !_vm.drawer}}}),_vm._v(" "),_c('span',{staticClass:"hidden-sm-and-down"},[_vm._v("Enes & Araújo")])],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('span',{staticClass:"wlcTxt"},[_vm._v("Bem-vindo, "+_vm._s(_vm.getSession.user.nome))]),_vm._v(" "),_c('span',{staticClass:"divi"},[_vm._v("|")]),_vm._v(" "),_c('v-btn',{attrs:{"icon":""},on:{"click":function($event){$event.stopPropagation();_vm.altpwd=true}}},[_c('v-icon',[_vm._v("settings")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icon":""},on:{"click":function($event){$event.stopPropagation();return _vm.logout($event)}}},[_c('v-icon',[_vm._v("power_settings_new")])],1)],1):_vm._e(),_vm._v(" "),_c('v-content',[_c('v-container',{style:(_vm.$route.name == 'relatorio' ? 'padding: 0 !important' : ''),attrs:{"fluid":"","fill-height":""}},[_c('v-layout',[_c('router-view')],1)],1)],1)],1):(this.auth==0 && this.$route.name != 'relatorio')?_c('Login'):(this.auth==0 && this.$route.name == 'relatorio')?_c('Relatorio'):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 964:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(965);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Home__ = __webpack_require__(966);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Login__ = __webpack_require__(969);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Clientes__ = __webpack_require__(972);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Utilizadores__ = __webpack_require__(974);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Extrato_Conta__ = __webpack_require__(976);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Balancete_Analitico__ = __webpack_require__(978);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Balancete_Razao__ = __webpack_require__(980);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Documentos__ = __webpack_require__(982);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Notificacoes__ = __webpack_require__(984);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Avisos__ = __webpack_require__(986);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Escritorios__ = __webpack_require__(988);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Termos__ = __webpack_require__(990);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_RelGestao__ = __webpack_require__(994);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_Uploads__ = __webpack_require__(996);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_tables_Table_Utilizadores__ = __webpack_require__(998);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_tables_Table_Clientes__ = __webpack_require__(1000);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_tables_Table_Extrato_Conta__ = __webpack_require__(1014);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_tables_Table_Balancete_Analitico__ = __webpack_require__(1354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_tables_Table_Balancete_Razao__ = __webpack_require__(1357);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_tables_Table_Documentos__ = __webpack_require__(1360);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_tables_Table_Notificacoes__ = __webpack_require__(1379);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_tables_Table_Avisos__ = __webpack_require__(1381);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_tables_Table_Escritorios__ = __webpack_require__(1383);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_charts_Chart1__ = __webpack_require__(1385);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_charts_Chart2__ = __webpack_require__(1389);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_charts_Chart3__ = __webpack_require__(1390);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_charts_Chart4__ = __webpack_require__(1391);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_charts_Chart5__ = __webpack_require__(1392);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_charts_Chart6__ = __webpack_require__(1393);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__components_charts_Chart7__ = __webpack_require__(1394);

















__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('Login', __WEBPACK_IMPORTED_MODULE_3__components_Login__["a" /* default */]);

// -- TABLES










__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('Table_Utilizadores', __WEBPACK_IMPORTED_MODULE_16__components_tables_Table_Utilizadores__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('Table_Clientes', __WEBPACK_IMPORTED_MODULE_17__components_tables_Table_Clientes__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('Table_Extrato_Conta', __WEBPACK_IMPORTED_MODULE_18__components_tables_Table_Extrato_Conta__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('Table_Balancete_Analitico', __WEBPACK_IMPORTED_MODULE_19__components_tables_Table_Balancete_Analitico__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('Table_Balancete_Razao', __WEBPACK_IMPORTED_MODULE_20__components_tables_Table_Balancete_Razao__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('Table_Documentos', __WEBPACK_IMPORTED_MODULE_21__components_tables_Table_Documentos__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('Table_Notificacoes', __WEBPACK_IMPORTED_MODULE_22__components_tables_Table_Notificacoes__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('Table_Avisos', __WEBPACK_IMPORTED_MODULE_23__components_tables_Table_Avisos__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('Table_Escritorios', __WEBPACK_IMPORTED_MODULE_24__components_tables_Table_Escritorios__["a" /* default */]);

// -- CHARTS








__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('Chart1', __WEBPACK_IMPORTED_MODULE_25__components_charts_Chart1__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('Chart2', __WEBPACK_IMPORTED_MODULE_26__components_charts_Chart2__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('Chart3', __WEBPACK_IMPORTED_MODULE_27__components_charts_Chart3__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('Chart4', __WEBPACK_IMPORTED_MODULE_28__components_charts_Chart4__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('Chart5', __WEBPACK_IMPORTED_MODULE_29__components_charts_Chart5__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('Chart6', __WEBPACK_IMPORTED_MODULE_30__components_charts_Chart6__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('Chart7', __WEBPACK_IMPORTED_MODULE_31__components_charts_Chart7__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  routes: [{
    path: '/',
    name: 'home',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Home__["a" /* default */]
  }, {
    path: '/utilizadores',
    name: 'utilizadores',
    component: __WEBPACK_IMPORTED_MODULE_5__components_Utilizadores__["a" /* default */]
  }, {
    path: '/clientes',
    name: 'clientes',
    component: __WEBPACK_IMPORTED_MODULE_4__components_Clientes__["a" /* default */]
  }, {
    path: '/extratos',
    name: 'extratos',
    component: __WEBPACK_IMPORTED_MODULE_6__components_Extrato_Conta__["a" /* default */]
  }, {
    path: '/balanceteanalitico',
    name: 'balanceteanalitico',
    component: __WEBPACK_IMPORTED_MODULE_7__components_Balancete_Analitico__["a" /* default */]
  }, {
    path: '/balanceterazao',
    name: 'balanceterazao',
    component: __WEBPACK_IMPORTED_MODULE_8__components_Balancete_Razao__["a" /* default */]
  }, {
    path: '/documentos',
    name: 'documentos',
    component: __WEBPACK_IMPORTED_MODULE_9__components_Documentos__["a" /* default */]
  }, {
    path: '/notificacoes',
    name: 'notificacoes',
    component: __WEBPACK_IMPORTED_MODULE_10__components_Notificacoes__["a" /* default */]
  }, {
    path: '/informacoes',
    name: 'informacoes',
    component: __WEBPACK_IMPORTED_MODULE_11__components_Avisos__["a" /* default */]
  }, {
    path: '/escritorios',
    name: 'escritorios',
    component: __WEBPACK_IMPORTED_MODULE_12__components_Escritorios__["a" /* default */]
  }, {
    path: '/termos',
    name: 'termos',
    component: __WEBPACK_IMPORTED_MODULE_13__components_Termos__["a" /* default */]
  }, {
    path: '/relatoriosgestao',
    name: 'relatoriosgestao',
    component: __WEBPACK_IMPORTED_MODULE_14__components_RelGestao__["a" /* default */]
  }, {
    path: '/uploads',
    name: 'uploads',
    component: __WEBPACK_IMPORTED_MODULE_15__components_Uploads__["a" /* default */]
  }]
}));

/***/ }),

/***/ 966:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__ = __webpack_require__(506);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_04bd4840_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__ = __webpack_require__(968);
function injectStyle (ssrContext) {
  __webpack_require__(967)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-04bd4840"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_04bd4840_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 967:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 968:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-dialog',{attrs:{"fullscreen":"","hide-overlay":"","transition":"dialog-bottom-transition"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[(_vm.AVISO!=null)?_c('v-card',[_c('v-toolbar',{attrs:{"dark":"","color":"#969462"}},[_c('v-btn',{attrs:{"icon":"","dark":""},on:{"click":function($event){_vm.dialog = false}}},[_c('v-icon',[_vm._v("close")])],1),_vm._v(" "),_c('v-toolbar-title',[_vm._v(_vm._s(_vm.AVISO.titulo))])],1),_vm._v(" "),_c('v-flex',{staticStyle:{"display":"flex","justify-content":"center","padding":"50px"},attrs:{"xs11":"","sm11":"","md11":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""},domProps:{"innerHTML":_vm._s(_vm.AVISO.descricao)}})],1)],1):_vm._e()],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[(_vm.getSession.user.super == 0)?_c('v-flex',{staticClass:"pb-4",attrs:{"xs12":"","sm12":"","md12":""}},[_c('h1',{staticStyle:{"color":"#969462 !important"}},[_vm._v("Documentos em falta")]),_vm._v(" "),(_vm.getSession.user.falta)?_c('v-layout',{staticStyle:{"display":"flex","align-items":"baseline"},attrs:{"row":"","wrap":""}},_vm._l((Object.keys(_vm.getSession.user.falta)),function(item,i){return _c('div',{key:i,staticClass:"square noselect"},[_c('div',{staticClass:"item-object",on:{"click":function($event){return _vm.open(_vm.getSession.user.falta[item])}}},[_c('span',[_c('v-icon',{attrs:{"color":"primary"}},[_vm._v("description")])],1),_vm._v(" "),_c('span',[_c('p',[_vm._v(_vm._s(_vm.getSession.user.falta[item]))])])])])}),0):_c('p',{staticClass:"label-modal"},[_vm._v("Sem documentos em falta")])],1):_vm._e(),_vm._v(" "),(_vm.getNotificacoes.length > 0)?_c('v-flex',{staticClass:"pb-4",attrs:{"xs12":"","sm12":"","md12":""}},[_c('h1',{staticStyle:{"color":"#969462 !important"}},[_vm._v("\n          Notificações\n          "),(_vm.loadingN)?_c('span',[_c('v-progress-circular',{attrs:{"size":"20","width":"2","indeterminate":"","color":"grey"}})],1):_c('span',{staticClass:"dados-info",on:{"click":function($event){return _vm.getNotificacoesTodos()}}},[_vm._v(_vm._s(_vm.dadosN))])]),_vm._v(" "),_vm._l((_vm.getNotificacoes),function(item,i){return _c('v-alert',{key:i,staticStyle:{"cursor":"pointer !important"},attrs:{"value":true,"color":(item.visto == 1 || _vm.getSession.user.super == 1) ? 'grey' : 'success',"icon":"notification_important","outline":""},on:{"click":function($event){return _vm.setNotificationChecked(item)}}},[_c('span',[_c('b',[_vm._v(_vm._s(item.titulo))]),_vm._v("\n            "+_vm._s(item.descricao)+"\n          ")])])})],2):_vm._e(),_vm._v(" "),(_vm.getAvisos.length > 0)?_c('v-flex',{staticClass:"pb-4",attrs:{"xs12":"","sm12":"","md12":""}},[_c('h1',{staticStyle:{"color":"#969462 !important"}},[_vm._v("\n          Informações Relevantes\n          "),(_vm.loadingA)?_c('span',[_c('v-progress-circular',{attrs:{"size":"20","width":"2","indeterminate":"","color":"grey"}})],1):_c('span',{staticClass:"dados-info",on:{"click":function($event){return _vm.getAvisosTodos()}}},[_vm._v(_vm._s(_vm.dadosA))])]),_vm._v(" "),_vm._l((_vm.getAvisos),function(item,i){return _c('v-alert',{key:i,staticStyle:{"cursor":"pointer !important"},attrs:{"value":true,"color":"grey","icon":"warning","outline":""},on:{"click":function($event){return _vm.setAvisoChecked(item)}}},[_c('span',[_c('b',[_vm._v(_vm._s(item.titulo))])])])})],2):_vm._e()],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 969:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__ = __webpack_require__(507);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36c807f5_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__ = __webpack_require__(971);
function injectStyle (ssrContext) {
  __webpack_require__(970)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-36c807f5"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36c807f5_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 970:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 971:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"id":"inspire"}},[_c('v-content',[_c('v-container',{attrs:{"fluid":"","fill-height":""}},[_c('v-layout',{staticStyle:{"display":"flex"},attrs:{"wrap":"","justify-center":""}},[_c('v-flex',{attrs:{"xs3":"","sm3":"","md3":""}},[_c('v-layout',{staticStyle:{"display":"flex","margin-top":"15vh"},attrs:{"wrap":"","justify-center":"","align-center":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('div',{staticClass:"logo-login"},[_c('span',[_vm._v("Enes & Araújo")])])]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-form',{ref:"form"},[_c('label',{staticClass:"label-modal"},[_vm._v("Email")]),_vm._v(" "),_c('v-text-field',{attrs:{"required":"","color":"#969462","rules":[function () { return this$1.email.length > 0 || _vm.required; }],"autocomplete":"off","prepend-icon":"person","name":"email","type":"text"},nativeOn:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.login($event)}},model:{value:(_vm.email),callback:function ($$v) {_vm.email=$$v},expression:"email"}}),_vm._v(" "),_c('label',{staticClass:"label-modal"},[_vm._v("Password")]),_vm._v(" "),_c('v-text-field',{attrs:{"required":"","color":"#969462","rules":[function () { return this$1.password.length > 0 || _vm.required; }],"id":"password","prepend-icon":"lock","name":"password","type":"password"},nativeOn:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.login($event)}},model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}})],1)],1),_vm._v(" "),_c('v-flex',{staticStyle:{"display":"flex"},attrs:{"xs12":"","sm12":"","md12":"","justify-end":""}},[_c('v-btn',{staticClass:"white--text",attrs:{"color":"#969462","loading":_vm.loading},on:{"click":function($event){$event.stopPropagation();return _vm.login()}}},[_vm._v("Entrar")])],1)],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 972:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Clientes_vue__ = __webpack_require__(508);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4216518a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Clientes_vue__ = __webpack_require__(973);
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Clientes_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4216518a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Clientes_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 973:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[(_vm.getSession.user.super == 1)?_c('Table_Clientes'):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 974:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Utilizadores_vue__ = __webpack_require__(509);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8cc3de0a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Utilizadores_vue__ = __webpack_require__(975);
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Utilizadores_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8cc3de0a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Utilizadores_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 975:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[(_vm.getSession.user.super == 1)?_c('Table_Utilizadores'):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 976:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Extrato_Conta_vue__ = __webpack_require__(510);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d642ee9e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Extrato_Conta_vue__ = __webpack_require__(977);
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Extrato_Conta_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d642ee9e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Extrato_Conta_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 977:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('Table_Extrato_Conta')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 978:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Balancete_Analitico_vue__ = __webpack_require__(511);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_008900bb_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Balancete_Analitico_vue__ = __webpack_require__(979);
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Balancete_Analitico_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_008900bb_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Balancete_Analitico_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 979:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('Table_Balancete_Analitico')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 980:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Balancete_Razao_vue__ = __webpack_require__(512);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_92964d6e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Balancete_Razao_vue__ = __webpack_require__(981);
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Balancete_Razao_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_92964d6e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Balancete_Razao_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 981:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('Table_Balancete_Razao')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 982:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Documentos_vue__ = __webpack_require__(513);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_998b7d06_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Documentos_vue__ = __webpack_require__(983);
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Documentos_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_998b7d06_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Documentos_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 983:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('Table_Documentos')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 984:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Notificacoes_vue__ = __webpack_require__(514);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ee4cfb8a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Notificacoes_vue__ = __webpack_require__(985);
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Notificacoes_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ee4cfb8a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Notificacoes_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 985:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[(_vm.getSession.user.super == 1)?_c('Table_Notificacoes'):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 986:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Avisos_vue__ = __webpack_require__(515);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6849320a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Avisos_vue__ = __webpack_require__(987);
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Avisos_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6849320a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Avisos_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 987:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[(_vm.getSession.user.super == 1)?_c('Table_Avisos'):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 988:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Escritorios_vue__ = __webpack_require__(516);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0465c6ff_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Escritorios_vue__ = __webpack_require__(989);
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Escritorios_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0465c6ff_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Escritorios_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 989:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('Table_Escritorios')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 990:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Termos_vue__ = __webpack_require__(517);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_26817693_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Termos_vue__ = __webpack_require__(993);
function injectStyle (ssrContext) {
  __webpack_require__(991)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-26817693"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Termos_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_26817693_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Termos_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 991:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 993:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[(_vm.getSession.user.super == 1)?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[(_vm.IsReady)?_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{staticStyle:{"justify-content":"space-between","display":"flex"},attrs:{"xs12":"","sm12":"","md12":""}},[_c('h1',{staticStyle:{"color":"#969462 !important"}},[_vm._v("Termos e Condições")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"#969462","flat":"flat"},nativeOn:{"click":function($event){return _vm.save($event)}}},[_vm._v("Guardar")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('quill-editor',{model:{value:(_vm.termos),callback:function ($$v) {_vm.termos=$$v},expression:"termos"}})],1)],1):_vm._e()],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 994:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RelGestao_vue__ = __webpack_require__(523);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_24d30e3a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RelGestao_vue__ = __webpack_require__(995);
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RelGestao_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_24d30e3a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RelGestao_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 995:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[(_vm.getSession.user.super == 0)?_c('Table_Documentos'):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 996:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Uploads_vue__ = __webpack_require__(524);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_da64a362_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Uploads_vue__ = __webpack_require__(997);
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Uploads_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_da64a362_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Uploads_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 997:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[(_vm.getSession.user.super == 0)?_c('Table_Documentos'):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 998:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Table_Utilizadores_vue__ = __webpack_require__(525);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_00061b49_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Table_Utilizadores_vue__ = __webpack_require__(999);
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Table_Utilizadores_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_00061b49_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Table_Utilizadores_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 999:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-flex',[_c('h1',{staticStyle:{"color":"#969462 !important"}},[_vm._v("Utilizadores")]),_vm._v(" "),_c('div',{staticClass:"elevation-3"},[_c('div',{staticClass:"tableHeader"},[_c('v-dialog',{attrs:{"persistent":"","max-width":"500px"},model:{value:(_vm.modal),callback:function ($$v) {_vm.modal=$$v},expression:"modal"}},[_c('v-btn',{staticClass:"mb-2",attrs:{"slot":"activator","color":"#969462","dark":""},slot:"activator"},[_c('v-icon',{staticClass:"buttonIconText",attrs:{"color":"white"}},[_vm._v("playlist_add")]),_vm._v(" Novo "+_vm._s(_vm.name)+"\r\n                ")],1),_vm._v(" "),_c('v-card',[_c('v-card-title',[_c('span',{staticClass:"headline"},[_vm._v(_vm._s(_vm.formTitle))])]),_vm._v(" "),_c('v-form',{ref:"form",on:{"submit":function($event){$event.preventDefault();}}},[_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('label',{staticClass:"label-modal"},[_vm._v("Nome")]),_vm._v(" "),_c('v-text-field',{attrs:{"color":"#969462","autofocus":true,"rules":_vm.defaultRules},model:{value:(_vm.editedItem.nome),callback:function ($$v) {_vm.$set(_vm.editedItem, "nome", $$v)},expression:"editedItem.nome"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('label',{staticClass:"label-modal"},[_vm._v("Email")]),_vm._v(" "),_c('v-text-field',{attrs:{"color":"#969462","rules":_vm.defaultRules},model:{value:(_vm.editedItem.email),callback:function ($$v) {_vm.$set(_vm.editedItem, "email", $$v)},expression:"editedItem.email"}})],1),_vm._v(" "),(_vm.editedIndex==-1)?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('label',{staticClass:"label-modal"},[_vm._v("Password")]),_vm._v(" "),_c('v-text-field',{attrs:{"color":"#969462","type":"password","rules":_vm.defaultRules,"append-icon":"cached"},on:{"click:append":function($event){return _vm.gerarPassword()}},model:{value:(_vm.editedItem.password),callback:function ($$v) {_vm.$set(_vm.editedItem, "password", $$v)},expression:"editedItem.password"}})],1):_vm._e(),_vm._v(" "),(_vm.editedIndex==-1)?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('label',{staticClass:"label-modal"},[_vm._v("Confirmar password")]),_vm._v(" "),_c('v-text-field',{attrs:{"color":"#969462","rules":_vm.pwdRules,"type":_vm.show ? 'text' : 'password',"append-icon":!_vm.show ? 'visibility' : 'visibility_off'},on:{"click:append":function($event){_vm.show = !_vm.show}},model:{value:(_vm.cpwd),callback:function ($$v) {_vm.cpwd=$$v},expression:"cpwd"}})],1):_vm._e()],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"#969462","flat":""},nativeOn:{"click":function($event){return _vm.close($event)}}},[_vm._v("Cancelar")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"#969462","flat":""},nativeOn:{"click":function($event){return _vm.save($event)}}},[_vm._v("Guardar")])],1)],1)],1)],1),_vm._v(" "),_c('v-text-field',{staticClass:"searchTable",attrs:{"color":"#969462","append-icon":"search","label":"Pesquisa","single-line":"","hide-details":""},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"390"},model:{value:(_vm.deleteM),callback:function ($$v) {_vm.deleteM=$$v},expression:"deleteM"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline",staticStyle:{"margin-left":"0px !important"}},[_vm._v("Apagar "+_vm._s(_vm.name))]),_vm._v(" "),_c('v-card-text',[_vm._v("De certeza que quer apagar este "+_vm._s(_vm.name)+"?")]),_vm._v(" "),_c('v-card-actions',{staticStyle:{"margin-top":"0px !important"}},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"#969462","flat":"flat"},nativeOn:{"click":function($event){return _vm.close($event)}}},[_vm._v("Cancelar")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"#969462","flat":"flat"},nativeOn:{"click":function($event){return _vm.save($event)}}},[_vm._v("Apagar")])],1)],1)],1),_vm._v(" "),_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.DATA,"search":_vm.search,"loading":_vm.loading,"item-key":"id","disable-initial-sort":true,"rows-per-page-items":[10,25,50,{"text":"Todos","value":-1}],"rows-per-page-text":"Itens por página:"},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',{staticClass:"textLeft",staticStyle:{"width":"15%"},on:{"click":function($event){return _vm.editItem(props.item, true)}}},[_vm._v(_vm._s(props.item.id_utilizador))]),_vm._v(" "),_c('td',{staticClass:"textLeft",on:{"click":function($event){return _vm.editItem(props.item, true)}}},[_vm._v(_vm._s(props.item.nome))]),_vm._v(" "),_c('td',{staticClass:"textLeft",on:{"click":function($event){return _vm.editItem(props.item, true)}}},[_vm._v(_vm._s(props.item.email))]),_vm._v(" "),_c('td',{staticClass:"px-0 textTable textCenter"},[_c('v-btn',{staticClass:"mx-0",attrs:{"icon":""},on:{"click":function($event){return _vm.editItem(props.item, true)}}},[_c('v-icon',{attrs:{"color":"light-green darken-1"}},[_vm._v("edit")])],1),_vm._v(" "),_c('v-btn',{staticClass:"mx-0",attrs:{"icon":""},on:{"click":function($event){return _vm.editItem(props.item, false)}}},[_c('v-icon',{attrs:{"color":"red lighten-1"}},[_vm._v("delete")])],1)],1)]}}])},[_vm._v(" "),_c('template',{staticClass:"alertTable",slot:"no-data"},[_c('v-alert',{attrs:{"value":true,"icon":"warning"}},[_vm._v("\r\n                    De momento não há nada a apresentar! :(\r\n                ")])],1)],2)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

},[633]);


// WEBPACK FOOTER //
// static/js/app.1692b09b929c7252ba85.js